(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc80"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc80"] = parcelRequire;
}
parcelRequire.register("9rkWe", function(module, exports) {
"use strict";









// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var $6df6e08ce3191517$var$modules = [
    (parcelRequire("6kcNn")),
    (parcelRequire("43FHz")),
    (parcelRequire("eAz9i")),
    (parcelRequire("cah8e")),
    (parcelRequire("gm860")),
    (parcelRequire("akvJq")),
    (parcelRequire("eThsZ")),
    (parcelRequire("kkSTP")),
    (parcelRequire("Gz8Mv"))
];
// Put all encoding/alias/codec definitions to single object and export it.
for(var $6df6e08ce3191517$var$i = 0; $6df6e08ce3191517$var$i < $6df6e08ce3191517$var$modules.length; $6df6e08ce3191517$var$i++){
    var $6df6e08ce3191517$var$module = $6df6e08ce3191517$var$modules[$6df6e08ce3191517$var$i];
    for(var $6df6e08ce3191517$var$enc in $6df6e08ce3191517$var$module)if (Object.prototype.hasOwnProperty.call($6df6e08ce3191517$var$module, $6df6e08ce3191517$var$enc)) module.exports[$6df6e08ce3191517$var$enc] = $6df6e08ce3191517$var$module[$6df6e08ce3191517$var$enc];
}

});
parcelRequire.register("6kcNn", function(module, exports) {
"use strict";

var $aavGG = parcelRequire("aavGG");
var $49ae893fb7e97614$require$Buffer = $aavGG.Buffer;
// Export Node.js internal encodings.
module.exports = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: $49ae893fb7e97614$var$InternalCodec
};
//------------------------------------------------------------------------------
function $49ae893fb7e97614$var$InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = $49ae893fb7e97614$var$InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = $49ae893fb7e97614$var$InternalEncoderCesu8;
        // Add decoder for versions of Node not supporting CESU-8
        if ($49ae893fb7e97614$require$Buffer.from("eda0bdedb2a9", "hex").toString() !== "\uD83D\uDCA9") {
            this.decoder = $49ae893fb7e97614$var$InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
$49ae893fb7e97614$var$InternalCodec.prototype.encoder = $49ae893fb7e97614$var$InternalEncoder;
$49ae893fb7e97614$var$InternalCodec.prototype.decoder = $49ae893fb7e97614$var$InternalDecoder;

var $jJ0xG = parcelRequire("jJ0xG");
var $49ae893fb7e97614$require$StringDecoder = $jJ0xG.StringDecoder;
if (!$49ae893fb7e97614$require$StringDecoder.prototype.end) $49ae893fb7e97614$require$StringDecoder.prototype.end = function() {};
function $49ae893fb7e97614$var$InternalDecoder(options, codec) {
    this.decoder = new $49ae893fb7e97614$require$StringDecoder(codec.enc);
}
$49ae893fb7e97614$var$InternalDecoder.prototype.write = function(buf) {
    if (!$49ae893fb7e97614$require$Buffer.isBuffer(buf)) buf = $49ae893fb7e97614$require$Buffer.from(buf);
    return this.decoder.write(buf);
};
$49ae893fb7e97614$var$InternalDecoder.prototype.end = function() {
    return this.decoder.end();
};
//------------------------------------------------------------------------------
// Encoder is mostly trivial
function $49ae893fb7e97614$var$InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
$49ae893fb7e97614$var$InternalEncoder.prototype.write = function(str) {
    return $49ae893fb7e97614$require$Buffer.from(str, this.enc);
};
$49ae893fb7e97614$var$InternalEncoder.prototype.end = function() {};
//------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function $49ae893fb7e97614$var$InternalEncoderBase64(options, codec) {
    this.prevStr = "";
}
$49ae893fb7e97614$var$InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return $49ae893fb7e97614$require$Buffer.from(str, "base64");
};
$49ae893fb7e97614$var$InternalEncoderBase64.prototype.end = function() {
    return $49ae893fb7e97614$require$Buffer.from(this.prevStr, "base64");
};
//------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function $49ae893fb7e97614$var$InternalEncoderCesu8(options, codec) {}
$49ae893fb7e97614$var$InternalEncoderCesu8.prototype.write = function(str) {
    var buf = $49ae893fb7e97614$require$Buffer.alloc(str.length * 3), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
$49ae893fb7e97614$var$InternalEncoderCesu8.prototype.end = function() {};
//------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function $49ae893fb7e97614$var$InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
$49ae893fb7e97614$var$InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = "";
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            if (contBytes > 0) {
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else res += this.defaultCharUnicode;
        } else if (contBytes > 0) {
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else // Actually add character.
                res += String.fromCharCode(acc);
            }
        } else res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
$49ae893fb7e97614$var$InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};

});
parcelRequire.register("aavGG", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ibaza = parcelRequire("ibaza");
"use strict";

var $N0o3H = parcelRequire("N0o3H");
var $76736b097c9b8317$var$Buffer = $N0o3H.Buffer;
var $76736b097c9b8317$var$safer = {};
var $76736b097c9b8317$var$key;
for($76736b097c9b8317$var$key in $N0o3H){
    if (!$N0o3H.hasOwnProperty($76736b097c9b8317$var$key)) continue;
    if ($76736b097c9b8317$var$key === "SlowBuffer" || $76736b097c9b8317$var$key === "Buffer") continue;
    $76736b097c9b8317$var$safer[$76736b097c9b8317$var$key] = $N0o3H[$76736b097c9b8317$var$key];
}
var $76736b097c9b8317$var$Safer = $76736b097c9b8317$var$safer.Buffer = {};
for($76736b097c9b8317$var$key in $76736b097c9b8317$var$Buffer){
    if (!$76736b097c9b8317$var$Buffer.hasOwnProperty($76736b097c9b8317$var$key)) continue;
    if ($76736b097c9b8317$var$key === "allocUnsafe" || $76736b097c9b8317$var$key === "allocUnsafeSlow") continue;
    $76736b097c9b8317$var$Safer[$76736b097c9b8317$var$key] = $76736b097c9b8317$var$Buffer[$76736b097c9b8317$var$key];
}
$76736b097c9b8317$var$safer.Buffer.prototype = $76736b097c9b8317$var$Buffer.prototype;
if (!$76736b097c9b8317$var$Safer.from || $76736b097c9b8317$var$Safer.from === Uint8Array.from) $76736b097c9b8317$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $76736b097c9b8317$var$Buffer(value, encodingOrOffset, length);
};
if (!$76736b097c9b8317$var$Safer.alloc) $76736b097c9b8317$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $76736b097c9b8317$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$76736b097c9b8317$var$safer.kStringMaxLength) try {
    $76736b097c9b8317$var$safer.kStringMaxLength = $ibaza.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$76736b097c9b8317$var$safer.constants) {
    $76736b097c9b8317$var$safer.constants = {
        MAX_LENGTH: $76736b097c9b8317$var$safer.kMaxLength
    };
    if ($76736b097c9b8317$var$safer.kStringMaxLength) $76736b097c9b8317$var$safer.constants.MAX_STRING_LENGTH = $76736b097c9b8317$var$safer.kStringMaxLength;
}
module.exports = $76736b097c9b8317$var$safer;

});
parcelRequire.register("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $0934e0939605d48c$export$e4cf37d7f6fb9e0a, (v) => $0934e0939605d48c$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $0934e0939605d48c$export$599f31c3813fae4d, (v) => $0934e0939605d48c$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRequire.register("jJ0xG", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $e5c2a3f70c10f900$export$63a7aa211a91ed69, (v) => $e5c2a3f70c10f900$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $e5c2a3f70c10f900$export$63a7aa211a91ed69;
"use strict";

var $bjYgF = parcelRequire("bjYgF");
var $e5c2a3f70c10f900$require$Buffer = $bjYgF.Buffer;
/*</replacement>*/ var $e5c2a3f70c10f900$var$isEncoding = $e5c2a3f70c10f900$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $e5c2a3f70c10f900$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $e5c2a3f70c10f900$var$normalizeEncoding(enc) {
    var nenc = $e5c2a3f70c10f900$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($e5c2a3f70c10f900$require$Buffer.isEncoding === $e5c2a3f70c10f900$var$isEncoding || !$e5c2a3f70c10f900$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$e5c2a3f70c10f900$export$63a7aa211a91ed69 = $e5c2a3f70c10f900$var$StringDecoder;
function $e5c2a3f70c10f900$var$StringDecoder(encoding) {
    this.encoding = $e5c2a3f70c10f900$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $e5c2a3f70c10f900$var$utf16Text;
            this.end = $e5c2a3f70c10f900$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $e5c2a3f70c10f900$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $e5c2a3f70c10f900$var$base64Text;
            this.end = $e5c2a3f70c10f900$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $e5c2a3f70c10f900$var$simpleWrite;
            this.end = $e5c2a3f70c10f900$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $e5c2a3f70c10f900$require$Buffer.allocUnsafe(nb);
}
$e5c2a3f70c10f900$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$e5c2a3f70c10f900$var$StringDecoder.prototype.end = $e5c2a3f70c10f900$var$utf8End;
// Returns only complete characters in a Buffer
$e5c2a3f70c10f900$var$StringDecoder.prototype.text = $e5c2a3f70c10f900$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$e5c2a3f70c10f900$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $e5c2a3f70c10f900$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $e5c2a3f70c10f900$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $e5c2a3f70c10f900$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $e5c2a3f70c10f900$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $e5c2a3f70c10f900$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $e5c2a3f70c10f900$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $e5c2a3f70c10f900$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $e5c2a3f70c10f900$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $e5c2a3f70c10f900$var$utf8Text(buf, i) {
    var total = $e5c2a3f70c10f900$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $e5c2a3f70c10f900$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $e5c2a3f70c10f900$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $e5c2a3f70c10f900$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $e5c2a3f70c10f900$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $e5c2a3f70c10f900$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $e5c2a3f70c10f900$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $e5c2a3f70c10f900$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRequire.register("bjYgF", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $N0o3H = parcelRequire("N0o3H");
var $83e03800350be187$var$Buffer = $N0o3H.Buffer;
// alternative to using Object.keys for old browsers
function $83e03800350be187$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($83e03800350be187$var$Buffer.from && $83e03800350be187$var$Buffer.alloc && $83e03800350be187$var$Buffer.allocUnsafe && $83e03800350be187$var$Buffer.allocUnsafeSlow) module.exports = $N0o3H;
else {
    // Copy properties from require('buffer')
    $83e03800350be187$var$copyProps($N0o3H, module.exports);
    module.exports.Buffer = $83e03800350be187$var$SafeBuffer;
}
function $83e03800350be187$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $83e03800350be187$var$Buffer(arg, encodingOrOffset, length);
}
$83e03800350be187$var$SafeBuffer.prototype = Object.create($83e03800350be187$var$Buffer.prototype);
// Copy static methods from Buffer
$83e03800350be187$var$copyProps($83e03800350be187$var$Buffer, $83e03800350be187$var$SafeBuffer);
$83e03800350be187$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $83e03800350be187$var$Buffer(arg, encodingOrOffset, length);
};
$83e03800350be187$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $83e03800350be187$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$83e03800350be187$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $83e03800350be187$var$Buffer(size);
};
$83e03800350be187$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $N0o3H.SlowBuffer(size);
};

});



parcelRequire.register("43FHz", function(module, exports) {

$parcel$export(module.exports, "_utf32", () => $2f47ca55cdb1d6b3$export$b2b6b8849c32811a, (v) => $2f47ca55cdb1d6b3$export$b2b6b8849c32811a = v);
$parcel$export(module.exports, "utf32le", () => $2f47ca55cdb1d6b3$export$8ab18849c577cec0, (v) => $2f47ca55cdb1d6b3$export$8ab18849c577cec0 = v);
$parcel$export(module.exports, "utf32be", () => $2f47ca55cdb1d6b3$export$197feba3617118ca, (v) => $2f47ca55cdb1d6b3$export$197feba3617118ca = v);
$parcel$export(module.exports, "ucs4le", () => $2f47ca55cdb1d6b3$export$b3ab04f31ec3be1f, (v) => $2f47ca55cdb1d6b3$export$b3ab04f31ec3be1f = v);
$parcel$export(module.exports, "ucs4be", () => $2f47ca55cdb1d6b3$export$a8734ff2aa536306, (v) => $2f47ca55cdb1d6b3$export$a8734ff2aa536306 = v);
$parcel$export(module.exports, "utf32", () => $2f47ca55cdb1d6b3$export$43e4d86902f4e7e9, (v) => $2f47ca55cdb1d6b3$export$43e4d86902f4e7e9 = v);
$parcel$export(module.exports, "ucs4", () => $2f47ca55cdb1d6b3$export$1350116c6c9180d2, (v) => $2f47ca55cdb1d6b3$export$1350116c6c9180d2 = v);
// == UTF32-LE/BE codec. ==========================================================
var $2f47ca55cdb1d6b3$export$b2b6b8849c32811a;
var $2f47ca55cdb1d6b3$export$8ab18849c577cec0;
var $2f47ca55cdb1d6b3$export$197feba3617118ca;
// Aliases
var $2f47ca55cdb1d6b3$export$b3ab04f31ec3be1f;
var $2f47ca55cdb1d6b3$export$a8734ff2aa536306;
// == UTF-32 Auto codec =============================================================
// Decoder chooses automatically from UTF-32LE and UTF-32BE using BOM and space-based heuristic.
// Defaults to UTF-32LE. http://en.wikipedia.org/wiki/UTF-32
// Encoder/decoder default can be changed: iconv.decode(buf, 'utf32', {defaultEncoding: 'utf-32be'});
// Encoder prepends BOM (which can be overridden with (addBOM: false}).
var $2f47ca55cdb1d6b3$export$43e4d86902f4e7e9;
var $2f47ca55cdb1d6b3$export$1350116c6c9180d2;
"use strict";

var $aavGG = parcelRequire("aavGG");
var $2f47ca55cdb1d6b3$require$Buffer = $aavGG.Buffer;
$2f47ca55cdb1d6b3$export$b2b6b8849c32811a = $2f47ca55cdb1d6b3$var$Utf32Codec;
function $2f47ca55cdb1d6b3$var$Utf32Codec(codecOptions, iconv) {
    this.iconv = iconv;
    this.bomAware = true;
    this.isLE = codecOptions.isLE;
}
$2f47ca55cdb1d6b3$export$8ab18849c577cec0 = {
    type: "_utf32",
    isLE: true
};
$2f47ca55cdb1d6b3$export$197feba3617118ca = {
    type: "_utf32",
    isLE: false
};
$2f47ca55cdb1d6b3$export$b3ab04f31ec3be1f = "utf32le";
$2f47ca55cdb1d6b3$export$a8734ff2aa536306 = "utf32be";
$2f47ca55cdb1d6b3$var$Utf32Codec.prototype.encoder = $2f47ca55cdb1d6b3$var$Utf32Encoder;
$2f47ca55cdb1d6b3$var$Utf32Codec.prototype.decoder = $2f47ca55cdb1d6b3$var$Utf32Decoder;
// -- Encoding
function $2f47ca55cdb1d6b3$var$Utf32Encoder(options, codec) {
    this.isLE = codec.isLE;
    this.highSurrogate = 0;
}
$2f47ca55cdb1d6b3$var$Utf32Encoder.prototype.write = function(str) {
    var src = $2f47ca55cdb1d6b3$require$Buffer.from(str, "ucs2");
    var dst = $2f47ca55cdb1d6b3$require$Buffer.alloc(src.length * 2);
    var write32 = this.isLE ? dst.writeUInt32LE : dst.writeUInt32BE;
    var offset = 0;
    for(var i = 0; i < src.length; i += 2){
        var code = src.readUInt16LE(i);
        var isHighSurrogate = 0xD800 <= code && code < 0xDC00;
        var isLowSurrogate = 0xDC00 <= code && code < 0xE000;
        if (this.highSurrogate) {
            if (isHighSurrogate || !isLowSurrogate) {
                // There shouldn't be two high surrogates in a row, nor a high surrogate which isn't followed by a low
                // surrogate. If this happens, keep the pending high surrogate as a stand-alone semi-invalid character
                // (technically wrong, but expected by some applications, like Windows file names).
                write32.call(dst, this.highSurrogate, offset);
                offset += 4;
            } else {
                // Create 32-bit value from high and low surrogates;
                var codepoint = (this.highSurrogate - 0xD800 << 10 | code - 0xDC00) + 0x10000;
                write32.call(dst, codepoint, offset);
                offset += 4;
                this.highSurrogate = 0;
                continue;
            }
        }
        if (isHighSurrogate) this.highSurrogate = code;
        else {
            // Even if the current character is a low surrogate, with no previous high surrogate, we'll
            // encode it as a semi-invalid stand-alone character for the same reasons expressed above for
            // unpaired high surrogates.
            write32.call(dst, code, offset);
            offset += 4;
            this.highSurrogate = 0;
        }
    }
    if (offset < dst.length) dst = dst.slice(0, offset);
    return dst;
};
$2f47ca55cdb1d6b3$var$Utf32Encoder.prototype.end = function() {
    // Treat any leftover high surrogate as a semi-valid independent character.
    if (!this.highSurrogate) return;
    var buf = $2f47ca55cdb1d6b3$require$Buffer.alloc(4);
    if (this.isLE) buf.writeUInt32LE(this.highSurrogate, 0);
    else buf.writeUInt32BE(this.highSurrogate, 0);
    this.highSurrogate = 0;
    return buf;
};
// -- Decoding
function $2f47ca55cdb1d6b3$var$Utf32Decoder(options, codec) {
    this.isLE = codec.isLE;
    this.badChar = codec.iconv.defaultCharUnicode.charCodeAt(0);
    this.overflow = [];
}
$2f47ca55cdb1d6b3$var$Utf32Decoder.prototype.write = function(src) {
    if (src.length === 0) return "";
    var i = 0;
    var codepoint = 0;
    var dst = $2f47ca55cdb1d6b3$require$Buffer.alloc(src.length + 4);
    var offset = 0;
    var isLE = this.isLE;
    var overflow = this.overflow;
    var badChar = this.badChar;
    if (overflow.length > 0) {
        for(; i < src.length && overflow.length < 4; i++)overflow.push(src[i]);
        if (overflow.length === 4) {
            // NOTE: codepoint is a signed int32 and can be negative.
            // NOTE: We copied this block from below to help V8 optimize it (it works with array, not buffer).
            if (isLE) codepoint = overflow[i] | overflow[i + 1] << 8 | overflow[i + 2] << 16 | overflow[i + 3] << 24;
            else codepoint = overflow[i + 3] | overflow[i + 2] << 8 | overflow[i + 1] << 16 | overflow[i] << 24;
            overflow.length = 0;
            offset = $2f47ca55cdb1d6b3$var$_writeCodepoint(dst, offset, codepoint, badChar);
        }
    }
    // Main loop. Should be as optimized as possible.
    for(; i < src.length - 3; i += 4){
        // NOTE: codepoint is a signed int32 and can be negative.
        if (isLE) codepoint = src[i] | src[i + 1] << 8 | src[i + 2] << 16 | src[i + 3] << 24;
        else codepoint = src[i + 3] | src[i + 2] << 8 | src[i + 1] << 16 | src[i] << 24;
        offset = $2f47ca55cdb1d6b3$var$_writeCodepoint(dst, offset, codepoint, badChar);
    }
    // Keep overflowing bytes.
    for(; i < src.length; i++)overflow.push(src[i]);
    return dst.slice(0, offset).toString("ucs2");
};
function $2f47ca55cdb1d6b3$var$_writeCodepoint(dst, offset, codepoint, badChar) {
    // NOTE: codepoint is signed int32 and can be negative. We keep it that way to help V8 with optimizations.
    if (codepoint < 0 || codepoint > 0x10FFFF) // Not a valid Unicode codepoint
    codepoint = badChar;
    // Ephemeral Planes: Write high surrogate.
    if (codepoint >= 0x10000) {
        codepoint -= 0x10000;
        var high = 0xD800 | codepoint >> 10;
        dst[offset++] = high & 0xff;
        dst[offset++] = high >> 8;
        // Low surrogate is written below.
        var codepoint = 0xDC00 | codepoint & 0x3FF;
    }
    // Write BMP char or low surrogate.
    dst[offset++] = codepoint & 0xff;
    dst[offset++] = codepoint >> 8;
    return offset;
}
$2f47ca55cdb1d6b3$var$Utf32Decoder.prototype.end = function() {
    this.overflow.length = 0;
};
$2f47ca55cdb1d6b3$export$43e4d86902f4e7e9 = $2f47ca55cdb1d6b3$var$Utf32AutoCodec;
$2f47ca55cdb1d6b3$export$1350116c6c9180d2 = "utf32";
function $2f47ca55cdb1d6b3$var$Utf32AutoCodec(options, iconv) {
    this.iconv = iconv;
}
$2f47ca55cdb1d6b3$var$Utf32AutoCodec.prototype.encoder = $2f47ca55cdb1d6b3$var$Utf32AutoEncoder;
$2f47ca55cdb1d6b3$var$Utf32AutoCodec.prototype.decoder = $2f47ca55cdb1d6b3$var$Utf32AutoDecoder;
// -- Encoding
function $2f47ca55cdb1d6b3$var$Utf32AutoEncoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder(options.defaultEncoding || "utf-32le", options);
}
$2f47ca55cdb1d6b3$var$Utf32AutoEncoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$2f47ca55cdb1d6b3$var$Utf32AutoEncoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function $2f47ca55cdb1d6b3$var$Utf32AutoDecoder(options, codec) {
    this.decoder = null;
    this.initialBufs = [];
    this.initialBufsLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$2f47ca55cdb1d6b3$var$Utf32AutoDecoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBufs.push(buf);
        this.initialBufsLen += buf.length;
        if (this.initialBufsLen < 32) return "";
        // We have enough bytes -> detect endianness.
        var encoding = $2f47ca55cdb1d6b3$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.write(buf);
};
$2f47ca55cdb1d6b3$var$Utf32AutoDecoder.prototype.end = function() {
    if (!this.decoder) {
        var encoding = $2f47ca55cdb1d6b3$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        var trail = this.decoder.end();
        if (trail) resStr += trail;
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.end();
};
function $2f47ca55cdb1d6b3$var$detectEncoding(bufs, defaultEncoding) {
    var b = [];
    var charsProcessed = 0;
    var invalidLE = 0, invalidBE = 0; // Number of invalid chars when decoded as LE or BE.
    var bmpCharsLE = 0, bmpCharsBE = 0; // Number of BMP chars when decoded as LE or BE.
    outer_loop: for(var i = 0; i < bufs.length; i++){
        var buf = bufs[i];
        for(var j = 0; j < buf.length; j++){
            b.push(buf[j]);
            if (b.length === 4) {
                if (charsProcessed === 0) {
                    // Check BOM first.
                    if (b[0] === 0xFF && b[1] === 0xFE && b[2] === 0 && b[3] === 0) return "utf-32le";
                    if (b[0] === 0 && b[1] === 0 && b[2] === 0xFE && b[3] === 0xFF) return "utf-32be";
                }
                if (b[0] !== 0 || b[1] > 0x10) invalidBE++;
                if (b[3] !== 0 || b[2] > 0x10) invalidLE++;
                if (b[0] === 0 && b[1] === 0 && (b[2] !== 0 || b[3] !== 0)) bmpCharsBE++;
                if ((b[0] !== 0 || b[1] !== 0) && b[2] === 0 && b[3] === 0) bmpCharsLE++;
                b.length = 0;
                charsProcessed++;
                if (charsProcessed >= 100) break outer_loop;
            }
        }
    }
    // Make decisions.
    if (bmpCharsBE - invalidBE > bmpCharsLE - invalidLE) return "utf-32be";
    if (bmpCharsBE - invalidBE < bmpCharsLE - invalidLE) return "utf-32le";
    // Couldn't decide (likely all zeros or not enough data).
    return defaultEncoding || "utf-32le";
}

});

parcelRequire.register("eAz9i", function(module, exports) {

$parcel$export(module.exports, "utf16be", () => $a9efb14e5bcf7b32$export$8b9ec48b10867f55, (v) => $a9efb14e5bcf7b32$export$8b9ec48b10867f55 = v);
$parcel$export(module.exports, "utf16", () => $a9efb14e5bcf7b32$export$5e3087022f4331a5, (v) => $a9efb14e5bcf7b32$export$5e3087022f4331a5 = v);
// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
var $a9efb14e5bcf7b32$export$8b9ec48b10867f55;
// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
var $a9efb14e5bcf7b32$export$5e3087022f4331a5;
"use strict";

var $aavGG = parcelRequire("aavGG");
var $a9efb14e5bcf7b32$require$Buffer = $aavGG.Buffer;
$a9efb14e5bcf7b32$export$8b9ec48b10867f55 = $a9efb14e5bcf7b32$var$Utf16BECodec;
function $a9efb14e5bcf7b32$var$Utf16BECodec() {}
$a9efb14e5bcf7b32$var$Utf16BECodec.prototype.encoder = $a9efb14e5bcf7b32$var$Utf16BEEncoder;
$a9efb14e5bcf7b32$var$Utf16BECodec.prototype.decoder = $a9efb14e5bcf7b32$var$Utf16BEDecoder;
$a9efb14e5bcf7b32$var$Utf16BECodec.prototype.bomAware = true;
// -- Encoding
function $a9efb14e5bcf7b32$var$Utf16BEEncoder() {}
$a9efb14e5bcf7b32$var$Utf16BEEncoder.prototype.write = function(str) {
    var buf = $a9efb14e5bcf7b32$require$Buffer.from(str, "ucs2");
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
$a9efb14e5bcf7b32$var$Utf16BEEncoder.prototype.end = function() {};
// -- Decoding
function $a9efb14e5bcf7b32$var$Utf16BEDecoder() {
    this.overflowByte = -1;
}
$a9efb14e5bcf7b32$var$Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return "";
    var buf2 = $a9efb14e5bcf7b32$require$Buffer.alloc(buf.length + 1), i = 0, j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString("ucs2");
};
$a9efb14e5bcf7b32$var$Utf16BEDecoder.prototype.end = function() {
    this.overflowByte = -1;
};
$a9efb14e5bcf7b32$export$5e3087022f4331a5 = $a9efb14e5bcf7b32$var$Utf16Codec;
function $a9efb14e5bcf7b32$var$Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$a9efb14e5bcf7b32$var$Utf16Codec.prototype.encoder = $a9efb14e5bcf7b32$var$Utf16Encoder;
$a9efb14e5bcf7b32$var$Utf16Codec.prototype.decoder = $a9efb14e5bcf7b32$var$Utf16Decoder;
// -- Encoding (pass-through)
function $a9efb14e5bcf7b32$var$Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder("utf-16le", options);
}
$a9efb14e5bcf7b32$var$Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$a9efb14e5bcf7b32$var$Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function $a9efb14e5bcf7b32$var$Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBufs = [];
    this.initialBufsLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$a9efb14e5bcf7b32$var$Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBufs.push(buf);
        this.initialBufsLen += buf.length;
        if (this.initialBufsLen < 16) return "";
        // We have enough bytes -> detect endianness.
        var encoding = $a9efb14e5bcf7b32$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.write(buf);
};
$a9efb14e5bcf7b32$var$Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var encoding = $a9efb14e5bcf7b32$var$detectEncoding(this.initialBufs, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var resStr = "";
        for(var i = 0; i < this.initialBufs.length; i++)resStr += this.decoder.write(this.initialBufs[i]);
        var trail = this.decoder.end();
        if (trail) resStr += trail;
        this.initialBufs.length = this.initialBufsLen = 0;
        return resStr;
    }
    return this.decoder.end();
};
function $a9efb14e5bcf7b32$var$detectEncoding(bufs, defaultEncoding) {
    var b = [];
    var charsProcessed = 0;
    var asciiCharsLE = 0, asciiCharsBE = 0; // Number of ASCII chars when decoded as LE or BE.
    outer_loop: for(var i = 0; i < bufs.length; i++){
        var buf = bufs[i];
        for(var j = 0; j < buf.length; j++){
            b.push(buf[j]);
            if (b.length === 2) {
                if (charsProcessed === 0) {
                    // Check BOM first.
                    if (b[0] === 0xFF && b[1] === 0xFE) return "utf-16le";
                    if (b[0] === 0xFE && b[1] === 0xFF) return "utf-16be";
                }
                if (b[0] === 0 && b[1] !== 0) asciiCharsBE++;
                if (b[0] !== 0 && b[1] === 0) asciiCharsLE++;
                b.length = 0;
                charsProcessed++;
                if (charsProcessed >= 100) break outer_loop;
            }
        }
    }
    // Make decisions.
    // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
    // So, we count ASCII as if it was LE or BE, and decide from that.
    if (asciiCharsBE > asciiCharsLE) return "utf-16be";
    if (asciiCharsBE < asciiCharsLE) return "utf-16le";
    // Couldn't decide (likely all zeros or not enough data).
    return defaultEncoding || "utf-16le";
}

});

parcelRequire.register("cah8e", function(module, exports) {

$parcel$export(module.exports, "utf7", () => $8db3b53c7ba0d7f6$export$b2f9c8661b81cf99, (v) => $8db3b53c7ba0d7f6$export$b2f9c8661b81cf99 = v);
$parcel$export(module.exports, "unicode11utf7", () => $8db3b53c7ba0d7f6$export$cc49de5f94fc4004, (v) => $8db3b53c7ba0d7f6$export$cc49de5f94fc4004 = v);
$parcel$export(module.exports, "utf7imap", () => $8db3b53c7ba0d7f6$export$2488b28744623c18, (v) => $8db3b53c7ba0d7f6$export$2488b28744623c18 = v);
// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
var $8db3b53c7ba0d7f6$export$b2f9c8661b81cf99;
var $8db3b53c7ba0d7f6$export$cc49de5f94fc4004;
// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
var $8db3b53c7ba0d7f6$export$2488b28744623c18;
"use strict";

var $aavGG = parcelRequire("aavGG");
var $8db3b53c7ba0d7f6$require$Buffer = $aavGG.Buffer;
$8db3b53c7ba0d7f6$export$b2f9c8661b81cf99 = $8db3b53c7ba0d7f6$var$Utf7Codec;
$8db3b53c7ba0d7f6$export$cc49de5f94fc4004 = "utf7"; // Alias UNICODE-1-1-UTF-7
function $8db3b53c7ba0d7f6$var$Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$8db3b53c7ba0d7f6$var$Utf7Codec.prototype.encoder = $8db3b53c7ba0d7f6$var$Utf7Encoder;
$8db3b53c7ba0d7f6$var$Utf7Codec.prototype.decoder = $8db3b53c7ba0d7f6$var$Utf7Decoder;
$8db3b53c7ba0d7f6$var$Utf7Codec.prototype.bomAware = true;
// -- Encoding
var $8db3b53c7ba0d7f6$var$nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function $8db3b53c7ba0d7f6$var$Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
$8db3b53c7ba0d7f6$var$Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return $8db3b53c7ba0d7f6$require$Buffer.from(str.replace($8db3b53c7ba0d7f6$var$nonDirectChars, (function(chunk) {
        return "+" + (chunk === "+" ? "" : this.iconv.encode(chunk, "utf16-be").toString("base64").replace(/=+$/, "")) + "-";
    }).bind(this)));
};
$8db3b53c7ba0d7f6$var$Utf7Encoder.prototype.end = function() {};
// -- Decoding
function $8db3b53c7ba0d7f6$var$Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = "";
}
var $8db3b53c7ba0d7f6$var$base64Regex = /[A-Za-z0-9\/+]/;
var $8db3b53c7ba0d7f6$var$base64Chars = [];
for(var $8db3b53c7ba0d7f6$var$i = 0; $8db3b53c7ba0d7f6$var$i < 256; $8db3b53c7ba0d7f6$var$i++)$8db3b53c7ba0d7f6$var$base64Chars[$8db3b53c7ba0d7f6$var$i] = $8db3b53c7ba0d7f6$var$base64Regex.test(String.fromCharCode($8db3b53c7ba0d7f6$var$i));
var $8db3b53c7ba0d7f6$var$plusChar = "+".charCodeAt(0), $8db3b53c7ba0d7f6$var$minusChar = "-".charCodeAt(0), $8db3b53c7ba0d7f6$var$andChar = "&".charCodeAt(0);
$8db3b53c7ba0d7f6$var$Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '+'
        {
            if (buf[i] == $8db3b53c7ba0d7f6$var$plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!$8db3b53c7ba0d7f6$var$base64Chars[buf[i]]) {
            if (i == lastI && buf[i] == $8db3b53c7ba0d7f6$var$minusChar) res += "+";
            else {
                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii");
                res += this.iconv.decode($8db3b53c7ba0d7f6$require$Buffer.from(b64str, "base64"), "utf16-be");
            }
            if (buf[i] != $8db3b53c7ba0d7f6$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = "";
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii");
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($8db3b53c7ba0d7f6$require$Buffer.from(b64str, "base64"), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$8db3b53c7ba0d7f6$var$Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($8db3b53c7ba0d7f6$require$Buffer.from(this.base64Accum, "base64"), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = "";
    return res;
};
$8db3b53c7ba0d7f6$export$2488b28744623c18 = $8db3b53c7ba0d7f6$var$Utf7IMAPCodec;
function $8db3b53c7ba0d7f6$var$Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
$8db3b53c7ba0d7f6$var$Utf7IMAPCodec.prototype.encoder = $8db3b53c7ba0d7f6$var$Utf7IMAPEncoder;
$8db3b53c7ba0d7f6$var$Utf7IMAPCodec.prototype.decoder = $8db3b53c7ba0d7f6$var$Utf7IMAPDecoder;
$8db3b53c7ba0d7f6$var$Utf7IMAPCodec.prototype.bomAware = true;
// -- Encoding
function $8db3b53c7ba0d7f6$var$Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = $8db3b53c7ba0d7f6$require$Buffer.alloc(6);
    this.base64AccumIdx = 0;
}
$8db3b53c7ba0d7f6$var$Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = $8db3b53c7ba0d7f6$require$Buffer.alloc(str.length * 5 + 10), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) {
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = $8db3b53c7ba0d7f6$var$minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character
                if (uChar === $8db3b53c7ba0d7f6$var$andChar) buf[bufIdx++] = $8db3b53c7ba0d7f6$var$minusChar;
            }
        } else {
            if (!inBase64) {
                buf[bufIdx++] = $8db3b53c7ba0d7f6$var$andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString("base64").replace(/\//g, ","), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
$8db3b53c7ba0d7f6$var$Utf7IMAPEncoder.prototype.end = function() {
    var buf = $8db3b53c7ba0d7f6$require$Buffer.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString("base64").replace(/\//g, ",").replace(/=+$/, ""), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = $8db3b53c7ba0d7f6$var$minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
};
// -- Decoding
function $8db3b53c7ba0d7f6$var$Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = "";
}
var $8db3b53c7ba0d7f6$var$base64IMAPChars = $8db3b53c7ba0d7f6$var$base64Chars.slice();
$8db3b53c7ba0d7f6$var$base64IMAPChars[",".charCodeAt(0)] = true;
$8db3b53c7ba0d7f6$var$Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '&'
        {
            if (buf[i] == $8db3b53c7ba0d7f6$var$andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!$8db3b53c7ba0d7f6$var$base64IMAPChars[buf[i]]) {
            if (i == lastI && buf[i] == $8db3b53c7ba0d7f6$var$minusChar) res += "&";
            else {
                var b64str = base64Accum + this.iconv.decode(buf.slice(lastI, i), "ascii").replace(/,/g, "/");
                res += this.iconv.decode($8db3b53c7ba0d7f6$require$Buffer.from(b64str, "base64"), "utf16-be");
            }
            if (buf[i] != $8db3b53c7ba0d7f6$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = "";
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + this.iconv.decode(buf.slice(lastI), "ascii").replace(/,/g, "/");
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($8db3b53c7ba0d7f6$require$Buffer.from(b64str, "base64"), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$8db3b53c7ba0d7f6$var$Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($8db3b53c7ba0d7f6$require$Buffer.from(this.base64Accum, "base64"), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = "";
    return res;
};

});

parcelRequire.register("gm860", function(module, exports) {

$parcel$export(module.exports, "_sbcs", () => $be84fb11fb24f326$export$90ce6c201c0ff1a9, (v) => $be84fb11fb24f326$export$90ce6c201c0ff1a9 = v);
// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 
var $be84fb11fb24f326$export$90ce6c201c0ff1a9;
"use strict";

var $aavGG = parcelRequire("aavGG");
var $be84fb11fb24f326$require$Buffer = $aavGG.Buffer;
$be84fb11fb24f326$export$90ce6c201c0ff1a9 = $be84fb11fb24f326$var$SBCSCodec;
function $be84fb11fb24f326$var$SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = $be84fb11fb24f326$require$Buffer.from(codecOptions.chars, "ucs2");
    // Encoding buffer.
    var encodeBuf = $be84fb11fb24f326$require$Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
$be84fb11fb24f326$var$SBCSCodec.prototype.encoder = $be84fb11fb24f326$var$SBCSEncoder;
$be84fb11fb24f326$var$SBCSCodec.prototype.decoder = $be84fb11fb24f326$var$SBCSDecoder;
function $be84fb11fb24f326$var$SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
$be84fb11fb24f326$var$SBCSEncoder.prototype.write = function(str) {
    var buf = $be84fb11fb24f326$require$Buffer.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
$be84fb11fb24f326$var$SBCSEncoder.prototype.end = function() {};
function $be84fb11fb24f326$var$SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
$be84fb11fb24f326$var$SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = $be84fb11fb24f326$require$Buffer.alloc(buf.length * 2);
    var idx1 = 0, idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString("ucs2");
};
$be84fb11fb24f326$var$SBCSDecoder.prototype.end = function() {};

});

parcelRequire.register("akvJq", function(module, exports) {
"use strict";
// Manually added data to be used by sbcs codec in addition to generated one.
module.exports = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "\xc4Āā\xc9Ą\xd6\xdc\xe1ąČ\xe4čĆć\xe9ŹźĎ\xedďĒēĖ\xf3ė\xf4\xf6\xf5\xfaĚě\xfc†\xb0Ę\xa3\xa7•\xb6\xdf\xae\xa9™ę\xa8≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ\xac√ńŇ∆\xab\xbb…\xa0ňŐ\xd5őŌ–—“”‘’\xf7◊ōŔŕŘ‹›řŖŗŠ‚„šŚś\xc1Ťť\xcdŽžŪ\xd3\xd4ūŮ\xdaůŰűŲų\xdd\xfdķŻŁżĢˇ"
    },
    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў\xb0∙\xb7√№€■\xa0"
    },
    "mik": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№\xa7╗╝┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "cp720": {
        "type": "_sbcs",
        "chars": "\x80\x81\xe9\xe2\x84\xe0\x86\xe7\xea\xeb\xe8\xef\xee\x8d\x8e\x8f\x90ّْ\xf4\xa4ـ\xfb\xf9ءآأؤ\xa3إئابةتثجحخدذرزسشص\xab\xbb░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ضطظعغف\xb5قكلمنهوىي≡ًٌٍَُِ≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",
    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",
    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek": "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",
    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",
    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",
    "cp819": "iso88591",
    "ibm819": "iso88591",
    "cyrillic": "iso88595",
    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",
    "greek": "iso88597",
    "greek8": "iso88597",
    "ecma118": "iso88597",
    "elot928": "iso88597",
    "hebrew": "iso88598",
    "hebrew8": "iso88598",
    "turkish": "iso88599",
    "turkish8": "iso88599",
    "thai": "iso885911",
    "thai8": "iso885911",
    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",
    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",
    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",
    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",
    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",
    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",
    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",
    "strk10482002": "rk1048",
    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",
    "gb198880": "iso646cn",
    "cn": "iso646cn",
    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",
    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",
    "mac": "macintosh",
    "csmacintosh": "macintosh"
};

});

parcelRequire.register("eThsZ", function(module, exports) {
"use strict";
// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "€����…�����������‘’“”•–—��������\xa0กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź\xa0ˇ˘Ł\xa4Ą\xa6\xa7\xa8\xa9Ş\xab\xac\xad\xaeŻ\xb0\xb1˛ł\xb4\xb5\xb6\xb7\xb8ąş\xbbĽ˝ľżŔ\xc1\xc2Ă\xc4ĹĆ\xc7Č\xc9Ę\xcbĚ\xcd\xceĎĐŃŇ\xd3\xd4Ő\xd6\xd7ŘŮ\xdaŰ\xdc\xddŢ\xdfŕ\xe1\xe2ă\xe4ĺć\xe7č\xe9ę\xebě\xed\xeeďđńň\xf3\xf4ő\xf6\xf7řů\xfaű\xfc\xfdţ˙"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ\xa0ЎўЈ\xa4Ґ\xa6\xa7Ё\xa9Є\xab\xac\xad\xaeЇ\xb0\xb1Ііґ\xb5\xb6\xb7ё№є\xbbјЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›����\xa0΅Ά\xa3\xa4\xa5\xa6\xa7\xa8\xa9�\xab\xac\xad\xae―\xb0\xb1\xb2\xb3΄\xb5\xb6\xb7ΈΉΊ\xbbΌ\xbdΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcfĞ\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdcİŞ\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xefğ\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfcış\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›����\xa0\xa1\xa2\xa3₪\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbfְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں\xa0،\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9ھ\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9؛\xbb\xbc\xbd\xbe؟ہءآأؤإئابةتثجحخدذرزسشصض\xd7طظعغـفقك\xe0ل\xe2منهو\xe7\xe8\xe9\xea\xebىي\xee\xefًٌٍَ\xf4ُِ\xf7ّ\xf9ْ\xfb\xfc‎‏ے"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "€�‚�„…†‡�‰�‹�\xa8ˇ\xb8�‘’“”•–—�™�›�\xaf˛�\xa0�\xa2\xa3\xa4�\xa6\xa7\xd8\xa9Ŗ\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9ŗ\xbb\xbc\xbd\xbe\xe6ĄĮĀĆ\xc4\xc5ĘĒČ\xc9ŹĖĢĶĪĻŠŃŅ\xd3Ō\xd5\xd6\xd7ŲŁŚŪ\xdcŻŽ\xdfąįāć\xe4\xe5ęēč\xe9źėģķīļšńņ\xf3ō\xf5\xf6\xf7ųłśū\xfcżž˙"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2Ă\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb̀\xcd\xce\xcfĐ\xd1̉\xd3\xd4Ơ\xd6\xd7\xd8\xd9\xda\xdb\xdcỮ\xdf\xe0\xe1\xe2ă\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb́\xed\xee\xefđ\xf1̣\xf3\xf4ơ\xf6\xf7\xf8\xf9\xfa\xfb\xfcư₫\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0Ą˘Ł\xa4ĽŚ\xa7\xa8ŠŞŤŹ\xadŽŻ\xb0ą˛ł\xb4ľśˇ\xb8šşťź˝žżŔ\xc1\xc2Ă\xc4ĹĆ\xc7Č\xc9Ę\xcbĚ\xcd\xceĎĐŃŇ\xd3\xd4Ő\xd6\xd7ŘŮ\xdaŰ\xdc\xddŢ\xdfŕ\xe1\xe2ă\xe4ĺć\xe7č\xe9ę\xebě\xed\xeeďđńň\xf3\xf4ő\xf6\xf7řů\xfaű\xfc\xfdţ˙"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0Ħ˘\xa3\xa4�Ĥ\xa7\xa8İŞĞĴ\xad�Ż\xb0ħ\xb2\xb3\xb4\xb5ĥ\xb7\xb8ışğĵ\xbd�ż\xc0\xc1\xc2�\xc4ĊĈ\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf�\xd1\xd2\xd3\xd4Ġ\xd6\xd7Ĝ\xd9\xda\xdb\xdcŬŜ\xdf\xe0\xe1\xe2�\xe4ċĉ\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef�\xf1\xf2\xf3\xf4ġ\xf6\xf7ĝ\xf9\xfa\xfb\xfcŭŝ˙"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0ĄĸŖ\xa4ĨĻ\xa7\xa8ŠĒĢŦ\xadŽ\xaf\xb0ą˛ŗ\xb4ĩļˇ\xb8šēģŧŊžŋĀ\xc1\xc2\xc3\xc4\xc5\xc6ĮČ\xc9Ę\xcbĖ\xcd\xceĪĐŅŌĶ\xd4\xd5\xd6\xd7\xd8Ų\xda\xdb\xdcŨŪ\xdfā\xe1\xe2\xe3\xe4\xe5\xe6įč\xe9ę\xebė\xed\xeeīđņōķ\xf4\xf5\xf6\xf7\xf8ų\xfa\xfb\xfcũū˙"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0ЁЂЃЄЅІЇЈЉЊЋЌ\xadЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ\xa7ўџ"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0���\xa4�������،\xad�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0‘’\xa3€₯\xa6\xa7\xa8\xa9ͺ\xab\xac\xad�―\xb0\xb1\xb2\xb3΄΅Ά\xb7ΈΉΊ\xbbΌ\xbdΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0�\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcfĞ\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdcİŞ\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xefğ\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfcış\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0ĄĒĢĪĨĶ\xa7ĻĐŠŦŽ\xadŪŊ\xb0ąēģīĩķ\xb7ļđšŧž―ūŋĀ\xc1\xc2\xc3\xc4\xc5\xc6ĮČ\xc9Ę\xcbĖ\xcd\xce\xcf\xd0ŅŌ\xd3\xd4\xd5\xd6Ũ\xd8Ų\xda\xdb\xdc\xdd\xde\xdfā\xe1\xe2\xe3\xe4\xe5\xe6įč\xe9ę\xebė\xed\xee\xef\xf0ņō\xf3\xf4\xf5\xf6ũ\xf8ų\xfa\xfb\xfc\xfd\xfeĸ"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0”\xa2\xa3\xa4„\xa6\xa7\xd8\xa9Ŗ\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3“\xb5\xb6\xb7\xf8\xb9ŗ\xbb\xbc\xbd\xbe\xe6ĄĮĀĆ\xc4\xc5ĘĒČ\xc9ŹĖĢĶĪĻŠŃŅ\xd3Ō\xd5\xd6\xd7ŲŁŚŪ\xdcŻŽ\xdfąįāć\xe4\xe5ęēč\xe9źėģķīļšńņ\xf3ō\xf5\xf6\xf7ųłśū\xfcżž’"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0Ḃḃ\xa3ĊċḊ\xa7Ẁ\xa9ẂḋỲ\xad\xaeŸḞḟĠġṀṁ\xb6ṖẁṗẃṠỳẄẅṡ\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcfŴ\xd1\xd2\xd3\xd4\xd5\xd6Ṫ\xd8\xd9\xda\xdb\xdc\xddŶ\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xefŵ\xf1\xf2\xf3\xf4\xf5\xf6ṫ\xf8\xf9\xfa\xfb\xfc\xfdŷ\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3€\xa5Š\xa7š\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3Ž\xb5\xb6\xb7ž\xb9\xba\xbbŒœŸ\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0ĄąŁ€„Š\xa7š\xa9Ș\xabŹ\xadźŻ\xb0\xb1ČłŽ”\xb6\xb7žčș\xbbŒœŸż\xc0\xc1\xc2Ă\xc4Ć\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcfĐŃ\xd2\xd3\xd4Ő\xd6ŚŰ\xd9\xda\xdb\xdcĘȚ\xdf\xe0\xe1\xe2ă\xe4ć\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xefđń\xf2\xf3\xf4ő\xf6śű\xf9\xfa\xfb\xfcęț\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5₧ƒ\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf⌐\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ\xb1≥≤ΪΫ\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "Ć\xfc\xe9ā\xe4ģ\xe5ćłēŖŗīŹ\xc4\xc5\xc9\xe6\xc6ō\xf6Ģ\xa2Śś\xd6\xdc\xf8\xa3\xd8\xd7\xa4ĀĪ\xf3Żżź”\xa6\xa9\xae\xac\xbd\xbcŁ\xab\xbb░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀\xd3\xdfŌŃ\xf5\xd5\xb5ńĶķĻļņĒŅ’\xad\xb1“\xbe\xb6\xa7\xf7„\xb0∙\xb7\xb9\xb3\xb2■\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7ƒ\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤\xc1\xc2\xc0\xa9╣║╗╝\xa2\xa5┐└┴┬├─┼\xe3\xc3╚╔╩╦╠═╬\xa4\xf0\xd0\xca\xcb\xc8ı\xcd\xce\xcf┘┌█▄\xa6\xcc▀\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1‗\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2■\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4ůć\xe7ł\xebŐő\xeeŹ\xc4Ć\xc9Ĺĺ\xf4\xf6ĽľŚś\xd6\xdcŤťŁ\xd7č\xe1\xed\xf3\xfaĄąŽžĘę\xacźČş\xab\xbb░▒▓│┤\xc1\xc2ĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬\xa4đĐĎ\xcbďŇ\xcd\xceě┘┌█▄ŢŮ▀\xd3\xdf\xd4ŃńňŠšŔ\xdaŕŰ\xfd\xddţ\xb4\xad˝˛ˇ˘\xa7\xf7\xb8\xb0\xa8˙űŘř■\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ\xab\xbb░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬\xa4лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№\xadыЫзЗшШэЭщЩчЧ\xa7■\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�\xa3�\xd7����������\xae\xac\xbd\xbc�\xab\xbb░▒▓│┤���\xa9╣║╗╝\xa2\xa5┐└┴┬├─┼��╚╔╩╦╠═╬\xa4���������┘┌█▄\xa6�▀������\xb5�������\xaf\xb4\xad\xb1‗\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2■\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xeeı\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9İ\xd6\xdc\xf8\xa3\xd8Şş\xe1\xed\xf3\xfa\xf1\xd1Ğğ\xbf\xae\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤\xc1\xc2\xc0\xa9╣║╗╝\xa2\xa5┐└┴┬├─┼\xe3\xc3╚╔╩╦╠═╬\xa4\xba\xaa\xca\xcb\xc8�\xcd\xce\xcf┘┌█▄\xa6\xcc▀\xd3\xdf\xd4\xd2\xf5\xd5\xb5�\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1�\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2■\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7ƒ\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤\xc1\xc2\xc0\xa9╣║╗╝\xa2\xa5┐└┴┬├─┼\xe3\xc3╚╔╩╦╠═╬\xa4\xf0\xd0\xca\xcb\xc8€\xcd\xce\xcf┘┌█▄\xa6\xcc▀\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1‗\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2■\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9₧\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8₧ƒ\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf⌐\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת\xa2\xa3\xa5₧ƒ\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf⌐\xac\xbd\xbc\xa1\xab\xbb░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee‗\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdbƒ\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce⌐\xac\xbd\xbc\xbe\xab\xbb░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7∙√▒─│┼┤┬├┴┐┌└┘β∞φ\xb1\xbd\xbc≈\xab\xbbﻷﻸ��ﻻﻼ�\xa0\xadﺂ\xa3\xa4ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟\xa2ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ\xa6\xac\xf7\xd7ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8₧ƒ\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf⌐\xac\xbd\xbc\xa1\xab\xa4░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀α\xdfΓπΣσ\xb5τΦΘΩδ∞φε∩≡\xb1≥≤⌠⌡\xf7≈\xb0∙\xb7√ⁿ\xb2■\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў\xb0∙\xb7√№\xa4■\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "������Ά�\xb7\xac\xa6‘’Έ―ΉΊΪΌ��ΎΫ\xa9Ώ\xb2\xb3ά\xa3έήίϊΐόύΑΒΓΔΕΖΗ\xbdΘΙ\xab\xbb░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄\xad\xb1υφχ\xa7ψ΅\xb0\xa8ωϋΰώ■\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae‾\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcfŠ\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xddŽ\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xefš\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfdž\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "ﺈ\xd7\xf7ﹱ\x88■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ\xa0\xa4ﺋﺑﺗﺛﺟﺣ،\xadﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0ЁЂҐЄЅІЇЈЉЊЋЌ\xadЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ\xa7ўџ"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї\xb7√№\xa4■\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7œ\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3Ÿ\xb5\xb6\xb7Œ\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2Ă\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb̀\xcd\xce\xcfĐ\xd1̉\xd3\xd4Ơ\xd6\xd7\xd8\xd9\xda\xdb\xdcỮ\xdf\xe0\xe1\xe2ă\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb́\xed\xee\xefđ\xf1̣\xf3\xf4ơ\xf6\xf7\xf8\xf9\xfa\xfb\xfcư₫\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��\xa2\xac\xa6�"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "€\x81\x82\x83\x84…\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90‘’“”•–—\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3€\xa5\xa6\xa7œ\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3Ÿ\xb5\xb6\xb7Œ\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2Ă\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb̀\xcd\xce\xcfĐ\xd1̉\xd3\xd4Ơ\xd6\xd7\xd8\xd9\xda\xdb\xdcỮ\xdf\xe0\xe1\xe2ă\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb́\xed\xee\xefđ\xf1̣\xf3\xf4ơ\xf6\xf7\xf8\xf9\xfa\xfb\xfcư₫\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc†\xb0\xa2\xa3\xa7•\xb6\xdf\xaeŠ™\xb4\xa8≠Ž\xd8∞\xb1≤≥∆\xb5∂∑∏š∫\xaa\xbaΩž\xf8\xbf\xa1\xac√ƒ≈Ć\xabČ…\xa0\xc0\xc3\xd5ŒœĐ—“”‘’\xf7◊�\xa9⁄\xa4‹›\xc6\xbb–\xb7‚„‰\xc2ć\xc1č\xc8\xcd\xce\xcf\xcc\xd3\xd4đ\xd2\xda\xdb\xd9ıˆ˜\xafπ\xcb˚\xb8\xca\xe6ˇ"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†\xb0\xa2\xa3\xa7•\xb6І\xae\xa9™Ђђ≠Ѓѓ∞\xb1≤≥і\xb5∂ЈЄєЇїЉљЊњјЅ\xac√ƒ≈∆\xab\xbb…\xa0ЋћЌќѕ–—“”‘’\xf7„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc΅\xe0\xe2\xe4΄\xa8\xe7\xe9\xe8\xea\xeb\xa3™\xee\xef•\xbd‰\xf4\xf6\xa6\xad\xf9\xfb\xfc†ΓΔΘΛΞΠ\xdf\xae\xa9ΣΪ\xa7≠\xb0·Α\xb1≤≥\xa5ΒΕΖΗΙΚΜΦΫΨΩάΝ\xacΟΡ≈Τ\xab\xbb…\xa0ΥΧΆΈœ–―“”‘’\xf7ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7•\xb6\xdf\xae\xa9™\xb4\xa8≠\xc6\xd8∞\xb1≤≥\xa5\xb5∂∑∏π∫\xaa\xbaΩ\xe6\xf8\xbf\xa1\xac√ƒ≈∆\xab\xbb…\xa0\xc0\xc3\xd5Œœ–—“”‘’\xf7◊\xffŸ⁄\xa4\xd0\xf0\xde\xfe\xfd\xb7‚„‰\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4�\xd2\xda\xdb\xd9ıˆ˜\xaf˘˙˚\xb8˝˛ˇ"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc†\xb0\xa2\xa3\xa7•\xb6\xdf\xae\xa9™\xb4\xa8≠\xc6\xd8∞\xb1≤≥\xa5\xb5∂∑∏π∫\xaa\xbaΩ\xe6\xf8\xbf\xa1\xac√ƒ≈∆\xab\xbb…\xa0\xc0\xc3\xd5Œœ–—“”‘’\xf7◊\xffŸ⁄\xa4‹›ﬁﬂ‡\xb7‚„‰\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4�\xd2\xda\xdb\xd9ıˆ˜\xaf˘˙˚\xb8˝˛ˇ"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc†\xb0\xa2\xa3\xa7•\xb6\xdf\xae\xa9™\xb4\xa8≠ĂŞ∞\xb1≤≥\xa5\xb5∂∑∏π∫\xaa\xbaΩăş\xbf\xa1\xac√ƒ≈∆\xab\xbb…\xa0\xc0\xc3\xd5Œœ–—“”‘’\xf7◊\xffŸ⁄\xa4‹›Ţţ‡\xb7‚„‰\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4�\xd2\xda\xdb\xd9ıˆ˜\xaf˘˙˚\xb8˝˛ˇ"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb…“”�•‘’�\xa0กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู\uFEFF​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙\xae\xa9����"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc†\xb0\xa2\xa3\xa7•\xb6\xdf\xae\xa9™\xb4\xa8≠\xc6\xd8∞\xb1≤≥\xa5\xb5∂∑∏π∫\xaa\xbaΩ\xe6\xf8\xbf\xa1\xac√ƒ≈∆\xab\xbb…\xa0\xc0\xc3\xd5Œœ–—“”‘’\xf7◊\xffŸĞğİıŞş‡\xb7‚„‰\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4�\xd2\xda\xdb\xd9�ˆ˜\xaf˘˙˚\xb8˝˛ˇ"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†\xb0Ґ\xa3\xa7•\xb6І\xae\xa9™Ђђ≠Ѓѓ∞\xb1≤≥і\xb5ґЈЄєЇїЉљЊњјЅ\xac√ƒ≈∆\xab\xbb…\xa0ЋћЌќѕ–—“”‘’\xf7„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥\xa0⌡\xb0\xb2\xb7\xf7═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬\xa9юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥\xa0⌡\xb0\xb2\xb7\xf7═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬\xa9юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥\xa0⌡\xb0\xb2\xb7\xf7═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ\xa9юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё\xa4ӣ\xa6\xa7���\xab\xac\xad\xae�\xb0\xb1\xb2Ё�Ӣ\xb6\xb7�№�\xbb���\xa9юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0�և։)(\xbb\xab—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ\xa0ҰұӘ\xa4Ө\xa6\xa7Ё\xa9Ғ\xab\xac\xad\xaeҮ\xb0\xb1Ііө\xb5\xb6\xb7ё№ғ\xbbәҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\x00\xdaỤ\x03ỪỬỮ\x07\b	\n\v\f\r\x0e\x0f\x10ỨỰỲỶỸ\xddỴ\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0Ả\xc3\xc1ẠẶẬ\xc8ẺẼ\xc9ẸỆ\xccỈĨ\xcdỊ\xd2Ỏ\xd5\xd3ỌỘỜỞỠỚỢ\xd9ỦŨ\xa0Ă\xc2\xca\xd4ƠƯĐă\xe2\xea\xf4ơưđẶ̀̀̉̃́\xe0ả\xe3\xe1ạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậ\xe8Ểẻẽ\xe9ẹềểễếệ\xecỉỄẾỒĩ\xedị\xf2Ổỏ\xf5\xf3ọồổỗốộờởỡớợ\xf9Ỗủũ\xfaụừửữứựỳỷỹ\xfdỵỐ"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81‚ƒ„…†‡ˆ‰Š‹Œ\x8d\x8e\x8f\x90‘’“”•–—˜™š›œ\x9d\x9eŸ\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbfაბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶ\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81‚ƒ„…†‡ˆ‰Š‹Œ\x8d\x8e\x8f\x90‘’“”•–—˜™š›œ\x9d\x9eŸ\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbfაბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵ\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ\xa0ЎўЈӨҘҰ\xa7Ё\xa9Ә\xab\xacӯ\xaeҜ\xb0ұІіҙө\xb6\xb7ё№ә\xbbјҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\x00\x01Ẳ\x03\x04ẴẪ\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13Ỷ\x15\x16\x17\x18Ỹ\x1a\x1b\x1c\x1dỴ\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7fẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲ\xd5ắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯ\xc0\xc1\xc2\xc3ẢĂẳẵ\xc8\xc9\xcaẺ\xcc\xcdĨỳĐứ\xd2\xd3\xd4ạỷừử\xd9\xdaỹỵ\xddỡư\xe0\xe1\xe2\xe3ảăữẫ\xe8\xe9\xeaẻ\xec\xedĩỉđự\xf2\xf3\xf4\xf5ỏọụ\xf9\xfaũủ\xfdợỮ"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾\x7f��������������������������������������������������������������������������������������������������������������������������������"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\x00\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}‾\x7f��������������������������������������������������������������������������������������������������������������������������������"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4ˋˆ\xa8˜\xd9\xdb₤\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7ƒ\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5Šš\xdaŸ\xff\xde\xfe\xb7\xb5\xb6\xbe—\xbc\xbd\xaa\xba\xab■\xbb\xb1�"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc†\xb0\xa2\xa3\xa7•\xb6\xdf\xae\xa9™\xb4\xa8≠\xc6\xd8∞\xb1≤≥\xa5\xb5∂∑∏π∫\xaa\xbaΩ\xe6\xf8\xbf\xa1\xac√ƒ≈∆\xab\xbb…\xa0\xc0\xc3\xd5Œœ–—“”‘’\xf7◊\xffŸ⁄\xa4‹›ﬁﬂ‡\xb7‚„‰\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4�\xd2\xda\xdb\xd9ıˆ˜\xaf˘˙˚\xb8˝˛ˇ"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "��������������������������������������������������������������������������������������������������������������������������������"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
    }
};

});

parcelRequire.register("kkSTP", function(module, exports) {

$parcel$export(module.exports, "_dbcs", () => $ece042c973d04c6f$export$d4d33b1e1c7abf2e, (v) => $ece042c973d04c6f$export$d4d33b1e1c7abf2e = v);
// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
var $ece042c973d04c6f$export$d4d33b1e1c7abf2e;
"use strict";

var $aavGG = parcelRequire("aavGG");
var $ece042c973d04c6f$require$Buffer = $aavGG.Buffer;
$ece042c973d04c6f$export$d4d33b1e1c7abf2e = $ece042c973d04c6f$var$DBCSCodec;
var $ece042c973d04c6f$var$UNASSIGNED = -1, $ece042c973d04c6f$var$GB18030_CODE = -2, $ece042c973d04c6f$var$SEQ_START = -10, $ece042c973d04c6f$var$NODE_START = -1000, $ece042c973d04c6f$var$UNASSIGNED_NODE = new Array(0x100), $ece042c973d04c6f$var$DEF_CHAR = -1;
for(var $ece042c973d04c6f$var$i = 0; $ece042c973d04c6f$var$i < 0x100; $ece042c973d04c6f$var$i++)$ece042c973d04c6f$var$UNASSIGNED_NODE[$ece042c973d04c6f$var$i] = $ece042c973d04c6f$var$UNASSIGNED;
// Class DBCSCodec reads and initializes mapping tables.
function $ece042c973d04c6f$var$DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
    // Load tables.
    var mappingTable = codecOptions.table();
    // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = $ece042c973d04c6f$var$UNASSIGNED_NODE.slice(0); // Create root node.
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = [];
    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === "function") {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
        // Add GB18030 common decode nodes.
        var commonThirdByteNodeIdx = this.decodeTables.length;
        this.decodeTables.push($ece042c973d04c6f$var$UNASSIGNED_NODE.slice(0));
        var commonFourthByteNodeIdx = this.decodeTables.length;
        this.decodeTables.push($ece042c973d04c6f$var$UNASSIGNED_NODE.slice(0));
        // Fill out the tree
        var firstByteNode = this.decodeTables[0];
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNode = this.decodeTables[$ece042c973d04c6f$var$NODE_START - firstByteNode[i]];
            for(var j = 0x30; j <= 0x39; j++){
                if (secondByteNode[j] === $ece042c973d04c6f$var$UNASSIGNED) secondByteNode[j] = $ece042c973d04c6f$var$NODE_START - commonThirdByteNodeIdx;
                else if (secondByteNode[j] > $ece042c973d04c6f$var$NODE_START) throw new Error("gb18030 decode tables conflict at byte 2");
                var thirdByteNode = this.decodeTables[$ece042c973d04c6f$var$NODE_START - secondByteNode[j]];
                for(var k = 0x81; k <= 0xFE; k++){
                    if (thirdByteNode[k] === $ece042c973d04c6f$var$UNASSIGNED) thirdByteNode[k] = $ece042c973d04c6f$var$NODE_START - commonFourthByteNodeIdx;
                    else if (thirdByteNode[k] === $ece042c973d04c6f$var$NODE_START - commonFourthByteNodeIdx) continue;
                    else if (thirdByteNode[k] > $ece042c973d04c6f$var$NODE_START) throw new Error("gb18030 decode tables conflict at byte 3");
                    var fourthByteNode = this.decodeTables[$ece042c973d04c6f$var$NODE_START - thirdByteNode[k]];
                    for(var l = 0x30; l <= 0x39; l++)if (fourthByteNode[l] === $ece042c973d04c6f$var$UNASSIGNED) fourthByteNode[l] = $ece042c973d04c6f$var$GB18030_CODE;
                }
            }
        }
    }
    this.defaultCharUnicode = iconv.defaultCharUnicode;
    // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];
    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === "number") skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    }
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);
    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === $ece042c973d04c6f$var$UNASSIGNED) this.defCharSB = this.encodeTable[0]["?"];
    if (this.defCharSB === $ece042c973d04c6f$var$UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
}
$ece042c973d04c6f$var$DBCSCodec.prototype.encoder = $ece042c973d04c6f$var$DBCSEncoder;
$ece042c973d04c6f$var$DBCSCodec.prototype.decoder = $ece042c973d04c6f$var$DBCSDecoder;
// Decoder helpers
$ece042c973d04c6f$var$DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        var val = node[bytes[i]];
        if (val == $ece042c973d04c6f$var$UNASSIGNED) {
            node[bytes[i]] = $ece042c973d04c6f$var$NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = $ece042c973d04c6f$var$UNASSIGNED_NODE.slice(0));
        } else if (val <= $ece042c973d04c6f$var$NODE_START) node = this.decodeTables[$ece042c973d04c6f$var$NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
$ece042c973d04c6f$var$DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);
    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;
    // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (0xD800 <= code && code < 0xDC00) {
                var codeTrail = part.charCodeAt(l++);
                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (0x0FF0 < code && code <= 0x0FFF) {
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = $ece042c973d04c6f$var$SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code; // Basic char
        }
        else if (typeof part === "number") {
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
};
// Encoder helpers
$ece042c973d04c6f$var$DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = $ece042c973d04c6f$var$UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
};
$ece042c973d04c6f$var$DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= $ece042c973d04c6f$var$SEQ_START) this.encodeTableSeq[$ece042c973d04c6f$var$SEQ_START - bucket[low]][$ece042c973d04c6f$var$DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == $ece042c973d04c6f$var$UNASSIGNED) bucket[low] = dbcsCode;
};
$ece042c973d04c6f$var$DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= $ece042c973d04c6f$var$SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[$ece042c973d04c6f$var$SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== $ece042c973d04c6f$var$UNASSIGNED) node[$ece042c973d04c6f$var$DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = $ece042c973d04c6f$var$SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }
    // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === "object") node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[$ece042c973d04c6f$var$DEF_CHAR] = oldVal;
        }
    }
    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
$ece042c973d04c6f$var$DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    var hasValues = false;
    var subNodeEmpty = {};
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) {
            this._setEncodeChar(uCode, mbCode);
            hasValues = true;
        } else if (uCode <= $ece042c973d04c6f$var$NODE_START) {
            var subNodeIdx = $ece042c973d04c6f$var$NODE_START - uCode;
            if (!subNodeEmpty[subNodeIdx]) {
                var newPrefix = mbCode << 8 >>> 0; // NOTE: '>>> 0' keeps 32-bit num positive.
                if (this._fillEncodeTable(subNodeIdx, newPrefix, skipEncodeChars)) hasValues = true;
                else subNodeEmpty[subNodeIdx] = true;
            }
        } else if (uCode <= $ece042c973d04c6f$var$SEQ_START) {
            this._setEncodeSequence(this.decodeTableSeq[$ece042c973d04c6f$var$SEQ_START - uCode], mbCode);
            hasValues = true;
        }
    }
    return hasValues;
};
// == Encoder ==================================================================
function $ece042c973d04c6f$var$DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
$ece042c973d04c6f$var$DBCSEncoder.prototype.write = function(str) {
    var newBuf = $ece042c973d04c6f$require$Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        }
        // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) {
            if (uCode < 0xDC00) {
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = $ece042c973d04c6f$var$UNASSIGNED;
                }
            } else if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = $ece042c973d04c6f$var$UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = $ece042c973d04c6f$var$UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        }
        // 2. Convert uCode character.
        var dbcsCode = $ece042c973d04c6f$var$UNASSIGNED;
        if (seqObj !== undefined && uCode != $ece042c973d04c6f$var$UNASSIGNED) {
            var resCode = seqObj[uCode];
            if (typeof resCode === "object") {
                seqObj = resCode;
                continue;
            } else if (typeof resCode == "number") dbcsCode = resCode;
            else if (resCode == undefined) {
                // Try default character for this sequence
                resCode = seqObj[$ece042c973d04c6f$var$DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= $ece042c973d04c6f$var$SEQ_START) {
                seqObj = this.encodeTableSeq[$ece042c973d04c6f$var$SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == $ece042c973d04c6f$var$UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = $ece042c973d04c6f$var$findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }
        // 3. Write dbcsCode character.
        if (dbcsCode === $ece042c973d04c6f$var$UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8; // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        } else if (dbcsCode < 0x1000000) {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        } else {
            newBuf[j++] = dbcsCode >>> 24;
            newBuf[j++] = dbcsCode >>> 16 & 0xFF;
            newBuf[j++] = dbcsCode >>> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
$ece042c973d04c6f$var$DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
    var newBuf = $ece042c973d04c6f$require$Buffer.alloc(10), j = 0;
    if (this.seqObj) {
        var dbcsCode = this.seqObj[$ece042c973d04c6f$var$DEF_CHAR];
        if (dbcsCode !== undefined) {
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        } else ;
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
};
// Export for testing
$ece042c973d04c6f$var$DBCSEncoder.prototype.findIdx = $ece042c973d04c6f$var$findIdx;
// == Decoder ==================================================================
function $ece042c973d04c6f$var$DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBytes = [];
    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
$ece042c973d04c6f$var$DBCSDecoder.prototype.write = function(buf) {
    var newBuf = $ece042c973d04c6f$require$Buffer.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBytes = this.prevBytes, prevOffset = this.prevBytes.length, seqStart = -this.prevBytes.length, uCode;
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBytes[i + prevOffset];
        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === $ece042c973d04c6f$var$UNASSIGNED) {
            // TODO: Callback with seq.
            uCode = this.defaultCharUnicode.charCodeAt(0);
            i = seqStart; // Skip one byte ('i' will be incremented by the for loop) and try to parse again.
        } else if (uCode === $ece042c973d04c6f$var$GB18030_CODE) {
            if (i >= 3) var ptr = (buf[i - 3] - 0x81) * 12600 + (buf[i - 2] - 0x30) * 1260 + (buf[i - 1] - 0x81) * 10 + (curByte - 0x30);
            else var ptr = (prevBytes[i - 3 + prevOffset] - 0x81) * 12600 + ((i - 2 >= 0 ? buf[i - 2] : prevBytes[i - 2 + prevOffset]) - 0x30) * 1260 + ((i - 1 >= 0 ? buf[i - 1] : prevBytes[i - 1 + prevOffset]) - 0x81) * 10 + (curByte - 0x30);
            var idx = $ece042c973d04c6f$var$findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= $ece042c973d04c6f$var$NODE_START) {
            nodeIdx = $ece042c973d04c6f$var$NODE_START - uCode;
            continue;
        } else if (uCode <= $ece042c973d04c6f$var$SEQ_START) {
            var seq = this.decodeTableSeq[$ece042c973d04c6f$var$SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode >= 0x10000) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 | uCode >> 10;
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 | uCode & 0x3FF;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;
        // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBytes = seqStart >= 0 ? Array.prototype.slice.call(buf, seqStart) : prevBytes.slice(seqStart + prevOffset).concat(Array.prototype.slice.call(buf));
    return newBuf.slice(0, j).toString("ucs2");
};
$ece042c973d04c6f$var$DBCSDecoder.prototype.end = function() {
    var ret = "";
    // Try to parse all remaining chars.
    while(this.prevBytes.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var bytesArr = this.prevBytes.slice(1);
        // Parse remaining as usual.
        this.prevBytes = [];
        this.nodeIdx = 0;
        if (bytesArr.length > 0) ret += this.write(bytesArr);
    }
    this.prevBytes = [];
    this.nodeIdx = 0;
    return ret;
};
// Binary search for GB18030. Returns largest i such that table[i] <= val.
function $ece042c973d04c6f$var$findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0, r = table.length;
    while(l < r - 1){
        var mid = l + (r - l + 1 >> 1);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}

});

parcelRequire.register("Gz8Mv", function(module, exports) {
"use strict";












// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
module.exports = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    "shiftjis": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("1GwyH"));
        },
        encodeAdd: {
            "\xa5": 0x5C,
            "‾": 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    "csshiftjis": "shiftjis",
    "mskanji": "shiftjis",
    "sjis": "shiftjis",
    "windows31j": "shiftjis",
    "ms31j": "shiftjis",
    "xsjis": "shiftjis",
    "windows932": "shiftjis",
    "ms932": "shiftjis",
    "932": "shiftjis",
    "cp932": "shiftjis",
    "eucjp": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("cZ0X9"));
        },
        encodeAdd: {
            "\xa5": 0x5C,
            "‾": 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    "gb2312": "cp936",
    "gb231280": "cp936",
    "gb23121980": "cp936",
    "csgb2312": "cp936",
    "csiso58gb231280": "cp936",
    "euccn": "cp936",
    // Microsoft's CP936 is a subset and approximation of GBK.
    "windows936": "cp936",
    "ms936": "cp936",
    "936": "cp936",
    "cp936": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("irNZV"));
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    "gbk": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("irNZV")).concat((parcelRequire("iWhJA")));
        }
    },
    "xgbk": "gbk",
    "isoir58": "gbk",
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    "gb18030": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("irNZV")).concat((parcelRequire("iWhJA")));
        },
        gb18030: function() {
            return (parcelRequire("aQcCn"));
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "€": 0xA2E3
        }
    },
    "chinese": "gb18030",
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    "windows949": "cp949",
    "ms949": "cp949",
    "949": "cp949",
    "cp949": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("3pwLU"));
        }
    },
    "cseuckr": "cp949",
    "csksc56011987": "cp949",
    "euckr": "cp949",
    "isoir149": "cp949",
    "korean": "cp949",
    "ksc56011987": "cp949",
    "ksc56011989": "cp949",
    "ksc5601": "cp949",
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    "windows950": "cp950",
    "ms950": "cp950",
    "950": "cp950",
    "cp950": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("cmg3R"));
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    "big5": "big5hkscs",
    "big5hkscs": {
        type: "_dbcs",
        table: function() {
            return (parcelRequire("cmg3R")).concat((parcelRequire("h2tr1")));
        },
        encodeSkipVals: [
            // Although Encoding Standard says we should avoid encoding to HKSCS area (See Step 1 of
            // https://encoding.spec.whatwg.org/#index-big5-pointer), we still do it to increase compatibility with ICU.
            // But if a single unicode point can be encoded both as HKSCS and regular Big5, we prefer the latter.
            0x8e69,
            0x8e6f,
            0x8e7e,
            0x8eab,
            0x8eb4,
            0x8ecd,
            0x8ed0,
            0x8f57,
            0x8f69,
            0x8f6e,
            0x8fcb,
            0x8ffe,
            0x906d,
            0x907a,
            0x90c4,
            0x90dc,
            0x90f1,
            0x91bf,
            0x92af,
            0x92b0,
            0x92b1,
            0x92b2,
            0x92d1,
            0x9447,
            0x94ca,
            0x95d9,
            0x96fc,
            0x9975,
            0x9b76,
            0x9b78,
            0x9b7b,
            0x9bc6,
            0x9bde,
            0x9bec,
            0x9bf6,
            0x9c42,
            0x9c53,
            0x9c62,
            0x9c68,
            0x9c6b,
            0x9c77,
            0x9cbc,
            0x9cbd,
            0x9cd0,
            0x9d57,
            0x9d5a,
            0x9dc4,
            0x9def,
            0x9dfb,
            0x9ea9,
            0x9eef,
            0x9efd,
            0x9f60,
            0x9fcb,
            0xa077,
            0xa0dc,
            0xa0df,
            0x8fcc,
            0x92c8,
            0x9644,
            0x96ed,
            // Step 2 of https://encoding.spec.whatwg.org/#index-big5-pointer: Use last pointer for U+2550, U+255E, U+2561, U+256A, U+5341, or U+5345
            0xa2a4,
            0xa2a5,
            0xa2a7,
            0xa2a6,
            0xa2cc,
            0xa2ce
        ]
    },
    "cnbig5": "big5hkscs",
    "csbig5": "big5hkscs",
    "xxbig5": "big5hkscs"
};

});
parcelRequire.register("1GwyH", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜\xb4｀\xa8＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－\xb1\xd7"],["8180","\xf7＝≠＜＞≦≧∞∴♂♀\xb0′″℃￥＄￠￡％＃＆＊＠\xa7☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡\xb6"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]');

});

parcelRequire.register("cZ0X9", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜\xb4｀\xa8＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－\xb1\xd7\xf7＝≠＜＞≦≧∞∴♂♀\xb0′″℃￥＄￠￡％＃＆＊＠\xa7☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡\xb6"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ\xb8˙˝\xaf˛˚～΄΅"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae™\xa4№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","\xc6Đ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","Ŋ\xd8Œ"],["8fa9af","Ŧ\xde"],["8fa9c1","\xe6đ\xf0ħıĳĸłŀŉŋ\xf8œ\xdfŧ\xfe"],["8faaa1","\xc1\xc0\xc4\xc2ĂǍĀĄ\xc5\xc3ĆĈČ\xc7ĊĎ\xc9\xc8\xcb\xcaĚĖĒĘ"],["8faaba","ĜĞĢĠĤ\xcd\xcc\xcf\xceǏİĪĮĨĴĶĹĽĻŃŇŅ\xd1\xd3\xd2\xd6\xd4ǑŐŌ\xd5ŔŘŖŚŜŠŞŤŢ\xda\xd9\xdc\xdbŬǓŰŪŲŮŨǗǛǙǕŴ\xddŸŶŹŽŻ"],["8faba1","\xe1\xe0\xe4\xe2ăǎāą\xe5\xe3ćĉč\xe7ċď\xe9\xe8\xeb\xeaěėēęǵĝğ"],["8fabbd","ġĥ\xed\xec\xef\xeeǐ"],["8fabc5","īįĩĵķĺľļńňņ\xf1\xf3\xf2\xf6\xf4ǒőō\xf5ŕřŗśŝšşťţ\xfa\xf9\xfc\xfbŭǔűūųůũǘǜǚǖŵ\xfd\xffŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]');

});

parcelRequire.register("irNZV", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。\xb7ˉˇ\xa8〃々—～‖…‘’“”〔〕〈",7,"〖〗【】\xb1\xd7\xf7∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀\xb0′″℃＄\xa4￠￡‰\xa7№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","ā\xe1ǎ\xe0ē\xe9ě\xe8ī\xedǐ\xecō\xf3ǒ\xf2ū\xfaǔ\xf9ǖǘǚǜ\xfc\xeaɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]');

});

parcelRequire.register("iWhJA", function(module, exports) {
module.exports = JSON.parse('[["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc","ḿ"],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93],["8135f437",""]]');

});

parcelRequire.register("aQcCn", function(module, exports) {
module.exports = JSON.parse('{"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}');

});

parcelRequire.register("3pwLU", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。\xb7‥…\xa8〃\xad―∥＼∼‘’“”〔〕〈",9,"\xb1\xd7\xf7≠≤≥∞∴\xb0′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒\xa7※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃\xb4～ˇ˘˝˚˙\xb8˛\xa1\xbfː∮∑∏\xa4℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞\xb6†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€\xae"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"\xc6\xd0\xaaĦ"],["a8a6","Ĳ"],["a8a8","ĿŁ\xd8Œ\xba\xdeŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"\xbd⅓⅔\xbc\xbe⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤\xe6đ\xf0ħıĳĸŀł\xf8œ\xdf\xfeŧŋŉ㈀",27,"⒜",25,"⑴",14,"\xb9\xb2\xb3⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]');

});

parcelRequire.register("cmg3R", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒\xb7﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※\xa7〃○●△▲◎☆★◇◆□■▽▼㊣℅\xaf￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－\xd7\xf7\xb1√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄\xb0兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]');

});

parcelRequire.register("h2tr1", function(module, exports) {
module.exports = JSON.parse('[["8740","䏰䰲䘃䖦䕸\uD85C\uDE67䵷䖳\uD85F\uDCB1䳢\uD85F\uDCC5㮕䜶䝄䱇䱀\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2䱗\uD868\uDF51䝏䗚䲅\uD85F\uDC6C䴇䪤䚡\uD85A\uDF23爥\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61晍囻"],["8767","綕夝\uD862\uDFB9㷴霴\uD85E\uDFEF寛\uD847\uDD5E媤㘥\uD867\uDEB0嫑宷峼杮薓\uD866\uDD45瑡璝㡵\uD847\uDD53\uD84D\uDE9E\uD858\uDC21㻬"],["87a1","\uD856\uDCDE㫵竼龗\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄\uD857\uDDB9瓆鿇垳䤯呌䄱\uD84D\uDE8E堘穲\uD85E\uDF65讏䚮\uD85B\uDE88䆁\uD857\uDD99箮\uD849\uDCBC鿈\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC鿉蔄\uD84D\uDDBB䂴鿊䓡\uD86B\uDDFF拁灮鿋"],["8840","㇀",4,"\uD840\uDD0C㇅\uD840\uDCD1\uD840\uDCCD㇆㇇\uD840\uDCCB\uD847\uDFE8㇈\uD840\uDCCA㇉㇊㇋㇌\uD840\uDD0E㇍㇎Ā\xc1Ǎ\xc0Ē\xc9Ě\xc8Ō\xd3Ǒ\xd2࿿\xcāẾ࿿\xcǎỀ\xcaā\xe1ǎ\xe0ɑē\xe9ě\xe8ī\xedǐ\xecō\xf3ǒ\xf2ū\xfaǔ\xf9ǖǘǚ"],["88a1","ǜ\xfc࿿\xeāế࿿\xeǎề\xeaɡ⏚⏛"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","攊"],["8946","丽滝鵎釟"],["894c","\uD85D\uDF35撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶\uD842\uDDE7"],["89b5","肟黇䳍鷉鸌䰾\uD867\uDDF6\uD85C\uDC0E鸊\uD868\uDD33㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","\uD85F\uDD84唥"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B喐\uD84B\uDCC6㧬\uD840\uDF41蹆\uD853\uDDB8\uD865\uDCE5䁓\uD860\uDCBE睺\uD84B\uDC38㨴䟕\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA擝\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4撍蹾\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9䟴\uD853\uDEA7\uD84B\uDCC2骲㩧\uD865\uDDF4㿭㔆\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44鵮頕"],["8a76","䏙\uD858\uDCA5撴哣\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77㧻\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0擪\uD854\uDC52\uD843\uDC43蹨\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","䠋\uD840\uDDA9㿺塳\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96啹䂻䎺"],["8abb","䪴\uD84A\uDE66\uD844\uDC9D膪飵\uD843\uDD9C捹㧾\uD849\uDF75跀嚡摼㹃"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2㦒㨆\uD860\uDE9B㕸\uD857\uDE49\uD848\uDCC7噒\uD843\uDF31\uD84B\uDCB2\uD865\uDF20㒼氽\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C羓\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39㗻\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA㾓\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D㿹\uD849\uDE96搲\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55㨘\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA閪哌苄喹"],["8b55","\uD867\uDEC3鰦骶\uD85D\uDF5E\uD84B\uDDEE煀腭胬尜\uD859\uDD72脴㞗卟\uD860\uDCBD醶\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB㗝\uD853\uDDEB㘉\uD843\uDCD6嚯\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4婔\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6垜\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E㜃\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C墙剨㘚\uD855\uDF3D箲孨䠀䬬鼧䧧鰟鮍\uD856\uDF74\uD84C\uDD3D嗻㗲嚉丨夂\uD846\uDFC1\uD87E\uDC78靑\uD840\uDC86乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭\uD852\uDCE9罒礻糹罓\uD858\uDE6A㓁"],["8bde","\uD858\uDF4B耂肀\uD859\uDE12\uD85A\uDD51卝衤见\uD85E\uDCB2讠贝钅镸长门\uD863\uDE0F韦页风飞饣\uD866\uDC10鱼鸟黄歯龜丷\uD840\uDC87阝户钢"],["8c40","倻淾\uD867\uDC73龦㷉袏\uD850\uDD4E灷峵䬠\uD854\uDDCD㕙\uD857\uDD30愢\uD862\uDE32辧釶熑朙玺\uD84C\uDE81\uD868\uDD07㲋\uD846\uDD80䬐磤琂冮\uD861\uDF0F䀉橣\uD868\uDEBA䈣蘏\uD842\uDE6F稪\uD866\uDD47\uD862\uDEEA靕灍匤\uD848\uDC7E鏴盙\uD862\uDDE3龧矝亣俰傼丯众龨吴綋墒壐\uD847\uDDB6庒庙忂\uD849\uDF12斋"],["8ca1","\uD84C\uDFF9椙橃\uD84F\uDC63泿"],["8ca7","爀\uD851\uDD05玌㻛\uD852\uDE13嬕璹讃\uD857\uDCA4\uD855\uDE95窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬\uD863\uDDB9\uD845\uDC3F䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖\uD852\uDD7B芿\uD85C\uDD0D䲁\uD85B\uDD74嵻\uD85A\uDF15\uD85B\uDFBE龭龮宖龯曧繛湗秊㶈䓃\uD84C\uDE56\uD849\uDF96䎚䔶"],["8ce6","峕\uD84E\uDF1A諹屸㴒\uD84D\uDD51嵸龲煗䕘\uD850\uDCEC\uD847\uDE23䱷㥸㑊\uD840\uDDA4\uD85B\uDC41諌侴\uD840\uDE39妿腬顖\uD866\uDCFA弻"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D䄂䚻\uD864\uDC79㼇龳\uD868\uDDB5䃸㟖䛷\uD85B\uDC46䅼\uD861\uDEB2\uD85C\uDFFF䕭㣔\uD855\uDC9A䕡䔛䶉䱻䵶䗪㿈\uD852\uDF0F㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆\uD862\uDDC0溻滢滚齿滨滩漤漴㵆\uD84F\uDF41澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉\uD840\uDF25䏁㗱\uD843\uDED8"],["8e40","\uD84F\uDED7垾\uD85B\uDED3焾\uD855\uDFE0㙎榢\uD862\uDFE9孴穉\uD856\uDCE1\uD865\uDCD9穥穽\uD856\uDDAC窻窰竂竃燑\uD859\uDC8D䇊竚竝竪䇯咲\uD857\uDC01笋筕笩\uD854\uDF0E\uD857\uDCFE箢筯莜\uD856\uDFB4\uD85B\uDC7F篐萡箒箸\uD857\uDD20㶭\uD857\uDC65蒒篺簆簵\uD857\uDCC1籄粃\uD852\uDC82粦晽\uD851\uDD78糉糇糦籴糳糵糎"],["8ea1","繧䔝\uD85B\uDE44絝\uD85B\uDED6璍綉綫焵綳緒\uD850\uDC57\uD858\uDC29緤㴓緵\uD845\uDFF9緥\uD860\uDF6D縝\uD858\uDD21\uD858\uDD5A繮纒䌫鑬縧罀罁罇礶\uD858\uDED0駡羗\uD858\uDF51羣\uD845\uDE61\uD840\uDC68䕜\uD84D\uDF66䔃\uD860\uDF3A翺\uD859\uDC89者耈耝耨耯\uD868\uDC87\uD85B\uDCC3耻耼聡\uD849\uDF14䦉\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8朥肧\uD862\uDE48脇脚墰\uD849\uDEF6汿\uD859\uDC98\uD853\uDFB8擧\uD845\uDC8A舘\uD846\uDC5E橓\uD852\uDE65\uD852\uDE95䑺舩\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E俹\uD845\uDCFD蓢荢\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8芪椛\uD87E\uDD94䇛"],["8f40","蕋苐茚\uD843\uDE16\uD845\uDFB4㛁\uD84C\uDD7D\uD84D\uDD5A艻苢茘\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE㶿茝嗬莅䔋\uD85B\uDDA5莬菁菓㑾\uD85B\uDED4橗蕚㒖\uD85B\uDE42\uD84B\uDEEF葘\uD856\uDFE4葱㷓䓤檧葊\uD84F\uDCB5祘蒨\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43蓞萏莑䒠蒓蓤\uD857\uDC91䉀\uD857\uDCC0䕃蔴嫲\uD85B\uDE99䔧蕳䔖枿蘖"],["8fa1","\uD861\uDE25\uD861\uDE3B藁\uD85C\uDC88蘂\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2䕪蘨㙈\uD846\uDCA2号\uD85C\uDF9A虾蝱\uD868\uDCF8蟮\uD84B\uDC27螱蟚蠏噡虬桖䘏衅衆\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4衞袜䙛袴袵揁装睷\uD85D\uDF0F覇覊覦覩覧覼\uD862\uDE25觧\uD85E\uDD24\uD85E\uDEBD誜瞓釾誐\uD85E\uDE59竩\uD85E\uDF3A\uD84F\uDF8F䜓\uD85E\uDF38煼謌謟\uD855\uDC30\uD855\uDD65謿譌譍誩\uD852\uDE7A讐讛誯\uD845\uDEDF䘕衏貛\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4㜥\uD85F\uDD53賖\uD85F\uDD98\uD85F\uDDBD贒贃\uD846\uDD10賛灜贑\uD853\uDCC9㻐起"],["9040","趩\uD860\uDC02\uD844\uDC14\uD852\uDD8A㭼\uD860\uDDBC\uD85C\uDD0C竧躭躶軃鋔輙輭\uD860\uDF65\uD861\uDC12辥錃\uD868\uDE9F\uD842\uDE50辳䤪\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB廸\uD84C\uDE62迹\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25㦀\uD85B\uDED7逷\uD861\uDD3C\uD85E\uDEBE遡\uD861\uDD6C\uD861\uDE0B邨\uD861\uDF13郄\uD861\uDEE6邮都酧㫰醩釄粬\uD862\uDD33\uD847\uDE89鈎沟鉁鉢\uD855\uDDB9銹\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31錬鍫\uD862\uDEE1\uD862\uDFEB炏嫃\uD862\uDEE2\uD862\uDEE5䥥鉄\uD862\uDFEC\uD863\uDC39\uD862\uDFFF鍳鑛躼閅閦鐦閠濶䊹\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E䧟氜陻隖䅬隣\uD85B\uDED5懚隶磵\uD862\uDEE0隽双䦡\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A霱虂霶䨏䔽䖅\uD852\uDEE9灵孁霛靜\uD864\uDDD5靗孊\uD864\uDDEB靟鐥僐\uD84C\uDCB7\uD84C\uDCBC鞉鞟鞱鞾韀韒韠\uD855\uDC6C韮琜\uD865\uDC33響韵\uD865\uDC1D\uD85E\uDD7A䫑頴頳顋顦㬎\uD85C\uDD75㵑\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06飊颷飈飇䫿\uD85B\uDD27\uD845\uDED3喰飡飦飬鍸餹\uD852\uDE29䭲\uD866\uDC57\uD866\uDD05駵騌騻騐驘\uD855\uDF25㛄\uD864\uDCB1\uD866\uDFD5髠髢\uD866\uDF05髴䰎鬔鬭\uD861\uDE00倴鬴\uD85A\uDDA8㣃\uD84C\uDC7D魐魀\uD867\uDD3E婅\uD846\uDC63鮎\uD850\uDE4B鰂鯿鰌\uD867\uDE68鷔\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF鵾鶃\uD868\uDD34鸎梈"],["91a1","鷄\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33鴹\uD868\uDCB9\uD868\uDEB4麐麕麞麢䴴麪麯\uD850\uDF64黁㭠㧥㴝伲㞾\uD863\uDC2B鼂鼈䮖鐤\uD85B\uDDA2鼗鼖鼹嚟嚊齅馸\uD864\uDC8B韲葿齢齩竜龎爖䮾\uD852\uDD75\uD852\uDDBB煷\uD852\uDDF8\uD850\uDF48\uD852\uDE51玞\uD862\uDFDA\uD846\uDCFA禟\uD862\uDD7E\uD863\uDE36鍩鏳\uD862\uDE44鋬鎁鏋\uD862\uDD6C\uD851\uDCB9爗㻫睲穃烐\uD851\uDC73\uD850\uDFF8煾\uD845\uDFEF炣\uD846\uDCBE\uD84D\uDD99㻇\uD846\uDC85\uD855\uDC2F\uD845\uDFF8㜢\uD845\uDEFB\uD846\uDC39㛡\uD845\uDF74\uD846\uDCD1\uD857\uDF4B㜣\uD845\uDEC0坛\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6蔃\uD84D\uDEA6蔃葕\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52䓴\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26柹㜳㰕㷧塬\uD846\uDD22栐䁗\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21哋嚞\uD859\uDEB1嚒\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D鏆\uD862\uDF13鎜仸儫㠙\uD851\uDC36亼\uD841\uDC65\uD840\uDF7F佋侊\uD855\uDE51婨\uD840\uDDAB\uD840\uDFCB㦙\uD840\uDF0A\uD841\uDC14㐵伩\uD840\uDEC0\uD863\uDEB3\uD840\uDE75諚\uD840\uDE0C亘"],["92a1","働儍侢伃\uD852\uDE0E\uD84F\uDE8A佂倮偬傁俌俥偘僼兙兛兝兞湶\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF浲\uD846\uDC84\uD84F\uDE89冨凃\uD841\uDDE0䓝\uD841\uDCA3\uD841\uDC92\uD841\uDC91赺\uD862\uDE9C\uD841\uDF0E剙劤\uD842\uDC73勡鍮䙺熌\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4槑\uD843\uDE1D瑹㻞璙琔瑖玘䮎\uD852\uDEBC\uD850\uDC8D叐㖄爏\uD850\uDCC9喴\uD840\uDF45响\uD842\uDFC6圝鉝雴鍦埝垍坿㘾壋媙\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10娬妸銏婾嫏娒\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95㛵洅瑃娡\uD857\uDE83"],["9340","媁\uD862\uDFD7\uD841\uDC13鏠璌\uD844\uDF03焅䥲鐈\uD862\uDDFB鎽㞠尞岞幞幈\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE廍孏\uD846\uDD03\uD846\uDD04㜁\uD846\uDCA0㛝\uD845\uDEFE㛓脪\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8弌弎\uD846\uDD27\uD845\uDFAB婫\uD845\uDF3B孄蘔\uD85D\uDDFD衠恾\uD84A\uDC60\uD849\uDE2B忛㺸\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73懀\uD840\uDC3E\uD840\uDC46\uD849\uDE1B憙憘恵\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","摱\uD851\uDE65\uD84A\uDF6A㨩\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78挷\uD869\uDC5B撶挱揑\uD852\uDDE3\uD84B\uDD67护\uD84B\uDCA1搻敫楲㯴\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB唍\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F曎\uD84C\uDE89\uD84C\uDDB3㫠䆐\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25磮\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34㑤\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9暎\uD85B\uDD24晫䮓昰\uD85E\uDC70\uD847\uDDEB晣\uD84C\uDED2\uD84C\uDEE1昞\uD856\uDC72㣑\uD84E\uDC3A\uD84D\uDFBC㮙\uD84D\uDFA2\uD84C\uDFFE瓐㮖枏\uD851\uDE2A梶栞㯄檾㡣\uD84D\uDFD5\uD851\uDC87樳橒櫉欅\uD846\uDD12攑梘橌㯗橺歗\uD84F\uDFC0\uD84F\uDC9A鎠鋲\uD862\uDFEA\uD862\uDECB"],["9440","銉\uD860\uDC1E\uD862\uDDDC鑧涥漋\uD852\uDDEC浧\uD84F\uDF7F㶏渄\uD850\uDC3C娽渊塇洤硂焻\uD850\uDF1A\uD850\uDE76烱牐犇犔\uD851\uDF8F\uD851\uDF25兹\uD852\uDEA4\uD841\uDDEB瑺\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1㼆㺱\uD852\uDEDF\uD863\uDC23\uD84F\uDF35悧㻳瓌琼鎇琷䒟\uD85B\uDDEA䕑疃㽣\uD853\uDCD9\uD853\uDD06㽘畕癳\uD869\uDDC6㬙瑨\uD862\uDECC\uD852\uDDAB\uD852\uDD8E㫻"],["94a1","㷍\uD852\uDE4E㻿\uD852\uDDC5\uD852\uDCF3釺圲鍂\uD862\uDEE3\uD846\uDC64僟\uD854\uDE21\uD854\uDDE7睸\uD84C\uDE32眎眏睻\uD851\uDE97\uD84D\uDF81㩞\uD852\uDCF0琸璛㺿\uD852\uDEBA\uD852\uDEC7䃈\uD852\uDE96\uD858\uDDAE錇\uD855\uDD81砞碍碈磒珐祙\uD85D\uDF41\uD855\uDEE3䄎禛蒖禥樭\uD84F\uDEFA稺秴䅮\uD845\uDEE6䄲鈵秱\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E㖗啫㕰㚪\uD840\uDDD4\uD843\uDC0D竢婙\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C娍\uD840\uDE5B磰娪\uD856\uDFC6竾䇹籝籭䈑\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6糍\uD852\uDDF9\uD845\uDFB0粎籼粮檲緜縇緓罎\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48綗\uD857\uDE82䉪\uD85A\uDF75\uD842\uDD16柖\uD840\uDC4E\uD84D\uDDCF埄\uD859\uDC12\uD858\uDFF8\uD852\uDD62翝笧\uD842\uDC2C\uD856\uDEE9\uD857\uDD43笌\uD857\uDE0E駦虅驣樜\uD84D\uDC3F㧢\uD852\uDDF7\uD859\uDDAD騟\uD859\uDDA0蒀\uD85C\uDD27\uD85B\uDCD1䓪脷䐂胆脉腂\uD859\uDFB4飃\uD85A\uDE42艢艥\uD85A\uDE51葓\uD85B\uDDA7蘐\uD85C\uDE1B媆䅿\uD846\uDC40嬫\uD846\uDCA1嫤\uD846\uDCD8蚠\uD87E\uDDBC\uD84F\uDD8F蠭\uD85D\uDC22娂"],["95a1","衮佅袇袿裦襥襍\uD855\uDE83襔\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9㺭蒣䛵䛏㟲訽訜\uD865\uDC48彍鈫\uD850\uDE84旔焩烄\uD846\uDC45鵭貟賩\uD85F\uDDDC妚矃姰䍮㛔踪躧\uD853\uDC09輰轊䋴汘澻\uD848\uDF21䢛潹溋\uD845\uDFDA鯩㚵\uD852\uDD2F邻邗啱䤆醻鐄\uD862\uDE4B䁢\uD862\uDEFC鐧\uD863\uDC1D\uD863\uDC3B蓥訫閙閧閗閖\uD863\uDD34瑅㻂\uD852\uDCFF\uD852\uDE42\uD850\uDFEA㻧\uD84C\uDE25随\uD863\uDEE7\uD863\uDE66\uD863\uDE65㻌\uD852\uDDED\uD852\uDE78\uD84F\uDFEE琒瑫㻼靁\uD864\uDCB0"],["9640","桇䨝\uD864\uDC93\uD855\uDFDF靝鍨\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE銺嬑譩䤼珹\uD850\uDE1B鞛靱餸\uD843\uDF26巁\uD862\uDFC5\uD852\uDEB2頟\uD865\uDCDA鋶\uD865\uDDD7釥䓀\uD862\uDF50\uD852\uDE67\uD862\uDF64飜\uD862\uDE45㼀鈪䤥萔餻饍\uD85E\uDF06㷽馛䭯馪驜\uD862\uDF65\uD856\uDCC8檏騡嫾騯\uD866\uDCF1䮐\uD866\uDD48馼䮽䮗鍽塲\uD844\uDF02堢\uD852\uDDB8"],["96a1","\uD845\uDCE8硄\uD849\uDF1F\uD84F\uDDB8棅㵽鑘㤧慐\uD849\uDF81\uD84A\uDD6B愇鱏鱓鱻鰵鰐魿鯏\uD867\uDE2D鮟\uD868\uDDF5\uD868\uDCFE鴡䲮\uD850\uDD04鸘䲰鴌\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F鶥蒽\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82藼䔳\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0萠藮\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64秢\uD84D\uDD9C\uD84D\uDE40䤭\uD852\uDDDE㵢鏛銾鍈\uD840\uDEBF碹鉷鑍俤㑀遤\uD855\uDD5D砽硔碶硋\uD845\uDF57\uD84C\uDDC9\uD852\uDD41㚚佲濚濙瀞瀞吔\uD850\uDDB5垻壳垊鴖埗焴㒯\uD850\uDDAC燫\uD85B\uDC40\uD853\uDF97嬨\uD845\uDFB5\uD862\uDE49"],["9740","愌嫎娋䊼\uD851\uDC88㜬䭻\uD862\uDDFC鎻鎸\uD846\uDCD6\uD843\uDF1D葲\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1妔\uD84F\uDDB7\uD859\uDF41綨\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA鋥珢㻩璴\uD862\uDF63\uD846\uDC9F㻡\uD852\uDEB3櫘珳珻㻖\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5瑈\uD852\uDD16炥\uD852\uDD76銄珦鍟\uD841\uDCFE錱\uD862\uDECE\uD862\uDE16鎆\uD862\uDFE7\uD855\uDDD5䤵\uD862\uDE82煫"],["97a1","\uD852\uDD43\uD843\uDCFF嚤\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8唂秄\uD845\uDFFA緾\uD845\uDEC2\uD852\uDE50\uD846\uDC52䔮鐁㜊\uD862\uDEC0\uD852\uDDAD妰\uD846\uDCBF\uD846\uDC83\uD85D\uDC84媡㛢\uD84F\uDD5B㚰鉟婹\uD862\uDE81\uD846\uDC62鍴㳍\uD842\uDEB4䪖㦊僴㵩㵌\uD844\uDF9C煵䋻\uD860\uDE18渏\uD864\uDCE4䓫浗\uD85F\uDE4F灧沯㳖\uD84F\uDFED\uD84F\uDE2D渂漌㵯\uD840\uDFF5畑㚼㓈䚀㻚䡱姄鉮䤾轁\uD863\uDC1C\uD85A\uDFC0堒埈㛖\uD845\uDC52烾\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD梹楧\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F樚\uD84D\uDEAD\uD85B\uDCB7萾䓟䓎"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE漗\uD85C\uDD09茽\uD845\uDF3A菭\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB妉媂\uD845\uDFB3婡婱\uD846\uDD05\uD850\uDDFC㜭姯\uD845\uDF3C㛇熎鎐暚\uD850\uDEA5婮娫\uD850\uDE93樫\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA焝\uD850\uDE59\uD862\uDDE1侰\uD85B\uDD28峂\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD樌\uD850\uDE56\uD844\uDF04炦焳\uD850\uDFE9㶥泟\uD87E\uDC25\uD852\uDE4F繥姫崯㷳彜\uD852\uDE5D\uD845\uDFDF綤萦"],["98a1","咅\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14坾\uD842\uDCD5\uD841\uDE19㿥\uD847\uDF9E\uD868\uDEB6瀃\uD864\uDD5B嵰玏糓\uD862\uDE59\uD865\uDC20俈翧狍猐\uD85E\uDEF4猸猹\uD855\uDEF6獁獈㺩\uD85E\uDF18遬燵\uD852\uDCF2珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発\uD853\uDF5C熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈\uD855\uDD35礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀\uD843\uDCCF総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑\uD85E\uDD67訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯\uD846\uDFC2鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄\uD840\uDC94\uD840\uDEB7\uD840\uDFA0椚铃妬\uD841\uDCD7塀铁㞹\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA块煳\uD842\uDEC2\uD842\uDECD\uD842\uDFBF呪\uD87E\uDC3B\uD842\uDFCB咞\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C惧\uD843\uDC8D噺\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8楕鰯螥\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73尠\uD843\uDFBC帋\uD844\uDC5C\uD844\uDC4F\uD844\uDC76朞\uD844\uDC7B\uD844\uDC88\uD844\uDC96㙇\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B卤蒭\uD844\uDEE3\uD844\uDF75\uD844\uDF36讁\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7乸炻\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8拃\uD847\uDED5\uD847\uDF15熘桕\uD848\uDC45槩㛈\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F苽\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5覥\uD84A\uDEE8辠\uD84A\uDF0E鞸\uD84A\uDF3F顇骽\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE徱晈暿\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3爁\uD852\uDDBA矗\uD84D\uDE1A\uD84D\uDF16纇\uD840\uDF46墵朎"],["9ba1","椘\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A䣐䪸\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA凒\uD841\uDE11妟\uD847\uDEA8㮾\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6垈\uD851\uDE74㦛\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9㝢\uD848\uDDC3譞\uD862\uDF4E駖\uD852\uDC12\uD852\uDCFB\uD852\uDE15爉\uD852\uDEC0\uD843\uDC78奥\uD853\uDEA5\uD853\uDF86\uD841\uDF79軚\uD854\uDC2C劏圿煱\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7喼\uD855\uDC46\uD855\uDC6E\uD85A\uDF52釔㑳\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E䜘\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D偦㓻\uD84C\uDFCC惞\uD856\uDD03䝼\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90垡煑澶\uD858\uDD02\uD85F\uDC12遖\uD858\uDDB2\uD853\uDF9A譢\uD859\uDC02\uD859\uDC4A"],["9c40","嵛\uD85A\uDFF7輶\uD859\uDC84\uD846\uDD1C諪\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12䯀\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B鑥\uD855\uDFE1憕娧\uD87E\uDCCD侻嚹\uD851\uDD21\uD859\uDEFC乪\uD852\uDD34陖涏\uD85B\uDCBD㘘襷\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E營\uD85A\uDCC7筂\uD864\uDCC0\uD842\uDE11\uD85A\uDD26鄄\uD85A\uDD39穅鷰\uD85A\uDDFA騦\uD85A\uDE2D㙟\uD859\uDC69\uD840\uDC21禃\uD85A\uDE34\uD85A\uDF5B崬\uD84D\uDD19菏\uD85A\uDF9D䛐\uD85B\uDCA4画补\uD85B\uDDAE墶"],["9ca1","㜜\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD㱔\uD85C\uDE80\uD85C\uDE85銁\uD848\uDD7A\uD85C\uDE8B錰\uD85C\uDEE6\uD852\uDDD0氹钟\uD85D\uDC50\uD843\uDEF8蠧裵\uD84A\uDD26\uD861\uDC73\uD845\uDFB1溸\uD852\uDE2A\uD846\uDC20㦤㚹尐秣䔿暶\uD867\uDCAD\uD866\uDCA4襃\uD85D\uDFCC\uD85E\uDC58囖䃟\uD845\uDE0A㦡\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5熭荦\uD85E\uDDDD\uD864\uDDA8婧䲷\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A筃祾\uD860\uDC09澵\uD868\uDEDF樃\uD860\uDF18厢\uD85B\uDE07鎿栶靝\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48嶅\uD863\uDC30\uD860\uDC83圕頣\uD862\uDD49嶫\uD852\uDD88斾槕叒\uD852\uDEA5\uD84F\uDF81㰑朶\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A㗊\uD861\uDC68\uD861\uDEAA䣺揦\uD862\uDD56砈鉕\uD862\uDDB8䏲\uD862\uDDE7䏟\uD862\uDDE8\uD862\uDF46\uD862\uDFD4姸\uD863\uDC09輋\uD863\uDFC5\uD864\uDCEC筑\uD864\uDD10\uD864\uDD3C㷷\uD864\uDD5E\uD852\uDECA运犏嚋\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B纟\uD867\uDEF8\uD867\uDF23䲤镇\uD868\uDE93熢\uD868\uDEFF䶑递\uD869\uDDCB䶜\uD843\uDC9C达嗁"],["9da1","辺\uD849\uDCB0边\uD852\uDE93䔉繿潖檱仪㓤\uD862\uDF2C\uD85E\uDC9D㜺躀\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF㷫\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56亚\uD857\uDE81\uD858\uDE58嚿\uD843\uDE6D踎孭\uD84F\uDE88\uD853\uDC9E揞拐\uD845\uDFF6\uD846\uDC7B攰嘭\uD857\uDC4A吚\uD854\uDF11㷆\uD867\uDD98䱽嘢嘞罉\uD857\uDED8奵\uD84F\uDD40蝰东\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖\uD843\uDE9D㗎嘅嗱曱\uD860\uDEE2㘭甴嗰喺咗啲\uD843\uDC41\uD843\uDC96廐\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2麫絚嗞\uD844\uDC75抝靭咔賍燶酶揼掹揾啩\uD84A\uDF43鱲\uD84B\uDEB3冚㓟\uD843\uDDA7冧呍唞唓癦踭\uD85A\uDC8A疱肶蠄螆裇膶萜\uD844\uDCC1䓬猄\uD851\uDF06宐茋\uD85A\uDC93噻\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6酰\uD844\uDDD9鈈\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9牦\uD847\uDCA2䝎\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB䃺"],["9ea1","鱝攟\uD84B\uDDA0䣳\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A恢\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥\uD851\uDE18墚\uD852\uDF6E舭呋垪\uD856\uDE95\uD842\uDD79"],["9ec5","㩒\uD849\uDC65獴\uD867\uDEAC䴉鯭\uD84F\uDCFE\uD867\uDF30䱛\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE葜\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20挮紥\uD84F\uDEF7\uD84F\uDE2C㨪逈勌㹴㙺䗩\uD841\uDC8E癀嫰\uD843\uDEB6硺\uD85F\uDF2E墧䂿噼鮋嵴癔\uD869\uDC34麅䳡痹㟻愙\uD84C\uDCDA\uD850\uDFF2"],["9ef5","噝\uD844\uDEA9垧\uD852\uDD63\uD867\uDE06刴\uD85C\uDCAE㖭汊鵼"],["9f40","籖鬹埞\uD845\uDF6C屓擓\uD865\uDCD0\uD858\uDF35\uD85C\uDD64蚭\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","凾\uD847\uDF0F嶎霃\uD847\uDDD1麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛\uD852\uDD3E齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆\uD845\uDF6D駚剳"],["9fae","酙隁酜"],["9fb2","酑\uD863\uDE97捿\uD85B\uDD23櫊嘑醎畺抅\uD840\uDFFC獏籰\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19盖鮝个\uD843\uDCD4莾衂"],["9fc9","届槀僭坺刟巵从氱\uD840\uDDF2伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠\uD869\uDE4A蹷齓"],["9ff0","跔蹏鸜踁抂\uD860\uDF7D踨蹵竓\uD852\uDE77稾磘泪詧瘇"],["a040","\uD862\uDE5A鼦泎蟖痃\uD868\uDEB2硓\uD87E\uDC40贌狢獱謭猂瓱賫\uD852\uDEBB蘯徺袠䒷"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","詾\uD849\uDD1B"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊\uD858\uDD59慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪\uD84C\uDFF5捤栂㗒"],["a0a1","嵗\uD862\uDFC2迚\uD863\uDE39"],["a0a6","僙\uD847\uDD46礆匲阸\uD843\uDF3B䁥"],["a0ae","矾"],["a0b0","糂\uD857\uDF1A糚稭聦聣絍甅瓲覔舚朌聢\uD85D\uDC86聛瓰脃眤覉\uD859\uDFCC畓\uD85B\uDED1螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁\uD850\uDC11瓧㷛煶悤憜㳑煢恷"],["a0e2","罱\uD862\uDF2D牐惩䭾删㰘\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD峁\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E䕢嬟\uD858\uDF4C齐麦\uD858\uDE6B"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶\xa8ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏\uD840\uDCCC乚\uD840\uDC8A刂䒑"],["c8a1","龰冈龱\uD85D\uDE07"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœ\xf8ŋʊɪ"],["f9fe","￭"],["fa40","\uD841\uDD47鋛\uD841\uDDDF\uD84F\uDFC5蕌䊵珯况㙉\uD852\uDD42\uD862\uDDE4鍄\uD846\uDDDB苮\uD84F\uDCC8砼杄拟\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05侫\uD849\uDCED倈\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13倩\uD840\uDF7E徤\uD840\uDF80\uD840\uDF47滛\uD841\uDC1F偽儁㑺儎顬㝃萖\uD852\uDDA4\uD841\uDC87兠\uD84C\uDFB4兪\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83宂蝽\uD841\uDDB3\uD84F\uDC99冲冸"],["faa1","鴴凉减凑㳜凓\uD852\uDEA6决凢卂凭菍椾\uD84D\uDF2D彻刋刦刼劵剗劔効勅簕蕂勠蘍\uD85A\uDF13包\uD862\uDEDE啉滙\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC匳卄\uD842\uDFE2泋\uD845\uDF26栛珕恊㺪㣌\uD845\uDEE8燝䒢卭却\uD861\uDEAB卾卿\uD845\uDD96\uD845\uDE13矦厓\uD862\uDE9B厠厫厮玧\uD855\uDF72㽙玜叁叅汉义埾叙㪫\uD842\uDF8F叠\uD84F\uDFEB\uD84B\uDDA3叶\uD843\uDC77吓灹唫晗浛呭\uD85A\uDF53\uD843\uDD74啝咏咤䞦\uD845\uDF0D\uD843\uDEDD㶴\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98啇䳭启琗喆喩嘅\uD846\uDCD7\uD850\uDC3A䕒\uD851\uDC35暳\uD844\uDCB4嘷曍\uD84C\uDE8A暤暭噍噏磱囱鞇叾圀囯园\uD862\uDF66㘣\uD844\uDE4F坆\uD850\uDDA5汮炋坂㚱\uD85B\uDC7E埦\uD845\uDC16堃\uD845\uDC54\uD850\uDF63堦\uD852\uDFF5塜墪㕡壠壜\uD844\uDE3C壻寿坃\uD868\uDD50\uD850\uDE78鏓㖡够梦㛃湙"],["fba1","\uD845\uDE3E娤啓\uD845\uDE92蔅姉\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC姙\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6浱\uD846\uDC28\uD845\uDED5姹\uD85B\uDE45媫婣㛦\uD852\uDDA9婷㜈媖瑥嫓\uD85B\uDFA1\uD849\uDD54㶅\uD846\uDD11㜲\uD845\uDEB8広勐孶斈孼\uD85E\uDE0E䀄䡝\uD840\uDE04寕慠\uD846\uDE34\uD856\uDDCC\uD841\uDDA5寳宝䴐尅\uD846\uDF44尓珎尔\uD847\uDCA5\uD85A\uDF28屉䣝岅峩峯嶋\uD847\uDDF9\uD847\uDE37崐崘嵆\uD847\uDEA4岺巗苼㠭\uD852\uDD01\uD848\uDC49\uD848\uDD73芇㠶㯂帮檊幵幺\uD851\uDCBC\uD843\uDCD3厦亷廐厨\uD845\uDF71帉廴\uD861\uDC82"],["fc40","廹廻㢠廼栾鐛弍\uD840\uDDC1\uD87E\uDC94㫞䢮\uD844\uDF3A强\uD85A\uDC88\uD848\uDFD0彘\uD849\uDC71彣鞽\uD85B\uDE6E彲鍀\uD862\uDE36徧嶶㵟\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68釖\uD840\uDE9E\uD862\uDE29怱暅\uD846\uDC77㥣㷇㘹垐\uD849\uDFB4祱㹀悞悤悳\uD852\uDD82\uD852\uDD8F\uD85E\uDE53璤僡媠慤萤慂\uD87E\uDCA6\uD85B\uDED2憁凴\uD841\uDE56憇宪\uD84F\uDFB7"],["fca1","\uD84A\uDC5F懓\uD862\uDF9D\uD866\uDD5D懐㤲\uD84A\uDD80\uD84A\uDCC1怣慜攞掋\uD840\uDD18担\uD845\uDF70拕\uD84B\uDE0D捬\uD852\uDDDF㨗搸揸\uD844\uDF8E\uD845\uDFFC撐澊\uD84B\uDE36頔\uD850\uDC8C\uD855\uDF1D擡擥鑻㩦携㩗敍漖\uD852\uDE28\uD852\uDE23斅敭敟\uD84C\uDC7E斵\uD852\uDD40䬷旑䃘\uD846\uDC29无旣忟\uD84D\uDC00昘\uD84C\uDDF7\uD84C\uDDF8晄\uD84C\uDDA4\uD84C\uDDA5晋\uD843\uDE75晧\uD854\uDDE6晳晴\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13矅\uD84A\uDCF7馤朂\uD850\uDF9C\uD852\uDE21㬫槺\uD84D\uDFC2杞杧杢\uD850\uDDCD\uD864\uDCED柗䓩栢湐鈼栁\uD84C\uDFE6\uD85B\uDDA0桝"],["fd40","\uD84D\uDC6F槡樋\uD862\uDEDF楳棃\uD84D\uDDCD椁椀㴲㨁\uD84D\uDE3C㮀枬楡\uD862\uDE4A䋼椶榘㮡\uD840\uDFC9荣傐槹\uD84D\uDE59\uD848\uDD2A橅\uD84D\uDF03檝㯳枱櫈\uD864\uDD9C㰍欝\uD842\uDD23惞欵歴\uD849\uDFCD溵\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58㝀吡\uD84E\uDF5A毡\uD84F\uDEFC毜氷\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51汚舦汹\uD84F\uDDBC䓅\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9㛥㳫\uD843\uDD32鮃\uD84C\uDDF9\uD849\uDC91羏样\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB涖浜湼漄\uD852\uDD7F\uD850\uDC85\uD85B\uDE72蔳\uD85B\uDF74凇沜渝萮\uD862\uDF21港\uD84F\uDE2F瑓\uD84F\uDF82秌湏媑\uD84C\uDC4B濸㜍澝\uD84F\uDE30滺\uD845\uDC97\uD850\uDC3D䕕鏰潄潜㵎潴\uD864\uDD70㴻澟\uD850\uDD44濓\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F凟\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD灋灾炧炁烌烕烖烟䄄㷨熴熖\uD850\uDE77焫煅媈煊煮岜\uD850\uDF65煏鍢\uD850\uDEC1焬\uD851\uDC5A\uD852\uDE27\uD852\uDE22熺\uD862\uDFE8炽爎"],["fe40","鑂爕夑鑃爤鍁\uD855\uDE05爮牀\uD852\uDD74梽牕牗㹕\uD84C\uDC44栍漽犂猪猫\uD852\uDC23\uD862\uDC2B䣭\uD862\uDC04猨献珏玪\uD843\uDC3A\uD85A\uDE2E珉瑉\uD850\uDDE2\uD845\uDEE7\uD852\uDE24昣㛅\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB珷琕椃\uD852\uDE26琹\uD841\uDDC3㻗瑜\uD84A\uDCAD瑠\uD863\uDEB2瑇珤瑶莹瑬㜰瑴鏱樬璂䥓\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F孆\uD863\uDC03\uD846\uDC9E瓈\uD846\uDD88甎瓩甞\uD863\uDED9\uD846\uDE4B寗\uD863\uDEAC鎅畍畊畧畮\uD853\uDF82㼄\uD853\uDD13疎瑝疞疴瘂瘬癑癏癯癶\uD858\uDFF5皐臯㟸\uD85A\uDD11\uD85A\uDD0E皡皥皷盌\uD85B\uDF9F葢\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C眞眦着撯\uD854\uDE20睘\uD84C\uDEAC瞯\uD862\uDD64\uD862\uDD68\uD845\uDEC1矴砉\uD844\uDF76\uD852\uDE12棊碯磇磓隥礮\uD855\uDDE0磗礴碱\uD85D\uDE0C辸袄\uD862\uDF2B\uD858\uDC83\uD849\uDE1C禆褀椂禀\uD856\uDC57禝\uD85E\uDF39礼禩渪\uD85C\uDD26㺨秆\uD864\uDD0D秔"]]');

});



parcelRequire.register("dGogL", function(module, exports) {
"use strict";

var $aavGG = parcelRequire("aavGG");
var $9f62060536d8d9a4$require$Buffer = $aavGG.Buffer;
// NOTE: Due to 'stream' module being pretty large (~100Kb, significant in browser environments), 
// we opt to dependency-inject it instead of creating a hard dependency.
module.exports = function(stream_module) {
    var Transform = stream_module.Transform;
    // == Encoder stream =======================================================
    function IconvLiteEncoderStream(conv, options) {
        this.conv = conv;
        options = options || {};
        options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
        Transform.call(this, options);
    }
    IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
        constructor: {
            value: IconvLiteEncoderStream
        }
    });
    IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
        if (typeof chunk != "string") return done(new Error("Iconv encoding stream needs strings as its input."));
        try {
            var res = this.conv.write(chunk);
            if (res && res.length) this.push(res);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteEncoderStream.prototype._flush = function(done) {
        try {
            var res = this.conv.end();
            if (res && res.length) this.push(res);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteEncoderStream.prototype.collect = function(cb) {
        var chunks = [];
        this.on("error", cb);
        this.on("data", function(chunk) {
            chunks.push(chunk);
        });
        this.on("end", function() {
            cb(null, $9f62060536d8d9a4$require$Buffer.concat(chunks));
        });
        return this;
    };
    // == Decoder stream =======================================================
    function IconvLiteDecoderStream(conv, options) {
        this.conv = conv;
        options = options || {};
        options.encoding = this.encoding = "utf8"; // We output strings.
        Transform.call(this, options);
    }
    IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
        constructor: {
            value: IconvLiteDecoderStream
        }
    });
    IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
        if (!$9f62060536d8d9a4$require$Buffer.isBuffer(chunk) && !(chunk instanceof Uint8Array)) return done(new Error("Iconv decoding stream needs buffers as its input."));
        try {
            var res = this.conv.write(chunk);
            if (res && res.length) this.push(res, this.encoding);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteDecoderStream.prototype._flush = function(done) {
        try {
            var res = this.conv.end();
            if (res && res.length) this.push(res, this.encoding);
            done();
        } catch (e) {
            done(e);
        }
    };
    IconvLiteDecoderStream.prototype.collect = function(cb) {
        var res = "";
        this.on("error", cb);
        this.on("data", function(chunk) {
            res += chunk;
        });
        this.on("end", function() {
            cb(null, res);
        });
        return this;
    };
    return {
        IconvLiteEncoderStream: IconvLiteEncoderStream,
        IconvLiteDecoderStream: IconvLiteDecoderStream
    };
};

});

parcelRequire.register("foUwZ", function(module, exports) {
"use strict";

});

parcelRequire.register("8RBlD", function(module, exports) {
"use strict";

var $f6tOL = parcelRequire("f6tOL");

var $MepZY = parcelRequire("MepZY");

var $8eeXS = parcelRequire("8eeXS");

var $bpCeP = parcelRequire("bpCeP");
const $67403e79431f4f40$var$isObject = (val)=>val && typeof val === "object" && !Array.isArray(val);
/**
 * Creates a matcher function from one or more glob patterns. The
 * returned function takes a string to match as its first argument,
 * and returns true if the string is a match. The returned matcher
 * function also takes a boolean as the second argument that, when true,
 * returns an object with additional information.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch(glob[, options]);
 *
 * const isMatch = picomatch('*.!(*a)');
 * console.log(isMatch('a.a')); //=> false
 * console.log(isMatch('a.b')); //=> true
 * ```
 * @name picomatch
 * @param {String|Array} `globs` One or more glob patterns.
 * @param {Object=} `options`
 * @return {Function=} Returns a matcher function.
 * @api public
 */ const $67403e79431f4f40$var$picomatch = (glob, options, returnState = false)=>{
    if (Array.isArray(glob)) {
        const fns = glob.map((input)=>$67403e79431f4f40$var$picomatch(input, options, returnState));
        const arrayMatcher = (str)=>{
            for (const isMatch of fns){
                const state = isMatch(str);
                if (state) return state;
            }
            return false;
        };
        return arrayMatcher;
    }
    const isState = $67403e79431f4f40$var$isObject(glob) && glob.tokens && glob.input;
    if (glob === "" || typeof glob !== "string" && !isState) throw new TypeError("Expected pattern to be a non-empty string");
    const opts = options || {};
    const posix = opts.windows;
    const regex = isState ? $67403e79431f4f40$var$picomatch.compileRe(glob, options) : $67403e79431f4f40$var$picomatch.makeRe(glob, options, false, true);
    const state = regex.state;
    delete regex.state;
    let isIgnored = ()=>false;
    if (opts.ignore) {
        const ignoreOpts = {
            ...options,
            ignore: null,
            onMatch: null,
            onResult: null
        };
        isIgnored = $67403e79431f4f40$var$picomatch(opts.ignore, ignoreOpts, returnState);
    }
    const matcher = (input, returnObject = false)=>{
        const { isMatch: isMatch, match: match, output: output } = $67403e79431f4f40$var$picomatch.test(input, regex, options, {
            glob: glob,
            posix: posix
        });
        const result = {
            glob: glob,
            state: state,
            regex: regex,
            posix: posix,
            input: input,
            output: output,
            match: match,
            isMatch: isMatch
        };
        if (typeof opts.onResult === "function") opts.onResult(result);
        if (isMatch === false) {
            result.isMatch = false;
            return returnObject ? result : false;
        }
        if (isIgnored(input)) {
            if (typeof opts.onIgnore === "function") opts.onIgnore(result);
            result.isMatch = false;
            return returnObject ? result : false;
        }
        if (typeof opts.onMatch === "function") opts.onMatch(result);
        return returnObject ? result : true;
    };
    if (returnState) matcher.state = state;
    return matcher;
};
/**
 * Test `input` with the given `regex`. This is used by the main
 * `picomatch()` function to test the input string.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.test(input, regex[, options]);
 *
 * console.log(picomatch.test('foo/bar', /^(?:([^/]*?)\/([^/]*?))$/));
 * // { isMatch: true, match: [ 'foo/', 'foo', 'bar' ], output: 'foo/bar' }
 * ```
 * @param {String} `input` String to test.
 * @param {RegExp} `regex`
 * @return {Object} Returns an object with matching info.
 * @api public
 */ $67403e79431f4f40$var$picomatch.test = (input, regex, options, { glob: glob, posix: posix } = {})=>{
    if (typeof input !== "string") throw new TypeError("Expected input to be a string");
    if (input === "") return {
        isMatch: false,
        output: ""
    };
    const opts = options || {};
    const format = opts.format || (posix ? $8eeXS.toPosixSlashes : null);
    let match = input === glob;
    let output = match && format ? format(input) : input;
    if (match === false) {
        output = format ? format(input) : input;
        match = output === glob;
    }
    if (match === false || opts.capture === true) {
        if (opts.matchBase === true || opts.basename === true) match = $67403e79431f4f40$var$picomatch.matchBase(input, regex, options, posix);
        else match = regex.exec(output);
    }
    return {
        isMatch: Boolean(match),
        match: match,
        output: output
    };
};
/**
 * Match the basename of a filepath.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.matchBase(input, glob[, options]);
 * console.log(picomatch.matchBase('foo/bar.js', '*.js'); // true
 * ```
 * @param {String} `input` String to test.
 * @param {RegExp|String} `glob` Glob pattern or regex created by [.makeRe](#makeRe).
 * @return {Boolean}
 * @api public
 */ $67403e79431f4f40$var$picomatch.matchBase = (input, glob, options)=>{
    const regex = glob instanceof RegExp ? glob : $67403e79431f4f40$var$picomatch.makeRe(glob, options);
    return regex.test($8eeXS.basename(input));
};
/**
 * Returns true if **any** of the given glob `patterns` match the specified `string`.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.isMatch(string, patterns[, options]);
 *
 * console.log(picomatch.isMatch('a.a', ['b.*', '*.a'])); //=> true
 * console.log(picomatch.isMatch('a.a', 'b.*')); //=> false
 * ```
 * @param {String|Array} str The string to test.
 * @param {String|Array} patterns One or more glob patterns to use for matching.
 * @param {Object} [options] See available [options](#options).
 * @return {Boolean} Returns true if any patterns match `str`
 * @api public
 */ $67403e79431f4f40$var$picomatch.isMatch = (str, patterns, options)=>$67403e79431f4f40$var$picomatch(patterns, options)(str);
/**
 * Parse a glob pattern to create the source string for a regular
 * expression.
 *
 * ```js
 * const picomatch = require('picomatch');
 * const result = picomatch.parse(pattern[, options]);
 * ```
 * @param {String} `pattern`
 * @param {Object} `options`
 * @return {Object} Returns an object with useful properties and output to be used as a regex source string.
 * @api public
 */ $67403e79431f4f40$var$picomatch.parse = (pattern, options)=>{
    if (Array.isArray(pattern)) return pattern.map((p)=>$67403e79431f4f40$var$picomatch.parse(p, options));
    return $MepZY(pattern, {
        ...options,
        fastpaths: false
    });
};
/**
 * Scan a glob pattern to separate the pattern into segments.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.scan(input[, options]);
 *
 * const result = picomatch.scan('!./foo/*.js');
 * console.log(result);
 * { prefix: '!./',
 *   input: '!./foo/*.js',
 *   start: 3,
 *   base: 'foo',
 *   glob: '*.js',
 *   isBrace: false,
 *   isBracket: false,
 *   isGlob: true,
 *   isExtglob: false,
 *   isGlobstar: false,
 *   negated: true }
 * ```
 * @param {String} `input` Glob pattern to scan.
 * @param {Object} `options`
 * @return {Object} Returns an object with
 * @api public
 */ $67403e79431f4f40$var$picomatch.scan = (input, options)=>$f6tOL(input, options);
/**
 * Compile a regular expression from the `state` object returned by the
 * [parse()](#parse) method.
 *
 * @param {Object} `state`
 * @param {Object} `options`
 * @param {Boolean} `returnOutput` Intended for implementors, this argument allows you to return the raw output from the parser.
 * @param {Boolean} `returnState` Adds the state to a `state` property on the returned regex. Useful for implementors and debugging.
 * @return {RegExp}
 * @api public
 */ $67403e79431f4f40$var$picomatch.compileRe = (state, options, returnOutput = false, returnState = false)=>{
    if (returnOutput === true) return state.output;
    const opts = options || {};
    const prepend = opts.contains ? "" : "^";
    const append = opts.contains ? "" : "$";
    let source = `${prepend}(?:${state.output})${append}`;
    if (state && state.negated === true) source = `^(?!${source}).*$`;
    const regex = $67403e79431f4f40$var$picomatch.toRegex(source, options);
    if (returnState === true) regex.state = state;
    return regex;
};
/**
 * Create a regular expression from a parsed glob pattern.
 *
 * ```js
 * const picomatch = require('picomatch');
 * const state = picomatch.parse('*.js');
 * // picomatch.compileRe(state[, options]);
 *
 * console.log(picomatch.compileRe(state));
 * //=> /^(?:(?!\.)(?=.)[^/]*?\.js)$/
 * ```
 * @param {String} `state` The object returned from the `.parse` method.
 * @param {Object} `options`
 * @param {Boolean} `returnOutput` Implementors may use this argument to return the compiled output, instead of a regular expression. This is not exposed on the options to prevent end-users from mutating the result.
 * @param {Boolean} `returnState` Implementors may use this argument to return the state from the parsed glob with the returned regular expression.
 * @return {RegExp} Returns a regex created from the given pattern.
 * @api public
 */ $67403e79431f4f40$var$picomatch.makeRe = (input, options = {}, returnOutput = false, returnState = false)=>{
    if (!input || typeof input !== "string") throw new TypeError("Expected a non-empty string");
    let parsed = {
        negated: false,
        fastpaths: true
    };
    if (options.fastpaths !== false && (input[0] === "." || input[0] === "*")) parsed.output = $MepZY.fastpaths(input, options);
    if (!parsed.output) parsed = $MepZY(input, options);
    return $67403e79431f4f40$var$picomatch.compileRe(parsed, options, returnOutput, returnState);
};
/**
 * Create a regular expression from the given regex source string.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.toRegex(source[, options]);
 *
 * const { output } = picomatch.parse('*.js');
 * console.log(picomatch.toRegex(output));
 * //=> /^(?:(?!\.)(?=.)[^/]*?\.js)$/
 * ```
 * @param {String} `source` Regular expression source string.
 * @param {Object} `options`
 * @return {RegExp}
 * @api public
 */ $67403e79431f4f40$var$picomatch.toRegex = (source, options)=>{
    try {
        const opts = options || {};
        return new RegExp(source, opts.flags || (opts.nocase ? "i" : ""));
    } catch (err) {
        if (options && options.debug === true) throw err;
        return /$^/;
    }
};
/**
 * Picomatch constants.
 * @return {Object}
 */ $67403e79431f4f40$var$picomatch.constants = $bpCeP;
/**
 * Expose "picomatch"
 */ module.exports = $67403e79431f4f40$var$picomatch;

});
parcelRequire.register("f6tOL", function(module, exports) {
"use strict";

var $8eeXS = parcelRequire("8eeXS");

var $bpCeP = parcelRequire("bpCeP");
var $02d66d9be49f6969$require$CHAR_ASTERISK = $bpCeP.CHAR_ASTERISK;
var $02d66d9be49f6969$require$CHAR_AT = $bpCeP.CHAR_AT;
var $02d66d9be49f6969$require$CHAR_BACKWARD_SLASH = $bpCeP.CHAR_BACKWARD_SLASH;
var $02d66d9be49f6969$require$CHAR_COMMA = $bpCeP.CHAR_COMMA;
var $02d66d9be49f6969$require$CHAR_DOT = $bpCeP.CHAR_DOT;
var $02d66d9be49f6969$require$CHAR_EXCLAMATION_MARK = $bpCeP.CHAR_EXCLAMATION_MARK;
var $02d66d9be49f6969$require$CHAR_FORWARD_SLASH = $bpCeP.CHAR_FORWARD_SLASH;
var $02d66d9be49f6969$require$CHAR_LEFT_CURLY_BRACE = $bpCeP.CHAR_LEFT_CURLY_BRACE;
var $02d66d9be49f6969$require$CHAR_LEFT_PARENTHESES = $bpCeP.CHAR_LEFT_PARENTHESES;
var $02d66d9be49f6969$require$CHAR_LEFT_SQUARE_BRACKET = $bpCeP.CHAR_LEFT_SQUARE_BRACKET;
var $02d66d9be49f6969$require$CHAR_PLUS = $bpCeP.CHAR_PLUS;
var $02d66d9be49f6969$require$CHAR_QUESTION_MARK = $bpCeP.CHAR_QUESTION_MARK;
var $02d66d9be49f6969$require$CHAR_RIGHT_CURLY_BRACE = $bpCeP.CHAR_RIGHT_CURLY_BRACE;
var $02d66d9be49f6969$require$CHAR_RIGHT_PARENTHESES = $bpCeP.CHAR_RIGHT_PARENTHESES;
var $02d66d9be49f6969$require$CHAR_RIGHT_SQUARE_BRACKET = $bpCeP.CHAR_RIGHT_SQUARE_BRACKET;
const $02d66d9be49f6969$var$isPathSeparator = (code)=>{
    return code === $02d66d9be49f6969$require$CHAR_FORWARD_SLASH || code === $02d66d9be49f6969$require$CHAR_BACKWARD_SLASH;
};
const $02d66d9be49f6969$var$depth = (token)=>{
    if (token.isPrefix !== true) token.depth = token.isGlobstar ? Infinity : 1;
};
/**
 * Quickly scans a glob pattern and returns an object with a handful of
 * useful properties, like `isGlob`, `path` (the leading non-glob, if it exists),
 * `glob` (the actual pattern), `negated` (true if the path starts with `!` but not
 * with `!(`) and `negatedExtglob` (true if the path starts with `!(`).
 *
 * ```js
 * const pm = require('picomatch');
 * console.log(pm.scan('foo/bar/*.js'));
 * { isGlob: true, input: 'foo/bar/*.js', base: 'foo/bar', glob: '*.js' }
 * ```
 * @param {String} `str`
 * @param {Object} `options`
 * @return {Object} Returns an object with tokens and regex source string.
 * @api public
 */ const $02d66d9be49f6969$var$scan = (input, options)=>{
    const opts = options || {};
    const length = input.length - 1;
    const scanToEnd = opts.parts === true || opts.scanToEnd === true;
    const slashes = [];
    const tokens = [];
    const parts = [];
    let str = input;
    let index = -1;
    let start = 0;
    let lastIndex = 0;
    let isBrace = false;
    let isBracket = false;
    let isGlob = false;
    let isExtglob = false;
    let isGlobstar = false;
    let braceEscaped = false;
    let backslashes = false;
    let negated = false;
    let negatedExtglob = false;
    let finished = false;
    let braces = 0;
    let prev;
    let code;
    let token = {
        value: "",
        depth: 0,
        isGlob: false
    };
    const eos = ()=>index >= length;
    const peek = ()=>str.charCodeAt(index + 1);
    const advance = ()=>{
        prev = code;
        return str.charCodeAt(++index);
    };
    while(index < length){
        code = advance();
        let next;
        if (code === $02d66d9be49f6969$require$CHAR_BACKWARD_SLASH) {
            backslashes = token.backslashes = true;
            code = advance();
            if (code === $02d66d9be49f6969$require$CHAR_LEFT_CURLY_BRACE) braceEscaped = true;
            continue;
        }
        if (braceEscaped === true || code === $02d66d9be49f6969$require$CHAR_LEFT_CURLY_BRACE) {
            braces++;
            while(eos() !== true && (code = advance())){
                if (code === $02d66d9be49f6969$require$CHAR_BACKWARD_SLASH) {
                    backslashes = token.backslashes = true;
                    advance();
                    continue;
                }
                if (code === $02d66d9be49f6969$require$CHAR_LEFT_CURLY_BRACE) {
                    braces++;
                    continue;
                }
                if (braceEscaped !== true && code === $02d66d9be49f6969$require$CHAR_DOT && (code = advance()) === $02d66d9be49f6969$require$CHAR_DOT) {
                    isBrace = token.isBrace = true;
                    isGlob = token.isGlob = true;
                    finished = true;
                    if (scanToEnd === true) continue;
                    break;
                }
                if (braceEscaped !== true && code === $02d66d9be49f6969$require$CHAR_COMMA) {
                    isBrace = token.isBrace = true;
                    isGlob = token.isGlob = true;
                    finished = true;
                    if (scanToEnd === true) continue;
                    break;
                }
                if (code === $02d66d9be49f6969$require$CHAR_RIGHT_CURLY_BRACE) {
                    braces--;
                    if (braces === 0) {
                        braceEscaped = false;
                        isBrace = token.isBrace = true;
                        finished = true;
                        break;
                    }
                }
            }
            if (scanToEnd === true) continue;
            break;
        }
        if (code === $02d66d9be49f6969$require$CHAR_FORWARD_SLASH) {
            slashes.push(index);
            tokens.push(token);
            token = {
                value: "",
                depth: 0,
                isGlob: false
            };
            if (finished === true) continue;
            if (prev === $02d66d9be49f6969$require$CHAR_DOT && index === start + 1) {
                start += 2;
                continue;
            }
            lastIndex = index + 1;
            continue;
        }
        if (opts.noext !== true) {
            const isExtglobChar = code === $02d66d9be49f6969$require$CHAR_PLUS || code === $02d66d9be49f6969$require$CHAR_AT || code === $02d66d9be49f6969$require$CHAR_ASTERISK || code === $02d66d9be49f6969$require$CHAR_QUESTION_MARK || code === $02d66d9be49f6969$require$CHAR_EXCLAMATION_MARK;
            if (isExtglobChar === true && peek() === $02d66d9be49f6969$require$CHAR_LEFT_PARENTHESES) {
                isGlob = token.isGlob = true;
                isExtglob = token.isExtglob = true;
                finished = true;
                if (code === $02d66d9be49f6969$require$CHAR_EXCLAMATION_MARK && index === start) negatedExtglob = true;
                if (scanToEnd === true) {
                    while(eos() !== true && (code = advance())){
                        if (code === $02d66d9be49f6969$require$CHAR_BACKWARD_SLASH) {
                            backslashes = token.backslashes = true;
                            code = advance();
                            continue;
                        }
                        if (code === $02d66d9be49f6969$require$CHAR_RIGHT_PARENTHESES) {
                            isGlob = token.isGlob = true;
                            finished = true;
                            break;
                        }
                    }
                    continue;
                }
                break;
            }
        }
        if (code === $02d66d9be49f6969$require$CHAR_ASTERISK) {
            if (prev === $02d66d9be49f6969$require$CHAR_ASTERISK) isGlobstar = token.isGlobstar = true;
            isGlob = token.isGlob = true;
            finished = true;
            if (scanToEnd === true) continue;
            break;
        }
        if (code === $02d66d9be49f6969$require$CHAR_QUESTION_MARK) {
            isGlob = token.isGlob = true;
            finished = true;
            if (scanToEnd === true) continue;
            break;
        }
        if (code === $02d66d9be49f6969$require$CHAR_LEFT_SQUARE_BRACKET) {
            while(eos() !== true && (next = advance())){
                if (next === $02d66d9be49f6969$require$CHAR_BACKWARD_SLASH) {
                    backslashes = token.backslashes = true;
                    advance();
                    continue;
                }
                if (next === $02d66d9be49f6969$require$CHAR_RIGHT_SQUARE_BRACKET) {
                    isBracket = token.isBracket = true;
                    isGlob = token.isGlob = true;
                    finished = true;
                    break;
                }
            }
            if (scanToEnd === true) continue;
            break;
        }
        if (opts.nonegate !== true && code === $02d66d9be49f6969$require$CHAR_EXCLAMATION_MARK && index === start) {
            negated = token.negated = true;
            start++;
            continue;
        }
        if (opts.noparen !== true && code === $02d66d9be49f6969$require$CHAR_LEFT_PARENTHESES) {
            isGlob = token.isGlob = true;
            if (scanToEnd === true) {
                while(eos() !== true && (code = advance())){
                    if (code === $02d66d9be49f6969$require$CHAR_LEFT_PARENTHESES) {
                        backslashes = token.backslashes = true;
                        code = advance();
                        continue;
                    }
                    if (code === $02d66d9be49f6969$require$CHAR_RIGHT_PARENTHESES) {
                        finished = true;
                        break;
                    }
                }
                continue;
            }
            break;
        }
        if (isGlob === true) {
            finished = true;
            if (scanToEnd === true) continue;
            break;
        }
    }
    if (opts.noext === true) {
        isExtglob = false;
        isGlob = false;
    }
    let base = str;
    let prefix = "";
    let glob = "";
    if (start > 0) {
        prefix = str.slice(0, start);
        str = str.slice(start);
        lastIndex -= start;
    }
    if (base && isGlob === true && lastIndex > 0) {
        base = str.slice(0, lastIndex);
        glob = str.slice(lastIndex);
    } else if (isGlob === true) {
        base = "";
        glob = str;
    } else base = str;
    if (base && base !== "" && base !== "/" && base !== str) {
        if ($02d66d9be49f6969$var$isPathSeparator(base.charCodeAt(base.length - 1))) base = base.slice(0, -1);
    }
    if (opts.unescape === true) {
        if (glob) glob = $8eeXS.removeBackslashes(glob);
        if (base && backslashes === true) base = $8eeXS.removeBackslashes(base);
    }
    const state = {
        prefix: prefix,
        input: input,
        start: start,
        base: base,
        glob: glob,
        isBrace: isBrace,
        isBracket: isBracket,
        isGlob: isGlob,
        isExtglob: isExtglob,
        isGlobstar: isGlobstar,
        negated: negated,
        negatedExtglob: negatedExtglob
    };
    if (opts.tokens === true) {
        state.maxDepth = 0;
        if (!$02d66d9be49f6969$var$isPathSeparator(code)) tokens.push(token);
        state.tokens = tokens;
    }
    if (opts.parts === true || opts.tokens === true) {
        let prevIndex;
        for(let idx = 0; idx < slashes.length; idx++){
            const n = prevIndex ? prevIndex + 1 : start;
            const i = slashes[idx];
            const value = input.slice(n, i);
            if (opts.tokens) {
                if (idx === 0 && start !== 0) {
                    tokens[idx].isPrefix = true;
                    tokens[idx].value = prefix;
                } else tokens[idx].value = value;
                $02d66d9be49f6969$var$depth(tokens[idx]);
                state.maxDepth += tokens[idx].depth;
            }
            if (idx !== 0 || value !== "") parts.push(value);
            prevIndex = i;
        }
        if (prevIndex && prevIndex + 1 < input.length) {
            const value = input.slice(prevIndex + 1);
            parts.push(value);
            if (opts.tokens) {
                tokens[tokens.length - 1].value = value;
                $02d66d9be49f6969$var$depth(tokens[tokens.length - 1]);
                state.maxDepth += tokens[tokens.length - 1].depth;
            }
        }
        state.slashes = slashes;
        state.parts = parts;
    }
    return state;
};
module.exports = $02d66d9be49f6969$var$scan;

});
parcelRequire.register("8eeXS", function(module, exports) {

$parcel$export(module.exports, "hasRegexChars", () => $5fdb3d3811ab7941$export$6540a013a39bb50d, (v) => $5fdb3d3811ab7941$export$6540a013a39bb50d = v);
$parcel$export(module.exports, "escapeRegex", () => $5fdb3d3811ab7941$export$104ed90cc1a13451, (v) => $5fdb3d3811ab7941$export$104ed90cc1a13451 = v);
$parcel$export(module.exports, "toPosixSlashes", () => $5fdb3d3811ab7941$export$e610e037975797ee, (v) => $5fdb3d3811ab7941$export$e610e037975797ee = v);
$parcel$export(module.exports, "removeBackslashes", () => $5fdb3d3811ab7941$export$f403de0a7ba7a743, (v) => $5fdb3d3811ab7941$export$f403de0a7ba7a743 = v);
$parcel$export(module.exports, "escapeLast", () => $5fdb3d3811ab7941$export$13d0f4185f159c8, (v) => $5fdb3d3811ab7941$export$13d0f4185f159c8 = v);
$parcel$export(module.exports, "removePrefix", () => $5fdb3d3811ab7941$export$f2888183a34644d4, (v) => $5fdb3d3811ab7941$export$f2888183a34644d4 = v);
$parcel$export(module.exports, "wrapOutput", () => $5fdb3d3811ab7941$export$25bddda26836484b, (v) => $5fdb3d3811ab7941$export$25bddda26836484b = v);
$parcel$export(module.exports, "basename", () => $5fdb3d3811ab7941$export$9bf319d8f74f51d1, (v) => $5fdb3d3811ab7941$export$9bf319d8f74f51d1 = v);
var $5fdb3d3811ab7941$export$a6cdc56e425d0d0a;
var $5fdb3d3811ab7941$export$6540a013a39bb50d;
var $5fdb3d3811ab7941$export$a92319f7ab133839;
var $5fdb3d3811ab7941$export$104ed90cc1a13451;
var $5fdb3d3811ab7941$export$e610e037975797ee;
var $5fdb3d3811ab7941$export$f403de0a7ba7a743;
var $5fdb3d3811ab7941$export$13d0f4185f159c8;
var $5fdb3d3811ab7941$export$f2888183a34644d4;
var $5fdb3d3811ab7941$export$25bddda26836484b;
var $5fdb3d3811ab7941$export$9bf319d8f74f51d1;
"use strict";

var $bpCeP = parcelRequire("bpCeP");
var $5fdb3d3811ab7941$require$REGEX_BACKSLASH = $bpCeP.REGEX_BACKSLASH;
var $5fdb3d3811ab7941$require$REGEX_REMOVE_BACKSLASH = $bpCeP.REGEX_REMOVE_BACKSLASH;
var $5fdb3d3811ab7941$require$REGEX_SPECIAL_CHARS = $bpCeP.REGEX_SPECIAL_CHARS;
var $5fdb3d3811ab7941$require$REGEX_SPECIAL_CHARS_GLOBAL = $bpCeP.REGEX_SPECIAL_CHARS_GLOBAL;
$5fdb3d3811ab7941$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object" && !Array.isArray(val);
$5fdb3d3811ab7941$export$6540a013a39bb50d = (str)=>$5fdb3d3811ab7941$require$REGEX_SPECIAL_CHARS.test(str);
$5fdb3d3811ab7941$export$a92319f7ab133839 = (str)=>str.length === 1 && $5fdb3d3811ab7941$export$6540a013a39bb50d(str);
$5fdb3d3811ab7941$export$104ed90cc1a13451 = (str)=>str.replace($5fdb3d3811ab7941$require$REGEX_SPECIAL_CHARS_GLOBAL, "\\$1");
$5fdb3d3811ab7941$export$e610e037975797ee = (str)=>str.replace($5fdb3d3811ab7941$require$REGEX_BACKSLASH, "/");
$5fdb3d3811ab7941$export$f403de0a7ba7a743 = (str)=>{
    return str.replace($5fdb3d3811ab7941$require$REGEX_REMOVE_BACKSLASH, (match)=>{
        return match === "\\" ? "" : match;
    });
};
$5fdb3d3811ab7941$export$13d0f4185f159c8 = (input, char, lastIdx)=>{
    const idx = input.lastIndexOf(char, lastIdx);
    if (idx === -1) return input;
    if (input[idx - 1] === "\\") return $5fdb3d3811ab7941$export$13d0f4185f159c8(input, char, idx - 1);
    return `${input.slice(0, idx)}\\${input.slice(idx)}`;
};
$5fdb3d3811ab7941$export$f2888183a34644d4 = (input, state = {})=>{
    let output = input;
    if (output.startsWith("./")) {
        output = output.slice(2);
        state.prefix = "./";
    }
    return output;
};
$5fdb3d3811ab7941$export$25bddda26836484b = (input, state = {}, options = {})=>{
    const prepend = options.contains ? "" : "^";
    const append = options.contains ? "" : "$";
    let output = `${prepend}(?:${input})${append}`;
    if (state.negated === true) output = `(?:^(?!${output}).*$)`;
    return output;
};
$5fdb3d3811ab7941$export$9bf319d8f74f51d1 = (path, { windows: windows } = {})=>{
    const segs = path.split(windows ? /[\\/]/ : "/");
    const last = segs[segs.length - 1];
    if (last === "") return segs[segs.length - 2];
    return last;
};

});
parcelRequire.register("bpCeP", function(module, exports) {
"use strict";
const $84efb0d36ff39d53$var$WIN_SLASH = "\\\\/";
const $84efb0d36ff39d53$var$WIN_NO_SLASH = `[^${$84efb0d36ff39d53$var$WIN_SLASH}]`;
/**
 * Posix glob regex
 */ const $84efb0d36ff39d53$var$DOT_LITERAL = "\\.";
const $84efb0d36ff39d53$var$PLUS_LITERAL = "\\+";
const $84efb0d36ff39d53$var$QMARK_LITERAL = "\\?";
const $84efb0d36ff39d53$var$SLASH_LITERAL = "\\/";
const $84efb0d36ff39d53$var$ONE_CHAR = "(?=.)";
const $84efb0d36ff39d53$var$QMARK = "[^/]";
const $84efb0d36ff39d53$var$END_ANCHOR = `(?:${$84efb0d36ff39d53$var$SLASH_LITERAL}|$)`;
const $84efb0d36ff39d53$var$START_ANCHOR = `(?:^|${$84efb0d36ff39d53$var$SLASH_LITERAL})`;
const $84efb0d36ff39d53$var$DOTS_SLASH = `${$84efb0d36ff39d53$var$DOT_LITERAL}{1,2}${$84efb0d36ff39d53$var$END_ANCHOR}`;
const $84efb0d36ff39d53$var$NO_DOT = `(?!${$84efb0d36ff39d53$var$DOT_LITERAL})`;
const $84efb0d36ff39d53$var$NO_DOTS = `(?!${$84efb0d36ff39d53$var$START_ANCHOR}${$84efb0d36ff39d53$var$DOTS_SLASH})`;
const $84efb0d36ff39d53$var$NO_DOT_SLASH = `(?!${$84efb0d36ff39d53$var$DOT_LITERAL}{0,1}${$84efb0d36ff39d53$var$END_ANCHOR})`;
const $84efb0d36ff39d53$var$NO_DOTS_SLASH = `(?!${$84efb0d36ff39d53$var$DOTS_SLASH})`;
const $84efb0d36ff39d53$var$QMARK_NO_DOT = `[^.${$84efb0d36ff39d53$var$SLASH_LITERAL}]`;
const $84efb0d36ff39d53$var$STAR = `${$84efb0d36ff39d53$var$QMARK}*?`;
const $84efb0d36ff39d53$var$SEP = "/";
const $84efb0d36ff39d53$var$POSIX_CHARS = {
    DOT_LITERAL: $84efb0d36ff39d53$var$DOT_LITERAL,
    PLUS_LITERAL: $84efb0d36ff39d53$var$PLUS_LITERAL,
    QMARK_LITERAL: $84efb0d36ff39d53$var$QMARK_LITERAL,
    SLASH_LITERAL: $84efb0d36ff39d53$var$SLASH_LITERAL,
    ONE_CHAR: $84efb0d36ff39d53$var$ONE_CHAR,
    QMARK: $84efb0d36ff39d53$var$QMARK,
    END_ANCHOR: $84efb0d36ff39d53$var$END_ANCHOR,
    DOTS_SLASH: $84efb0d36ff39d53$var$DOTS_SLASH,
    NO_DOT: $84efb0d36ff39d53$var$NO_DOT,
    NO_DOTS: $84efb0d36ff39d53$var$NO_DOTS,
    NO_DOT_SLASH: $84efb0d36ff39d53$var$NO_DOT_SLASH,
    NO_DOTS_SLASH: $84efb0d36ff39d53$var$NO_DOTS_SLASH,
    QMARK_NO_DOT: $84efb0d36ff39d53$var$QMARK_NO_DOT,
    STAR: $84efb0d36ff39d53$var$STAR,
    START_ANCHOR: $84efb0d36ff39d53$var$START_ANCHOR,
    SEP: $84efb0d36ff39d53$var$SEP
};
/**
 * Windows glob regex
 */ const $84efb0d36ff39d53$var$WINDOWS_CHARS = {
    ...$84efb0d36ff39d53$var$POSIX_CHARS,
    SLASH_LITERAL: `[${$84efb0d36ff39d53$var$WIN_SLASH}]`,
    QMARK: $84efb0d36ff39d53$var$WIN_NO_SLASH,
    STAR: `${$84efb0d36ff39d53$var$WIN_NO_SLASH}*?`,
    DOTS_SLASH: `${$84efb0d36ff39d53$var$DOT_LITERAL}{1,2}(?:[${$84efb0d36ff39d53$var$WIN_SLASH}]|$)`,
    NO_DOT: `(?!${$84efb0d36ff39d53$var$DOT_LITERAL})`,
    NO_DOTS: `(?!(?:^|[${$84efb0d36ff39d53$var$WIN_SLASH}])${$84efb0d36ff39d53$var$DOT_LITERAL}{1,2}(?:[${$84efb0d36ff39d53$var$WIN_SLASH}]|$))`,
    NO_DOT_SLASH: `(?!${$84efb0d36ff39d53$var$DOT_LITERAL}{0,1}(?:[${$84efb0d36ff39d53$var$WIN_SLASH}]|$))`,
    NO_DOTS_SLASH: `(?!${$84efb0d36ff39d53$var$DOT_LITERAL}{1,2}(?:[${$84efb0d36ff39d53$var$WIN_SLASH}]|$))`,
    QMARK_NO_DOT: `[^.${$84efb0d36ff39d53$var$WIN_SLASH}]`,
    START_ANCHOR: `(?:^|[${$84efb0d36ff39d53$var$WIN_SLASH}])`,
    END_ANCHOR: `(?:[${$84efb0d36ff39d53$var$WIN_SLASH}]|$)`,
    SEP: "\\"
};
/**
 * POSIX Bracket Regex
 */ const $84efb0d36ff39d53$var$POSIX_REGEX_SOURCE = {
    alnum: "a-zA-Z0-9",
    alpha: "a-zA-Z",
    ascii: "\\x00-\\x7F",
    blank: " \\t",
    cntrl: "\\x00-\\x1F\\x7F",
    digit: "0-9",
    graph: "\\x21-\\x7E",
    lower: "a-z",
    print: "\\x20-\\x7E ",
    punct: "\\-!\"#$%&'()\\*+,./:;<=>?@[\\]^_`{|}~",
    space: " \\t\\r\\n\\v\\f",
    upper: "A-Z",
    word: "A-Za-z0-9_",
    xdigit: "A-Fa-f0-9"
};
module.exports = {
    MAX_LENGTH: 65536,
    POSIX_REGEX_SOURCE: $84efb0d36ff39d53$var$POSIX_REGEX_SOURCE,
    // regular expressions
    REGEX_BACKSLASH: /\\(?![*+?^${}(|)[\]])/g,
    REGEX_NON_SPECIAL_CHARS: /^[^@![\].,$*+?^{}()|\\/]+/,
    REGEX_SPECIAL_CHARS: /[-*+?.^${}(|)[\]]/,
    REGEX_SPECIAL_CHARS_BACKREF: /(\\?)((\W)(\3*))/g,
    REGEX_SPECIAL_CHARS_GLOBAL: /([-*+?.^${}(|)[\]])/g,
    REGEX_REMOVE_BACKSLASH: /(?:\[.*?[^\\]\]|\\(?=.))/g,
    // Replace globs with equivalent patterns to reduce parsing time.
    REPLACEMENTS: {
        "***": "*",
        "**/**": "**",
        "**/**/**": "**"
    },
    // Digits
    CHAR_0: 48,
    /* 0 */ CHAR_9: 57,
    /* 9 */ // Alphabet chars.
    CHAR_UPPERCASE_A: 65,
    /* A */ CHAR_LOWERCASE_A: 97,
    /* a */ CHAR_UPPERCASE_Z: 90,
    /* Z */ CHAR_LOWERCASE_Z: 122,
    /* z */ CHAR_LEFT_PARENTHESES: 40,
    /* ( */ CHAR_RIGHT_PARENTHESES: 41,
    /* ) */ CHAR_ASTERISK: 42,
    /* * */ // Non-alphabetic chars.
    CHAR_AMPERSAND: 38,
    /* & */ CHAR_AT: 64,
    /* @ */ CHAR_BACKWARD_SLASH: 92,
    /* \ */ CHAR_CARRIAGE_RETURN: 13,
    /* \r */ CHAR_CIRCUMFLEX_ACCENT: 94,
    /* ^ */ CHAR_COLON: 58,
    /* : */ CHAR_COMMA: 44,
    /* , */ CHAR_DOT: 46,
    /* . */ CHAR_DOUBLE_QUOTE: 34,
    /* " */ CHAR_EQUAL: 61,
    /* = */ CHAR_EXCLAMATION_MARK: 33,
    /* ! */ CHAR_FORM_FEED: 12,
    /* \f */ CHAR_FORWARD_SLASH: 47,
    /* / */ CHAR_GRAVE_ACCENT: 96,
    /* ` */ CHAR_HASH: 35,
    /* # */ CHAR_HYPHEN_MINUS: 45,
    /* - */ CHAR_LEFT_ANGLE_BRACKET: 60,
    /* < */ CHAR_LEFT_CURLY_BRACE: 123,
    /* { */ CHAR_LEFT_SQUARE_BRACKET: 91,
    /* [ */ CHAR_LINE_FEED: 10,
    /* \n */ CHAR_NO_BREAK_SPACE: 160,
    /* \u00A0 */ CHAR_PERCENT: 37,
    /* % */ CHAR_PLUS: 43,
    /* + */ CHAR_QUESTION_MARK: 63,
    /* ? */ CHAR_RIGHT_ANGLE_BRACKET: 62,
    /* > */ CHAR_RIGHT_CURLY_BRACE: 125,
    /* } */ CHAR_RIGHT_SQUARE_BRACKET: 93,
    /* ] */ CHAR_SEMICOLON: 59,
    /* ; */ CHAR_SINGLE_QUOTE: 39,
    /* ' */ CHAR_SPACE: 32,
    /*   */ CHAR_TAB: 9,
    /* \t */ CHAR_UNDERSCORE: 95,
    /* _ */ CHAR_VERTICAL_LINE: 124,
    /* | */ CHAR_ZERO_WIDTH_NOBREAK_SPACE: 65279,
    /* \uFEFF */ /**
   * Create EXTGLOB_CHARS
   */ extglobChars (chars) {
        return {
            "!": {
                type: "negate",
                open: "(?:(?!(?:",
                close: `))${chars.STAR})`
            },
            "?": {
                type: "qmark",
                open: "(?:",
                close: ")?"
            },
            "+": {
                type: "plus",
                open: "(?:",
                close: ")+"
            },
            "*": {
                type: "star",
                open: "(?:",
                close: ")*"
            },
            "@": {
                type: "at",
                open: "(?:",
                close: ")"
            }
        };
    },
    /**
   * Create GLOB_CHARS
   */ globChars (win32) {
        return win32 === true ? $84efb0d36ff39d53$var$WINDOWS_CHARS : $84efb0d36ff39d53$var$POSIX_CHARS;
    }
};

});



parcelRequire.register("MepZY", function(module, exports) {
"use strict";

var $bpCeP = parcelRequire("bpCeP");

var $8eeXS = parcelRequire("8eeXS");
/**
 * Constants
 */ const { MAX_LENGTH: $090faafd742897eb$var$MAX_LENGTH, POSIX_REGEX_SOURCE: $090faafd742897eb$var$POSIX_REGEX_SOURCE, REGEX_NON_SPECIAL_CHARS: $090faafd742897eb$var$REGEX_NON_SPECIAL_CHARS, REGEX_SPECIAL_CHARS_BACKREF: $090faafd742897eb$var$REGEX_SPECIAL_CHARS_BACKREF, REPLACEMENTS: $090faafd742897eb$var$REPLACEMENTS } = $bpCeP;
/**
 * Helpers
 */ const $090faafd742897eb$var$expandRange = (args, options)=>{
    if (typeof options.expandRange === "function") return options.expandRange(...args, options);
    args.sort();
    const value = `[${args.join("-")}]`;
    try {
        /* eslint-disable-next-line no-new */ new RegExp(value);
    } catch (ex) {
        return args.map((v)=>$8eeXS.escapeRegex(v)).join("..");
    }
    return value;
};
/**
 * Create the message for a syntax error
 */ const $090faafd742897eb$var$syntaxError = (type, char)=>{
    return `Missing ${type}: "${char}" - use "\\\\${char}" to match literal characters`;
};
/**
 * Parse the given input string.
 * @param {String} input
 * @param {Object} options
 * @return {Object}
 */ const $090faafd742897eb$var$parse = (input, options)=>{
    if (typeof input !== "string") throw new TypeError("Expected a string");
    input = $090faafd742897eb$var$REPLACEMENTS[input] || input;
    const opts = {
        ...options
    };
    const max = typeof opts.maxLength === "number" ? Math.min($090faafd742897eb$var$MAX_LENGTH, opts.maxLength) : $090faafd742897eb$var$MAX_LENGTH;
    let len = input.length;
    if (len > max) throw new SyntaxError(`Input length: ${len}, exceeds maximum allowed length: ${max}`);
    const bos = {
        type: "bos",
        value: "",
        output: opts.prepend || ""
    };
    const tokens = [
        bos
    ];
    const capture = opts.capture ? "" : "?:";
    // create constants based on platform, for windows or posix
    const PLATFORM_CHARS = $bpCeP.globChars(opts.windows);
    const EXTGLOB_CHARS = $bpCeP.extglobChars(PLATFORM_CHARS);
    const { DOT_LITERAL: DOT_LITERAL, PLUS_LITERAL: PLUS_LITERAL, SLASH_LITERAL: SLASH_LITERAL, ONE_CHAR: ONE_CHAR, DOTS_SLASH: DOTS_SLASH, NO_DOT: NO_DOT, NO_DOT_SLASH: NO_DOT_SLASH, NO_DOTS_SLASH: NO_DOTS_SLASH, QMARK: QMARK, QMARK_NO_DOT: QMARK_NO_DOT, STAR: STAR, START_ANCHOR: START_ANCHOR } = PLATFORM_CHARS;
    const globstar = (opts)=>{
        return `(${capture}(?:(?!${START_ANCHOR}${opts.dot ? DOTS_SLASH : DOT_LITERAL}).)*?)`;
    };
    const nodot = opts.dot ? "" : NO_DOT;
    const qmarkNoDot = opts.dot ? QMARK : QMARK_NO_DOT;
    let star = opts.bash === true ? globstar(opts) : STAR;
    if (opts.capture) star = `(${star})`;
    // minimatch options support
    if (typeof opts.noext === "boolean") opts.noextglob = opts.noext;
    const state = {
        input: input,
        index: -1,
        start: 0,
        dot: opts.dot === true,
        consumed: "",
        output: "",
        prefix: "",
        backtrack: false,
        negated: false,
        brackets: 0,
        braces: 0,
        parens: 0,
        quotes: 0,
        globstar: false,
        tokens: tokens
    };
    input = $8eeXS.removePrefix(input, state);
    len = input.length;
    const extglobs = [];
    const braces = [];
    const stack = [];
    let prev = bos;
    let value;
    /**
   * Tokenizing helpers
   */ const eos = ()=>state.index === len - 1;
    const peek = state.peek = (n = 1)=>input[state.index + n];
    const advance = state.advance = ()=>input[++state.index] || "";
    const remaining = ()=>input.slice(state.index + 1);
    const consume = (value = "", num = 0)=>{
        state.consumed += value;
        state.index += num;
    };
    const append = (token)=>{
        state.output += token.output != null ? token.output : token.value;
        consume(token.value);
    };
    const negate = ()=>{
        let count = 1;
        while(peek() === "!" && (peek(2) !== "(" || peek(3) === "?")){
            advance();
            state.start++;
            count++;
        }
        if (count % 2 === 0) return false;
        state.negated = true;
        state.start++;
        return true;
    };
    const increment = (type)=>{
        state[type]++;
        stack.push(type);
    };
    const decrement = (type)=>{
        state[type]--;
        stack.pop();
    };
    /**
   * Push tokens onto the tokens array. This helper speeds up
   * tokenizing by 1) helping us avoid backtracking as much as possible,
   * and 2) helping us avoid creating extra tokens when consecutive
   * characters are plain text. This improves performance and simplifies
   * lookbehinds.
   */ const push = (tok)=>{
        if (prev.type === "globstar") {
            const isBrace = state.braces > 0 && (tok.type === "comma" || tok.type === "brace");
            const isExtglob = tok.extglob === true || extglobs.length && (tok.type === "pipe" || tok.type === "paren");
            if (tok.type !== "slash" && tok.type !== "paren" && !isBrace && !isExtglob) {
                state.output = state.output.slice(0, -prev.output.length);
                prev.type = "star";
                prev.value = "*";
                prev.output = star;
                state.output += prev.output;
            }
        }
        if (extglobs.length && tok.type !== "paren") extglobs[extglobs.length - 1].inner += tok.value;
        if (tok.value || tok.output) append(tok);
        if (prev && prev.type === "text" && tok.type === "text") {
            prev.output = (prev.output || prev.value) + tok.value;
            prev.value += tok.value;
            return;
        }
        tok.prev = prev;
        tokens.push(tok);
        prev = tok;
    };
    const extglobOpen = (type, value)=>{
        const token = {
            ...EXTGLOB_CHARS[value],
            conditions: 1,
            inner: ""
        };
        token.prev = prev;
        token.parens = state.parens;
        token.output = state.output;
        const output = (opts.capture ? "(" : "") + token.open;
        increment("parens");
        push({
            type: type,
            value: value,
            output: state.output ? "" : ONE_CHAR
        });
        push({
            type: "paren",
            extglob: true,
            value: advance(),
            output: output
        });
        extglobs.push(token);
    };
    const extglobClose = (token)=>{
        let output = token.close + (opts.capture ? ")" : "");
        let rest;
        if (token.type === "negate") {
            let extglobStar = star;
            if (token.inner && token.inner.length > 1 && token.inner.includes("/")) extglobStar = globstar(opts);
            if (extglobStar !== star || eos() || /^\)+$/.test(remaining())) output = token.close = `)$))${extglobStar}`;
            if (token.inner.includes("*") && (rest = remaining()) && /^\.[^\\/.]+$/.test(rest)) {
                // Any non-magical string (`.ts`) or even nested expression (`.{ts,tsx}`) can follow after the closing parenthesis.
                // In this case, we need to parse the string and use it in the output of the original pattern.
                // Suitable patterns: `/!(*.d).ts`, `/!(*.d).{ts,tsx}`, `**/!(*-dbg).@(js)`.
                //
                // Disabling the `fastpaths` option due to a problem with parsing strings as `.ts` in the pattern like `**/!(*.d).ts`.
                const expression = $090faafd742897eb$var$parse(rest, {
                    ...options,
                    fastpaths: false
                }).output;
                output = token.close = `)${expression})${extglobStar})`;
            }
            if (token.prev.type === "bos") state.negatedExtglob = true;
        }
        push({
            type: "paren",
            extglob: true,
            value: value,
            output: output
        });
        decrement("parens");
    };
    /**
   * Fast paths
   */ if (opts.fastpaths !== false && !/(^[*!]|[/()[\]{}"])/.test(input)) {
        let backslashes = false;
        let output = input.replace($090faafd742897eb$var$REGEX_SPECIAL_CHARS_BACKREF, (m, esc, chars, first, rest, index)=>{
            if (first === "\\") {
                backslashes = true;
                return m;
            }
            if (first === "?") {
                if (esc) return esc + first + (rest ? QMARK.repeat(rest.length) : "");
                if (index === 0) return qmarkNoDot + (rest ? QMARK.repeat(rest.length) : "");
                return QMARK.repeat(chars.length);
            }
            if (first === ".") return DOT_LITERAL.repeat(chars.length);
            if (first === "*") {
                if (esc) return esc + first + (rest ? star : "");
                return star;
            }
            return esc ? m : `\\${m}`;
        });
        if (backslashes === true) {
            if (opts.unescape === true) output = output.replace(/\\/g, "");
            else output = output.replace(/\\+/g, (m)=>{
                return m.length % 2 === 0 ? "\\\\" : m ? "\\" : "";
            });
        }
        if (output === input && opts.contains === true) {
            state.output = input;
            return state;
        }
        state.output = $8eeXS.wrapOutput(output, state, options);
        return state;
    }
    /**
   * Tokenize input until we reach end-of-string
   */ while(!eos()){
        value = advance();
        if (value === "\x00") continue;
        /**
     * Escaped characters
     */ if (value === "\\") {
            const next = peek();
            if (next === "/" && opts.bash !== true) continue;
            if (next === "." || next === ";") continue;
            if (!next) {
                value += "\\";
                push({
                    type: "text",
                    value: value
                });
                continue;
            }
            // collapse slashes to reduce potential for exploits
            const match = /^\\+/.exec(remaining());
            let slashes = 0;
            if (match && match[0].length > 2) {
                slashes = match[0].length;
                state.index += slashes;
                if (slashes % 2 !== 0) value += "\\";
            }
            if (opts.unescape === true) value = advance();
            else value += advance();
            if (state.brackets === 0) {
                push({
                    type: "text",
                    value: value
                });
                continue;
            }
        }
        /**
     * If we're inside a regex character class, continue
     * until we reach the closing bracket.
     */ if (state.brackets > 0 && (value !== "]" || prev.value === "[" || prev.value === "[^")) {
            if (opts.posix !== false && value === ":") {
                const inner = prev.value.slice(1);
                if (inner.includes("[")) {
                    prev.posix = true;
                    if (inner.includes(":")) {
                        const idx = prev.value.lastIndexOf("[");
                        const pre = prev.value.slice(0, idx);
                        const rest = prev.value.slice(idx + 2);
                        const posix = $090faafd742897eb$var$POSIX_REGEX_SOURCE[rest];
                        if (posix) {
                            prev.value = pre + posix;
                            state.backtrack = true;
                            advance();
                            if (!bos.output && tokens.indexOf(prev) === 1) bos.output = ONE_CHAR;
                            continue;
                        }
                    }
                }
            }
            if (value === "[" && peek() !== ":" || value === "-" && peek() === "]") value = `\\${value}`;
            if (value === "]" && (prev.value === "[" || prev.value === "[^")) value = `\\${value}`;
            if (opts.posix === true && value === "!" && prev.value === "[") value = "^";
            prev.value += value;
            append({
                value: value
            });
            continue;
        }
        /**
     * If we're inside a quoted string, continue
     * until we reach the closing double quote.
     */ if (state.quotes === 1 && value !== '"') {
            value = $8eeXS.escapeRegex(value);
            prev.value += value;
            append({
                value: value
            });
            continue;
        }
        /**
     * Double quotes
     */ if (value === '"') {
            state.quotes = state.quotes === 1 ? 0 : 1;
            if (opts.keepQuotes === true) push({
                type: "text",
                value: value
            });
            continue;
        }
        /**
     * Parentheses
     */ if (value === "(") {
            increment("parens");
            push({
                type: "paren",
                value: value
            });
            continue;
        }
        if (value === ")") {
            if (state.parens === 0 && opts.strictBrackets === true) throw new SyntaxError($090faafd742897eb$var$syntaxError("opening", "("));
            const extglob = extglobs[extglobs.length - 1];
            if (extglob && state.parens === extglob.parens + 1) {
                extglobClose(extglobs.pop());
                continue;
            }
            push({
                type: "paren",
                value: value,
                output: state.parens ? ")" : "\\)"
            });
            decrement("parens");
            continue;
        }
        /**
     * Square brackets
     */ if (value === "[") {
            if (opts.nobracket === true || !remaining().includes("]")) {
                if (opts.nobracket !== true && opts.strictBrackets === true) throw new SyntaxError($090faafd742897eb$var$syntaxError("closing", "]"));
                value = `\\${value}`;
            } else increment("brackets");
            push({
                type: "bracket",
                value: value
            });
            continue;
        }
        if (value === "]") {
            if (opts.nobracket === true || prev && prev.type === "bracket" && prev.value.length === 1) {
                push({
                    type: "text",
                    value: value,
                    output: `\\${value}`
                });
                continue;
            }
            if (state.brackets === 0) {
                if (opts.strictBrackets === true) throw new SyntaxError($090faafd742897eb$var$syntaxError("opening", "["));
                push({
                    type: "text",
                    value: value,
                    output: `\\${value}`
                });
                continue;
            }
            decrement("brackets");
            const prevValue = prev.value.slice(1);
            if (prev.posix !== true && prevValue[0] === "^" && !prevValue.includes("/")) value = `/${value}`;
            prev.value += value;
            append({
                value: value
            });
            // when literal brackets are explicitly disabled
            // assume we should match with a regex character class
            if (opts.literalBrackets === false || $8eeXS.hasRegexChars(prevValue)) continue;
            const escaped = $8eeXS.escapeRegex(prev.value);
            state.output = state.output.slice(0, -prev.value.length);
            // when literal brackets are explicitly enabled
            // assume we should escape the brackets to match literal characters
            if (opts.literalBrackets === true) {
                state.output += escaped;
                prev.value = escaped;
                continue;
            }
            // when the user specifies nothing, try to match both
            prev.value = `(${capture}${escaped}|${prev.value})`;
            state.output += prev.value;
            continue;
        }
        /**
     * Braces
     */ if (value === "{" && opts.nobrace !== true) {
            increment("braces");
            const open = {
                type: "brace",
                value: value,
                output: "(",
                outputIndex: state.output.length,
                tokensIndex: state.tokens.length
            };
            braces.push(open);
            push(open);
            continue;
        }
        if (value === "}") {
            const brace = braces[braces.length - 1];
            if (opts.nobrace === true || !brace) {
                push({
                    type: "text",
                    value: value,
                    output: value
                });
                continue;
            }
            let output = ")";
            if (brace.dots === true) {
                const arr = tokens.slice();
                const range = [];
                for(let i = arr.length - 1; i >= 0; i--){
                    tokens.pop();
                    if (arr[i].type === "brace") break;
                    if (arr[i].type !== "dots") range.unshift(arr[i].value);
                }
                output = $090faafd742897eb$var$expandRange(range, opts);
                state.backtrack = true;
            }
            if (brace.comma !== true && brace.dots !== true) {
                const out = state.output.slice(0, brace.outputIndex);
                const toks = state.tokens.slice(brace.tokensIndex);
                brace.value = brace.output = "\\{";
                value = output = "\\}";
                state.output = out;
                for (const t of toks)state.output += t.output || t.value;
            }
            push({
                type: "brace",
                value: value,
                output: output
            });
            decrement("braces");
            braces.pop();
            continue;
        }
        /**
     * Pipes
     */ if (value === "|") {
            if (extglobs.length > 0) extglobs[extglobs.length - 1].conditions++;
            push({
                type: "text",
                value: value
            });
            continue;
        }
        /**
     * Commas
     */ if (value === ",") {
            let output = value;
            const brace = braces[braces.length - 1];
            if (brace && stack[stack.length - 1] === "braces") {
                brace.comma = true;
                output = "|";
            }
            push({
                type: "comma",
                value: value,
                output: output
            });
            continue;
        }
        /**
     * Slashes
     */ if (value === "/") {
            // if the beginning of the glob is "./", advance the start
            // to the current index, and don't add the "./" characters
            // to the state. This greatly simplifies lookbehinds when
            // checking for BOS characters like "!" and "." (not "./")
            if (prev.type === "dot" && state.index === state.start + 1) {
                state.start = state.index + 1;
                state.consumed = "";
                state.output = "";
                tokens.pop();
                prev = bos; // reset "prev" to the first token
                continue;
            }
            push({
                type: "slash",
                value: value,
                output: SLASH_LITERAL
            });
            continue;
        }
        /**
     * Dots
     */ if (value === ".") {
            if (state.braces > 0 && prev.type === "dot") {
                if (prev.value === ".") prev.output = DOT_LITERAL;
                const brace = braces[braces.length - 1];
                prev.type = "dots";
                prev.output += value;
                prev.value += value;
                brace.dots = true;
                continue;
            }
            if (state.braces + state.parens === 0 && prev.type !== "bos" && prev.type !== "slash") {
                push({
                    type: "text",
                    value: value,
                    output: DOT_LITERAL
                });
                continue;
            }
            push({
                type: "dot",
                value: value,
                output: DOT_LITERAL
            });
            continue;
        }
        /**
     * Question marks
     */ if (value === "?") {
            const isGroup = prev && prev.value === "(";
            if (!isGroup && opts.noextglob !== true && peek() === "(" && peek(2) !== "?") {
                extglobOpen("qmark", value);
                continue;
            }
            if (prev && prev.type === "paren") {
                const next = peek();
                let output = value;
                if (prev.value === "(" && !/[!=<:]/.test(next) || next === "<" && !/<([!=]|\w+>)/.test(remaining())) output = `\\${value}`;
                push({
                    type: "text",
                    value: value,
                    output: output
                });
                continue;
            }
            if (opts.dot !== true && (prev.type === "slash" || prev.type === "bos")) {
                push({
                    type: "qmark",
                    value: value,
                    output: QMARK_NO_DOT
                });
                continue;
            }
            push({
                type: "qmark",
                value: value,
                output: QMARK
            });
            continue;
        }
        /**
     * Exclamation
     */ if (value === "!") {
            if (opts.noextglob !== true && peek() === "(") {
                if (peek(2) !== "?" || !/[!=<:]/.test(peek(3))) {
                    extglobOpen("negate", value);
                    continue;
                }
            }
            if (opts.nonegate !== true && state.index === 0) {
                negate();
                continue;
            }
        }
        /**
     * Plus
     */ if (value === "+") {
            if (opts.noextglob !== true && peek() === "(" && peek(2) !== "?") {
                extglobOpen("plus", value);
                continue;
            }
            if (prev && prev.value === "(" || opts.regex === false) {
                push({
                    type: "plus",
                    value: value,
                    output: PLUS_LITERAL
                });
                continue;
            }
            if (prev && (prev.type === "bracket" || prev.type === "paren" || prev.type === "brace") || state.parens > 0) {
                push({
                    type: "plus",
                    value: value
                });
                continue;
            }
            push({
                type: "plus",
                value: PLUS_LITERAL
            });
            continue;
        }
        /**
     * Plain text
     */ if (value === "@") {
            if (opts.noextglob !== true && peek() === "(" && peek(2) !== "?") {
                push({
                    type: "at",
                    extglob: true,
                    value: value,
                    output: ""
                });
                continue;
            }
            push({
                type: "text",
                value: value
            });
            continue;
        }
        /**
     * Plain text
     */ if (value !== "*") {
            if (value === "$" || value === "^") value = `\\${value}`;
            const match = $090faafd742897eb$var$REGEX_NON_SPECIAL_CHARS.exec(remaining());
            if (match) {
                value += match[0];
                state.index += match[0].length;
            }
            push({
                type: "text",
                value: value
            });
            continue;
        }
        /**
     * Stars
     */ if (prev && (prev.type === "globstar" || prev.star === true)) {
            prev.type = "star";
            prev.star = true;
            prev.value += value;
            prev.output = star;
            state.backtrack = true;
            state.globstar = true;
            consume(value);
            continue;
        }
        let rest = remaining();
        if (opts.noextglob !== true && /^\([^?]/.test(rest)) {
            extglobOpen("star", value);
            continue;
        }
        if (prev.type === "star") {
            if (opts.noglobstar === true) {
                consume(value);
                continue;
            }
            const prior = prev.prev;
            const before = prior.prev;
            const isStart = prior.type === "slash" || prior.type === "bos";
            const afterStar = before && (before.type === "star" || before.type === "globstar");
            if (opts.bash === true && (!isStart || rest[0] && rest[0] !== "/")) {
                push({
                    type: "star",
                    value: value,
                    output: ""
                });
                continue;
            }
            const isBrace = state.braces > 0 && (prior.type === "comma" || prior.type === "brace");
            const isExtglob = extglobs.length && (prior.type === "pipe" || prior.type === "paren");
            if (!isStart && prior.type !== "paren" && !isBrace && !isExtglob) {
                push({
                    type: "star",
                    value: value,
                    output: ""
                });
                continue;
            }
            // strip consecutive `/**/`
            while(rest.slice(0, 3) === "/**"){
                const after = input[state.index + 4];
                if (after && after !== "/") break;
                rest = rest.slice(3);
                consume("/**", 3);
            }
            if (prior.type === "bos" && eos()) {
                prev.type = "globstar";
                prev.value += value;
                prev.output = globstar(opts);
                state.output = prev.output;
                state.globstar = true;
                consume(value);
                continue;
            }
            if (prior.type === "slash" && prior.prev.type !== "bos" && !afterStar && eos()) {
                state.output = state.output.slice(0, -(prior.output + prev.output).length);
                prior.output = `(?:${prior.output}`;
                prev.type = "globstar";
                prev.output = globstar(opts) + (opts.strictSlashes ? ")" : "|$)");
                prev.value += value;
                state.globstar = true;
                state.output += prior.output + prev.output;
                consume(value);
                continue;
            }
            if (prior.type === "slash" && prior.prev.type !== "bos" && rest[0] === "/") {
                const end = rest[1] !== void 0 ? "|$" : "";
                state.output = state.output.slice(0, -(prior.output + prev.output).length);
                prior.output = `(?:${prior.output}`;
                prev.type = "globstar";
                prev.output = `${globstar(opts)}${SLASH_LITERAL}|${SLASH_LITERAL}${end})`;
                prev.value += value;
                state.output += prior.output + prev.output;
                state.globstar = true;
                consume(value + advance());
                push({
                    type: "slash",
                    value: "/",
                    output: ""
                });
                continue;
            }
            if (prior.type === "bos" && rest[0] === "/") {
                prev.type = "globstar";
                prev.value += value;
                prev.output = `(?:^|${SLASH_LITERAL}|${globstar(opts)}${SLASH_LITERAL})`;
                state.output = prev.output;
                state.globstar = true;
                consume(value + advance());
                push({
                    type: "slash",
                    value: "/",
                    output: ""
                });
                continue;
            }
            // remove single star from output
            state.output = state.output.slice(0, -prev.output.length);
            // reset previous token to globstar
            prev.type = "globstar";
            prev.output = globstar(opts);
            prev.value += value;
            // reset output with globstar
            state.output += prev.output;
            state.globstar = true;
            consume(value);
            continue;
        }
        const token = {
            type: "star",
            value: value,
            output: star
        };
        if (opts.bash === true) {
            token.output = ".*?";
            if (prev.type === "bos" || prev.type === "slash") token.output = nodot + token.output;
            push(token);
            continue;
        }
        if (prev && (prev.type === "bracket" || prev.type === "paren") && opts.regex === true) {
            token.output = value;
            push(token);
            continue;
        }
        if (state.index === state.start || prev.type === "slash" || prev.type === "dot") {
            if (prev.type === "dot") {
                state.output += NO_DOT_SLASH;
                prev.output += NO_DOT_SLASH;
            } else if (opts.dot === true) {
                state.output += NO_DOTS_SLASH;
                prev.output += NO_DOTS_SLASH;
            } else {
                state.output += nodot;
                prev.output += nodot;
            }
            if (peek() !== "*") {
                state.output += ONE_CHAR;
                prev.output += ONE_CHAR;
            }
        }
        push(token);
    }
    while(state.brackets > 0){
        if (opts.strictBrackets === true) throw new SyntaxError($090faafd742897eb$var$syntaxError("closing", "]"));
        state.output = $8eeXS.escapeLast(state.output, "[");
        decrement("brackets");
    }
    while(state.parens > 0){
        if (opts.strictBrackets === true) throw new SyntaxError($090faafd742897eb$var$syntaxError("closing", ")"));
        state.output = $8eeXS.escapeLast(state.output, "(");
        decrement("parens");
    }
    while(state.braces > 0){
        if (opts.strictBrackets === true) throw new SyntaxError($090faafd742897eb$var$syntaxError("closing", "}"));
        state.output = $8eeXS.escapeLast(state.output, "{");
        decrement("braces");
    }
    if (opts.strictSlashes !== true && (prev.type === "star" || prev.type === "bracket")) push({
        type: "maybe_slash",
        value: "",
        output: `${SLASH_LITERAL}?`
    });
    // rebuild the output if we had to backtrack at any point
    if (state.backtrack === true) {
        state.output = "";
        for (const token of state.tokens){
            state.output += token.output != null ? token.output : token.value;
            if (token.suffix) state.output += token.suffix;
        }
    }
    return state;
};
/**
 * Fast paths for creating regular expressions for common glob patterns.
 * This can significantly speed up processing and has very little downside
 * impact when none of the fast paths match.
 */ $090faafd742897eb$var$parse.fastpaths = (input, options)=>{
    const opts = {
        ...options
    };
    const max = typeof opts.maxLength === "number" ? Math.min($090faafd742897eb$var$MAX_LENGTH, opts.maxLength) : $090faafd742897eb$var$MAX_LENGTH;
    const len = input.length;
    if (len > max) throw new SyntaxError(`Input length: ${len}, exceeds maximum allowed length: ${max}`);
    input = $090faafd742897eb$var$REPLACEMENTS[input] || input;
    // create constants based on platform, for windows or posix
    const { DOT_LITERAL: DOT_LITERAL, SLASH_LITERAL: SLASH_LITERAL, ONE_CHAR: ONE_CHAR, DOTS_SLASH: DOTS_SLASH, NO_DOT: NO_DOT, NO_DOTS: NO_DOTS, NO_DOTS_SLASH: NO_DOTS_SLASH, STAR: STAR, START_ANCHOR: START_ANCHOR } = $bpCeP.globChars(opts.windows);
    const nodot = opts.dot ? NO_DOTS : NO_DOT;
    const slashDot = opts.dot ? NO_DOTS_SLASH : NO_DOT;
    const capture = opts.capture ? "" : "?:";
    const state = {
        negated: false,
        prefix: ""
    };
    let star = opts.bash === true ? ".*?" : STAR;
    if (opts.capture) star = `(${star})`;
    const globstar = (opts)=>{
        if (opts.noglobstar === true) return star;
        return `(${capture}(?:(?!${START_ANCHOR}${opts.dot ? DOTS_SLASH : DOT_LITERAL}).)*?)`;
    };
    const create = (str)=>{
        switch(str){
            case "*":
                return `${nodot}${ONE_CHAR}${star}`;
            case ".*":
                return `${DOT_LITERAL}${ONE_CHAR}${star}`;
            case "*.*":
                return `${nodot}${star}${DOT_LITERAL}${ONE_CHAR}${star}`;
            case "*/*":
                return `${nodot}${star}${SLASH_LITERAL}${ONE_CHAR}${slashDot}${star}`;
            case "**":
                return nodot + globstar(opts);
            case "**/*":
                return `(?:${nodot}${globstar(opts)}${SLASH_LITERAL})?${slashDot}${ONE_CHAR}${star}`;
            case "**/*.*":
                return `(?:${nodot}${globstar(opts)}${SLASH_LITERAL})?${slashDot}${star}${DOT_LITERAL}${ONE_CHAR}${star}`;
            case "**/.*":
                return `(?:${nodot}${globstar(opts)}${SLASH_LITERAL})?${DOT_LITERAL}${ONE_CHAR}${star}`;
            default:
                {
                    const match = /^(.*?)\.(\w+)$/.exec(str);
                    if (!match) return;
                    const source = create(match[1]);
                    if (!source) return;
                    return source + DOT_LITERAL + match[2];
                }
        }
    };
    const output = $8eeXS.removePrefix(input, state);
    let source = create(output);
    if (source && opts.strictSlashes !== true) source += `${SLASH_LITERAL}?`;
    return source;
};
module.exports = $090faafd742897eb$var$parse;

});


/*global globalObject, virtualfs*/ 
var $N0o3H = parcelRequire("N0o3H");
var $d2d6477b44a50ea0$require$Buffer = $N0o3H.Buffer;
var $8f57302d7f35c9a9$exports = {};
parcelRequire = function(e, r, t, n) {
    var i, o = "function" == typeof parcelRequire && parcelRequire, u = undefined;
    function f(t, n) {
        if (!r[t]) {
            if (!e[t]) {
                var i = "function" == typeof parcelRequire && parcelRequire;
                if (!n && i) return i(t, !0);
                if (o) return o(t, !0);
                if (u && "string" == typeof t) return u(t);
                var c = new Error("Cannot find module '" + t + "'");
                throw c.code = "MODULE_NOT_FOUND", c;
            }
            p.resolve = function(r) {
                return e[t][1][r] || r;
            }, p.cache = {};
            var l = r[t] = new f.Module(t);
            e[t][0].call(l.exports, p, l, l.exports, this);
        }
        return r[t].exports;
        function p(e) {
            return f(p.resolve(e));
        }
    }
    f.isParcelRequire = !0, f.Module = function(e) {
        this.id = e, this.bundle = f, this.exports = {};
    }, f.modules = e, f.cache = r, f.parent = o, f.register = function(r, t) {
        e[r] = [
            function(e, r) {
                r.exports = t;
            },
            {}
        ];
    };
    for(var c = 0; c < t.length; c++)try {
        f(t[c]);
    } catch (e) {
        i || (i = e);
    }
    if (t.length) {
        var l = f(t[t.length - 1]);
        $8f57302d7f35c9a9$exports = l;
    }
    if (parcelRequire = f, i) throw i;
    return f;
}({
    "b1ZG": [
        function(require1, module1, exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.promisify = e;
            var r = "__ES6-PROMISIFY--CUSTOM-ARGUMENTS__";
            function e(o) {
                if ("function" != typeof o) throw new TypeError("Argument to promisify must be a function");
                var n = o[r], t = e.Promise || Promise;
                if ("function" != typeof t) throw new Error("No Promise implementation found; do you need a polyfill?");
                return function() {
                    for(var r = this, e = arguments.length, i = Array(e), f = 0; f < e; f++)i[f] = arguments[f];
                    return new t(function(e, t) {
                        i.push(function(r) {
                            if (r) return t(r);
                            for(var o = arguments.length, i = Array(1 < o ? o - 1 : 0), f = 1; f < o; f++)i[f - 1] = arguments[f];
                            if (1 === i.length || !n) return e(i[0]);
                            var u = {};
                            i.forEach(function(r, e) {
                                var o = n[e];
                                o && (u[o] = r);
                            }), e(u);
                        }), o.apply(r, i);
                    });
                };
            }
            e.argumentNames = "__ES6-PROMISIFY--CUSTOM-ARGUMENTS__", e.Promise = void 0;
        },
        {}
    ],
    "pBGv": [
        function(require1, module1, exports) {
            var t, e, n = module1.exports = {};
            function r() {
                throw new Error("setTimeout has not been defined");
            }
            function o() {
                throw new Error("clearTimeout has not been defined");
            }
            function i(e) {
                if (t === setTimeout) return setTimeout(e, 0);
                if ((t === r || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                try {
                    return t(e, 0);
                } catch (n) {
                    try {
                        return t.call(null, e, 0);
                    } catch (n) {
                        return t.call(this, e, 0);
                    }
                }
            }
            function u(t) {
                if (e === clearTimeout) return clearTimeout(t);
                if ((e === o || !e) && clearTimeout) return e = clearTimeout, clearTimeout(t);
                try {
                    return e(t);
                } catch (n) {
                    try {
                        return e.call(null, t);
                    } catch (n) {
                        return e.call(this, t);
                    }
                }
            }
            !function() {
                try {
                    t = "function" == typeof setTimeout ? setTimeout : r;
                } catch (n) {
                    t = r;
                }
                try {
                    e = "function" == typeof clearTimeout ? clearTimeout : o;
                } catch (n) {
                    e = o;
                }
            }();
            var c, s = [], l = !1, a = -1;
            function f() {
                l && c && (l = !1, c.length ? s = c.concat(s) : a = -1, s.length && h());
            }
            function h() {
                if (!l) {
                    var t = i(f);
                    l = !0;
                    for(var e = s.length; e;){
                        for(c = s, s = []; ++a < e;)c && c[a].run();
                        a = -1, e = s.length;
                    }
                    c = null, l = !1, u(t);
                }
            }
            function m(t, e) {
                this.fun = t, this.array = e;
            }
            function p() {}
            n.nextTick = function(t) {
                var e = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
                s.push(new m(t, e)), 1 !== s.length || l || i(h);
            }, m.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, n.title = "browser", n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = p, n.addListener = p, n.once = p, n.off = p, n.removeListener = p, n.removeAllListeners = p, n.emit = p, n.prependListener = p, n.prependOnceListener = p, n.listeners = function(t) {
                return [];
            }, n.binding = function(t) {
                throw new Error("process.binding is not supported");
            }, n.cwd = function() {
                return "/";
            }, n.chdir = function(t) {
                throw new Error("process.chdir is not supported");
            }, n.umask = function() {
                return 0;
            };
        },
        {}
    ],
    "UUq2": [
        function(require1, module1, exports) {
            var process = require1("process");
            var r = require1("process");
            function t(r, t) {
                for(var e = 0, n = r.length - 1; n >= 0; n--){
                    var o = r[n];
                    "." === o ? r.splice(n, 1) : ".." === o ? (r.splice(n, 1), e++) : e && (r.splice(n, 1), e--);
                }
                if (t) for(; e--; e)r.unshift("..");
                return r;
            }
            function e(r) {
                "string" != typeof r && (r += "");
                var t, e = 0, n = -1, o = !0;
                for(t = r.length - 1; t >= 0; --t)if (47 === r.charCodeAt(t)) {
                    if (!o) {
                        e = t + 1;
                        break;
                    }
                } else -1 === n && (o = !1, n = t + 1);
                return -1 === n ? "" : r.slice(e, n);
            }
            function n(r, t) {
                if (r.filter) return r.filter(t);
                for(var e = [], n = 0; n < r.length; n++)t(r[n], n, r) && e.push(r[n]);
                return e;
            }
            exports.resolve = function() {
                for(var e = "", o = !1, s = arguments.length - 1; s >= -1 && !o; s--){
                    var i = s >= 0 ? arguments[s] : r.cwd();
                    if ("string" != typeof i) throw new TypeError("Arguments to path.resolve must be strings");
                    i && (e = i + "/" + e, o = "/" === i.charAt(0));
                }
                return (o ? "/" : "") + (e = t(n(e.split("/"), function(r) {
                    return !!r;
                }), !o).join("/")) || ".";
            }, exports.normalize = function(r) {
                var e = exports.isAbsolute(r), s = "/" === o(r, -1);
                return (r = t(n(r.split("/"), function(r) {
                    return !!r;
                }), !e).join("/")) || e || (r = "."), r && s && (r += "/"), (e ? "/" : "") + r;
            }, exports.isAbsolute = function(r) {
                return "/" === r.charAt(0);
            }, exports.join = function() {
                var r = Array.prototype.slice.call(arguments, 0);
                return exports.normalize(n(r, function(r, t) {
                    if ("string" != typeof r) throw new TypeError("Arguments to path.join must be strings");
                    return r;
                }).join("/"));
            }, exports.relative = function(r, t) {
                function e(r) {
                    for(var t = 0; t < r.length && "" === r[t]; t++);
                    for(var e = r.length - 1; e >= 0 && "" === r[e]; e--);
                    return t > e ? [] : r.slice(t, e - t + 1);
                }
                r = exports.resolve(r).substr(1), t = exports.resolve(t).substr(1);
                for(var n = e(r.split("/")), o = e(t.split("/")), s = Math.min(n.length, o.length), i = s, u = 0; u < s; u++)if (n[u] !== o[u]) {
                    i = u;
                    break;
                }
                var f = [];
                for(u = i; u < n.length; u++)f.push("..");
                return (f = f.concat(o.slice(i))).join("/");
            }, exports.sep = "/", exports.delimiter = ":", exports.dirname = function(r) {
                if ("string" != typeof r && (r += ""), 0 === r.length) return ".";
                for(var t = r.charCodeAt(0), e = 47 === t, n = -1, o = !0, s = r.length - 1; s >= 1; --s)if (47 === (t = r.charCodeAt(s))) {
                    if (!o) {
                        n = s;
                        break;
                    }
                } else o = !1;
                return -1 === n ? e ? "/" : "." : e && 1 === n ? "/" : r.slice(0, n);
            }, exports.basename = function(r, t) {
                var n = e(r);
                return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
            }, exports.extname = function(r) {
                "string" != typeof r && (r += "");
                for(var t = -1, e = 0, n = -1, o = !0, s = 0, i = r.length - 1; i >= 0; --i){
                    var u = r.charCodeAt(i);
                    if (47 !== u) -1 === n && (o = !1, n = i + 1), 46 === u ? -1 === t ? t = i : 1 !== s && (s = 1) : -1 !== t && (s = -1);
                    else if (!o) {
                        e = i + 1;
                        break;
                    }
                }
                return -1 === t || -1 === n || 0 === s || 1 === s && t === n - 1 && t === e + 1 ? "" : r.slice(t, n);
            };
            var o = "b" === "ab".substr(-1) ? function(r, t, e) {
                return r.substr(t, e);
            } : function(r, t, e) {
                return t < 0 && (t = r.length + t), r.substr(t, e);
            };
        },
        {
            "process": "pBGv"
        }
    ],
    "UzoP": [
        function(require1, module1, exports) {
            var process = require1("process");
            var r = require1("process");
            r.cwd = function() {
                return "/";
            };
            var e = require1("path"), n = Object.assign({}, e);
            n.basename = function(r, n) {
                var i = e.basename(r, n);
                return "" === i ? "/" : i;
            }, n.normalize = function(r) {
                return "/" === (r = e.normalize(r)) ? r : n.removeTrailing(r);
            }, n.isNull = function(r) {
                return -1 !== ("" + r).indexOf("\x00");
            }, n.addTrailing = function(r) {
                return r.replace(/\/*$/, "/");
            }, n.removeTrailing = function(r) {
                return "" === (r = r.replace(/\/*$/, "")) ? "/" : r;
            }, module1.exports = n;
        },
        {
            "path": "UUq2",
            "process": "pBGv"
        }
    ],
    "iJA9": [
        function(require1, module1, exports) {
            var _ = "READ", E = "WRITE", O = "CREATE", R = "EXCLUSIVE", I = "TRUNCATE", S = "APPEND", T = "CREATE", N = "REPLACE";
            module1.exports = {
                FILE_SYSTEM_NAME: "local",
                FILE_STORE_NAME: "files",
                IDB_RO: "readonly",
                IDB_RW: "readwrite",
                WSQL_VERSION: "1",
                WSQL_SIZE: 5242880,
                WSQL_DESC: "FileSystem Storage",
                NODE_TYPE_FILE: "FILE",
                NODE_TYPE_DIRECTORY: "DIRECTORY",
                NODE_TYPE_SYMBOLIC_LINK: "SYMLINK",
                NODE_TYPE_META: "META",
                DEFAULT_DIR_PERMISSIONS: 493,
                DEFAULT_FILE_PERMISSIONS: 420,
                FULL_READ_WRITE_EXEC_PERMISSIONS: 511,
                READ_WRITE_PERMISSIONS: 438,
                SYMLOOP_MAX: 10,
                BINARY_MIME_TYPE: "application/octet-stream",
                JSON_MIME_TYPE: "application/json",
                ROOT_DIRECTORY_NAME: "/",
                FS_FORMAT: "FORMAT",
                FS_NOCTIME: "NOCTIME",
                FS_NOMTIME: "NOMTIME",
                FS_NODUPEIDCHECK: "FS_NODUPEIDCHECK",
                O_READ: _,
                O_WRITE: E,
                O_CREATE: O,
                O_EXCLUSIVE: R,
                O_TRUNCATE: I,
                O_APPEND: S,
                O_FLAGS: {
                    r: [
                        _
                    ],
                    "r+": [
                        _,
                        E
                    ],
                    w: [
                        E,
                        O,
                        I
                    ],
                    "w+": [
                        E,
                        _,
                        O,
                        I
                    ],
                    wx: [
                        E,
                        O,
                        R,
                        I
                    ],
                    "wx+": [
                        E,
                        _,
                        O,
                        R,
                        I
                    ],
                    a: [
                        E,
                        O,
                        S
                    ],
                    "a+": [
                        E,
                        _,
                        O,
                        S
                    ],
                    ax: [
                        E,
                        O,
                        R,
                        S
                    ],
                    "ax+": [
                        E,
                        _,
                        O,
                        R,
                        S
                    ]
                },
                XATTR_CREATE: T,
                XATTR_REPLACE: N,
                FS_READY: "READY",
                FS_PENDING: "PENDING",
                FS_ERROR: "ERROR",
                SUPER_NODE_ID: "00000000-0000-0000-0000-000000000000",
                STDIN: 0,
                STDOUT: 1,
                STDERR: 2,
                FIRST_DESCRIPTOR: 3,
                ENVIRONMENT: {
                    TMP: "/tmp",
                    PATH: ""
                },
                fsConstants: {
                    O_RDONLY: 0,
                    O_WRONLY: 1,
                    O_RDWR: 2,
                    S_IFMT: 61440,
                    S_IFREG: 32768,
                    S_IFDIR: 16384,
                    S_IFCHR: 8192,
                    S_IFBLK: 24576,
                    S_IFIFO: 4096,
                    S_IFLNK: 40960,
                    S_IFSOCK: 49152,
                    O_CREAT: 512,
                    O_EXCL: 2048,
                    O_NOCTTY: 131072,
                    O_TRUNC: 1024,
                    O_APPEND: 8,
                    O_DIRECTORY: 1048576,
                    O_NOFOLLOW: 256,
                    O_SYNC: 128,
                    O_DSYNC: 4194304,
                    O_SYMLINK: 2097152,
                    O_NONBLOCK: 4,
                    S_IRWXU: 448,
                    S_IRUSR: 256,
                    S_IWUSR: 128,
                    S_IXUSR: 64,
                    S_IRWXG: 56,
                    S_IRGRP: 32,
                    S_IWGRP: 16,
                    S_IXGRP: 8,
                    S_IRWXO: 7,
                    S_IROTH: 4,
                    S_IWOTH: 2,
                    S_IXOTH: 1,
                    F_OK: 0,
                    R_OK: 4,
                    W_OK: 2,
                    X_OK: 1,
                    UV_FS_COPYFILE_EXCL: 1,
                    COPYFILE_EXCL: 1
                }
            };
        },
        {}
    ],
    "yh9p": [
        function(require1, module1, exports) {
            "use strict";
            exports.byteLength = u, exports.toByteArray = i, exports.fromByteArray = d;
            for(var r = [], t = [], e = "undefined" != typeof Uint8Array ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = 0, a = n.length; o < a; ++o)r[o] = n[o], t[n.charCodeAt(o)] = o;
            function h(r) {
                var t = r.length;
                if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                var e = r.indexOf("=");
                return -1 === e && (e = t), [
                    e,
                    e === t ? 0 : 4 - e % 4
                ];
            }
            function u(r) {
                var t = h(r), e = t[0], n = t[1];
                return 3 * (e + n) / 4 - n;
            }
            function c(r, t, e) {
                return 3 * (t + e) / 4 - e;
            }
            function i(r) {
                var n, o, a = h(r), u = a[0], i = a[1], f = new e(c(r, u, i)), A = 0, d = i > 0 ? u - 4 : u;
                for(o = 0; o < d; o += 4)n = t[r.charCodeAt(o)] << 18 | t[r.charCodeAt(o + 1)] << 12 | t[r.charCodeAt(o + 2)] << 6 | t[r.charCodeAt(o + 3)], f[A++] = n >> 16 & 255, f[A++] = n >> 8 & 255, f[A++] = 255 & n;
                return 2 === i && (n = t[r.charCodeAt(o)] << 2 | t[r.charCodeAt(o + 1)] >> 4, f[A++] = 255 & n), 1 === i && (n = t[r.charCodeAt(o)] << 10 | t[r.charCodeAt(o + 1)] << 4 | t[r.charCodeAt(o + 2)] >> 2, f[A++] = n >> 8 & 255, f[A++] = 255 & n), f;
            }
            function f(t) {
                return r[t >> 18 & 63] + r[t >> 12 & 63] + r[t >> 6 & 63] + r[63 & t];
            }
            function A(r, t, e) {
                for(var n, o = [], a = t; a < e; a += 3)n = (r[a] << 16 & 16711680) + (r[a + 1] << 8 & 65280) + (255 & r[a + 2]), o.push(f(n));
                return o.join("");
            }
            function d(t) {
                for(var e, n = t.length, o = n % 3, a = [], h = 0, u = n - o; h < u; h += 16383)a.push(A(t, h, h + 16383 > u ? u : h + 16383));
                return 1 === o ? (e = t[n - 1], a.push(r[e >> 2] + r[e << 4 & 63] + "==")) : 2 === o && (e = (t[n - 2] << 8) + t[n - 1], a.push(r[e >> 10] + r[e >> 4 & 63] + r[e << 2 & 63] + "=")), a.join("");
            }
            t["-".charCodeAt(0)] = 62, t["_".charCodeAt(0)] = 63;
        },
        {}
    ],
    "JgNJ": [
        function(require1, module1, exports) {
            exports.read = function(a, o, t, r, h) {
                var M, p, w = 8 * h - r - 1, f = (1 << w) - 1, e = f >> 1, i = -7, N = t ? h - 1 : 0, n = t ? -1 : 1, s = a[o + N];
                for(N += n, M = s & (1 << -i) - 1, s >>= -i, i += w; i > 0; M = 256 * M + a[o + N], N += n, i -= 8);
                for(p = M & (1 << -i) - 1, M >>= -i, i += r; i > 0; p = 256 * p + a[o + N], N += n, i -= 8);
                if (0 === M) M = 1 - e;
                else {
                    if (M === f) return p ? NaN : 1 / 0 * (s ? -1 : 1);
                    p += Math.pow(2, r), M -= e;
                }
                return (s ? -1 : 1) * p * Math.pow(2, M - r);
            }, exports.write = function(a, o, t, r, h, M) {
                var p, w, f, e = 8 * M - h - 1, i = (1 << e) - 1, N = i >> 1, n = 23 === h ? Math.pow(2, -24) - Math.pow(2, -77) : 0, s = r ? 0 : M - 1, u = r ? 1 : -1, l = o < 0 || 0 === o && 1 / o < 0 ? 1 : 0;
                for(o = Math.abs(o), isNaN(o) || o === 1 / 0 ? (w = isNaN(o) ? 1 : 0, p = i) : (p = Math.floor(Math.log(o) / Math.LN2), o * (f = Math.pow(2, -p)) < 1 && (p--, f *= 2), (o += p + N >= 1 ? n / f : n * Math.pow(2, 1 - N)) * f >= 2 && (p++, f /= 2), p + N >= i ? (w = 0, p = i) : p + N >= 1 ? (w = (o * f - 1) * Math.pow(2, h), p += N) : (w = o * Math.pow(2, N - 1) * Math.pow(2, h), p = 0)); h >= 8; a[t + s] = 255 & w, s += u, w /= 256, h -= 8);
                for(p = p << h | w, e += h; e > 0; a[t + s] = 255 & p, s += u, p /= 256, e -= 8);
                a[t + s - u] |= 128 * l;
            };
        },
        {}
    ],
    "REa7": [
        function(require1, module1, exports) {
            var r = {}.toString;
            module1.exports = Array.isArray || function(t) {
                return "[object Array]" == r.call(t);
            };
        },
        {}
    ],
    "dskh": [
        function(require1, module1, exports) {
            var global = arguments[3];
            var t = arguments[3], r = require1("base64-js"), e = require1("ieee754"), n = require1("isarray");
            function i() {
                try {
                    var t = new Uint8Array(1);
                    return t.__proto__ = {
                        __proto__: Uint8Array.prototype,
                        foo: function() {
                            return 42;
                        }
                    }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
                } catch (r) {
                    return !1;
                }
            }
            function o() {
                return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
            }
            function u(t, r) {
                if (o() < r) throw new RangeError("Invalid typed array length");
                return f.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(r)).__proto__ = f.prototype : (null === t && (t = new f(r)), t.length = r), t;
            }
            function f(t, r, e) {
                if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(t, r, e);
                if ("number" == typeof t) {
                    if ("string" == typeof r) throw new Error("If encoding is specified then the first argument must be a string");
                    return c(this, t);
                }
                return s(this, t, r, e);
            }
            function s(t, r, e, n) {
                if ("number" == typeof r) throw new TypeError('"value" argument must not be a number');
                return "undefined" != typeof ArrayBuffer && r instanceof ArrayBuffer ? g(t, r, e, n) : "string" == typeof r ? l(t, r, e) : y(t, r);
            }
            function h(t) {
                if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
                if (t < 0) throw new RangeError('"size" argument must not be negative');
            }
            function a(t, r, e, n) {
                return h(r), r <= 0 ? u(t, r) : void 0 !== e ? "string" == typeof n ? u(t, r).fill(e, n) : u(t, r).fill(e) : u(t, r);
            }
            function c(t, r) {
                if (h(r), t = u(t, r < 0 ? 0 : 0 | w(r)), !f.TYPED_ARRAY_SUPPORT) for(var e = 0; e < r; ++e)t[e] = 0;
                return t;
            }
            function l(t, r, e) {
                if ("string" == typeof e && "" !== e || (e = "utf8"), !f.isEncoding(e)) throw new TypeError('"encoding" must be a valid string encoding');
                var n = 0 | v(r, e), i = (t = u(t, n)).write(r, e);
                return i !== n && (t = t.slice(0, i)), t;
            }
            function p(t, r) {
                var e = r.length < 0 ? 0 : 0 | w(r.length);
                t = u(t, e);
                for(var n = 0; n < e; n += 1)t[n] = 255 & r[n];
                return t;
            }
            function g(t, r, e, n) {
                if (r.byteLength, e < 0 || r.byteLength < e) throw new RangeError("'offset' is out of bounds");
                if (r.byteLength < e + (n || 0)) throw new RangeError("'length' is out of bounds");
                return r = void 0 === e && void 0 === n ? new Uint8Array(r) : void 0 === n ? new Uint8Array(r, e) : new Uint8Array(r, e, n), f.TYPED_ARRAY_SUPPORT ? (t = r).__proto__ = f.prototype : t = p(t, r), t;
            }
            function y(t, r) {
                if (f.isBuffer(r)) {
                    var e = 0 | w(r.length);
                    return 0 === (t = u(t, e)).length ? t : (r.copy(t, 0, 0, e), t);
                }
                if (r) {
                    if ("undefined" != typeof ArrayBuffer && r.buffer instanceof ArrayBuffer || "length" in r) return "number" != typeof r.length || W(r.length) ? u(t, 0) : p(t, r);
                    if ("Buffer" === r.type && n(r.data)) return p(t, r.data);
                }
                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }
            function w(t) {
                if (t >= o()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o().toString(16) + " bytes");
                return 0 | t;
            }
            function d(t) {
                return +t != t && (t = 0), f.alloc(+t);
            }
            function v(t, r) {
                if (f.isBuffer(t)) return t.length;
                if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
                "string" != typeof t && (t = "" + t);
                var e = t.length;
                if (0 === e) return 0;
                for(var n = !1;;)switch(r){
                    case "ascii":
                    case "latin1":
                    case "binary":
                        return e;
                    case "utf8":
                    case "utf-8":
                    case void 0:
                        return $(t).length;
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return 2 * e;
                    case "hex":
                        return e >>> 1;
                    case "base64":
                        return K(t).length;
                    default:
                        if (n) return $(t).length;
                        r = ("" + r).toLowerCase(), n = !0;
                }
            }
            function E(t, r, e) {
                var n = !1;
                if ((void 0 === r || r < 0) && (r = 0), r > this.length) return "";
                if ((void 0 === e || e > this.length) && (e = this.length), e <= 0) return "";
                if ((e >>>= 0) <= (r >>>= 0)) return "";
                for(t || (t = "utf8");;)switch(t){
                    case "hex":
                        return x(this, r, e);
                    case "utf8":
                    case "utf-8":
                        return Y(this, r, e);
                    case "ascii":
                        return L(this, r, e);
                    case "latin1":
                    case "binary":
                        return D(this, r, e);
                    case "base64":
                        return S(this, r, e);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return C(this, r, e);
                    default:
                        if (n) throw new TypeError("Unknown encoding: " + t);
                        t = (t + "").toLowerCase(), n = !0;
                }
            }
            function b(t, r, e) {
                var n = t[r];
                t[r] = t[e], t[e] = n;
            }
            function R(t, r, e, n, i) {
                if (0 === t.length) return -1;
                if ("string" == typeof e ? (n = e, e = 0) : e > 2147483647 ? e = 2147483647 : e < -2147483648 && (e = -2147483648), e = +e, isNaN(e) && (e = i ? 0 : t.length - 1), e < 0 && (e = t.length + e), e >= t.length) {
                    if (i) return -1;
                    e = t.length - 1;
                } else if (e < 0) {
                    if (!i) return -1;
                    e = 0;
                }
                if ("string" == typeof r && (r = f.from(r, n)), f.isBuffer(r)) return 0 === r.length ? -1 : _(t, r, e, n, i);
                if ("number" == typeof r) return r &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, r, e) : Uint8Array.prototype.lastIndexOf.call(t, r, e) : _(t, [
                    r
                ], e, n, i);
                throw new TypeError("val must be string, number or Buffer");
            }
            function _(t, r, e, n, i) {
                var o, u = 1, f = t.length, s = r.length;
                if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                    if (t.length < 2 || r.length < 2) return -1;
                    u = 2, f /= 2, s /= 2, e /= 2;
                }
                function h(t, r) {
                    return 1 === u ? t[r] : t.readUInt16BE(r * u);
                }
                if (i) {
                    var a = -1;
                    for(o = e; o < f; o++)if (h(t, o) === h(r, -1 === a ? 0 : o - a)) {
                        if (-1 === a && (a = o), o - a + 1 === s) return a * u;
                    } else -1 !== a && (o -= o - a), a = -1;
                } else for(e + s > f && (e = f - s), o = e; o >= 0; o--){
                    for(var c = !0, l = 0; l < s; l++)if (h(t, o + l) !== h(r, l)) {
                        c = !1;
                        break;
                    }
                    if (c) return o;
                }
                return -1;
            }
            function A(t, r, e, n) {
                e = Number(e) || 0;
                var i = t.length - e;
                n ? (n = Number(n)) > i && (n = i) : n = i;
                var o = r.length;
                if (o % 2 != 0) throw new TypeError("Invalid hex string");
                n > o / 2 && (n = o / 2);
                for(var u = 0; u < n; ++u){
                    var f = parseInt(r.substr(2 * u, 2), 16);
                    if (isNaN(f)) return u;
                    t[e + u] = f;
                }
                return u;
            }
            function m(t, r, e, n) {
                return Q($(r, t.length - e), t, e, n);
            }
            function P(t, r, e, n) {
                return Q(G(r), t, e, n);
            }
            function T(t, r, e, n) {
                return P(t, r, e, n);
            }
            function B(t, r, e, n) {
                return Q(K(r), t, e, n);
            }
            function U(t, r, e, n) {
                return Q(H(r, t.length - e), t, e, n);
            }
            function S(t, e, n) {
                return 0 === e && n === t.length ? r.fromByteArray(t) : r.fromByteArray(t.slice(e, n));
            }
            function Y(t, r, e) {
                e = Math.min(t.length, e);
                for(var n = [], i = r; i < e;){
                    var o, u, f, s, h = t[i], a = null, c = h > 239 ? 4 : h > 223 ? 3 : h > 191 ? 2 : 1;
                    if (i + c <= e) switch(c){
                        case 1:
                            h < 128 && (a = h);
                            break;
                        case 2:
                            128 == (192 & (o = t[i + 1])) && (s = (31 & h) << 6 | 63 & o) > 127 && (a = s);
                            break;
                        case 3:
                            o = t[i + 1], u = t[i + 2], 128 == (192 & o) && 128 == (192 & u) && (s = (15 & h) << 12 | (63 & o) << 6 | 63 & u) > 2047 && (s < 55296 || s > 57343) && (a = s);
                            break;
                        case 4:
                            o = t[i + 1], u = t[i + 2], f = t[i + 3], 128 == (192 & o) && 128 == (192 & u) && 128 == (192 & f) && (s = (15 & h) << 18 | (63 & o) << 12 | (63 & u) << 6 | 63 & f) > 65535 && s < 1114112 && (a = s);
                    }
                    null === a ? (a = 65533, c = 1) : a > 65535 && (a -= 65536, n.push(a >>> 10 & 1023 | 55296), a = 56320 | 1023 & a), n.push(a), i += c;
                }
                return O(n);
            }
            exports.Buffer = f, exports.SlowBuffer = d, exports.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : i(), exports.kMaxLength = o(), f.poolSize = 8192, f._augment = function(t) {
                return t.__proto__ = f.prototype, t;
            }, f.from = function(t, r, e) {
                return s(null, t, r, e);
            }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
                value: null,
                configurable: !0
            })), f.alloc = function(t, r, e) {
                return a(null, t, r, e);
            }, f.allocUnsafe = function(t) {
                return c(null, t);
            }, f.allocUnsafeSlow = function(t) {
                return c(null, t);
            }, f.isBuffer = function(t) {
                return !(null == t || !t._isBuffer);
            }, f.compare = function(t, r) {
                if (!f.isBuffer(t) || !f.isBuffer(r)) throw new TypeError("Arguments must be Buffers");
                if (t === r) return 0;
                for(var e = t.length, n = r.length, i = 0, o = Math.min(e, n); i < o; ++i)if (t[i] !== r[i]) {
                    e = t[i], n = r[i];
                    break;
                }
                return e < n ? -1 : n < e ? 1 : 0;
            }, f.isEncoding = function(t) {
                switch(String(t).toLowerCase()){
                    case "hex":
                    case "utf8":
                    case "utf-8":
                    case "ascii":
                    case "latin1":
                    case "binary":
                    case "base64":
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return !0;
                    default:
                        return !1;
                }
            }, f.concat = function(t, r) {
                if (!n(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                if (0 === t.length) return f.alloc(0);
                var e;
                if (void 0 === r) for(r = 0, e = 0; e < t.length; ++e)r += t[e].length;
                var i = f.allocUnsafe(r), o = 0;
                for(e = 0; e < t.length; ++e){
                    var u = t[e];
                    if (!f.isBuffer(u)) throw new TypeError('"list" argument must be an Array of Buffers');
                    u.copy(i, o), o += u.length;
                }
                return i;
            }, f.byteLength = v, f.prototype._isBuffer = !0, f.prototype.swap16 = function() {
                var t = this.length;
                if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                for(var r = 0; r < t; r += 2)b(this, r, r + 1);
                return this;
            }, f.prototype.swap32 = function() {
                var t = this.length;
                if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                for(var r = 0; r < t; r += 4)b(this, r, r + 3), b(this, r + 1, r + 2);
                return this;
            }, f.prototype.swap64 = function() {
                var t = this.length;
                if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                for(var r = 0; r < t; r += 8)b(this, r, r + 7), b(this, r + 1, r + 6), b(this, r + 2, r + 5), b(this, r + 3, r + 4);
                return this;
            }, f.prototype.toString = function() {
                var t = 0 | this.length;
                return 0 === t ? "" : 0 === arguments.length ? Y(this, 0, t) : E.apply(this, arguments);
            }, f.prototype.equals = function(t) {
                if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
                return this === t || 0 === f.compare(this, t);
            }, f.prototype.inspect = function() {
                var t = "", r = exports.INSPECT_MAX_BYTES;
                return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
            }, f.prototype.compare = function(t, r, e, n, i) {
                if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
                if (void 0 === r && (r = 0), void 0 === e && (e = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), r < 0 || e > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                if (n >= i && r >= e) return 0;
                if (n >= i) return -1;
                if (r >= e) return 1;
                if (this === t) return 0;
                for(var o = (i >>>= 0) - (n >>>= 0), u = (e >>>= 0) - (r >>>= 0), s = Math.min(o, u), h = this.slice(n, i), a = t.slice(r, e), c = 0; c < s; ++c)if (h[c] !== a[c]) {
                    o = h[c], u = a[c];
                    break;
                }
                return o < u ? -1 : u < o ? 1 : 0;
            }, f.prototype.includes = function(t, r, e) {
                return -1 !== this.indexOf(t, r, e);
            }, f.prototype.indexOf = function(t, r, e) {
                return R(this, t, r, e, !0);
            }, f.prototype.lastIndexOf = function(t, r, e) {
                return R(this, t, r, e, !1);
            }, f.prototype.write = function(t, r, e, n) {
                if (void 0 === r) n = "utf8", e = this.length, r = 0;
                else if (void 0 === e && "string" == typeof r) n = r, e = this.length, r = 0;
                else {
                    if (!isFinite(r)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                    r |= 0, isFinite(e) ? (e |= 0, void 0 === n && (n = "utf8")) : (n = e, e = void 0);
                }
                var i = this.length - r;
                if ((void 0 === e || e > i) && (e = i), t.length > 0 && (e < 0 || r < 0) || r > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                n || (n = "utf8");
                for(var o = !1;;)switch(n){
                    case "hex":
                        return A(this, t, r, e);
                    case "utf8":
                    case "utf-8":
                        return m(this, t, r, e);
                    case "ascii":
                        return P(this, t, r, e);
                    case "latin1":
                    case "binary":
                        return T(this, t, r, e);
                    case "base64":
                        return B(this, t, r, e);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return U(this, t, r, e);
                    default:
                        if (o) throw new TypeError("Unknown encoding: " + n);
                        n = ("" + n).toLowerCase(), o = !0;
                }
            }, f.prototype.toJSON = function() {
                return {
                    type: "Buffer",
                    data: Array.prototype.slice.call(this._arr || this, 0)
                };
            };
            var I = 4096;
            function O(t) {
                var r = t.length;
                if (r <= I) return String.fromCharCode.apply(String, t);
                for(var e = "", n = 0; n < r;)e += String.fromCharCode.apply(String, t.slice(n, n += I));
                return e;
            }
            function L(t, r, e) {
                var n = "";
                e = Math.min(t.length, e);
                for(var i = r; i < e; ++i)n += String.fromCharCode(127 & t[i]);
                return n;
            }
            function D(t, r, e) {
                var n = "";
                e = Math.min(t.length, e);
                for(var i = r; i < e; ++i)n += String.fromCharCode(t[i]);
                return n;
            }
            function x(t, r, e) {
                var n = t.length;
                (!r || r < 0) && (r = 0), (!e || e < 0 || e > n) && (e = n);
                for(var i = "", o = r; o < e; ++o)i += Z(t[o]);
                return i;
            }
            function C(t, r, e) {
                for(var n = t.slice(r, e), i = "", o = 0; o < n.length; o += 2)i += String.fromCharCode(n[o] + 256 * n[o + 1]);
                return i;
            }
            function M(t, r, e) {
                if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
                if (t + r > e) throw new RangeError("Trying to access beyond buffer length");
            }
            function k(t, r, e, n, i, o) {
                if (!f.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
                if (r > i || r < o) throw new RangeError('"value" argument is out of bounds');
                if (e + n > t.length) throw new RangeError("Index out of range");
            }
            function N(t, r, e, n) {
                r < 0 && (r = 65535 + r + 1);
                for(var i = 0, o = Math.min(t.length - e, 2); i < o; ++i)t[e + i] = (r & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
            }
            function z(t, r, e, n) {
                r < 0 && (r = 4294967295 + r + 1);
                for(var i = 0, o = Math.min(t.length - e, 4); i < o; ++i)t[e + i] = r >>> 8 * (n ? i : 3 - i) & 255;
            }
            function F(t, r, e, n, i, o) {
                if (e + n > t.length) throw new RangeError("Index out of range");
                if (e < 0) throw new RangeError("Index out of range");
            }
            function j(t, r, n, i, o) {
                return o || F(t, r, n, 4, 3.4028234663852886e38, -340282346638528860000000000000000000000), e.write(t, r, n, i, 23, 4), n + 4;
            }
            function q(t, r, n, i, o) {
                return o || F(t, r, n, 8, 1.7976931348623157e308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), e.write(t, r, n, i, 52, 8), n + 8;
            }
            f.prototype.slice = function(t, r) {
                var e, n = this.length;
                if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (r = void 0 === r ? n : ~~r) < 0 ? (r += n) < 0 && (r = 0) : r > n && (r = n), r < t && (r = t), f.TYPED_ARRAY_SUPPORT) (e = this.subarray(t, r)).__proto__ = f.prototype;
                else {
                    var i = r - t;
                    e = new f(i, void 0);
                    for(var o = 0; o < i; ++o)e[o] = this[o + t];
                }
                return e;
            }, f.prototype.readUIntLE = function(t, r, e) {
                t |= 0, r |= 0, e || M(t, r, this.length);
                for(var n = this[t], i = 1, o = 0; ++o < r && (i *= 256);)n += this[t + o] * i;
                return n;
            }, f.prototype.readUIntBE = function(t, r, e) {
                t |= 0, r |= 0, e || M(t, r, this.length);
                for(var n = this[t + --r], i = 1; r > 0 && (i *= 256);)n += this[t + --r] * i;
                return n;
            }, f.prototype.readUInt8 = function(t, r) {
                return r || M(t, 1, this.length), this[t];
            }, f.prototype.readUInt16LE = function(t, r) {
                return r || M(t, 2, this.length), this[t] | this[t + 1] << 8;
            }, f.prototype.readUInt16BE = function(t, r) {
                return r || M(t, 2, this.length), this[t] << 8 | this[t + 1];
            }, f.prototype.readUInt32LE = function(t, r) {
                return r || M(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
            }, f.prototype.readUInt32BE = function(t, r) {
                return r || M(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
            }, f.prototype.readIntLE = function(t, r, e) {
                t |= 0, r |= 0, e || M(t, r, this.length);
                for(var n = this[t], i = 1, o = 0; ++o < r && (i *= 256);)n += this[t + o] * i;
                return n >= (i *= 128) && (n -= Math.pow(2, 8 * r)), n;
            }, f.prototype.readIntBE = function(t, r, e) {
                t |= 0, r |= 0, e || M(t, r, this.length);
                for(var n = r, i = 1, o = this[t + --n]; n > 0 && (i *= 256);)o += this[t + --n] * i;
                return o >= (i *= 128) && (o -= Math.pow(2, 8 * r)), o;
            }, f.prototype.readInt8 = function(t, r) {
                return r || M(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
            }, f.prototype.readInt16LE = function(t, r) {
                r || M(t, 2, this.length);
                var e = this[t] | this[t + 1] << 8;
                return 32768 & e ? 4294901760 | e : e;
            }, f.prototype.readInt16BE = function(t, r) {
                r || M(t, 2, this.length);
                var e = this[t + 1] | this[t] << 8;
                return 32768 & e ? 4294901760 | e : e;
            }, f.prototype.readInt32LE = function(t, r) {
                return r || M(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
            }, f.prototype.readInt32BE = function(t, r) {
                return r || M(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
            }, f.prototype.readFloatLE = function(t, r) {
                return r || M(t, 4, this.length), e.read(this, t, !0, 23, 4);
            }, f.prototype.readFloatBE = function(t, r) {
                return r || M(t, 4, this.length), e.read(this, t, !1, 23, 4);
            }, f.prototype.readDoubleLE = function(t, r) {
                return r || M(t, 8, this.length), e.read(this, t, !0, 52, 8);
            }, f.prototype.readDoubleBE = function(t, r) {
                return r || M(t, 8, this.length), e.read(this, t, !1, 52, 8);
            }, f.prototype.writeUIntLE = function(t, r, e, n) {
                (t = +t, r |= 0, e |= 0, n) || k(this, t, r, e, Math.pow(2, 8 * e) - 1, 0);
                var i = 1, o = 0;
                for(this[r] = 255 & t; ++o < e && (i *= 256);)this[r + o] = t / i & 255;
                return r + e;
            }, f.prototype.writeUIntBE = function(t, r, e, n) {
                (t = +t, r |= 0, e |= 0, n) || k(this, t, r, e, Math.pow(2, 8 * e) - 1, 0);
                var i = e - 1, o = 1;
                for(this[r + i] = 255 & t; --i >= 0 && (o *= 256);)this[r + i] = t / o & 255;
                return r + e;
            }, f.prototype.writeUInt8 = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[r] = 255 & t, r + 1;
            }, f.prototype.writeUInt16LE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & t, this[r + 1] = t >>> 8) : N(this, t, r, !0), r + 2;
            }, f.prototype.writeUInt16BE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[r] = t >>> 8, this[r + 1] = 255 & t) : N(this, t, r, !1), r + 2;
            }, f.prototype.writeUInt32LE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[r + 3] = t >>> 24, this[r + 2] = t >>> 16, this[r + 1] = t >>> 8, this[r] = 255 & t) : z(this, t, r, !0), r + 4;
            }, f.prototype.writeUInt32BE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[r] = t >>> 24, this[r + 1] = t >>> 16, this[r + 2] = t >>> 8, this[r + 3] = 255 & t) : z(this, t, r, !1), r + 4;
            }, f.prototype.writeIntLE = function(t, r, e, n) {
                if (t = +t, r |= 0, !n) {
                    var i = Math.pow(2, 8 * e - 1);
                    k(this, t, r, e, i - 1, -i);
                }
                var o = 0, u = 1, f = 0;
                for(this[r] = 255 & t; ++o < e && (u *= 256);)t < 0 && 0 === f && 0 !== this[r + o - 1] && (f = 1), this[r + o] = (t / u >> 0) - f & 255;
                return r + e;
            }, f.prototype.writeIntBE = function(t, r, e, n) {
                if (t = +t, r |= 0, !n) {
                    var i = Math.pow(2, 8 * e - 1);
                    k(this, t, r, e, i - 1, -i);
                }
                var o = e - 1, u = 1, f = 0;
                for(this[r + o] = 255 & t; --o >= 0 && (u *= 256);)t < 0 && 0 === f && 0 !== this[r + o + 1] && (f = 1), this[r + o] = (t / u >> 0) - f & 255;
                return r + e;
            }, f.prototype.writeInt8 = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[r] = 255 & t, r + 1;
            }, f.prototype.writeInt16LE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & t, this[r + 1] = t >>> 8) : N(this, t, r, !0), r + 2;
            }, f.prototype.writeInt16BE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[r] = t >>> 8, this[r + 1] = 255 & t) : N(this, t, r, !1), r + 2;
            }, f.prototype.writeInt32LE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[r] = 255 & t, this[r + 1] = t >>> 8, this[r + 2] = t >>> 16, this[r + 3] = t >>> 24) : z(this, t, r, !0), r + 4;
            }, f.prototype.writeInt32BE = function(t, r, e) {
                return t = +t, r |= 0, e || k(this, t, r, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), f.TYPED_ARRAY_SUPPORT ? (this[r] = t >>> 24, this[r + 1] = t >>> 16, this[r + 2] = t >>> 8, this[r + 3] = 255 & t) : z(this, t, r, !1), r + 4;
            }, f.prototype.writeFloatLE = function(t, r, e) {
                return j(this, t, r, !0, e);
            }, f.prototype.writeFloatBE = function(t, r, e) {
                return j(this, t, r, !1, e);
            }, f.prototype.writeDoubleLE = function(t, r, e) {
                return q(this, t, r, !0, e);
            }, f.prototype.writeDoubleBE = function(t, r, e) {
                return q(this, t, r, !1, e);
            }, f.prototype.copy = function(t, r, e, n) {
                if (e || (e = 0), n || 0 === n || (n = this.length), r >= t.length && (r = t.length), r || (r = 0), n > 0 && n < e && (n = e), n === e) return 0;
                if (0 === t.length || 0 === this.length) return 0;
                if (r < 0) throw new RangeError("targetStart out of bounds");
                if (e < 0 || e >= this.length) throw new RangeError("sourceStart out of bounds");
                if (n < 0) throw new RangeError("sourceEnd out of bounds");
                n > this.length && (n = this.length), t.length - r < n - e && (n = t.length - r + e);
                var i, o = n - e;
                if (this === t && e < r && r < n) for(i = o - 1; i >= 0; --i)t[i + r] = this[i + e];
                else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for(i = 0; i < o; ++i)t[i + r] = this[i + e];
                else Uint8Array.prototype.set.call(t, this.subarray(e, e + o), r);
                return o;
            }, f.prototype.fill = function(t, r, e, n) {
                if ("string" == typeof t) {
                    if ("string" == typeof r ? (n = r, r = 0, e = this.length) : "string" == typeof e && (n = e, e = this.length), 1 === t.length) {
                        var i = t.charCodeAt(0);
                        i < 256 && (t = i);
                    }
                    if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                    if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                } else "number" == typeof t && (t &= 255);
                if (r < 0 || this.length < r || this.length < e) throw new RangeError("Out of range index");
                if (e <= r) return this;
                var o;
                if (r >>>= 0, e = void 0 === e ? this.length : e >>> 0, t || (t = 0), "number" == typeof t) for(o = r; o < e; ++o)this[o] = t;
                else {
                    var u = f.isBuffer(t) ? t : $(new f(t, n).toString()), s = u.length;
                    for(o = 0; o < e - r; ++o)this[o + r] = u[o % s];
                }
                return this;
            };
            var V = /[^+\/0-9A-Za-z-_]/g;
            function X(t) {
                if ((t = J(t).replace(V, "")).length < 2) return "";
                for(; t.length % 4 != 0;)t += "=";
                return t;
            }
            function J(t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
            }
            function Z(t) {
                return t < 16 ? "0" + t.toString(16) : t.toString(16);
            }
            function $(t, r) {
                var e;
                r = r || 1 / 0;
                for(var n = t.length, i = null, o = [], u = 0; u < n; ++u){
                    if ((e = t.charCodeAt(u)) > 55295 && e < 57344) {
                        if (!i) {
                            if (e > 56319) {
                                (r -= 3) > -1 && o.push(239, 191, 189);
                                continue;
                            }
                            if (u + 1 === n) {
                                (r -= 3) > -1 && o.push(239, 191, 189);
                                continue;
                            }
                            i = e;
                            continue;
                        }
                        if (e < 56320) {
                            (r -= 3) > -1 && o.push(239, 191, 189), i = e;
                            continue;
                        }
                        e = 65536 + (i - 55296 << 10 | e - 56320);
                    } else i && (r -= 3) > -1 && o.push(239, 191, 189);
                    if (i = null, e < 128) {
                        if ((r -= 1) < 0) break;
                        o.push(e);
                    } else if (e < 2048) {
                        if ((r -= 2) < 0) break;
                        o.push(e >> 6 | 192, 63 & e | 128);
                    } else if (e < 65536) {
                        if ((r -= 3) < 0) break;
                        o.push(e >> 12 | 224, e >> 6 & 63 | 128, 63 & e | 128);
                    } else {
                        if (!(e < 1114112)) throw new Error("Invalid code point");
                        if ((r -= 4) < 0) break;
                        o.push(e >> 18 | 240, e >> 12 & 63 | 128, e >> 6 & 63 | 128, 63 & e | 128);
                    }
                }
                return o;
            }
            function G(t) {
                for(var r = [], e = 0; e < t.length; ++e)r.push(255 & t.charCodeAt(e));
                return r;
            }
            function H(t, r) {
                for(var e, n, i, o = [], u = 0; u < t.length && !((r -= 2) < 0); ++u)n = (e = t.charCodeAt(u)) >> 8, i = e % 256, o.push(i), o.push(n);
                return o;
            }
            function K(t) {
                return r.toByteArray(X(t));
            }
            function Q(t, r, e, n) {
                for(var i = 0; i < n && !(i + e >= r.length || i >= t.length); ++i)r[i + e] = t[i];
                return i;
            }
            function W(t) {
                return t != t;
            }
        },
        {
            "base64-js": "yh9p",
            "ieee754": "JgNJ",
            "isarray": "REa7",
            "buffer": "dskh"
        }
    ],
    "QO4x": [
        function(require1, module1, exports) {
            var Buffer = require1("buffer").Buffer;
            var global = arguments[3];
            var t = require1("buffer").Buffer, e = arguments[3], r = require1("../constants.js").FILE_SYSTEM_NAME, n = require1("../constants.js").FILE_STORE_NAME, o = require1("../constants.js").IDB_RW, u = require1("../constants.js").IDB_RO;
            function c(t, e) {
                this.db = t, this.mode = e;
            }
            function i(t) {
                this.name = t || r, this.db = null;
            }
            c.prototype._getObjectStore = function() {
                if (this.objectStore) return this.objectStore;
                var t = this.db.transaction(n, this.mode);
                return this.objectStore = t.objectStore(n), this.objectStore;
            }, c.prototype.clear = function(t) {
                try {
                    var e = this._getObjectStore().clear();
                    e.onsuccess = function() {
                        t();
                    }, e.onerror = function(e) {
                        e.preventDefault(), t(e.error);
                    };
                } catch (r) {
                    t(r);
                }
            }, c.prototype._get = function(t, e) {
                try {
                    var r = this._getObjectStore().get(t);
                    r.onsuccess = function(t) {
                        var r = t.target.result;
                        e(null, r);
                    }, r.onerror = function(t) {
                        t.preventDefault(), e(t.error);
                    };
                } catch (n) {
                    e(n);
                }
            }, c.prototype.getObject = function(t, e) {
                this._get(t, e);
            }, c.prototype.getBuffer = function(e, r) {
                this._get(e, function(e, n) {
                    if (e) return r(e);
                    r(null, t.from(n));
                });
            }, c.prototype._put = function(t, e, r) {
                try {
                    var n = this._getObjectStore().put(e, t);
                    n.onsuccess = function(t) {
                        var e = t.target.result;
                        r(null, e);
                    }, n.onerror = function(t) {
                        t.preventDefault(), r(t.error);
                    };
                } catch (o) {
                    r(o);
                }
            }, c.prototype.putObject = function(t, e, r) {
                this._put(t, e, r);
            }, c.prototype.putBuffer = function(t, e, r) {
                var n = e.buffer;
                this._put(t, n, r);
            }, c.prototype.delete = function(t, e) {
                try {
                    var r = this._getObjectStore().delete(t);
                    r.onsuccess = function(t) {
                        var r = t.target.result;
                        e(null, r);
                    }, r.onerror = function(t) {
                        t.preventDefault(), e(t.error);
                    };
                } catch (n) {
                    e(n);
                }
            }, i.isSupported = function() {
                return !!(e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB);
            }, i.prototype.open = function(t) {
                var r = this;
                if (r.db) return t();
                try {
                    var o = (e.indexedDB || e.mozIndexedDB || e.webkitIndexedDB || e.msIndexedDB).open(r.name);
                    o.onupgradeneeded = function(t) {
                        var e = t.target.result;
                        e.objectStoreNames.contains(n) && e.deleteObjectStore(n), e.createObjectStore(n);
                    }, o.onsuccess = function(e) {
                        r.db = e.target.result, t();
                    }, o.onerror = function(e) {
                        e.preventDefault(), t(e.error);
                    };
                } catch (u) {
                    t(u);
                }
            }, i.prototype.getReadOnlyContext = function() {
                return new c(this.db, u);
            }, i.prototype.getReadWriteContext = function() {
                return new c(this.db, o);
            }, module1.exports = i;
        },
        {
            "../constants.js": "iJA9",
            "buffer": "dskh"
        }
    ],
    "u4Zs": [
        function(require1, module1, exports) {
            var process = require1("process");
            var define;
            var e, t = require1("process");
            !function() {
                var n = {};
                void 0 !== t && t.nextTick ? (n.nextTick = t.nextTick, "undefined" != typeof setImmediate ? n.setImmediate = function(e) {
                    setImmediate(e);
                } : n.setImmediate = n.nextTick) : "function" == typeof setImmediate ? (n.nextTick = function(e) {
                    setImmediate(e);
                }, n.setImmediate = n.nextTick) : (n.nextTick = function(e) {
                    setTimeout(e, 0);
                }, n.setImmediate = n.nextTick), n.eachSeries = function(e, t, n) {
                    if (n = n || function() {}, !e.length) return n();
                    var i = 0;
                    !function o() {
                        t(e[i], function(t) {
                            t ? (n(t), n = function() {}) : (i += 1) >= e.length ? n() : o();
                        });
                    }();
                }, n.forEachSeries = n.eachSeries, void 0 !== e && e.amd ? e([], function() {
                    return n;
                }) : "undefined" != typeof module1 && module1.exports ? module1.exports = n : root.async = n;
            }();
        },
        {
            "process": "pBGv"
        }
    ],
    "OWym": [
        function(require1, module1, exports) {
            var t = require1("../constants.js").FILE_SYSTEM_NAME, e = require1("../../lib/async.js").setImmediate, o = function() {
                var t = {};
                return function(e) {
                    return Object.prototype.hasOwnProperty.call(t, e) || (t[e] = {}), t[e];
                };
            }();
            function n(t, e) {
                this.readOnly = e, this.objectStore = t;
            }
            function r(e) {
                this.name = e || t;
            }
            n.prototype.clear = function(t) {
                if (this.readOnly) e(function() {
                    t("[MemoryContext] Error: write operation on read only context");
                });
                else {
                    var o = this.objectStore;
                    Object.keys(o).forEach(function(t) {
                        delete o[t];
                    }), e(t);
                }
            }, n.prototype.getObject = n.prototype.getBuffer = function(t, o) {
                var n = this;
                e(function() {
                    o(null, n.objectStore[t]);
                });
            }, n.prototype.putObject = n.prototype.putBuffer = function(t, o, n) {
                this.readOnly ? e(function() {
                    n("[MemoryContext] Error: write operation on read only context");
                }) : (this.objectStore[t] = o, e(n));
            }, n.prototype.delete = function(t, o) {
                this.readOnly ? e(function() {
                    o("[MemoryContext] Error: write operation on read only context");
                }) : (delete this.objectStore[t], e(o));
            }, r.isSupported = function() {
                return !0;
            }, r.prototype.open = function(t) {
                this.db = o(this.name), e(t);
            }, r.prototype.getReadOnlyContext = function() {
                return new n(this.db, !0);
            }, r.prototype.getReadWriteContext = function() {
                return new n(this.db, !1);
            }, module1.exports = r;
        },
        {
            "../constants.js": "iJA9",
            "../../lib/async.js": "u4Zs"
        }
    ],
    "AiW7": [
        function(require1, module1, exports) {
            var e = require1("./indexeddb.js"), r = require1("./memory.js");
            module1.exports = {
                IndexedDB: e,
                Default: e,
                Memory: r
            };
        },
        {
            "./indexeddb.js": "QO4x",
            "./memory.js": "OWym"
        }
    ],
    "p8GN": [
        function(require1, module1, exports) {
            var t = {};
            [
                "3:EACCES:permission denied",
                "9:EBADF:bad file descriptor",
                "10:EBUSY:resource busy or locked",
                "18:EINVAL:invalid argument",
                "27:ENOTDIR:not a directory",
                "28:EISDIR:illegal operation on a directory",
                "34:ENOENT:no such file or directory",
                "47:EEXIST:file already exists",
                "50:EPERM:operation not permitted",
                "51:ELOOP:too many symbolic links encountered",
                "53:ENOTEMPTY:directory not empty",
                "55:EIO:i/o error",
                "1000:ENOTMOUNTED:not mounted",
                "1001:EFILESYSTEMERROR:missing super node, use 'FORMAT' flag to format filesystem.",
                "1002:ENOATTR:attribute does not exist"
            ].forEach(function(e) {
                var o = +(e = e.split(":"))[0], r = e[1], i = e[2];
                function s(t, e) {
                    Error.call(this), this.name = r, this.code = r, this.errno = o, this.message = t || i, e && (this.path = e), this.stack = new Error(this.message).stack;
                }
                s.prototype = Object.create(Error.prototype), s.prototype.constructor = s, s.prototype.toString = function() {
                    var t = this.path ? ", '" + this.path + "'" : "";
                    return this.name + ": " + this.message + t;
                }, t[r] = t[o] = s;
            }), module1.exports = t;
        },
        {}
    ],
    "QMiB": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("../constants.js").ENVIRONMENT;
            module1.exports = function(n) {
                (n = n || {}).TMP = n.TMP || t.TMP, n.PATH = n.PATH || t.PATH, this.get = function(t) {
                    return n[t];
                }, this.set = function(t, s) {
                    n[t] = s;
                };
            };
        },
        {
            "../constants.js": "iJA9"
        }
    ],
    "bQx9": [
        function(require1, module1, exports) {
            module1.exports = function(t, o) {
                for(var a = [], e = 0; e < t.length; e++){
                    var n = o(t[e], e);
                    r(n) ? a.push.apply(a, n) : a.push(n);
                }
                return a;
            };
            var r = Array.isArray || function(r) {
                return "[object Array]" === Object.prototype.toString.call(r);
            };
        },
        {}
    ],
    "D9yG": [
        function(require1, module1, exports) {
            "use strict";
            function e(e, r, i) {
                e instanceof RegExp && (e = n(e, i)), r instanceof RegExp && (r = n(r, i));
                var o = t(e, r, i);
                return o && {
                    start: o[0],
                    end: o[1],
                    pre: i.slice(0, o[0]),
                    body: i.slice(o[0] + e.length, o[1]),
                    post: i.slice(o[1] + r.length)
                };
            }
            function n(e, n) {
                var t = n.match(e);
                return t ? t[0] : null;
            }
            function t(e, n, t) {
                var r, i, o, f, l, s = t.indexOf(e), c = t.indexOf(n, s + 1), p = s;
                if (s >= 0 && c > 0) {
                    for(r = [], o = t.length; p >= 0 && !l;)p == s ? (r.push(p), s = t.indexOf(e, p + 1)) : 1 == r.length ? l = [
                        r.pop(),
                        c
                    ] : ((i = r.pop()) < o && (o = i, f = c), c = t.indexOf(n, p + 1)), p = s < c && s >= 0 ? s : c;
                    r.length && (l = [
                        o,
                        f
                    ]);
                }
                return l;
            }
            module1.exports = e, e.range = t;
        },
        {}
    ],
    "dwXQ": [
        function(require1, module1, exports) {
            var t = require1("concat-map"), r = require1("balanced-match");
            module1.exports = f;
            var n = "\x00SLASH" + Math.random() + "\x00", e = "\x00OPEN" + Math.random() + "\x00", i = "\x00CLOSE" + Math.random() + "\x00", o = "\x00COMMA" + Math.random() + "\x00", a = "\x00PERIOD" + Math.random() + "\x00";
            function s(t) {
                return parseInt(t, 10) == t ? parseInt(t, 10) : t.charCodeAt(0);
            }
            function p(t) {
                return t.split("\\\\").join(n).split("\\{").join(e).split("\\}").join(i).split("\\,").join(o).split("\\.").join(a);
            }
            function u(t) {
                return t.split(n).join("\\").split(e).join("{").split(i).join("}").split(o).join(",").split(a).join(".");
            }
            function l(t) {
                if (!t) return [
                    ""
                ];
                var n = [], e = r("{", "}", t);
                if (!e) return t.split(",");
                var i = e.pre, o = e.body, a = e.post, s = i.split(",");
                s[s.length - 1] += "{" + o + "}";
                var p = l(a);
                return a.length && (s[s.length - 1] += p.shift(), s.push.apply(s, p)), n.push.apply(n, s), n;
            }
            function f(t) {
                return t ? ("{}" === t.substr(0, 2) && (t = "\\{\\}" + t.substr(2)), m(p(t), !0).map(u)) : [];
            }
            function h(t) {
                return t;
            }
            function d(t) {
                return "{" + t + "}";
            }
            function c(t) {
                return /^-?0\d/.test(t);
            }
            function v(t, r) {
                return t <= r;
            }
            function g(t, r) {
                return t >= r;
            }
            function m(n, e) {
                var o = [], a = r("{", "}", n);
                if (!a || /\$$/.test(a.pre)) return [
                    n
                ];
                var p, u = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(a.body), f = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(a.body), h = u || f, b = a.body.indexOf(",") >= 0;
                if (!h && !b) return a.post.match(/,.*\}/) ? m(n = a.pre + "{" + a.body + i + a.post) : [
                    n
                ];
                if (h) p = a.body.split(/\.\./);
                else if (1 === (p = l(a.body)).length && 1 === (p = m(p[0], !1).map(d)).length) return (M = a.post.length ? m(a.post, !1) : [
                    ""
                ]).map(function(t) {
                    return a.pre + p[0] + t;
                });
                var j, y = a.pre, M = a.post.length ? m(a.post, !1) : [
                    ""
                ];
                if (h) {
                    var A = s(p[0]), C = s(p[1]), O = Math.max(p[0].length, p[1].length), S = 3 == p.length ? Math.abs(s(p[2])) : 1, $ = v;
                    C < A && (S *= -1, $ = g);
                    var x = p.some(c);
                    j = [];
                    for(var E = A; $(E, C); E += S){
                        var I;
                        if (f) "\\" === (I = String.fromCharCode(E)) && (I = "");
                        else if (I = String(E), x) {
                            var q = O - I.length;
                            if (q > 0) {
                                var z = new Array(q + 1).join("0");
                                I = E < 0 ? "-" + z + I.slice(1) : z + I;
                            }
                        }
                        j.push(I);
                    }
                } else j = t(p, function(t) {
                    return m(t, !1);
                });
                for(var L = 0; L < j.length; L++)for(var P = 0; P < M.length; P++){
                    var Z = y + j[L] + M[P];
                    (!e || h || Z) && o.push(Z);
                }
                return o;
            }
        },
        {
            "concat-map": "bQx9",
            "balanced-match": "D9yG"
        }
    ],
    "NtKi": [
        function(require1, module1, exports) {
            module1.exports = g, g.Minimatch = l;
            var t = {
                sep: "/"
            };
            try {
                t = require1("path");
            } catch (O) {}
            var e = g.GLOBSTAR = l.GLOBSTAR = {}, n = require1("brace-expansion"), r = {
                "!": {
                    open: "(?:(?!(?:",
                    close: "))[^/]*?)"
                },
                "?": {
                    open: "(?:",
                    close: ")?"
                },
                "+": {
                    open: "(?:",
                    close: ")+"
                },
                "*": {
                    open: "(?:",
                    close: ")*"
                },
                "@": {
                    open: "(?:",
                    close: ")"
                }
            }, i = "[^/]", s = i + "*?", a = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?", o = "(?:(?!(?:\\/|^)\\.).)*?", h = c("().*{}+?[]^$\\!");
            function c(t) {
                return t.split("").reduce(function(t, e) {
                    return t[e] = !0, t;
                }, {});
            }
            var u = /\/+/;
            function p(t, e) {
                return e = e || {}, function(n, r, i) {
                    return g(n, t, e);
                };
            }
            function f(t, e) {
                t = t || {}, e = e || {};
                var n = {};
                return Object.keys(e).forEach(function(t) {
                    n[t] = e[t];
                }), Object.keys(t).forEach(function(e) {
                    n[e] = t[e];
                }), n;
            }
            function g(t, e, n) {
                if ("string" != typeof e) throw new TypeError("glob pattern string required");
                return n || (n = {}), !(!n.nocomment && "#" === e.charAt(0)) && ("" === e.trim() ? "" === t : new l(e, n).match(t));
            }
            function l(e, n) {
                if (!(this instanceof l)) return new l(e, n);
                if ("string" != typeof e) throw new TypeError("glob pattern string required");
                n || (n = {}), e = e.trim(), "/" !== t.sep && (e = e.split(t.sep).join("/")), this.options = n, this.set = [], this.pattern = e, this.regexp = null, this.negate = !1, this.comment = !1, this.empty = !1, this.make();
            }
            function d() {
                if (!this._made) {
                    var t = this.pattern, e = this.options;
                    if (e.nocomment || "#" !== t.charAt(0)) {
                        if (t) {
                            this.parseNegate();
                            var n = this.globSet = this.braceExpand();
                            e.debug && (this.debug = console.error), this.debug(this.pattern, n), n = this.globParts = n.map(function(t) {
                                return t.split(u);
                            }), this.debug(this.pattern, n), n = n.map(function(t, e, n) {
                                return t.map(this.parse, this);
                            }, this), this.debug(this.pattern, n), n = n.filter(function(t) {
                                return -1 === t.indexOf(!1);
                            }), this.debug(this.pattern, n), this.set = n;
                        } else this.empty = !0;
                    } else this.comment = !0;
                }
            }
            function b() {
                var t = this.pattern, e = !1, n = 0;
                if (!this.options.nonegate) {
                    for(var r = 0, i = t.length; r < i && "!" === t.charAt(r); r++)e = !e, n++;
                    n && (this.pattern = t.substr(n)), this.negate = e;
                }
            }
            function m(t, e) {
                if (e || (e = this instanceof l ? this.options : {}), void 0 === (t = void 0 === t ? this.pattern : t)) throw new TypeError("undefined pattern");
                return e.nobrace || !t.match(/\{.*\}/) ? [
                    t
                ] : n(t);
            }
            g.filter = p, g.defaults = function(t) {
                if (!t || !Object.keys(t).length) return g;
                var e = g, n = function(n, r, i) {
                    return e.minimatch(n, r, f(t, i));
                };
                return n.Minimatch = function(n, r) {
                    return new e.Minimatch(n, f(t, r));
                }, n;
            }, l.defaults = function(t) {
                return t && Object.keys(t).length ? g.defaults(t).Minimatch : l;
            }, l.prototype.debug = function() {}, l.prototype.make = d, l.prototype.parseNegate = b, g.braceExpand = function(t, e) {
                return m(t, e);
            }, l.prototype.braceExpand = m, l.prototype.parse = y;
            var v = {};
            function y(t, n) {
                if (t.length > 65536) throw new TypeError("pattern is too long");
                var a = this.options;
                if (!a.noglobstar && "**" === t) return e;
                if ("" === t) return "";
                var o, c = "", u = !!a.nocase, p = !1, f = [], g = [], l = !1, d = -1, b = -1, m = "." === t.charAt(0) ? "" : a.dot ? "(?!(?:^|\\/)\\.{1,2}(?:$|\\/))" : "(?!\\.)", y = this;
                function w() {
                    if (o) {
                        switch(o){
                            case "*":
                                c += s, u = !0;
                                break;
                            case "?":
                                c += i, u = !0;
                                break;
                            default:
                                c += "\\" + o;
                        }
                        y.debug("clearStateChar %j %j", o, c), o = !1;
                    }
                }
                for(var x, j = 0, k = t.length; j < k && (x = t.charAt(j)); j++)if (this.debug("%s	%s %s %j", t, j, c, x), p && h[x]) c += "\\" + x, p = !1;
                else switch(x){
                    case "/":
                        return !1;
                    case "\\":
                        w(), p = !0;
                        continue;
                    case "?":
                    case "*":
                    case "+":
                    case "@":
                    case "!":
                        if (this.debug("%s	%s %s %j <-- stateChar", t, j, c, x), l) {
                            this.debug("  in class"), "!" === x && j === b + 1 && (x = "^"), c += x;
                            continue;
                        }
                        y.debug("call clearStateChar %j", o), w(), o = x, a.noext && w();
                        continue;
                    case "(":
                        if (l) {
                            c += "(";
                            continue;
                        }
                        if (!o) {
                            c += "\\(";
                            continue;
                        }
                        f.push({
                            type: o,
                            start: j - 1,
                            reStart: c.length,
                            open: r[o].open,
                            close: r[o].close
                        }), c += "!" === o ? "(?:(?!(?:" : "(?:", this.debug("plType %j %j", o, c), o = !1;
                        continue;
                    case ")":
                        if (l || !f.length) {
                            c += "\\)";
                            continue;
                        }
                        w(), u = !0;
                        var A = f.pop();
                        c += A.close, "!" === A.type && g.push(A), A.reEnd = c.length;
                        continue;
                    case "|":
                        if (l || !f.length || p) {
                            c += "\\|", p = !1;
                            continue;
                        }
                        w(), c += "|";
                        continue;
                    case "[":
                        if (w(), l) {
                            c += "\\" + x;
                            continue;
                        }
                        l = !0, b = j, d = c.length, c += x;
                        continue;
                    case "]":
                        if (j === b + 1 || !l) {
                            c += "\\" + x, p = !1;
                            continue;
                        }
                        if (l) {
                            var S = t.substring(b + 1, j);
                            try {
                                RegExp("[" + S + "]");
                            } catch (O) {
                                var $ = this.parse(S, v);
                                c = c.substr(0, d) + "\\[" + $[0] + "\\]", u = u || $[1], l = !1;
                                continue;
                            }
                        }
                        u = !0, l = !1, c += x;
                        continue;
                    default:
                        w(), p ? p = !1 : !h[x] || "^" === x && l || (c += "\\"), c += x;
                }
                for(l && (S = t.substr(b + 1), $ = this.parse(S, v), c = c.substr(0, d) + "\\[" + $[0], u = u || $[1]), A = f.pop(); A; A = f.pop()){
                    var R = c.slice(A.reStart + A.open.length);
                    this.debug("setting tail", c, A), R = R.replace(/((?:\\{2}){0,64})(\\?)\|/g, function(t, e, n) {
                        return n || (n = "\\"), e + e + n + "|";
                    }), this.debug("tail=%j\n   %s", R, R, A, c);
                    var T = "*" === A.type ? s : "?" === A.type ? i : "\\" + A.type;
                    u = !0, c = c.slice(0, A.reStart) + T + "\\(" + R;
                }
                w(), p && (c += "\\\\");
                var C = !1;
                switch(c.charAt(0)){
                    case ".":
                    case "[":
                    case "(":
                        C = !0;
                }
                for(var L = g.length - 1; L > -1; L--){
                    var q = g[L], B = c.slice(0, q.reStart), M = c.slice(q.reStart, q.reEnd - 8), N = c.slice(q.reEnd - 8, q.reEnd), _ = c.slice(q.reEnd);
                    N += _;
                    var G = B.split("(").length - 1, P = _;
                    for(j = 0; j < G; j++)P = P.replace(/\)[+*?]?/, "");
                    var z = "";
                    "" === (_ = P) && n !== v && (z = "$"), c = B + M + _ + z + N;
                }
                if ("" !== c && u && (c = "(?=.)" + c), C && (c = m + c), n === v) return [
                    c,
                    u
                ];
                if (!u) return E(t);
                var D = a.nocase ? "i" : "";
                try {
                    var F = new RegExp("^" + c + "$", D);
                } catch (O) {
                    return new RegExp("$.");
                }
                return F._glob = t, F._src = c, F;
            }
            function w() {
                if (this.regexp || !1 === this.regexp) return this.regexp;
                var t = this.set;
                if (!t.length) return this.regexp = !1, this.regexp;
                var n = this.options, r = n.noglobstar ? s : n.dot ? a : o, i = n.nocase ? "i" : "", h = t.map(function(t) {
                    return t.map(function(t) {
                        return t === e ? r : "string" == typeof t ? j(t) : t._src;
                    }).join("\\/");
                }).join("|");
                h = "^(?:" + h + ")$", this.negate && (h = "^(?!" + h + ").*$");
                try {
                    this.regexp = new RegExp(h, i);
                } catch (c) {
                    this.regexp = !1;
                }
                return this.regexp;
            }
            function x(e, n) {
                if (this.debug("match", e, this.pattern), this.comment) return !1;
                if (this.empty) return "" === e;
                if ("/" === e && n) return !0;
                var r = this.options;
                "/" !== t.sep && (e = e.split(t.sep).join("/")), e = e.split(u), this.debug(this.pattern, "split", e);
                var i, s, a = this.set;
                for(this.debug(this.pattern, "set", a), s = e.length - 1; s >= 0 && !(i = e[s]); s--);
                for(s = 0; s < a.length; s++){
                    var o = a[s], h = e;
                    if (r.matchBase && 1 === o.length && (h = [
                        i
                    ]), this.matchOne(h, o, n)) return !!r.flipNegate || !this.negate;
                }
                return !r.flipNegate && this.negate;
            }
            function E(t) {
                return t.replace(/\\(.)/g, "$1");
            }
            function j(t) {
                return t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            }
            g.makeRe = function(t, e) {
                return new l(t, e || {}).makeRe();
            }, l.prototype.makeRe = w, g.match = function(t, e, n) {
                var r = new l(e, n = n || {});
                return t = t.filter(function(t) {
                    return r.match(t);
                }), r.options.nonull && !t.length && t.push(e), t;
            }, l.prototype.match = x, l.prototype.matchOne = function(t, n, r) {
                var i = this.options;
                this.debug("matchOne", {
                    this: this,
                    file: t,
                    pattern: n
                }), this.debug("matchOne", t.length, n.length);
                for(var s = 0, a = 0, o = t.length, h = n.length; s < o && a < h; s++, a++){
                    this.debug("matchOne loop");
                    var c, u = n[a], p = t[s];
                    if (this.debug(n, u, p), !1 === u) return !1;
                    if (u === e) {
                        this.debug("GLOBSTAR", [
                            n,
                            u,
                            p
                        ]);
                        var f = s, g = a + 1;
                        if (g === h) {
                            for(this.debug("** at the end"); s < o; s++)if ("." === t[s] || ".." === t[s] || !i.dot && "." === t[s].charAt(0)) return !1;
                            return !0;
                        }
                        for(; f < o;){
                            var l = t[f];
                            if (this.debug("\nglobstar while", t, f, n, g, l), this.matchOne(t.slice(f), n.slice(g), r)) return this.debug("globstar found match!", f, o, l), !0;
                            if ("." === l || ".." === l || !i.dot && "." === l.charAt(0)) {
                                this.debug("dot detected!", t, f, n, g);
                                break;
                            }
                            this.debug("globstar swallow a segment, and continue"), f++;
                        }
                        return !(!r || (this.debug("\n>>> no match, partial?", t, f, n, g), f !== o));
                    }
                    if ("string" == typeof u ? (c = i.nocase ? p.toLowerCase() === u.toLowerCase() : p === u, this.debug("string match", u, p, c)) : (c = p.match(u), this.debug("pattern match", u, p, c)), !c) return !1;
                }
                if (s === o && a === h) return !0;
                if (s === o) return r;
                if (a === h) return s === o - 1 && "" === t[s];
                throw new Error("wtf?");
            };
        },
        {
            "path": "UUq2",
            "brace-expansion": "dwXQ"
        }
    ],
    "D1Ra": [
        function(require1, module1, exports) {
            var n = require1("es6-promisify"), t = n.promisify, e = require1("../path.js"), i = require1("../errors.js"), r = require1("./environment.js"), o = require1("../../lib/async.js"), u = require1("minimatch");
            function c(n, o) {
                var u = this, c = new r((o = o || {}).env), f = "/";
                Object.defineProperty(this, "fs", {
                    get: function() {
                        return n;
                    },
                    enumerable: !0
                }), Object.defineProperty(this, "env", {
                    get: function() {
                        return c;
                    },
                    enumerable: !0
                }), this.cd = function(t, r) {
                    t = e.resolve(f, t), n.stat(t, function(n, e) {
                        n ? r(new i.ENOTDIR(null, t)) : "DIRECTORY" === e.type ? (f = t, r()) : r(new i.ENOTDIR(null, t));
                    });
                }, this.pwd = function() {
                    return f;
                }, this.promises = {}, [
                    "cd",
                    "exec",
                    "touch",
                    "cat",
                    "ls",
                    "rm",
                    "tempDir",
                    "mkdirp",
                    "find"
                ].forEach(function(n) {
                    u.promises[n] = t(u[n].bind(u));
                });
            }
            c.prototype.exec = function(n, t, i) {
                var r = this.fs;
                "function" == typeof t && (i = t, t = []), t = t || [], i = i || function() {}, n = e.resolve(this.pwd(), n), r.readFile(n, "utf8", function(n, e) {
                    if (n) i(n);
                    else try {
                        new Function("fs", "args", "callback", e)(r, t, i);
                    } catch (o) {
                        i(o);
                    }
                });
            }, c.prototype.touch = function(n, t, i) {
                var r = this.fs;
                "function" == typeof t && (i = t, t = {}), t = t || {}, i = i || function() {}, n = e.resolve(this.pwd(), n), r.stat(n, function(e) {
                    e ? !0 === t.updateOnly ? i() : function(n) {
                        r.writeFile(n, "", i);
                    }(n) : function(n) {
                        var e = Date.now(), o = t.date || e, u = t.date || e;
                        r.utimes(n, o, u, i);
                    }(n);
                });
            }, c.prototype.cat = function(n, t) {
                var r = this, u = r.fs, c = "";
                t = t || function() {}, n ? (n = "string" == typeof n ? [
                    n
                ] : n, o.eachSeries(n, function(n, t) {
                    var i = e.resolve(r.pwd(), n);
                    u.readFile(i, "utf8", function(n, e) {
                        n ? t(n) : (c += e + "\n", t());
                    });
                }, function(n) {
                    n ? t(n) : t(null, c.replace(/\n$/, ""));
                })) : t(new i.EINVAL("Missing files argument"));
            }, c.prototype.ls = function(n, t, r) {
                var u = this, c = u.fs;
                "function" == typeof t && (r = t, t = {}), t = t || {}, r = r || function() {}, n ? function n(i, r) {
                    var f = e.resolve(u.pwd(), i), s = [];
                    c.readdir(f, function(i, u) {
                        i ? r(i) : o.eachSeries(u, function(i, r) {
                            i = e.join(f, i), c.stat(i, function(i, o) {
                                if (i) r(i);
                                else {
                                    var u = o;
                                    t.recursive && "DIRECTORY" === o.type ? n(e.join(f, u.name), function(n, t) {
                                        n ? r(n) : (u.contents = t, s.push(u), r());
                                    }) : (s.push(u), r());
                                }
                            });
                        }, function(n) {
                            r(n, s);
                        });
                    });
                }(n, r) : r(new i.EINVAL("Missing dir argument"));
            }, c.prototype.rm = function(n, t, r) {
                var u = this, c = u.fs;
                "function" == typeof t && (r = t, t = {}), t = t || {}, r = r || function() {}, n ? function n(r, f) {
                    r = e.resolve(u.pwd(), r), c.stat(r, function(u, s) {
                        u ? f(u) : "FILE" !== s.type ? c.readdir(r, function(u, s) {
                            u ? f(u) : 0 !== s.length ? t.recursive ? (s = s.map(function(n) {
                                return e.join(r, n);
                            }), o.eachSeries(s, n, function(n) {
                                n ? f(n) : c.rmdir(r, f);
                            })) : f(new i.ENOTEMPTY(null, r)) : c.rmdir(r, f);
                        }) : c.unlink(r, f);
                    });
                }(n, r) : r(new i.EINVAL("Missing path argument"));
            }, c.prototype.tempDir = function(n) {
                var t = this.fs, e = this.env.get("TMP");
                n = n || function() {}, t.mkdir(e, function() {
                    n(null, e);
                });
            }, c.prototype.mkdirp = function(n, t) {
                var r = this.fs;
                t = t || function() {}, n ? "/" !== (n = e.resolve(this.pwd(), n)) ? function n(t, o) {
                    r.stat(t, function(u, c) {
                        if (c) {
                            if (c.isDirectory()) return void o();
                            if (c.isFile()) return void o(new i.ENOTDIR(null, t));
                        } else {
                            if (u && "ENOENT" !== u.code) return void o(u);
                            var f = e.dirname(t);
                            "/" === f ? r.mkdir(t, function(n) {
                                n && "EEXIST" !== n.code ? o(n) : o();
                            }) : n(f, function(n) {
                                if (n) return o(n);
                                r.mkdir(t, function(n) {
                                    n && "EEXIST" !== n.code ? o(n) : o();
                                });
                            });
                        }
                    });
                }(n, t) : t() : t(new i.EINVAL("Missing path argument"));
            }, c.prototype.find = function(n, t, r) {
                var c = this, f = c.fs;
                "function" == typeof t && (r = t, t = {}), r = r || function() {};
                var s = (t = t || {}).exec || function(n, t) {
                    t();
                }, a = [];
                function p(n, i) {
                    var r = e.removeTrailing(n);
                    !t.regex || t.regex.test(r) ? t.name && !u(e.basename(r), t.name) || t.path && !u(e.dirname(r), t.path) ? i() : function(n, t) {
                        s(n, function(e) {
                            e ? t(e) : (a.push(n), t());
                        });
                    }(n, i) : i();
                }
                function d(n, t) {
                    n = e.resolve(c.pwd(), n), f.readdir(n, function(i, r) {
                        i ? "ENOTDIR" === i.code ? p(n, t) : t(i) : p(e.addTrailing(n), function(i) {
                            i ? t(i) : (r = r.map(function(t) {
                                return e.join(n, t);
                            }), o.eachSeries(r, d, function(n) {
                                t(n, a);
                            }));
                        });
                    });
                }
                n ? f.stat(n, function(t, e) {
                    t ? r(t) : e.isDirectory() ? d(n, r) : r(new i.ENOTDIR(null, n));
                }) : r(new i.EINVAL("Missing path argument"));
            }, module1.exports = c;
        },
        {
            "es6-promisify": "b1ZG",
            "../path.js": "UzoP",
            "../errors.js": "p8GN",
            "./environment.js": "QMiB",
            "../../lib/async.js": "u4Zs",
            "minimatch": "NtKi"
        }
    ],
    "J4Qg": [
        function(require1, module1, exports) {
            function t(t, r) {
                for(var o = r.length - 1; o >= 0; o--)r[o] === t && r.splice(o, 1);
                return r;
            }
            var r = function() {};
            r.createInterface = function(r) {
                var o = {
                    on: function(t, o) {
                        void 0 === this[r] && (this[r] = {}), this[r].hasOwnProperty(t) || (this[r][t] = []), this[r][t].push(o);
                    },
                    off: function(o, e) {
                        void 0 !== this[r] && this[r].hasOwnProperty(o) && t(e, this[r][o]);
                    },
                    trigger: function(t) {
                        if (void 0 !== this[r] && this[r].hasOwnProperty(t)) for(var o = Array.prototype.slice.call(arguments, 1), e = 0; e < this[r][t].length; e++)this[r][t][e].apply(this[r][t][e], o);
                    },
                    removeAllListeners: function(t) {
                        if (void 0 !== this[r]) {
                            var o = this;
                            o[r][t].forEach(function(r) {
                                o.off(t, r);
                            });
                        }
                    }
                };
                return o;
            };
            var o = r.createInterface("_handlers");
            r.prototype._on = o.on, r.prototype._off = o.off, r.prototype._trigger = o.trigger;
            var e = r.createInterface("handlers");
            r.prototype.on = function() {
                e.on.apply(this, arguments), Array.prototype.unshift.call(arguments, "on"), this._trigger.apply(this, arguments);
            }, r.prototype.off = e.off, r.prototype.trigger = e.trigger, r.prototype.removeAllListeners = e.removeAllListeners, module1.exports = r;
        },
        {}
    ],
    "zBMa": [
        function(require1, module1, exports) {
            function x(x) {
                return x.replace(/[xy]/g, function(x) {
                    var n = 16 * Math.random() | 0;
                    return ("x" === x ? n : 3 & n | 8).toString(16);
                });
            }
            function n() {
                return x("xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx").toUpperCase();
            }
            function r(n) {
                return x("x".repeat(n = n || 6));
            }
            function t() {}
            module1.exports = {
                guid: n,
                nop: t,
                randomChars: r
            };
        },
        {}
    ],
    "u7Jv": [
        function(require1, module1, exports) {
            var global = arguments[3];
            var t = arguments[3];
            function e(t) {
                return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            var n = require1("./eventemitter.js"), o = require1("../src/shared.js").guid;
            function r(t, e) {
                var n = 0;
                return function() {
                    var o = Date.now();
                    o - n > t && (n = o, e.apply(this, arguments));
                };
            }
            function i(t, n) {
                if (void 0 !== t && t || (t = {}), "object" === e(n)) for(var o in n)n.hasOwnProperty(o) && (t[o] = n[o]);
                return t;
            }
            var a = function(t) {
                return void 0 === t || void 0 === t.localStorage ? {
                    getItem: function() {},
                    setItem: function() {},
                    removeItem: function() {}
                } : t.localStorage;
            }(t);
            function s() {
                var e = this, n = Date.now();
                this.origin = o(), this.lastMessage = n, this.receivedIDs = {}, this.previousValues = {};
                var r = function() {
                    e._onStorageEvent.apply(e, arguments);
                };
                "undefined" != typeof document && (document.attachEvent ? document.attachEvent("onstorage", r) : t.addEventListener("storage", r, !1));
            }
            s.prototype._transaction = function(t) {
                var e = 1e3, n = 20, o = this, r = !1, i = !1, s = null;
                function c() {
                    if (!r) {
                        var u = Date.now(), f = 0 | a.getItem(p);
                        if (f && u - f < e) return i || (o._on("storage", c), i = !0), void (s = setTimeout(c, n));
                        r = !0, a.setItem(p, u), t(), function() {
                            i && o._off("storage", c);
                            s && clearTimeout(s);
                            a.removeItem(p);
                        }();
                    }
                }
                c();
            }, s.prototype._cleanup_emit = r(100, function() {
                this._transaction(function() {
                    var t, e = Date.now() - f, n = 0;
                    try {
                        t = JSON.parse(a.getItem(c) || "[]");
                    } catch (r) {
                        t = [];
                    }
                    for(var o = t.length - 1; o >= 0; o--)t[o].timestamp < e && (t.splice(o, 1), n++);
                    n > 0 && a.setItem(c, JSON.stringify(t));
                });
            }), s.prototype._cleanup_once = r(100, function() {
                var t = this;
                t._transaction(function() {
                    Date.now();
                    var e, n, o = 0;
                    try {
                        n = JSON.parse(a.getItem(u) || "{}");
                    } catch (r) {
                        n = {};
                    }
                    for(e in n)t._once_expired(e, n) && (delete n[e], o++);
                    o > 0 && a.setItem(u, JSON.stringify(n));
                });
            }), s.prototype._once_expired = function(t, n) {
                if (!n) return !0;
                if (!n.hasOwnProperty(t)) return !0;
                if ("object" !== e(n[t])) return !0;
                var o = n[t].ttl || m, r = Date.now();
                return n[t].timestamp < r - o;
            }, s.prototype._localStorageChanged = function(t, e) {
                if (t && t.key) return t.key === e;
                var n = a.getItem(e);
                return n !== this.previousValues[e] && (this.previousValues[e] = n, !0);
            }, s.prototype._onStorageEvent = function(e) {
                e = e || t.event;
                var n = this;
                this._localStorageChanged(e, c) && this._transaction(function() {
                    var t, e = Date.now(), o = a.getItem(c);
                    try {
                        t = JSON.parse(o || "[]");
                    } catch (i) {
                        t = [];
                    }
                    for(var r = 0; r < t.length; r++)if (t[r].origin !== n.origin && !(t[r].timestamp < n.lastMessage)) {
                        if (t[r].id) {
                            if (n.receivedIDs.hasOwnProperty(t[r].id)) continue;
                            n.receivedIDs[t[r].id] = !0;
                        }
                        n.trigger(t[r].name, t[r].payload);
                    }
                    n.lastMessage = e;
                }), this._trigger("storage", e);
            }, s.prototype._emit = function(t, e, n) {
                if ((n = "string" == typeof n || "number" == typeof n ? String(n) : null) && n.length) {
                    if (this.receivedIDs.hasOwnProperty(n)) return;
                    this.receivedIDs[n] = !0;
                }
                var o = {
                    id: n,
                    name: t,
                    origin: this.origin,
                    timestamp: Date.now(),
                    payload: e
                }, r = this;
                this._transaction(function() {
                    var n = a.getItem(c) || "[]", i = "[]" === n ? "" : ",";
                    n = [
                        n.substring(0, n.length - 1),
                        i,
                        JSON.stringify(o),
                        "]"
                    ].join(""), a.setItem(c, n), r.trigger(t, e), setTimeout(function() {
                        r._cleanup_emit();
                    }, 50);
                });
            }, s.prototype.emit = function(t, e) {
                this._emit.apply(this, arguments), this._trigger("emit", t, e);
            }, s.prototype.once = function(t, e, n) {
                if (s.supported) {
                    var o = this;
                    this._transaction(function() {
                        var r;
                        try {
                            r = JSON.parse(a.getItem(u) || "{}");
                        } catch (i) {
                            r = {};
                        }
                        o._once_expired(t, r) && (r[t] = {}, r[t].timestamp = Date.now(), "number" == typeof n && (r[t].ttl = 1e3 * n), a.setItem(u, JSON.stringify(r)), e(), setTimeout(function() {
                            o._cleanup_once();
                        }, 50));
                    });
                }
            }, i(s.prototype, n.prototype), s.supported = void 0 !== a;
            var c = "intercom", u = "intercom_once", p = "intercom_lock", f = 5e4, m = 36e5;
            s.destroy = function() {
                a.removeItem(p), a.removeItem(c), a.removeItem(u);
            }, s.getInstance = function() {
                var t;
                return function() {
                    return t || (t = new s), t;
                };
            }(), module1.exports = s;
        },
        {
            "./eventemitter.js": "J4Qg",
            "../src/shared.js": "zBMa"
        }
    ],
    "VLEe": [
        function(require1, module1, exports) {
            var e = require1("../lib/eventemitter.js"), t = require1("./path.js"), n = require1("../lib/intercom.js");
            function r() {
                e.call(this);
                var r, i, o = this, s = !1;
                function c(e) {
                    (i === e || s && 0 === e.indexOf(r)) && o.trigger("change", "change", e);
                }
                o.start = function(e, o, a) {
                    if (!i) {
                        if (t.isNull(e)) throw new Error("Path must be a string without null bytes.");
                        i = t.normalize(e), (s = !0 === a) && (r = "/" === i ? "/" : i + "/"), n.getInstance().on("change", c);
                    }
                }, o.close = function() {
                    n.getInstance().off("change", c), o.removeAllListeners("change");
                };
            }
            r.prototype = new e, r.prototype.constructor = r, module1.exports = r;
        },
        {
            "../lib/eventemitter.js": "J4Qg",
            "./path.js": "UzoP",
            "../lib/intercom.js": "u7Jv"
        }
    ],
    "ZECt": [
        function(require1, module1, exports) {
            var t = require1("./constants.js").NODE_TYPE_FILE;
            module1.exports = function(s, e) {
                this.id = s, this.type = e || t;
            };
        },
        {
            "./constants.js": "iJA9"
        }
    ],
    "osLK": [
        function(require1, module1, exports) {
            var r = require1("./constants"), e = r.FIRST_DESCRIPTOR, n = {}, t = function() {
                for(var r = e; o(r);)r++;
                return r;
            }, o = function(r) {
                return n[r];
            }, i = function(r) {
                var e = t();
                return n[e] = r, e;
            }, u = function(r) {
                return delete n[r];
            };
            module1.exports = {
                allocDescriptor: i,
                releaseDescriptor: u,
                getOpenFileDescription: o
            };
        },
        {
            "./constants": "iJA9"
        }
    ],
    "KKNo": [
        function(require1, module1, exports) {
            function t(t, i) {
                if (!(t instanceof i)) throw new TypeError("Cannot call a class as a function");
            }
            function i(t, i) {
                for(var s = 0; s < i.length; s++){
                    var e = i[s];
                    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, e.key, e);
                }
            }
            function s(t, s, e) {
                return s && i(t.prototype, s), e && i(t, e), t;
            }
            var e = require1("./constants"), n = e.NODE_TYPE_FILE, r = e.NODE_TYPE_DIRECTORY, a = e.NODE_TYPE_SYMBOLIC_LINK, o = e.DEFAULT_FILE_PERMISSIONS, u = e.DEFAULT_DIR_PERMISSIONS, h = require1("./constants").fsConstants, c = h.S_IFREG, f = h.S_IFDIR, m = h.S_IFLNK;
            function d(t, i, s) {
                if (t[i]) return s();
                t.guid(function(e, n) {
                    if (e) return s(e);
                    t[i] = n, s();
                });
            }
            function l(t, i) {
                switch(t){
                    case r:
                        return (i || u) | f;
                    case a:
                        return (i || o) | m;
                    case n:
                    default:
                        return (i || o) | c;
                }
            }
            var p = function() {
                function i(s) {
                    t(this, i);
                    var e = Date.now();
                    this.id = s.id, this.data = s.data, this.size = s.size || 0, this.atime = s.atime || e, this.ctime = s.ctime || e, this.mtime = s.mtime || e, this.flags = s.flags || [], this.xattrs = s.xattrs || {}, this.nlinks = s.nlinks || 0, "string" == typeof s.type ? this.type = s.type : "string" == typeof s.mode ? this.type = s.mode : this.type = n, this.permissions = s.permissions || l(this.type), this.uid = s.uid || 0, this.gid = s.gid || 0;
                }
                return s(i, [
                    {
                        key: "toJSON",
                        value: function() {
                            return {
                                id: this.id,
                                data: this.data,
                                size: this.size,
                                atime: this.atime,
                                ctime: this.ctime,
                                mtime: this.ctime,
                                flags: this.flags,
                                xattrs: this.xattrs,
                                nlinks: this.nlinks,
                                mode: this.type,
                                permissions: this.permissions,
                                uid: this.uid,
                                gid: this.gid
                            };
                        }
                    },
                    {
                        key: "mode",
                        get: function() {
                            return l(this.type, this.permissions);
                        },
                        set: function(t) {
                            this.permissions = t;
                        }
                    }
                ]), i;
            }();
            module1.exports.create = function(t, i) {
                d(t, "id", function(s) {
                    if (s) return i(s);
                    d(t, "data", function(s) {
                        if (s) return i(s);
                        i(null, new p(t));
                    });
                });
            };
        },
        {
            "./constants": "iJA9"
        }
    ],
    "XWaV": [
        function(require1, module1, exports) {
            var e = require1("./errors.js"), t = require1("./node");
            function i(e, t, i, r) {
                this.path = e, this.id = t, this.flags = i, this.position = r;
            }
            i.prototype.getNode = function(i, r) {
                var o = this.id, n = this.path;
                i.getObject(o, function(i, o) {
                    return i ? r(i) : o ? void t.create(o, r) : r(new e.EBADF("file descriptor refers to unknown node", n));
                });
            }, module1.exports = i;
        },
        {
            "./errors.js": "p8GN",
            "./node": "KKNo"
        }
    ],
    "JEp0": [
        function(require1, module1, exports) {
            var t = require1("./constants.js");
            function e(e) {
                var i = Date.now();
                this.id = t.SUPER_NODE_ID, this.type = t.NODE_TYPE_META, this.atime = e.atime || i, this.ctime = e.ctime || i, this.mtime = e.mtime || i, this.rnode = e.rnode;
            }
            e.create = function(t, i) {
                t.guid(function(n, o) {
                    n ? i(n) : (t.rnode = t.rnode || o, i(null, new e(t)));
                });
            }, module1.exports = e;
        },
        {
            "./constants.js": "iJA9"
        }
    ],
    "dsCT": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("./constants.js"), i = require1("./path.js");
            function e(t) {
                return new Date(Number(t));
            }
            function s(t, s, o) {
                this.dev = o, this.node = s.id, this.type = s.type, this.size = s.size, this.nlinks = s.nlinks, this.atime = e(s.atime), this.mtime = e(s.mtime), this.ctime = e(s.ctime), this.atimeMs = s.atime, this.mtimeMs = s.mtime, this.ctimeMs = s.ctime, this.version = s.version, this.mode = s.mode, this.uid = s.uid, this.gid = s.gid, this.name = i.basename(t);
            }
            s.prototype.isFile = function() {
                return this.type === t.NODE_TYPE_FILE;
            }, s.prototype.isDirectory = function() {
                return this.type === t.NODE_TYPE_DIRECTORY;
            }, s.prototype.isSymbolicLink = function() {
                return this.type === t.NODE_TYPE_SYMBOLIC_LINK;
            }, s.prototype.isSocket = s.prototype.isFIFO = s.prototype.isCharacterDevice = s.prototype.isBlockDevice = function() {
                return !1;
            }, module1.exports = s;
        },
        {
            "./constants.js": "iJA9",
            "./path.js": "UzoP"
        }
    ],
    "q4Wu": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("./stats.js");
            function o(r, s, e) {
                this.constructor = o, t.call(this, r, s, e);
            }
            o.prototype = t.prototype, module1.exports = o;
        },
        {
            "./stats.js": "dsCT"
        }
    ],
    "bsBG": [
        function(require1, module1, exports) {
            var Buffer = require1("buffer").Buffer;
            var e = require1("buffer").Buffer;
            function n(e) {
                return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            var t = require1("../path.js"), i = t.normalize, o = t.dirname, r = t.basename, u = t.isAbsolute, a = require1("../shared.js"), c = require1("../../lib/async.js"), f = require1("../constants.js"), l = f.NODE_TYPE_FILE, s = f.NODE_TYPE_DIRECTORY, p = f.NODE_TYPE_SYMBOLIC_LINK, d = f.NODE_TYPE_META, m = f.FULL_READ_WRITE_EXEC_PERMISSIONS, E = f.ROOT_DIRECTORY_NAME, g = f.SUPER_NODE_ID, w = f.SYMLOOP_MAX, O = f.O_READ, b = f.O_WRITE, y = f.O_CREATE, v = f.O_EXCLUSIVE, N = f.O_APPEND, h = f.O_FLAGS, I = f.XATTR_CREATE, j = f.XATTR_REPLACE, A = f.FS_NOMTIME, D = f.FS_NOCTIME, T = require1("../errors.js"), L = require1("../directory-entry.js"), R = require1("../open-files.js"), _ = require1("../open-file-description.js"), F = require1("../super-node.js"), S = require1("../node.js"), V = require1("../dirent.js"), B = require1("../stats.js");
            function P(e, n, t, i, o) {
                var r = e.flags;
                r.includes(D) && delete i.ctime, r.includes(A) && delete i.mtime;
                var u = !1;
                function a(t) {
                    e.changes.push({
                        event: "change",
                        path: n
                    }), o(t);
                }
                i.ctime && (t.ctime = i.ctime, t.atime = i.ctime, u = !0), i.atime && (t.atime = i.atime, u = !0), i.mtime && (t.mtime = i.mtime, u = !0), u ? e.putObject(t.id, t, a) : a();
            }
            function x(e, n, t, u) {
                if (t !== s && t !== l) return u(new T.EINVAL("type must be a directory or file", n));
                n = i(n);
                var a, c, f, p = r(n), d = o(n);
                function m(t, i) {
                    !t && i ? u(new T.EEXIST("path name already exists", n)) : !t || t instanceof T.ENOENT ? e.getObject(a.data, E) : u(t);
                }
                function E(n, i) {
                    n ? u(n) : (c = i, S.create({
                        guid: e.guid,
                        type: t
                    }, function(n, t) {
                        n ? u(n) : ((f = t).nlinks += 1, e.putObject(f.id, f, w));
                    }));
                }
                function g(n) {
                    if (n) u(n);
                    else {
                        var t = Date.now();
                        P(e, d, f, {
                            mtime: t,
                            ctime: t
                        }, u);
                    }
                }
                function w(n) {
                    n ? u(n) : (c[p] = new L(f.id, t), e.putObject(a.data, c, g));
                }
                k(e, d, function(t, i) {
                    t ? u(t) : i.type !== s ? u(new T.ENOTDIR("a component of the path prefix is not a directory", n)) : (a = i, k(e, n, m));
                });
            }
            function k(e, n, t) {
                if (!(n = i(n))) return t(new T.ENOENT("path is an empty string"));
                var u = r(n), a = o(n), c = 0;
                function f(n, i) {
                    if (n) return t(n);
                    var o = new F(i);
                    o && o.type === d && o.rnode ? e.getObject(o.rnode, l) : t(new T.EFILESYSTEMERROR);
                }
                function l(e, n) {
                    e ? t(e) : n ? S.create(n, t) : t(new T.ENOENT);
                }
                function m(i, o) {
                    i ? t(i) : o.type === s && o.data ? e.getObject(o.data, O) : t(new T.ENOTDIR("a component of the path prefix is not a directory", n));
                }
                function O(i, o) {
                    if (i) t(i);
                    else if (Object.prototype.hasOwnProperty.call(o, u)) {
                        var r = o[u].id;
                        e.getObject(r, b);
                    } else t(new T.ENOENT(null, n));
                }
                function b(e, n) {
                    if (e) return t(e);
                    S.create(n, y);
                }
                function y(l, s) {
                    var d;
                    l ? t(l) : s.type === p ? ++c > w ? t(new T.ELOOP(null, n)) : (d = s.data, d = i(d), a = o(d), u = r(d), E === u ? e.getObject(g, f) : k(e, a, m)) : t(null, s);
                }
                E === u ? e.getObject(g, f) : k(e, a, m);
            }
            function C(e, n, t, i, o, r, u) {
                var a = t.xattrs;
                r === I && Object.prototype.hasOwnProperty.call(a, i) ? u(new T.EEXIST("attribute already exists", n)) : r !== j || Object.prototype.hasOwnProperty.call(a, i) ? (a[i] = o, e.putObject(t.id, t, function(i) {
                    i ? u(i) : P(e, n, t, {
                        ctime: Date.now()
                    }, u);
                })) : u(new T.ENOATTR(null, n));
            }
            function X(e, n) {
                var t, i, o;
                function r(o) {
                    o ? n(o) : S.create({
                        guid: e.guid,
                        id: t.rnode,
                        type: s
                    }, function(t, o) {
                        t ? n(t) : ((i = o).nlinks += 1, e.putObject(i.id, i, u));
                    });
                }
                function u(t) {
                    t ? n(t) : (o = {}, e.putObject(i.data, o, n));
                }
                e.getObject(g, function(i, o) {
                    !i && o ? n() : !i || i instanceof T.ENOENT ? F.create({
                        guid: e.guid
                    }, function(i, o) {
                        i ? n(i) : (t = o, e.putObject(t.id, t, r));
                    }) : n(i);
                });
            }
            function q(e, n, t) {
                n = i(n);
                var u, a, c, f, l = r(n), p = o(n);
                function d(n, i) {
                    n ? t(n) : (c = i, e.getObject(c.data, m));
                }
                function m(n, i) {
                    n ? t(n) : (f = i, S.create({
                        guid: e.guid,
                        type: s
                    }, function(n, i) {
                        n ? t(n) : ((u = i).nlinks += 1, e.putObject(u.id, u, E));
                    }));
                }
                function E(n) {
                    n ? t(n) : (a = {}, e.putObject(u.data, a, w));
                }
                function g(n) {
                    if (n) t(n);
                    else {
                        var i = Date.now();
                        P(e, p, c, {
                            mtime: i,
                            ctime: i
                        }, t);
                    }
                }
                function w(n) {
                    n ? t(n) : (f[l] = new L(u.id, s), e.putObject(c.data, f, g));
                }
                k(e, n, function(i, o) {
                    !i && o ? t(new T.EEXIST(null, n)) : !i || i instanceof T.ENOENT ? k(e, p, d) : t(i);
                });
            }
            function M(e, n, t, o) {
                var r = f.fsConstants, u = r.F_OK, a = r.R_OK, c = r.W_OK, l = r.X_OK, s = r.S_IXUSR, p = r.S_IXGRP, d = r.S_IXOTH;
                k(e, n = i(n), function(e, i) {
                    if (e) return o(e);
                    if (t === u) return o(null);
                    var r = xe(i.mode, o);
                    return r ? t & (a | c) ? o(null) : t & l && r & (s | p | d) ? o(null) : void o(new T.EACCES("permission denied", n)) : void 0;
                });
            }
            function z(e, n, t) {
                n = i(n);
                var u, a, c, f, l = r(n), p = o(n);
                function d(i, o) {
                    i ? t(i) : E === l ? t(new T.EBUSY(null, n)) : Object.prototype.hasOwnProperty.call(o, l) ? (u = (f = o)[l].id, e.getObject(u, m)) : t(new T.ENOENT(null, n));
                }
                function m(i, o) {
                    i ? t(i) : o.type !== s ? t(new T.ENOTDIR(null, n)) : (u = o, e.getObject(u.data, g));
                }
                function g(i, o) {
                    i ? t(i) : (a = o, Object.keys(a).length > 0 ? t(new T.ENOTEMPTY(null, n)) : (delete f[l], e.putObject(c.data, f, w)));
                }
                function w(n) {
                    if (n) t(n);
                    else {
                        var i = Date.now();
                        P(e, p, c, {
                            mtime: i,
                            ctime: i
                        }, O);
                    }
                }
                function O(n) {
                    n ? t(n) : e.delete(u.id, b);
                }
                function b(n) {
                    n ? t(n) : e.delete(u.data, t);
                }
                k(e, p, function(n, i) {
                    n ? t(n) : (c = i, e.getObject(c.data, d));
                });
            }
            function Y(n, t, u, a, c) {
                "function" == typeof a && (c = a, a = null), t = i(t);
                var f, d, m, g, O, N = r(t), h = o(t), I = 0;
                function j(e, i) {
                    e ? c(e) : i.type !== s ? c(new T.ENOENT(null, t)) : (f = i, n.getObject(f.data, A));
                }
                function A(e, i) {
                    e ? c(e) : (d = i, Object.prototype.hasOwnProperty.call(d, N) ? u.includes(v) ? c(new T.EEXIST("O_CREATE and O_EXCLUSIVE are set, and the named file exists", t)) : (m = d[N]).type === s && u.includes(b) ? c(new T.EISDIR("the named file is a directory and O_WRITE is set", t)) : n.getObject(m.id, D) : u.includes(y) ? S.create({
                        guid: n.guid,
                        type: l
                    }, function(e, t) {
                        e ? c(e) : ((g = t).nlinks += 1, a && (g.mode = a), n.putObject(g.id, g, _));
                    }) : c(new T.ENOENT("O_CREATE is not set and the named file does not exist", t)));
                }
                function D(e, a) {
                    if (e) c(e);
                    else {
                        var f = a;
                        f.type === p ? ++I > w ? c(new T.ELOOP(null, t)) : function(e) {
                            e = i(e), h = o(e), N = r(e), E === N && (u.includes(b) ? c(new T.EISDIR("the named file is a directory and O_WRITE is set", t)) : k(n, t, R));
                            k(n, h, j);
                        }(f.data) : R(void 0, f);
                    }
                }
                function R(e, n) {
                    e ? c(e) : c(null, g = n);
                }
                function _(t) {
                    t ? c(t) : (O = e.alloc(0), n.putBuffer(g.data, O, V));
                }
                function F(e) {
                    if (e) c(e);
                    else {
                        var t = Date.now();
                        P(n, h, f, {
                            mtime: t,
                            ctime: t
                        }, B);
                    }
                }
                function V(e) {
                    e ? c(e) : (d[N] = new L(g.id, l), n.putObject(f.data, d, F));
                }
                function B(e) {
                    e ? c(e) : c(null, g);
                }
                E === N ? u.includes(b) ? c(new T.EISDIR("the named file is a directory and O_WRITE is set", t)) : k(n, t, R) : k(n, h, j);
            }
            function K(n, t, i, o, r, u) {
                var a;
                function c(e) {
                    e ? u(e) : u(null, r);
                }
                function f(e) {
                    if (e) u(e);
                    else {
                        var i = Date.now();
                        P(n, t.path, a, {
                            mtime: i,
                            ctime: i
                        }, c);
                    }
                }
                function l(e) {
                    e ? u(e) : n.putObject(a.id, a, f);
                }
                n.getObject(t.id, function(c, f) {
                    if (c) u(c);
                    else {
                        a = f;
                        var s = e.alloc(r);
                        i.copy(s, 0, o, o + r), t.position = r, a.size = r, a.version += 1, n.putBuffer(a.data, s, l);
                    }
                });
            }
            function U(n, t, i, o, r, u, a) {
                var c, f;
                function l(e) {
                    e ? a(e) : a(null, r);
                }
                function s(e) {
                    if (e) a(e);
                    else {
                        var i = Date.now();
                        P(n, t.path, c, {
                            mtime: i,
                            ctime: i
                        }, l);
                    }
                }
                function p(e) {
                    e ? a(e) : n.putObject(c.id, c, s);
                }
                function d(l, s) {
                    if (l) a(l);
                    else {
                        if (!(f = s)) return a(new T.EIO("Expected Buffer"));
                        var d = null != u ? u : t.position, m = Math.max(f.length, d + r), E = e.alloc(m);
                        f && f.copy(E), i.copy(E, d, o, o + r), void 0 === u && (t.position += r), c.size = m, c.version += 1, n.putBuffer(c.data, E, p);
                    }
                }
                n.getObject(t.id, function(e, t) {
                    e ? a(e) : (c = t, n.getBuffer(c.data, d));
                });
            }
            function W(e, n, t, i, o, r, u) {
                var a, c;
                function f(e, a) {
                    if (e) u(e);
                    else {
                        if (!(c = a)) return u(new T.EIO("Expected Buffer"));
                        var f = null != r ? r : n.position;
                        o = f + o > t.length ? o - f : o, c.copy(t, i, f, f + o), void 0 === r && (n.position += o), u(null, o);
                    }
                }
                e.getObject(n.id, function(t, i) {
                    t ? u(t) : i.type === s ? u(new T.EISDIR("the named file is a directory", n.path)) : (a = i, e.getBuffer(a.data, f));
                });
            }
            function G(e, n, t) {
                k(e, n = i(n), t);
            }
            function H(e, n, t) {
                n.getNode(e, t);
            }
            function $(e, n, t) {
                n = i(n);
                var u, a, c = r(n), f = o(n);
                function l(e, n) {
                    if (e) return t(e);
                    S.create(n, t);
                }
                function s(i, o) {
                    i ? t(i) : (a = o, Object.prototype.hasOwnProperty.call(a, c) ? e.getObject(a[c].id, l) : t(new T.ENOENT("a component of the path does not name an existing file", n)));
                }
                E === c ? k(e, n, t) : k(e, f, function(n, i) {
                    n ? t(n) : (u = i, e.getObject(u.data, s));
                });
            }
            function J(e, n, t, u) {
                n = i(n);
                var a = r(n), c = o(n);
                t = i(t);
                var f, l, p, d, m, E, g = r(t), w = o(t), O = Date.now();
                function b(n) {
                    n ? u(n) : P(e, t, E, {
                        ctime: O
                    }, u);
                }
                function y(n, t) {
                    n ? u(n) : ((E = t).nlinks += 1, e.putObject(E.id, E, b));
                }
                function v(n) {
                    n ? u(n) : e.getObject(m, y);
                }
                function N(n, t) {
                    n ? u(n) : (d = t, Object.prototype.hasOwnProperty.call(d, g) ? u(new T.EEXIST("newpath resolves to an existing file", g)) : (d[g] = l[a], m = d[g].id, e.putObject(p.data, d, v)));
                }
                function h(n, t) {
                    n ? u(n) : (p = t, e.getObject(p.data, N));
                }
                function I(n, t) {
                    n ? u(n) : (l = t, Object.prototype.hasOwnProperty.call(l, a) ? l[a].type === s ? u(new T.EPERM("oldpath refers to a directory")) : k(e, w, h) : u(new T.ENOENT("a component of either path prefix does not exist", a)));
                }
                k(e, c, function(n, t) {
                    n ? u(n) : (f = t, e.getObject(f.data, I));
                });
            }
            function Q(e, n, t) {
                n = i(n);
                var u, a, c, f = r(n), l = o(n);
                function p(n) {
                    n ? t(n) : (delete a[f], e.putObject(u.data, a, function(n) {
                        if (n) t(n);
                        else {
                            var i = Date.now();
                            P(e, l, u, {
                                mtime: i,
                                ctime: i
                            }, t);
                        }
                    }));
                }
                function d(n) {
                    n ? t(n) : e.delete(c.data, p);
                }
                function m(i, o) {
                    i ? t(i) : o.type === s ? t(new T.EPERM("unlink not permitted on directories", f)) : function(i, o) {
                        i ? t(i) : ((c = o).nlinks -= 1, c.nlinks < 1 ? e.delete(c.id, d) : e.putObject(c.id, c, function(i) {
                            i ? t(i) : P(e, n, c, {
                                ctime: Date.now()
                            }, p);
                        }));
                    }(null, o);
                }
                function E(n, i) {
                    n ? t(n) : (a = i, Object.prototype.hasOwnProperty.call(a, f) ? e.getObject(a[f].id, m) : t(new T.ENOENT("a component of the path does not name an existing file", f)));
                }
                k(e, l, function(n, i) {
                    n ? t(n) : (u = i, e.getObject(u.data, E));
                });
            }
            function Z(n, o, r, u) {
                var a, f;
                function l(i, a) {
                    if (i) u(i);
                    else {
                        f = a;
                        var l = Object.keys(f);
                        if (r.encoding) {
                            var s = l.map(function(n) {
                                return e.from(n);
                            });
                            l = "buffer" === r.encoding ? s : s.map(function(e) {
                                return e.toString(r.encoding);
                            });
                        }
                        if (r.withFileTypes) {
                            var p = [];
                            c.eachSeries(l, function(i, u) {
                                var a = e.from(i, r.encoding).toString(), c = t.join(o, a);
                                ee(n, c, function(e, n) {
                                    e && u(e), n.name = i, p.push(n), u();
                                });
                            }, function(e) {
                                u(e, p);
                            });
                        } else u(null, l);
                    }
                }
                o = i(o), "function" == typeof r && (u = r, r = {}), r = ne(r), k(n, o, function(e, t) {
                    e ? u(e) : t.type !== s ? u(new T.ENOTDIR(null, o)) : (a = t, n.getObject(a.data, l));
                });
            }
            function ee(e, n, t) {
                $(e, n, function(i, o) {
                    if (i) t(i);
                    else {
                        var r = new V(n, o, e.name);
                        t(null, r);
                    }
                });
            }
            function ne(e, n) {
                return e ? "function" == typeof e ? e = {
                    encoding: n
                } : "string" == typeof e && (e = {
                    encoding: e
                }) : e = {
                    encoding: n
                }, e;
            }
            function te(e, n, a, c) {
                a = i(a);
                var f, l, s, d = r(a), m = o(a);
                function g(i, o) {
                    i ? c(i) : (l = o, Object.prototype.hasOwnProperty.call(l, d) ? c(new T.EEXIST(null, d)) : S.create({
                        guid: e.guid,
                        type: p
                    }, function(i, o) {
                        i ? c(i) : ((s = o).nlinks += 1, u(n) || (s.symlink_relpath = n, n = t.resolve(m, n)), s.size = n.length, s.data = n, e.putObject(s.id, s, O));
                    }));
                }
                function w(n) {
                    if (n) c(n);
                    else {
                        var t = Date.now();
                        P(e, m, f, {
                            mtime: t,
                            ctime: t
                        }, c);
                    }
                }
                function O(n) {
                    n ? c(n) : (l[d] = new L(s.id, p), e.putObject(f.data, l, w));
                }
                E === d ? c(new T.EEXIST(null, d)) : k(e, m, function(n, t) {
                    n ? c(n) : (f = t, e.getObject(f.data, g));
                });
            }
            function ie(e, n, t) {
                n = i(n);
                var u, a, c = r(n), f = o(n);
                function l(n, i) {
                    n ? t(n) : (a = i, Object.prototype.hasOwnProperty.call(a, c) ? e.getObject(a[c].id, s) : t(new T.ENOENT("a component of the path does not name an existing file", c)));
                }
                function s(e, i) {
                    if (e) t(e);
                    else if (i.type !== p) t(new T.EINVAL("path not a symbolic link", n));
                    else {
                        var o = i.symlink_relpath ? i.symlink_relpath : i.data;
                        t(null, o);
                    }
                }
                k(e, f, function(n, i) {
                    n ? t(n) : (u = i, e.getObject(u.data, l));
                });
            }
            function oe(n, t, o, r) {
                var u;
                function a(t, i) {
                    if (t) r(t);
                    else {
                        if (!i) return r(new T.EIO("Expected Buffer"));
                        var a = e.alloc(o);
                        i && i.copy(a), n.putBuffer(u.data, a, f);
                    }
                }
                function c(e) {
                    if (e) r(e);
                    else {
                        var i = Date.now();
                        P(n, t, u, {
                            mtime: i,
                            ctime: i
                        }, r);
                    }
                }
                function f(e) {
                    e ? r(e) : (u.size = o, u.version += 1, n.putObject(u.id, u, c));
                }
                t = i(t), o < 0 ? r(new T.EINVAL("length cannot be negative")) : k(n, t, function(e, i) {
                    e ? r(e) : i.type === s ? r(new T.EISDIR(null, t)) : (u = i, n.getBuffer(u.data, a));
                });
            }
            function re(n, t, i, o) {
                var r;
                function u(t, u) {
                    if (t) o(t);
                    else {
                        var a;
                        if (!u) return o(new T.EIO("Expected Buffer"));
                        a = u ? u.slice(0, i) : e.alloc(i), n.putBuffer(r.data, a, c);
                    }
                }
                function a(e) {
                    if (e) o(e);
                    else {
                        var i = Date.now();
                        P(n, t.path, r, {
                            mtime: i,
                            ctime: i
                        }, o);
                    }
                }
                function c(e) {
                    e ? o(e) : (r.size = i, r.version += 1, n.putObject(r.id, r, a));
                }
                i < 0 ? o(new T.EINVAL("length cannot be negative")) : t.getNode(n, function(e, t) {
                    e ? o(e) : t.type === s ? o(new T.EISDIR) : (r = t, n.getBuffer(r.data, u));
                });
            }
            function ue(e, n, t, o, r) {
                n = i(n), "number" != typeof t || "number" != typeof o ? r(new T.EINVAL("atime and mtime must be number", n)) : t < 0 || o < 0 ? r(new T.EINVAL("atime and mtime must be positive integers", n)) : k(e, n, function(i, u) {
                    i ? r(i) : P(e, n, u, {
                        atime: t,
                        ctime: o,
                        mtime: o
                    }, r);
                });
            }
            function ae(e, n, t, i, o) {
                "number" != typeof t || "number" != typeof i ? o(new T.EINVAL("atime and mtime must be a number")) : t < 0 || i < 0 ? o(new T.EINVAL("atime and mtime must be positive integers")) : n.getNode(e, function(r, u) {
                    r ? o(r) : P(e, n.path, u, {
                        atime: t,
                        ctime: i,
                        mtime: i
                    }, o);
                });
            }
            function ce(e, n, t, o, r, u) {
                n = i(n), "string" != typeof t ? u(new T.EINVAL("attribute name must be a string", n)) : t ? null !== r && r !== I && r !== j ? u(new T.EINVAL("invalid flag, must be null, XATTR_CREATE or XATTR_REPLACE", n)) : k(e, n, function(i, a) {
                    if (i) return u(i);
                    C(e, n, a, t, o, r, u);
                }) : u(new T.EINVAL("attribute name cannot be an empty string", n));
            }
            function fe(e, n, t, i, o, r) {
                "string" != typeof t ? r(new T.EINVAL("attribute name must be a string")) : t ? null !== o && o !== I && o !== j ? r(new T.EINVAL("invalid flag, must be null, XATTR_CREATE or XATTR_REPLACE")) : n.getNode(e, function(u, a) {
                    if (u) return r(u);
                    C(e, n.path, a, t, i, o, r);
                }) : r(new T.EINVAL("attribute name cannot be an empty string"));
            }
            function le(e, n, t, o) {
                n = i(n), "string" != typeof t ? o(new T.EINVAL("attribute name must be a string", n)) : t ? k(e, n, function(e, i) {
                    if (e) return o(e);
                    var r = i.xattrs;
                    Object.prototype.hasOwnProperty.call(r, t) ? o(null, r[t]) : o(new T.ENOATTR(null, n));
                }) : o(new T.EINVAL("attribute name cannot be an empty string", n));
            }
            function se(e, n, t, i) {
                "string" != typeof t ? i(new T.EINVAL) : t ? n.getNode(e, function(e, n) {
                    if (e) return i(e);
                    var o = n.xattrs;
                    Object.prototype.hasOwnProperty.call(o, t) ? i(null, o[t]) : i(new T.ENOATTR);
                }) : i(new T.EINVAL("attribute name cannot be an empty string"));
            }
            function pe(e, n, t, o) {
                n = i(n), "string" != typeof t ? o(new T.EINVAL("attribute name must be a string", n)) : t ? k(e, n, function(i, r) {
                    if (i) return o(i);
                    var u = r.xattrs;
                    Object.prototype.hasOwnProperty.call(u, t) ? (delete u[t], e.putObject(r.id, r, function(t) {
                        t ? o(t) : P(e, n, r, {
                            ctime: Date.now()
                        }, o);
                    })) : o(new T.ENOATTR(null, n));
                }) : o(new T.EINVAL("attribute name cannot be an empty string", n));
            }
            function de(e, n, t, i) {
                "string" != typeof t ? i(new T.EINVAL("attribute name must be a string")) : t ? n.getNode(e, function(o, r) {
                    if (o) return i(o);
                    var u = r.xattrs;
                    Object.prototype.hasOwnProperty.call(u, t) ? (delete u[t], e.putObject(r.id, r, function(t) {
                        t ? i(t) : P(e, n.path, r, {
                            ctime: Date.now()
                        }, i);
                    })) : i(new T.ENOATTR);
                }) : i(new T.EINVAL("attribute name cannot be an empty string"));
            }
            function me(e) {
                return Object.prototype.hasOwnProperty.call(h, e) ? h[e] : null;
            }
            function Ee(e, n, t) {
                return e ? "function" == typeof e ? e = {
                    encoding: n,
                    flag: t
                } : "string" == typeof e && (e = {
                    encoding: e,
                    flag: t
                }) : e = {
                    encoding: n,
                    flag: t
                }, e;
            }
            function ge(e, n, t, i, o) {
                if (arguments.length < 5 ? (o = arguments[arguments.length - 1], i = 420) : i = xe(i, m, o), !(t = me(t))) return o(new T.EINVAL("flags is not valid"), n);
                Y(e, n, t, i, function(e, i) {
                    if (e) o(e);
                    else {
                        var r;
                        r = t.includes(N) ? i.size : 0;
                        var u = new _(n, i.id, t, r), a = R.allocDescriptor(u);
                        o(null, a);
                    }
                });
            }
            function we(e, n, t) {
                R.getOpenFileDescription(n) ? (R.releaseDescriptor(n), t(null)) : t(new T.EBADF);
            }
            function Oe(e, n, t, i) {
                x(e, n, t, i);
            }
            function be(e, n, t, i) {
                if (arguments.length < 4) i = t, t = m;
                else if (!(t = xe(t, m, i))) return;
                q(e, n, i);
            }
            function ye(e, n, t, i) {
                "function" == typeof t && (i = t, t = f.fsConstants.F_OK), M(e, n, t |= f.fsConstants.F_OK, i);
            }
            function ve(e, n, t, i) {
                if (i = arguments[arguments.length - 1], !n) return i(new Error("filename prefix is required"));
                var o = n + "-" + a.randomChars(6);
                q(e, o, function(e) {
                    i(e, o);
                });
            }
            function Ne(e, n, t) {
                z(e, n, t);
            }
            function he(e, n, t) {
                G(e, n, function(i, o) {
                    if (i) t(i);
                    else {
                        var r = new B(n, o, e.name);
                        t(null, r);
                    }
                });
            }
            function Ie(e, n, t) {
                var i = R.getOpenFileDescription(n);
                i ? H(e, i, function(n, o) {
                    if (n) t(n);
                    else {
                        var r = new B(i.path, o, e.name);
                        t(null, r);
                    }
                }) : t(new T.EBADF);
            }
            function je(e, n, t, i) {
                J(e, n, t, i);
            }
            function Ae(e, n, t) {
                Q(e, n, t);
            }
            function De(e, n, t, i, o, r, u) {
                i = void 0 === i ? 0 : i, o = void 0 === o ? t.length - i : o, u = arguments[arguments.length - 1];
                var a = R.getOpenFileDescription(n);
                a ? a.flags.includes(O) ? W(e, a, t, i, o, r, function(e, n) {
                    u(e, n || 0, t);
                }) : u(new T.EBADF("descriptor does not permit reading")) : u(new T.EBADF);
            }
            function Te(e, n, t) {
                Ve(n, t) === n && (R.getOpenFileDescription(n) ? t() : t(new T.EBADF));
            }
            function Le(n, t, i, o) {
                o = arguments[arguments.length - 1];
                var r = me((i = Ee(i, null, "r")).flag || "r");
                if (!r) return o(new T.EINVAL("flags is not valid", t));
                Y(n, t, r, function(u, a) {
                    if (u) return o(u);
                    var c = new _(t, a.id, r, 0), f = R.allocDescriptor(c);
                    function l() {
                        R.releaseDescriptor(f);
                    }
                    H(n, c, function(r, u) {
                        if (r) return l(), o(r);
                        var a = new B(c.path, u, n.name);
                        if (a.isDirectory()) return l(), o(new T.EISDIR("illegal operation on directory", t));
                        var f = a.size, s = e.alloc(f);
                        W(n, c, s, 0, f, 0, function(e) {
                            if (l(), e) return o(e);
                            var n;
                            n = "utf8" === i.encoding ? s.toString("utf8") : s, o(null, n);
                        });
                    });
                });
            }
            function Re(e, n, t, i, o, r, u) {
                u = arguments[arguments.length - 1], i = void 0 === i ? 0 : i, o = void 0 === o ? t.length - i : o;
                var a = R.getOpenFileDescription(n);
                a ? a.flags.includes(b) ? t.length - i < o ? u(new T.EIO("input buffer is too small")) : U(e, a, t, i, o, r, u) : u(new T.EBADF("descriptor does not permit writing")) : u(new T.EBADF);
            }
            function _e(n, t, i, o, r) {
                r = arguments[arguments.length - 1];
                var u = me((o = Ee(o, "utf8", "w")).flag || "w");
                if (!u) return r(new T.EINVAL("flags is not valid", t));
                e.isBuffer(i) || ("number" == typeof i && (i = "" + i), i = "string" != typeof (i = i || "") ? e.from(i.toString()) : e.from(i || "", o.encoding || "utf8")), Y(n, t, u, function(e, o) {
                    if (e) return r(e);
                    var a = new _(t, o.id, u, 0), c = R.allocDescriptor(a);
                    K(n, a, i, 0, i.length, function(e) {
                        if (R.releaseDescriptor(c), e) return r(e);
                        r(null);
                    });
                });
            }
            function Fe(n, t, i, o, r) {
                r = arguments[arguments.length - 1];
                var u = me((o = Ee(o, "utf8", "a")).flag || "a");
                if (!u) return r(new T.EINVAL("flags is not valid", t));
                "number" == typeof (i = i || "") && (i = "" + i), "string" == typeof i && "utf8" === o.encoding && (i = e.from(i)), Y(n, t, u, function(e, o) {
                    if (e) return r(e);
                    var a = new _(t, o.id, u, o.size), c = R.allocDescriptor(a);
                    U(n, a, i, 0, i.length, a.position, function(e) {
                        if (R.releaseDescriptor(c), e) return r(e);
                        r(null);
                    });
                });
            }
            function Se(e, n, t) {
                he(e, n, function(e) {
                    t(!e);
                });
            }
            function Ve(e, n) {
                if ("number" == typeof e) return e;
                n(new T.EINVAL("Expected integer", e));
            }
            var Be = /^[0-7]+$/;
            function Pe(e) {
                return e === e >>> 0;
            }
            function xe(e, n, t) {
                return "function" == typeof n && (t = n, n = void 0), Pe(e) ? e & m : "number" == typeof e ? (Number.isInteger(e), t(new T.EINVAL("mode not a valid an integer value", e)), !1) : "string" == typeof e ? Be.test(e) ? parseInt(e, 8) & m : (t(new T.EINVAL("mode not a valid octal string", e)), !1) : void 0 !== n ? n : (t(new T.EINVAL("mode not valid", e)), !1);
            }
            function ke(e, n, t, o) {
                n = i(n), "number" != typeof t ? o(new T.EINVAL("mode must be number", n)) : k(e, n, function(i, r) {
                    i ? o(i) : (r.mode = t, P(e, n, r, {
                        mtime: Date.now()
                    }, o));
                });
            }
            function Ce(e, n, t, i) {
                "number" != typeof t ? i(new T.EINVAL("mode must be a number")) : n.getNode(e, function(o, r) {
                    o ? i(o) : (r.mode = t, P(e, n.path, r, {
                        mtime: Date.now()
                    }, i));
                });
            }
            function Xe(e, n, t, o, r) {
                n = i(n), k(e, n, function(i, u) {
                    i ? r(i) : (u.uid = t, u.gid = o, P(e, n, u, {
                        mtime: Date.now()
                    }, r));
                });
            }
            function qe(e, n, t, i, o) {
                n.getNode(e, function(r, u) {
                    r ? o(r) : (u.uid = t, u.gid = i, P(e, n.path, u, {
                        mtime: Date.now()
                    }, o));
                });
            }
            function Me(e, n, t, i) {
                le(e, n, t, i);
            }
            function ze(e, n, t, i) {
                var o = R.getOpenFileDescription(n);
                o ? se(e, o, t, i) : i(new T.EBADF);
            }
            function Ye(e, n, t, i, o, r) {
                "function" == typeof o && (r = o, o = null), ce(e, n, t, i, o, r);
            }
            function Ke(e, n, t, i, o, r) {
                "function" == typeof o && (r = o, o = null);
                var u = R.getOpenFileDescription(n);
                u ? u.flags.includes(b) ? fe(e, u, t, i, o, r) : r(new T.EBADF("descriptor does not permit writing")) : r(new T.EBADF);
            }
            function Ue(e, n, t, i) {
                pe(e, n, t, i);
            }
            function We(e, n, t, i) {
                var o = R.getOpenFileDescription(n);
                o ? o.flags.includes(b) ? de(e, o, t, i) : i(new T.EBADF("descriptor does not permit writing")) : i(new T.EBADF);
            }
            function Ge(e, n, t, i, o) {
                var r = R.getOpenFileDescription(n);
                r || o(new T.EBADF), "SET" === i ? t < 0 ? o(new T.EINVAL("resulting file offset would be negative")) : (r.position = t, o(null, r.position)) : "CUR" === i ? r.position + t < 0 ? o(new T.EINVAL("resulting file offset would be negative")) : (r.position += t, o(null, r.position)) : "END" === i ? H(e, r, function(e, n) {
                    e ? o(e) : n.size + t < 0 ? o(new T.EINVAL("resulting file offset would be negative")) : (r.position = n.size + t, o(null, r.position));
                }) : o(new T.EINVAL("whence argument is not a proper value"));
            }
            function He(e, n, t, i) {
                Z(e, n, t, i);
            }
            function $e(e) {
                return "number" == typeof e ? e : "object" === n(e) && "function" == typeof e.getTime ? e.getTime() : void 0;
            }
            function Je(e, n, t, i, o) {
                var r = Date.now();
                ue(e, n, t = $e(t || r), i = $e(i || r), o);
            }
            function Qe(e, n, t, i, o) {
                var r = Date.now();
                t = $e(t || r), i = $e(i || r);
                var u = R.getOpenFileDescription(n);
                u ? u.flags.includes(b) ? ae(e, u, t, i, o) : o(new T.EBADF("descriptor does not permit writing")) : o(new T.EBADF);
            }
            function Ze(e, n, t, i) {
                (t = xe(t, i)) && ke(e, n, t, i);
            }
            function en(e, n, t, i) {
                if (t = xe(t, i)) {
                    var o = R.getOpenFileDescription(n);
                    o ? o.flags.includes(b) ? Ce(e, o, t, i) : i(new T.EBADF("descriptor does not permit writing")) : i(new T.EBADF);
                }
            }
            function nn(e, n, t, i, o) {
                return Pe(t) ? Pe(i) ? void Xe(e, n, t, i, o) : o(new T.EINVAL("gid must be a valid integer", i)) : o(new T.EINVAL("uid must be a valid integer", t));
            }
            function tn(e, n, t, i, o) {
                if (!Pe(t)) return o(new T.EINVAL("uid must be a valid integer", t));
                if (!Pe(i)) return o(new T.EINVAL("gid must be a valid integer", i));
                var r = R.getOpenFileDescription(n);
                r ? r.flags.includes(b) ? qe(e, r, t, i, o) : o(new T.EBADF("descriptor does not permit writing")) : o(new T.EBADF);
            }
            function on(e, n, o, r) {
                n = i(n), o = i(o);
                var u, a, c, f, l = t.dirname(n), p = t.dirname(o), d = t.basename(n), m = t.basename(o), E = Date.now();
                function g(n, t) {
                    n ? r(n) : P(e, o, t, {
                        ctime: E
                    }, r);
                }
                function w(n) {
                    n ? r(n) : e.getObject(f[m].id, g);
                }
                function O(n) {
                    n ? r(n) : (u.id === c.id && (a = f), delete a[d], e.putObject(u.data, a, w));
                }
                function b(n) {
                    n ? r(n) : (f[m] = a[d], e.putObject(c.data, f, O));
                }
                function y(n, t) {
                    n ? r(n) : (f = t, Object.prototype.hasOwnProperty.call(f, m) ? z(e, o, b) : b());
                }
                function v(n, t) {
                    n ? r(n) : (c = t, e.getObject(c.data, y));
                }
                function N(n, t) {
                    n ? r(n) : (a = t, k(e, p, v));
                }
                function h(n, t) {
                    n ? r(n) : (u = t, e.getObject(t.data, N));
                }
                function I(t) {
                    t ? r(t) : Q(e, n, r);
                }
                k(e, n, function(t, i) {
                    t ? r(t) : i.type === s ? k(e, l, h) : J(e, n, o, I);
                });
            }
            function rn(e, n, t, i, o) {
                te(e, n, t, o = arguments[arguments.length - 1]);
            }
            function un(e, n, t) {
                ie(e, n, t);
            }
            function an(e, n, t) {
                $(e, n, function(i, o) {
                    if (i) t(i);
                    else {
                        var r = new B(n, o, e.name);
                        t(null, r);
                    }
                });
            }
            function cn(e, n, t, i) {
                Ve(t = t || 0, i = arguments[arguments.length - 1]) === t && oe(e, n, t, i);
            }
            function fn(e, n, t, i) {
                i = arguments[arguments.length - 1], t = t || 0;
                var o = R.getOpenFileDescription(n);
                if (o) {
                    if (o.flags.includes(b)) {
                        if (Ve(t, i) !== t) return;
                        re(e, o, t, i);
                    } else i(new T.EBADF("descriptor does not permit writing"));
                } else i(new T.EBADF);
            }
            module1.exports = {
                appendFile: Fe,
                access: ye,
                chown: nn,
                chmod: Ze,
                close: we,
                ensureRootDirectory: X,
                exists: Se,
                fchown: tn,
                fchmod: en,
                fgetxattr: ze,
                fremovexattr: We,
                fsetxattr: Ke,
                fstat: Ie,
                fsync: Te,
                ftruncate: fn,
                futimes: Qe,
                getxattr: Me,
                link: je,
                lseek: Ge,
                lstat: an,
                mkdir: be,
                mkdtemp: ve,
                mknod: Oe,
                open: ge,
                readdir: He,
                read: De,
                readFile: Le,
                readlink: un,
                removexattr: Ue,
                rename: on,
                rmdir: Ne,
                setxattr: Ye,
                stat: he,
                symlink: rn,
                truncate: cn,
                unlink: Ae,
                utimes: Je,
                writeFile: _e,
                write: Re
            };
        },
        {
            "../path.js": "UzoP",
            "../shared.js": "zBMa",
            "../../lib/async.js": "u4Zs",
            "../constants.js": "iJA9",
            "../errors.js": "p8GN",
            "../directory-entry.js": "ZECt",
            "../open-files.js": "osLK",
            "../open-file-description.js": "XWaV",
            "../super-node.js": "JEp0",
            "../node.js": "KKNo",
            "../dirent.js": "q4Wu",
            "../stats.js": "dsCT",
            "buffer": "dskh"
        }
    ],
    "GMi4": [
        function(require1, module1, exports) {
            var Buffer = require1("buffer").Buffer;
            var e = require1("buffer").Buffer, r = require1("es6-promisify"), t = r.promisify, n = require1("../path.js"), a = require1("../providers/index.js"), s = require1("../shell/shell.js"), o = require1("../../lib/intercom.js"), i = require1("../fs-watcher.js"), u = require1("../errors.js"), m = require1("../shared.js"), c = m.nop, f = m.guid, l = require1("../constants.js"), h = l.fsConstants, p = l.FILE_SYSTEM_NAME, d = l.FS_FORMAT, g = l.FS_READY, b = l.FS_PENDING, A = l.FS_ERROR, P = l.FS_NODUPEIDCHECK, v = l.STDIN, y = l.STDOUT, E = l.STDERR, R = require1("./implementation.js");
            function w(e) {
                return "function" == typeof e ? e : function(e) {
                    if (e) throw e;
                };
            }
            function S(e) {
                e && console.error("Filer error: ", e);
            }
            function O(e) {
                if (!(e && e.protocol && e.pathname)) return e;
                if ("file:" !== e.protocol) throw new u.EINVAL("only file: URLs are supported for paths", e);
                for(var r = e.pathname, t = 0; t < r.length; t++)if ("%" === r[t]) {
                    var n = 32 | r.codePointAt(t + 2);
                    if ("2" === r[t + 1] && 102 === n) throw new u.EINVAL("file: URLs must not include encoded / characters", e);
                }
                return decodeURIComponent(r);
            }
            function x(r) {
                return e.isBuffer(r) ? r.toString() : r;
            }
            function F(e, r) {
                return e ? n.isNull(e) ? new u.EINVAL("Path must be a string without null bytes.", e) : r || n.isAbsolute(e) ? void 0 : new u.EINVAL("Path must be absolute.", e) : new u.EINVAL("Path must be a string", e);
            }
            function _(e, r, t) {
                var n = e[r], a = F(n = x(n = O(n)), t);
                if (a) throw a;
                e[r] = n;
            }
            function q(e, r) {
                r = r || S;
                var m = (e = e || {}).flags || [], l = e.guid ? e.guid : f, O = e.provider || new a.Default(e.name || p), x = e.name || O.name, F = m.includes(d), I = this;
                I.readyState = b, I.name = x, I.error = null, I.stdin = v, I.stdout = y, I.stderr = E, I.constants = h, I.F_OK = h.F_OK, I.R_OK = h.R_OK, I.W_OK = h.W_OK, I.X_OK = h.X_OK, this.Shell = s.bind(void 0, this);
                var N = [];
                function j(e) {
                    return function(r) {
                        m.includes(P) ? r(null, l()) : function r(t) {
                            var n = l();
                            e.getObject(n, function(e, a) {
                                e ? t(e) : a ? r(t) : t(null, n);
                            });
                        }(r);
                    };
                }
                this.queueOrRun = function(e) {
                    var r;
                    return g === I.readyState ? e.call(I) : A === I.readyState ? r = new u.EFILESYSTEMERROR("unknown error") : N.push(e), r;
                }, this.watch = function(e, r, t) {
                    if (n.isNull(e)) throw new Error("Path must be a string without null bytes.");
                    "function" == typeof r && (t = r, r = {}), r = r || {}, t = t || c;
                    var a = new i;
                    return a.start(e, !1, r.recursive), a.on("change", t), a;
                }, O.open(function(e) {
                    function t(e) {
                        function t(e) {
                            var r = O[e]();
                            return r.name = x, r.flags = m, r.changes = [], r.guid = j(r), r.close = function() {
                                var e = r.changes;
                                !function(e) {
                                    if (e.length) {
                                        var r = o.getInstance();
                                        e.forEach(function(e) {
                                            r.emit(e.event, e.path);
                                        });
                                    }
                                }(e), e.length = 0;
                            }, r;
                        }
                        I.provider = {
                            openReadWriteContext: function() {
                                return t("getReadWriteContext");
                            },
                            openReadOnlyContext: function() {
                                return t("getReadOnlyContext");
                            }
                        }, I.readyState = e ? A : g, N.forEach((function(e) {
                            e.call(this);
                        }).bind(I)), N = null, r(e, I);
                    }
                    if (e) return t(e);
                    var n = O.getReadWriteContext();
                    n.guid = j(n), F ? n.clear(function(e) {
                        if (e) return t(e);
                        R.ensureRootDirectory(n, t);
                    }) : R.ensureRootDirectory(n, t);
                }), q.prototype.promises = {}, [
                    {
                        name: "appendFile",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "access",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "chown",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "chmod",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "close"
                    },
                    {
                        name: "exists",
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "fchown"
                    },
                    {
                        name: "fchmod"
                    },
                    {
                        name: "fgetxattr"
                    },
                    {
                        name: "fremovexattr"
                    },
                    {
                        name: "fsetxattr"
                    },
                    {
                        name: "fstat"
                    },
                    {
                        name: "fsync"
                    },
                    {
                        name: "ftruncate"
                    },
                    {
                        name: "futimes"
                    },
                    {
                        name: "getxattr",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "link",
                        promises: !0,
                        absPathArgs: [
                            0,
                            1
                        ]
                    },
                    {
                        name: "lseek"
                    },
                    {
                        name: "lstat",
                        promises: !0
                    },
                    {
                        name: "mkdir",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "mkdtemp",
                        promises: !0
                    },
                    {
                        name: "mknod",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "open",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "readdir",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "read"
                    },
                    {
                        name: "readFile",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "readlink",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "removexattr",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "rename",
                        promises: !0,
                        absPathArgs: [
                            0,
                            1
                        ]
                    },
                    {
                        name: "rmdir",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "setxattr",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "stat",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "symlink",
                        promises: !0,
                        relPathArgs: [
                            0
                        ],
                        absPathArgs: [
                            1
                        ]
                    },
                    {
                        name: "truncate",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "unlink",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "utimes",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "writeFile",
                        promises: !0,
                        absPathArgs: [
                            0
                        ]
                    },
                    {
                        name: "write"
                    }
                ].forEach(function(e) {
                    var r = e.name, n = !0 === e.promises;
                    q.prototype[r] = function() {
                        var t = this, n = Array.prototype.slice.call(arguments, 0), a = n.length - 1, s = "function" != typeof n[a], o = w(n[a]);
                        e.absPathArgs && e.absPathArgs.forEach(function(e) {
                            return _(n, e, !1);
                        }), e.relPathArgs && e.relPathArgs.forEach(function(e) {
                            return _(n, e, !0);
                        });
                        var i = t.queueOrRun(function() {
                            var e = t.provider.openReadWriteContext();
                            if (A === t.readyState) {
                                var i = new u.EFILESYSTEMERROR("filesystem unavailable, operation canceled");
                                return o.call(t, i);
                            }
                            function m() {
                                e.close(), o.apply(t, arguments);
                            }
                            s ? n.push(m) : n[a] = m;
                            var c = [
                                e
                            ].concat(n);
                            R[r].apply(null, c);
                        });
                        i && o(i);
                    }, n && (q.prototype.promises[r] = t(q.prototype[r].bind(I)));
                });
            }
            q.providers = a, module1.exports = q;
        },
        {
            "es6-promisify": "b1ZG",
            "../path.js": "UzoP",
            "../providers/index.js": "AiW7",
            "../shell/shell.js": "D1Ra",
            "../../lib/intercom.js": "u7Jv",
            "../fs-watcher.js": "VLEe",
            "../errors.js": "p8GN",
            "../shared.js": "zBMa",
            "../constants.js": "iJA9",
            "./implementation.js": "bsBG",
            "buffer": "dskh"
        }
    ],
    "iIhC": [
        function(require1, module1, exports) {
            "use strict";
            function e(e, t, r) {
                return {
                    dataPath: void 0,
                    schemaPath: void 0,
                    keyword: "absolutePath",
                    params: {
                        absolutePath: r
                    },
                    message: e,
                    parentSchema: t
                };
            }
            function t(t, r, a) {
                return e(t ? "The provided value ".concat(JSON.stringify(a), " is not an absolute path!") : "A relative path is expected. However, the provided value ".concat(JSON.stringify(a), " is an absolute path!"), r, a);
            }
            function r(r) {
                return r.addKeyword("absolutePath", {
                    errors: !0,
                    type: "string",
                    compile: function(r, a) {
                        var o = function o(s) {
                            var n = !0;
                            return s.includes("!") && (o.errors = [
                                e("The provided value ".concat(JSON.stringify(s), " contains exclamation mark (!) which is not allowed because it's reserved for loader syntax."), a, s)
                            ], n = !1), r === /^(?:[A-Za-z]:(\\|\/)|\\\\|\/)/.test(s) || (o.errors = [
                                t(r, a, s)
                            ], n = !1), n;
                        };
                        return o.errors = [], o;
                    }
                }), r;
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.default = void 0;
            var a = r;
            exports.default = a;
        },
        {}
    ],
    "GNtl": [
        function(require1, module1, exports) {
            "use strict";
            function t(t, n) {
                return a(t) || o(t, n) || r(t, n) || e();
            }
            function e() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function r(t, e) {
                if (t) {
                    if ("string" == typeof t) return n(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
                }
            }
            function n(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
                return n;
            }
            function o(t, e) {
                if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                    var r = [], n = !0, o = !1, a = void 0;
                    try {
                        for(var i, u = t[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !e || r.length !== e); n = !0);
                    } catch (f) {
                        o = !0, a = f;
                    } finally{
                        try {
                            n || null == u.return || u.return();
                        } finally{
                            if (o) throw a;
                        }
                    }
                    return r;
                }
            }
            function a(t) {
                if (Array.isArray(t)) return t;
            }
            function i(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function u(t, e) {
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                }
            }
            function f(t, e, r) {
                return e && u(t.prototype, e), r && u(t, r), t;
            }
            var c = function() {
                function e() {
                    i(this, e), this._left = [], this._right = [];
                }
                return f(e, [
                    {
                        key: "left",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                            this._left.push([
                                t,
                                e
                            ]);
                        }
                    },
                    {
                        key: "right",
                        value: function(t) {
                            var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                            this._right.push([
                                t,
                                e
                            ]);
                        }
                    },
                    {
                        key: "format",
                        value: function() {
                            var r = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], n = t(e.getRangeValue(this._left, r), 2), o = n[0], a = n[1], i = t(e.getRangeValue(this._right, !r), 2), u = i[0], f = i[1];
                            if (!Number.isFinite(o) && !Number.isFinite(u)) return "";
                            var c = a ? o + 1 : o;
                            return c === (f ? u - 1 : u) ? "should be ".concat(r ? "" : "!", "= ").concat(c) : Number.isFinite(o) && !Number.isFinite(u) ? e.formatLeft(o, r, a) : !Number.isFinite(o) && Number.isFinite(u) ? e.formatRight(u, r, f) : e.formatRange(o, u, a, f, r);
                        }
                    }
                ], [
                    {
                        key: "getOperator",
                        value: function(t, e) {
                            return "left" === t ? e ? ">" : ">=" : e ? "<" : "<=";
                        }
                    },
                    {
                        key: "formatRight",
                        value: function(t, r, n) {
                            return !1 === r ? e.formatLeft(t, !r, !n) : "should be ".concat(e.getOperator("right", n), " ").concat(t);
                        }
                    },
                    {
                        key: "formatLeft",
                        value: function(t, r, n) {
                            return !1 === r ? e.formatRight(t, !r, !n) : "should be ".concat(e.getOperator("left", n), " ").concat(t);
                        }
                    },
                    {
                        key: "formatRange",
                        value: function(t, r, n, o, a) {
                            var i = "should be";
                            return i += " ".concat(e.getOperator(a ? "left" : "right", a ? n : !n), " ").concat(t, " "), i += a ? "and" : "or", i += " ".concat(e.getOperator(a ? "right" : "left", a ? o : !o), " ").concat(r);
                        }
                    },
                    {
                        key: "getRangeValue",
                        value: function(e, r) {
                            for(var n = r ? 1 / 0 : -1 / 0, o = -1, a = r ? function(e) {
                                return t(e, 1)[0] <= n;
                            } : function(e) {
                                return t(e, 1)[0] >= n;
                            }, i = 0; i < e.length; i++)if (a(e[i])) {
                                var u = t(e[i], 1);
                                n = u[0], o = i;
                            }
                            return o > -1 ? e[o] : [
                                1 / 0,
                                !0
                            ];
                        }
                    }
                ]), e;
            }();
            module1.exports = c;
        },
        {}
    ],
    "SqDh": [
        function(require1, module1, exports) {
            "use strict";
            function t(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function e(e) {
                for(var r = 1; r < arguments.length; r++){
                    var m = null != arguments[r] ? arguments[r] : {};
                    r % 2 ? t(Object(m), !0).forEach(function(t) {
                        n(e, t, m[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(m)) : t(Object(m)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(m, t));
                    });
                }
                return e;
            }
            function n(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var r = require1("./Range");
            module1.exports.stringHints = function(t, n) {
                var r = [], m = "string", i = e({}, t);
                if (!n) {
                    var o = i.minLength, u = i.formatMinimum, a = i.formatExclusiveMaximum;
                    i.minLength = i.maxLength, i.maxLength = o, i.formatMinimum = i.formatMaximum, i.formatMaximum = u, i.formatExclusiveMaximum = !i.formatExclusiveMinimum, i.formatExclusiveMinimum = !a;
                }
                if ("number" == typeof i.minLength) {
                    if (1 === i.minLength) m = "non-empty string";
                    else {
                        var c = Math.max(i.minLength - 1, 0);
                        r.push("should be longer than ".concat(c, " character").concat(c > 1 ? "s" : ""));
                    }
                }
                if ("number" == typeof i.maxLength) {
                    if (0 === i.maxLength) m = "empty string";
                    else {
                        var f = i.maxLength + 1;
                        r.push("should be shorter than ".concat(f, " character").concat(f > 1 ? "s" : ""));
                    }
                }
                return i.pattern && r.push("should".concat(n ? "" : " not", " match pattern ").concat(JSON.stringify(i.pattern))), i.format && r.push("should".concat(n ? "" : " not", " match format ").concat(JSON.stringify(i.format))), i.formatMinimum && r.push("should be ".concat(i.formatExclusiveMinimum ? ">" : ">=", " ").concat(JSON.stringify(i.formatMinimum))), i.formatMaximum && r.push("should be ".concat(i.formatExclusiveMaximum ? "<" : "<=", " ").concat(JSON.stringify(i.formatMaximum))), [
                    m
                ].concat(r);
            }, module1.exports.numberHints = function(t, e) {
                var n = [
                    "integer" === t.type ? "integer" : "number"
                ], m = new r;
                "number" == typeof t.minimum && m.left(t.minimum), "number" == typeof t.exclusiveMinimum && m.left(t.exclusiveMinimum, !0), "number" == typeof t.maximum && m.right(t.maximum), "number" == typeof t.exclusiveMaximum && m.right(t.exclusiveMaximum, !0);
                var i = m.format(e);
                return i && n.push(i), "number" == typeof t.multipleOf && n.push("should".concat(e ? "" : " not", " be multiple of ").concat(t.multipleOf)), n;
            };
        },
        {
            "./Range": "GNtl"
        }
    ],
    "ySUA": [
        function(require1, module1, exports) {
            "use strict";
            function t(t) {
                return n(t) || r(t) || i(t) || e();
            }
            function e() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function n(t) {
                if (Array.isArray(t)) return s(t);
            }
            function a(t) {
                return m(t) || r(t) || i(t) || c();
            }
            function r(t) {
                if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
            }
            function o(t, e) {
                return m(t) || u(t, e) || i(t, e) || c();
            }
            function c() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(t, e) {
                if (t) {
                    if ("string" == typeof t) return s(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(t, e) : void 0;
                }
            }
            function s(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, a = new Array(e); n < e; n++)a[n] = t[n];
                return a;
            }
            function u(t, e) {
                if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                    var n = [], a = !0, r = !1, o = void 0;
                    try {
                        for(var c, i = t[Symbol.iterator](); !(a = (c = i.next()).done) && (n.push(c.value), !e || n.length !== e); a = !0);
                    } catch (s) {
                        r = !0, o = s;
                    } finally{
                        try {
                            a || null == i.return || i.return();
                        } finally{
                            if (r) throw o;
                        }
                    }
                    return n;
                }
            }
            function m(t) {
                if (Array.isArray(t)) return t;
            }
            function h(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function p(t, e) {
                for(var n = 0; n < e.length; n++){
                    var a = e[n];
                    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
                }
            }
            function l(t, e, n) {
                return e && p(t.prototype, e), n && p(t, n), t;
            }
            function f(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), e && x(t, e);
            }
            function d(t) {
                return function() {
                    var e, n = O(t);
                    if (S()) {
                        var a = O(this).constructor;
                        e = Reflect.construct(n, arguments, a);
                    } else e = n.apply(this, arguments);
                    return y(this, e);
                };
            }
            function y(t, e) {
                return !e || "object" !== j(e) && "function" != typeof e ? v(t) : e;
            }
            function v(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function g(t) {
                var e = "function" == typeof Map ? new Map : void 0;
                return (g = function(t) {
                    if (null === t || !P(t)) return t;
                    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== e) {
                        if (e.has(t)) return e.get(t);
                        e.set(t, n);
                    }
                    function n() {
                        return b(t, arguments, O(this).constructor);
                    }
                    return n.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: n,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), x(n, t);
                })(t);
            }
            function b(t, e, n) {
                return (b = S() ? Reflect.construct : function(t, e, n) {
                    var a = [
                        null
                    ];
                    a.push.apply(a, e);
                    var r = new (Function.bind.apply(t, a));
                    return n && x(r, n.prototype), r;
                }).apply(null, arguments);
            }
            function S() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                } catch (t) {
                    return !1;
                }
            }
            function P(t) {
                return -1 !== Function.toString.call(t).indexOf("[native code]");
            }
            function x(t, e) {
                return (x = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function O(t) {
                return (O = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function j(t) {
                return (j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.default = void 0;
            var w = require1("./util/hints"), D = w.stringHints, I = w.numberHints, T = {
                type: 1,
                not: 1,
                oneOf: 1,
                anyOf: 1,
                if: 1,
                enum: 1,
                const: 1,
                instanceof: 1,
                required: 2,
                pattern: 2,
                patternRequired: 2,
                format: 2,
                formatMinimum: 2,
                formatMaximum: 2,
                minimum: 2,
                exclusiveMinimum: 2,
                maximum: 2,
                exclusiveMaximum: 2,
                multipleOf: 2,
                uniqueItems: 2,
                contains: 2,
                minLength: 2,
                maxLength: 2,
                minItems: 2,
                maxItems: 2,
                minProperties: 2,
                maxProperties: 2,
                dependencies: 2,
                propertyNames: 2,
                additionalItems: 2,
                additionalProperties: 2,
                absolutePath: 2
            };
            function k(t, e) {
                var n = t.reduce(function(t, n) {
                    return Math.max(t, e(n));
                }, 0);
                return t.filter(function(t) {
                    return e(t) === n;
                });
            }
            function A(t) {
                var e = t;
                return e = k(e, function(t) {
                    return t.dataPath ? t.dataPath.length : 0;
                }), e = k(e, function(t) {
                    return T[t.keyword] || 2;
                });
            }
            function N(t, e) {
                for(var n = t.length - 1, a = function(e) {
                    return 0 !== t[n].schemaPath.indexOf(e);
                }; n > -1 && !e.every(a);)if ("anyOf" === t[n].keyword || "oneOf" === t[n].keyword) {
                    var r = M(t[n]), o = N(t.slice(0, n), r.concat(t[n].schemaPath));
                    n = o - 1;
                } else n -= 1;
                return n + 1;
            }
            function M(t) {
                var e = t.schema;
                return Array.isArray(e) ? e.map(function(t) {
                    return t.$ref;
                }).filter(function(t) {
                    return t;
                }) : [];
            }
            function E(t) {
                for(var e = [], n = t.length - 1; n > 0;){
                    var a = t[n];
                    if ("anyOf" === a.keyword || "oneOf" === a.keyword) {
                        var r = M(a), o = N(t.slice(0, n), r.concat(a.schemaPath));
                        o !== n ? (e.push(Object.assign({}, a, {
                            children: t.slice(o, n)
                        })), n = o) : e.push(a);
                    } else e.push(a);
                    n -= 1;
                }
                return 0 === n && e.push(t[n]), e.reverse();
            }
            function q(t, e) {
                return t.replace(/\n(?!$)/g, "\n".concat(e));
            }
            function R(t) {
                return !!t.not;
            }
            function J(t) {
                return R(t) ? J(t.not) : t;
            }
            function $(t) {
                var e = J(t);
                return V(e) || F(e) || L(e) || z(e) || B(e);
            }
            function _(t) {
                return "object" === j(t) && null !== t;
            }
            function V(t) {
                return "number" === t.type || void 0 !== t.minimum || void 0 !== t.exclusiveMinimum || void 0 !== t.maximum || void 0 !== t.exclusiveMaximum || void 0 !== t.multipleOf;
            }
            function F(t) {
                return "integer" === t.type || void 0 !== t.minimum || void 0 !== t.exclusiveMinimum || void 0 !== t.maximum || void 0 !== t.exclusiveMaximum || void 0 !== t.multipleOf;
            }
            function L(t) {
                return "string" === t.type || void 0 !== t.minLength || void 0 !== t.maxLength || void 0 !== t.pattern || void 0 !== t.format || void 0 !== t.formatMinimum || void 0 !== t.formatMaximum;
            }
            function B(t) {
                return "boolean" === t.type;
            }
            function C(t) {
                return "array" === t.type || "number" == typeof t.minItems || "number" == typeof t.maxItems || void 0 !== t.uniqueItems || void 0 !== t.items || void 0 !== t.additionalItems || void 0 !== t.contains;
            }
            function H(t) {
                return "object" === t.type || void 0 !== t.minProperties || void 0 !== t.maxProperties || void 0 !== t.required || void 0 !== t.properties || void 0 !== t.patternProperties || void 0 !== t.additionalProperties || void 0 !== t.dependencies || void 0 !== t.propertyNames || void 0 !== t.patternRequired;
            }
            function z(t) {
                return "null" === t.type;
            }
            function K(t) {
                return /^[aeiou]/i.test(t) ? "an" : "a";
            }
            function U(t) {
                if (!t) return "";
                if (!t.type) {
                    if (V(t) || F(t)) return " | should be any non-number";
                    if (L(t)) return " | should be any non-string";
                    if (C(t)) return " | should be any non-array";
                    if (H(t)) return " | should be any non-object";
                }
                return "";
            }
            function G(t) {
                return t.length > 0 ? "(".concat(t.join(", "), ")") : "";
            }
            function Q(t, e) {
                return V(t) || F(t) ? I(t, e) : L(t) ? D(t, e) : [];
            }
            var W = function(e) {
                f(r, g(Error));
                var n = d(r);
                function r(t, e) {
                    var a, c, i, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    if (h(this, r), (a = n.call(this)).name = "ValidationError", a.errors = t, a.schema = e, e.title && (!s.name || !s.baseDataPath)) {
                        var u = e.title.match(/^(.+) (.+)$/);
                        if (u) {
                            if (!s.name) c = o(u, 2)[1];
                            if (!s.baseDataPath) i = o(u, 3)[2];
                        }
                    }
                    a.headerName = s.name || c || "Object", a.baseDataPath = s.baseDataPath || i || "configuration", a.postFormatter = s.postFormatter || null;
                    var m = "Invalid ".concat(a.baseDataPath, " object. ").concat(a.headerName, " has been initialized using ").concat(K(a.baseDataPath), " ").concat(a.baseDataPath, " object that does not match the API schema.\n");
                    return a.message = "".concat(m).concat(a.formatValidationErrors(t)), Error.captureStackTrace(v(a), a.constructor), a;
                }
                return l(r, [
                    {
                        key: "getSchemaPart",
                        value: function(t) {
                            for(var e = t.split("/"), n = this.schema, a = 1; a < e.length; a++){
                                var r = n[e[a]];
                                if (!r) break;
                                n = r;
                            }
                            return n;
                        }
                    },
                    {
                        key: "formatSchema",
                        value: function(e) {
                            var n = this, r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [], c = r, i = function(t, a) {
                                return a ? o.includes(t) ? "(recursive)" : n.formatSchema(t, c, o.concat(e)) : n.formatSchema(t, c, o);
                            };
                            if (R(e) && !H(e)) {
                                if ($(e.not)) return c = !r, i(e.not);
                                var s = !e.not.not;
                                return c = !r, s ? (r ? "" : "non ") + i(e.not) : i(e.not);
                            }
                            if (e.instanceof) {
                                var u = e.instanceof;
                                return (Array.isArray(u) ? u : [
                                    u
                                ]).map(function(t) {
                                    return "Function" === t ? "function" : t;
                                }).join(" | ");
                            }
                            if (e.enum) return e.enum.map(function(t) {
                                return JSON.stringify(t);
                            }).join(" | ");
                            if (void 0 !== e.const) return JSON.stringify(e.const);
                            if (e.oneOf) return e.oneOf.map(function(t) {
                                return i(t, !0);
                            }).join(" | ");
                            if (e.anyOf) return e.anyOf.map(function(t) {
                                return i(t, !0);
                            }).join(" | ");
                            if (e.allOf) return e.allOf.map(function(t) {
                                return i(t, !0);
                            }).join(" & ");
                            if (e.if) {
                                var m = e.if, h = e.then, p = e.else;
                                return "".concat(m ? "if ".concat(i(m)) : "").concat(h ? " then ".concat(i(h)) : "").concat(p ? " else ".concat(i(p)) : "");
                            }
                            if (e.$ref) return i(this.getSchemaPart(e.$ref), !0);
                            if (V(e) || F(e)) {
                                var l = a(Q(e, r)), f = l[0], d = l.slice(1), y = "".concat(f).concat(d.length > 0 ? " ".concat(G(d)) : "");
                                return r ? y : d.length > 0 ? "non-".concat(f, " | ").concat(y) : "non-".concat(f);
                            }
                            if (L(e)) {
                                var v = a(Q(e, r)), g = v[0], b = v.slice(1), S = "".concat(g).concat(b.length > 0 ? " ".concat(G(b)) : "");
                                return r ? S : "string" === S ? "non-string" : "non-string | ".concat(S);
                            }
                            if (B(e)) return "".concat(r ? "" : "non-", "boolean");
                            if (C(e)) {
                                c = !0;
                                var P = [];
                                "number" == typeof e.minItems && P.push("should not have fewer than ".concat(e.minItems, " item").concat(e.minItems > 1 ? "s" : "")), "number" == typeof e.maxItems && P.push("should not have more than ".concat(e.maxItems, " item").concat(e.maxItems > 1 ? "s" : "")), e.uniqueItems && P.push("should not have duplicate items");
                                var x = void 0 === e.additionalItems || Boolean(e.additionalItems), O = "";
                                return e.items ? Array.isArray(e.items) && e.items.length > 0 ? (O = "".concat(e.items.map(function(t) {
                                    return i(t);
                                }).join(", ")), x && e.additionalItems && _(e.additionalItems) && Object.keys(e.additionalItems).length > 0 && P.push("additional items should be ".concat(i(e.additionalItems)))) : O = e.items && Object.keys(e.items).length > 0 ? "".concat(i(e.items)) : "any" : O = "any", e.contains && Object.keys(e.contains).length > 0 && P.push("should contains at least one ".concat(this.formatSchema(e.contains), " item")), "[".concat(O).concat(x ? ", ..." : "", "]").concat(P.length > 0 ? " (".concat(P.join(", "), ")") : "");
                            }
                            if (H(e)) {
                                c = !0;
                                var j = [];
                                if ("number" == typeof e.minProperties && j.push("should not have fewer than ".concat(e.minProperties, " ").concat(e.minProperties > 1 ? "properties" : "property")), "number" == typeof e.maxProperties && j.push("should not have more than ".concat(e.maxProperties, " ").concat(e.minProperties && e.minProperties > 1 ? "properties" : "property")), e.patternProperties && Object.keys(e.patternProperties).length > 0) {
                                    var w = Object.keys(e.patternProperties);
                                    j.push("additional property names should match pattern".concat(w.length > 1 ? "s" : "", " ").concat(w.map(function(t) {
                                        return JSON.stringify(t);
                                    }).join(" | ")));
                                }
                                var D = e.properties ? Object.keys(e.properties) : [], I = e.required ? e.required : [], T = t(new Set([].concat(I).concat(D))).map(function(t) {
                                    var e = I.includes(t);
                                    return "".concat(t).concat(e ? "" : "?");
                                }).concat(void 0 === e.additionalProperties || Boolean(e.additionalProperties) ? e.additionalProperties && _(e.additionalProperties) ? [
                                    "<key>: ".concat(i(e.additionalProperties))
                                ] : [
                                    "…"
                                ] : []).join(", "), k = e.dependencies, A = e.propertyNames, N = e.patternRequired;
                                return k && Object.keys(k).forEach(function(t) {
                                    var e = k[t];
                                    Array.isArray(e) ? j.push("should have ".concat(e.length > 1 ? "properties" : "property", " ").concat(e.map(function(t) {
                                        return "'".concat(t, "'");
                                    }).join(", "), " when property '").concat(t, "' is present")) : j.push("should be valid according to the schema ".concat(i(e), " when property '").concat(t, "' is present"));
                                }), A && Object.keys(A).length > 0 && j.push("each property name should match format ".concat(JSON.stringify(e.propertyNames.format))), N && N.length > 0 && j.push("should have property matching pattern ".concat(N.map(function(t) {
                                    return JSON.stringify(t);
                                }))), "object {".concat(T ? " ".concat(T, " ") : "", "}").concat(j.length > 0 ? " (".concat(j.join(", "), ")") : "");
                            }
                            return z(e) ? "".concat(r ? "" : "non-", "null") : Array.isArray(e.type) ? "".concat(e.type.join(" | ")) : JSON.stringify(e, null, 2);
                        }
                    },
                    {
                        key: "getSchemaPartText",
                        value: function(t, e) {
                            var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                            if (!t) return "";
                            if (Array.isArray(e)) for(var r = 0; r < e.length; r++){
                                var o = t[e[r]];
                                if (!o) break;
                                t = o;
                            }
                            for(; t.$ref;)t = this.getSchemaPart(t.$ref);
                            var c = "".concat(this.formatSchema(t, a)).concat(n ? "." : "");
                            return t.description && (c += "\n-> ".concat(t.description)), t.link && (c += "\n-> Read more at ".concat(t.link)), c;
                        }
                    },
                    {
                        key: "getSchemaPartDescription",
                        value: function(t) {
                            if (!t) return "";
                            for(; t.$ref;)t = this.getSchemaPart(t.$ref);
                            var e = "";
                            return t.description && (e += "\n-> ".concat(t.description)), t.link && (e += "\n-> Read more at ".concat(t.link)), e;
                        }
                    },
                    {
                        key: "formatValidationError",
                        value: function(t) {
                            var e = this, n = t.keyword, r = t.dataPath, o = "".concat(this.baseDataPath).concat(r);
                            switch(n){
                                case "type":
                                    var c = t.parentSchema;
                                    switch(t.params.type){
                                        case "number":
                                            return "".concat(o, " should be a ").concat(this.getSchemaPartText(c, !1, !0));
                                        case "integer":
                                            return "".concat(o, " should be an ").concat(this.getSchemaPartText(c, !1, !0));
                                        case "string":
                                        case "boolean":
                                            return "".concat(o, " should be a ").concat(this.getSchemaPartText(c, !1, !0));
                                        case "array":
                                            return "".concat(o, " should be an array:\n").concat(this.getSchemaPartText(c));
                                        case "object":
                                            return "".concat(o, " should be an object:\n").concat(this.getSchemaPartText(c));
                                        case "null":
                                            return "".concat(o, " should be a ").concat(this.getSchemaPartText(c, !1, !0));
                                        default:
                                            return "".concat(o, " should be:\n").concat(this.getSchemaPartText(c));
                                    }
                                case "instanceof":
                                    var i = t.parentSchema;
                                    return "".concat(o, " should be an instance of ").concat(this.getSchemaPartText(i, !1, !0));
                                case "pattern":
                                    var s = t.params, u = t.parentSchema, m = s.pattern;
                                    return "".concat(o, " should match pattern ").concat(JSON.stringify(m)).concat(U(u), ".").concat(this.getSchemaPartDescription(u));
                                case "format":
                                    var h = t.params, p = t.parentSchema, l = h.format;
                                    return "".concat(o, " should match format ").concat(JSON.stringify(l)).concat(U(p), ".").concat(this.getSchemaPartDescription(p));
                                case "formatMinimum":
                                case "formatMaximum":
                                    var f = t.params, d = t.parentSchema, y = f.comparison, v = f.limit;
                                    return "".concat(o, " should be ").concat(y, " ").concat(JSON.stringify(v)).concat(U(d), ".").concat(this.getSchemaPartDescription(d));
                                case "minimum":
                                case "maximum":
                                case "exclusiveMinimum":
                                case "exclusiveMaximum":
                                    var g = t.parentSchema, b = t.params, S = b.comparison, P = b.limit, x = a(Q(g, !0)).slice(1);
                                    return 0 === x.length && x.push("should be ".concat(S, " ").concat(P)), "".concat(o, " ").concat(x.join(" ")).concat(U(g), ".").concat(this.getSchemaPartDescription(g));
                                case "multipleOf":
                                    var O = t.params, j = t.parentSchema, w = O.multipleOf;
                                    return "".concat(o, " should be multiple of ").concat(w).concat(U(j), ".").concat(this.getSchemaPartDescription(j));
                                case "patternRequired":
                                    var D = t.params, I = t.parentSchema, T = D.missingPattern;
                                    return "".concat(o, " should have property matching pattern ").concat(JSON.stringify(T)).concat(U(I), ".").concat(this.getSchemaPartDescription(I));
                                case "minLength":
                                    var k = t.params, N = t.parentSchema, M = k.limit;
                                    if (1 === M) return "".concat(o, " should be a non-empty string").concat(U(N), ".").concat(this.getSchemaPartDescription(N));
                                    var R = M - 1;
                                    return "".concat(o, " should be longer than ").concat(R, " character").concat(R > 1 ? "s" : "").concat(U(N), ".").concat(this.getSchemaPartDescription(N));
                                case "minItems":
                                    var J = t.params, _ = t.parentSchema, V = J.limit;
                                    return 1 === V ? "".concat(o, " should be a non-empty array").concat(U(_), ".").concat(this.getSchemaPartDescription(_)) : "".concat(o, " should not have fewer than ").concat(V, " items").concat(U(_), ".").concat(this.getSchemaPartDescription(_));
                                case "minProperties":
                                    var F = t.params, L = t.parentSchema, B = F.limit;
                                    return 1 === B ? "".concat(o, " should be a non-empty object").concat(U(L), ".").concat(this.getSchemaPartDescription(L)) : "".concat(o, " should not have fewer than ").concat(B, " properties").concat(U(L), ".").concat(this.getSchemaPartDescription(L));
                                case "maxLength":
                                    var C = t.params, z = t.parentSchema, K = C.limit + 1;
                                    return "".concat(o, " should be shorter than ").concat(K, " character").concat(K > 1 ? "s" : "").concat(U(z), ".").concat(this.getSchemaPartDescription(z));
                                case "maxItems":
                                    var G = t.params, W = t.parentSchema, X = G.limit;
                                    return "".concat(o, " should not have more than ").concat(X, " items").concat(U(W), ".").concat(this.getSchemaPartDescription(W));
                                case "maxProperties":
                                    var Y = t.params, Z = t.parentSchema, tt = Y.limit;
                                    return "".concat(o, " should not have more than ").concat(tt, " properties").concat(U(Z), ".").concat(this.getSchemaPartDescription(Z));
                                case "uniqueItems":
                                    var et = t.params, nt = t.parentSchema, at = et.i;
                                    return "".concat(o, " should not contain the item '").concat(t.data[at], "' twice").concat(U(nt), ".").concat(this.getSchemaPartDescription(nt));
                                case "additionalItems":
                                    var rt = t.params, ot = t.parentSchema, ct = rt.limit;
                                    return "".concat(o, " should not have more than ").concat(ct, " items").concat(U(ot), ". These items are valid:\n").concat(this.getSchemaPartText(ot));
                                case "contains":
                                    var it = t.parentSchema;
                                    return "".concat(o, " should contains at least one ").concat(this.getSchemaPartText(it, [
                                        "contains"
                                    ]), " item").concat(U(it), ".");
                                case "required":
                                    var st = t.parentSchema, ut = t.params.missingProperty.replace(/^\./, ""), mt = st && Boolean(st.properties && st.properties[ut]);
                                    return "".concat(o, " misses the property '").concat(ut, "'").concat(U(st), ".").concat(mt ? " Should be:\n".concat(this.getSchemaPartText(st, [
                                        "properties",
                                        ut
                                    ])) : this.getSchemaPartDescription(st));
                                case "additionalProperties":
                                    var ht = t.params, pt = t.parentSchema, lt = ht.additionalProperty;
                                    return "".concat(o, " has an unknown property '").concat(lt, "'").concat(U(pt), ". These properties are valid:\n").concat(this.getSchemaPartText(pt));
                                case "dependencies":
                                    var ft = t.params, dt = t.parentSchema, yt = ft.property, vt = ft.deps.split(",").map(function(t) {
                                        return "'".concat(t.trim(), "'");
                                    }).join(", ");
                                    return "".concat(o, " should have properties ").concat(vt, " when property '").concat(yt, "' is present").concat(U(dt), ".").concat(this.getSchemaPartDescription(dt));
                                case "propertyNames":
                                    var gt = t.params, bt = t.parentSchema, St = t.schema, Pt = gt.propertyName;
                                    return "".concat(o, " property name '").concat(Pt, "' is invalid").concat(U(bt), ". Property names should be match format ").concat(JSON.stringify(St.format), ".").concat(this.getSchemaPartDescription(bt));
                                case "enum":
                                    var xt = t.parentSchema;
                                    return xt && xt.enum && 1 === xt.enum.length ? "".concat(o, " should be ").concat(this.getSchemaPartText(xt, !1, !0)) : "".concat(o, " should be one of these:\n").concat(this.getSchemaPartText(xt));
                                case "const":
                                    var Ot = t.parentSchema;
                                    return "".concat(o, " should be equal to constant ").concat(this.getSchemaPartText(Ot, !1, !0));
                                case "not":
                                    var jt = H(t.parentSchema) ? "\n".concat(this.getSchemaPartText(t.parentSchema)) : "", wt = this.getSchemaPartText(t.schema, !1, !1, !1);
                                    if ($(t.schema)) return "".concat(o, " should be any ").concat(wt).concat(jt, ".");
                                    var Dt = t.schema, It = t.parentSchema;
                                    return "".concat(o, " should not be ").concat(this.getSchemaPartText(Dt, !1, !0)).concat(It && H(It) ? "\n".concat(this.getSchemaPartText(It)) : "");
                                case "oneOf":
                                case "anyOf":
                                    var Tt = t.parentSchema, kt = t.children;
                                    if (kt && kt.length > 0) {
                                        if (1 === t.schema.length) {
                                            var At = kt[kt.length - 1], Nt = kt.slice(0, kt.length - 1);
                                            return this.formatValidationError(Object.assign({}, At, {
                                                children: Nt,
                                                parentSchema: Object.assign({}, Tt, At.parentSchema)
                                            }));
                                        }
                                        var Mt = A(kt);
                                        return 1 === Mt.length ? this.formatValidationError(Mt[0]) : (Mt = E(Mt), "".concat(o, " should be one of these:\n").concat(this.getSchemaPartText(Tt), "\nDetails:\n").concat(Mt.map(function(t) {
                                            return " * ".concat(q(e.formatValidationError(t), "   "));
                                        }).join("\n")));
                                    }
                                    return "".concat(o, " should be one of these:\n").concat(this.getSchemaPartText(Tt));
                                case "if":
                                    var Et = t.params, qt = t.parentSchema, Rt = Et.failingKeyword;
                                    return "".concat(o, ' should match "').concat(Rt, '" schema:\n').concat(this.getSchemaPartText(qt, [
                                        Rt
                                    ]));
                                case "absolutePath":
                                    var Jt = t.message, $t = t.parentSchema;
                                    return "".concat(o, ": ").concat(Jt).concat(this.getSchemaPartDescription($t));
                                default:
                                    var _t = t.message, Vt = t.parentSchema, Ft = JSON.stringify(t, null, 2);
                                    return "".concat(o, " ").concat(_t, " (").concat(Ft, ").\n").concat(this.getSchemaPartText(Vt, !1));
                            }
                        }
                    },
                    {
                        key: "formatValidationErrors",
                        value: function(t) {
                            var e = this;
                            return t.map(function(t) {
                                var n = e.formatValidationError(t);
                                return e.postFormatter && (n = e.postFormatter(n, t)), " - ".concat(q(n, "   "));
                            }).join("\n");
                        }
                    }
                ]), r;
            }(), X = W;
            exports.default = X;
        },
        {
            "./util/hints": "SqDh"
        }
    ],
    "wWOq": [
        function(require1, module1, exports) {
            var define;
            var global = arguments[3];
            var e, r = arguments[3];
            !function(r, t) {
                "object" == typeof exports && "undefined" != typeof module1 ? t(exports) : "function" == typeof e && e.amd ? e([
                    "exports"
                ], t) : t(r.URI = r.URI || {});
            }(this, function(e) {
                "use strict";
                function r() {
                    for(var e = arguments.length, r = Array(e), t = 0; t < e; t++)r[t] = arguments[t];
                    if (r.length > 1) {
                        r[0] = r[0].slice(0, -1);
                        for(var n = r.length - 1, o = 1; o < n; ++o)r[o] = r[o].slice(1, -1);
                        return r[n] = r[n].slice(1), r.join("");
                    }
                    return r[0];
                }
                function t(e) {
                    return "(?:" + e + ")";
                }
                function n(e) {
                    return void 0 === e ? "undefined" : null === e ? "null" : Object.prototype.toString.call(e).split(" ").pop().split("]").shift().toLowerCase();
                }
                function o(e) {
                    return e.toUpperCase();
                }
                function a(e) {
                    var n = r("[0-9]", "[A-Fa-f]"), o = t(t("%[EFef]" + n + "%" + n + n + "%" + n + n) + "|" + t("%[89A-Fa-f]" + n + "%" + n + n) + "|" + t("%" + n + n)), a = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", i = r("[\\:\\/\\?\\#\\[\\]\\@]", a), s = e ? "[\\uE000-\\uF8FF]" : "[]", u = r("[A-Za-z]", "[0-9]", "[\\-\\.\\_\\~]", e ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]"), c = t("[A-Za-z]" + r("[A-Za-z]", "[0-9]", "[\\+\\-\\.]") + "*"), p = t(t(o + "|" + r(u, a, "[\\:]")) + "*"), h = (t(t("25[0-5]") + "|" + t("2[0-4][0-9]") + "|" + t("1[0-9][0-9]") + "|" + t("[1-9][0-9]") + "|[0-9]"), t(t("25[0-5]") + "|" + t("2[0-4][0-9]") + "|" + t("1[0-9][0-9]") + "|" + t("0?[1-9][0-9]") + "|0?0?[0-9]")), f = t(h + "\\." + h + "\\." + h + "\\." + h), l = t(n + "{1,4}"), v = t(t(l + "\\:" + l) + "|" + f), d = t(t(l + "\\:") + "{6}" + v), g = t("\\:\\:" + t(l + "\\:") + "{5}" + v), m = t(t(l) + "?\\:\\:" + t(l + "\\:") + "{4}" + v), E = t(t(t(l + "\\:") + "{0,1}" + l) + "?\\:\\:" + t(l + "\\:") + "{3}" + v), C = t(t(t(l + "\\:") + "{0,2}" + l) + "?\\:\\:" + t(l + "\\:") + "{2}" + v), y = t(t(t(l + "\\:") + "{0,3}" + l) + "?\\:\\:" + l + "\\:" + v), S = t(t(t(l + "\\:") + "{0,4}" + l) + "?\\:\\:" + v), A = t(t(t(l + "\\:") + "{0,5}" + l) + "?\\:\\:" + l), D = t(t(t(l + "\\:") + "{0,6}" + l) + "?\\:\\:"), w = t([
                        d,
                        g,
                        m,
                        E,
                        C,
                        y,
                        S,
                        A,
                        D
                    ].join("|")), b = t(t(u + "|" + o) + "+"), x = (t(w + "\\%25" + b), t(w + t("\\%25|\\%(?!" + n + "{2})") + b)), O = t("[vV]" + n + "+\\." + r(u, a, "[\\:]") + "+"), I = t("\\[" + t(x + "|" + w + "|" + O) + "\\]"), F = t(t(o + "|" + r(u, a)) + "*"), N = t(I + "|" + f + "(?!" + F + ")|" + F), R = t("[0-9]*"), T = t(t(p + "@") + "?" + N + t("\\:" + R) + "?"), _ = t(o + "|" + r(u, a, "[\\:\\@]")), P = t(_ + "*"), U = t(_ + "+"), j = t(t(o + "|" + r(u, a, "[\\@]")) + "+"), q = t(t("\\/" + P) + "*"), H = t("\\/" + t(U + q) + "?"), z = t(j + q), L = t(U + q), $ = "(?!" + _ + ")", V = (t(q + "|" + H + "|" + z + "|" + L + "|" + $), t(t(_ + "|" + r("[\\/\\?]", s)) + "*")), M = t(t(_ + "|[\\/\\?]") + "*"), Z = t(t("\\/\\/" + T + q) + "|" + H + "|" + L + "|" + $), k = t(c + "\\:" + Z + t("\\?" + V) + "?" + t("\\#" + M) + "?"), G = t(t("\\/\\/" + T + q) + "|" + H + "|" + z + "|" + $), Q = t(G + t("\\?" + V) + "?" + t("\\#" + M) + "?");
                    t(k + "|" + Q), t(c + "\\:" + Z + t("\\?" + V) + "?"), t(t("\\/\\/(" + t("(" + p + ")@") + "?(" + N + ")" + t("\\:(" + R + ")") + "?)") + "?(" + q + "|" + H + "|" + L + "|" + $ + ")"), t("\\?(" + V + ")"), t("\\#(" + M + ")"), t(t("\\/\\/(" + t("(" + p + ")@") + "?(" + N + ")" + t("\\:(" + R + ")") + "?)") + "?(" + q + "|" + H + "|" + z + "|" + $ + ")"), t("\\?(" + V + ")"), t("\\#(" + M + ")"), t(t("\\/\\/(" + t("(" + p + ")@") + "?(" + N + ")" + t("\\:(" + R + ")") + "?)") + "?(" + q + "|" + H + "|" + L + "|" + $ + ")"), t("\\?(" + V + ")"), t("\\#(" + M + ")"), t("(" + p + ")@"), t("\\:(" + R + ")");
                    return {
                        NOT_SCHEME: new RegExp(r("[^]", "[A-Za-z]", "[0-9]", "[\\+\\-\\.]"), "g"),
                        NOT_USERINFO: new RegExp(r("[^\\%\\:]", u, a), "g"),
                        NOT_HOST: new RegExp(r("[^\\%\\[\\]\\:]", u, a), "g"),
                        NOT_PATH: new RegExp(r("[^\\%\\/\\:\\@]", u, a), "g"),
                        NOT_PATH_NOSCHEME: new RegExp(r("[^\\%\\/\\@]", u, a), "g"),
                        NOT_QUERY: new RegExp(r("[^\\%]", u, a, "[\\:\\@\\/\\?]", s), "g"),
                        NOT_FRAGMENT: new RegExp(r("[^\\%]", u, a, "[\\:\\@\\/\\?]"), "g"),
                        ESCAPE: new RegExp(r("[^]", u, a), "g"),
                        UNRESERVED: new RegExp(u, "g"),
                        OTHER_CHARS: new RegExp(r("[^\\%]", u, i), "g"),
                        PCT_ENCODED: new RegExp(o, "g"),
                        IPV4ADDRESS: new RegExp("^(" + f + ")$"),
                        IPV6ADDRESS: new RegExp("^\\[?(" + w + ")" + t(t("\\%25|\\%(?!" + n + "{2})") + "(" + b + ")") + "?\\]?$")
                    };
                }
                var i = a(!1), s = a(!0), u = function() {
                    return function(e, r) {
                        if (Array.isArray(e)) return e;
                        if (Symbol.iterator in Object(e)) return function(e, r) {
                            var t = [], n = !0, o = !1, a = void 0;
                            try {
                                for(var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (t.push(i.value), !r || t.length !== r); n = !0);
                            } catch (u) {
                                o = !0, a = u;
                            } finally{
                                try {
                                    !n && s.return && s.return();
                                } finally{
                                    if (o) throw a;
                                }
                            }
                            return t;
                        }(e, r);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }(), c = 2147483647, p = /^xn--/, h = /[^\0-\x7E]/, f = /[\x2E\u3002\uFF0E\uFF61]/g, l = {
                    overflow: "Overflow: input needs wider integers to process",
                    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                    "invalid-input": "Invalid input"
                }, v = Math.floor, d = String.fromCharCode;
                function g(e) {
                    throw new RangeError(l[e]);
                }
                function m(e, r) {
                    var t = e.split("@"), n = "";
                    t.length > 1 && (n = t[0] + "@", e = t[1]);
                    var o = (function(e, r) {
                        for(var t = [], n = e.length; n--;)t[n] = r(e[n]);
                        return t;
                    })((e = e.replace(f, ".")).split("."), r).join(".");
                    return n + o;
                }
                function E(e) {
                    for(var r = [], t = 0, n = e.length; t < n;){
                        var o = e.charCodeAt(t++);
                        if (o >= 55296 && o <= 56319 && t < n) {
                            var a = e.charCodeAt(t++);
                            56320 == (64512 & a) ? r.push(((1023 & o) << 10) + (1023 & a) + 65536) : (r.push(o), t--);
                        } else r.push(o);
                    }
                    return r;
                }
                var C = function(e, r) {
                    return e + 22 + 75 * (e < 26) - ((0 != r) << 5);
                }, y = function(e, r, t) {
                    var n = 0;
                    for(e = t ? v(e / 700) : e >> 1, e += v(e / r); e > 455; n += 36)e = v(e / 35);
                    return v(n + 36 * e / (e + 38));
                }, S = function(e) {
                    var r, t = [], n = e.length, o = 0, a = 128, i = 72, s = e.lastIndexOf("-");
                    s < 0 && (s = 0);
                    for(var u = 0; u < s; ++u)e.charCodeAt(u) >= 128 && g("not-basic"), t.push(e.charCodeAt(u));
                    for(var p = s > 0 ? s + 1 : 0; p < n;){
                        for(var h = o, f = 1, l = 36;; l += 36){
                            p >= n && g("invalid-input");
                            var d = (r = e.charCodeAt(p++)) - 48 < 10 ? r - 22 : r - 65 < 26 ? r - 65 : r - 97 < 26 ? r - 97 : 36;
                            (d >= 36 || d > v((c - o) / f)) && g("overflow"), o += d * f;
                            var m = l <= i ? 1 : l >= i + 26 ? 26 : l - i;
                            if (d < m) break;
                            var E = 36 - m;
                            f > v(c / E) && g("overflow"), f *= E;
                        }
                        var C = t.length + 1;
                        i = y(o - h, C, 0 == h), v(o / C) > c - a && g("overflow"), a += v(o / C), o %= C, t.splice(o++, 0, a);
                    }
                    return String.fromCodePoint.apply(String, t);
                }, A = function(e) {
                    var r = [], t = (e = E(e)).length, n = 128, o = 0, a = 72, i = !0, s = !1, u = void 0;
                    try {
                        for(var p, h = e[Symbol.iterator](); !(i = (p = h.next()).done); i = !0){
                            var f = p.value;
                            f < 128 && r.push(d(f));
                        }
                    } catch (L) {
                        s = !0, u = L;
                    } finally{
                        try {
                            !i && h.return && h.return();
                        } finally{
                            if (s) throw u;
                        }
                    }
                    var l = r.length, m = l;
                    for(l && r.push("-"); m < t;){
                        var S = c, A = !0, D = !1, w = void 0;
                        try {
                            for(var b, x = e[Symbol.iterator](); !(A = (b = x.next()).done); A = !0){
                                var O = b.value;
                                O >= n && O < S && (S = O);
                            }
                        } catch (L) {
                            D = !0, w = L;
                        } finally{
                            try {
                                !A && x.return && x.return();
                            } finally{
                                if (D) throw w;
                            }
                        }
                        var I = m + 1;
                        S - n > v((c - o) / I) && g("overflow"), o += (S - n) * I, n = S;
                        var F = !0, N = !1, R = void 0;
                        try {
                            for(var T, _ = e[Symbol.iterator](); !(F = (T = _.next()).done); F = !0){
                                var P = T.value;
                                if (P < n && ++o > c && g("overflow"), P == n) {
                                    for(var U = o, j = 36;; j += 36){
                                        var q = j <= a ? 1 : j >= a + 26 ? 26 : j - a;
                                        if (U < q) break;
                                        var H = U - q, z = 36 - q;
                                        r.push(d(C(q + H % z, 0))), U = v(H / z);
                                    }
                                    r.push(d(C(U, 0))), a = y(o, I, m == l), o = 0, ++m;
                                }
                            }
                        } catch (L) {
                            N = !0, R = L;
                        } finally{
                            try {
                                !F && _.return && _.return();
                            } finally{
                                if (N) throw R;
                            }
                        }
                        ++o, ++n;
                    }
                    return r.join("");
                }, D = {
                    version: "2.1.0",
                    ucs2: {
                        decode: E,
                        encode: function(e) {
                            return String.fromCodePoint.apply(String, function(e) {
                                if (Array.isArray(e)) {
                                    for(var r = 0, t = Array(e.length); r < e.length; r++)t[r] = e[r];
                                    return t;
                                }
                                return Array.from(e);
                            }(e));
                        }
                    },
                    decode: S,
                    encode: A,
                    toASCII: function(e) {
                        return m(e, function(e) {
                            return h.test(e) ? "xn--" + A(e) : e;
                        });
                    },
                    toUnicode: function(e) {
                        return m(e, function(e) {
                            return p.test(e) ? S(e.slice(4).toLowerCase()) : e;
                        });
                    }
                }, w = {};
                function b(e) {
                    var r = e.charCodeAt(0);
                    return r < 16 ? "%0" + r.toString(16).toUpperCase() : r < 128 ? "%" + r.toString(16).toUpperCase() : r < 2048 ? "%" + (r >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & r | 128).toString(16).toUpperCase() : "%" + (r >> 12 | 224).toString(16).toUpperCase() + "%" + (r >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & r | 128).toString(16).toUpperCase();
                }
                function x(e) {
                    for(var r = "", t = 0, n = e.length; t < n;){
                        var o = parseInt(e.substr(t + 1, 2), 16);
                        if (o < 128) r += String.fromCharCode(o), t += 3;
                        else if (o >= 194 && o < 224) {
                            if (n - t >= 6) {
                                var a = parseInt(e.substr(t + 4, 2), 16);
                                r += String.fromCharCode((31 & o) << 6 | 63 & a);
                            } else r += e.substr(t, 6);
                            t += 6;
                        } else if (o >= 224) {
                            if (n - t >= 9) {
                                var i = parseInt(e.substr(t + 4, 2), 16), s = parseInt(e.substr(t + 7, 2), 16);
                                r += String.fromCharCode((15 & o) << 12 | (63 & i) << 6 | 63 & s);
                            } else r += e.substr(t, 9);
                            t += 9;
                        } else r += e.substr(t, 3), t += 3;
                    }
                    return r;
                }
                function O(e, r) {
                    function t(e) {
                        var t = x(e);
                        return t.match(r.UNRESERVED) ? t : e;
                    }
                    return e.scheme && (e.scheme = String(e.scheme).replace(r.PCT_ENCODED, t).toLowerCase().replace(r.NOT_SCHEME, "")), void 0 !== e.userinfo && (e.userinfo = String(e.userinfo).replace(r.PCT_ENCODED, t).replace(r.NOT_USERINFO, b).replace(r.PCT_ENCODED, o)), void 0 !== e.host && (e.host = String(e.host).replace(r.PCT_ENCODED, t).toLowerCase().replace(r.NOT_HOST, b).replace(r.PCT_ENCODED, o)), void 0 !== e.path && (e.path = String(e.path).replace(r.PCT_ENCODED, t).replace(e.scheme ? r.NOT_PATH : r.NOT_PATH_NOSCHEME, b).replace(r.PCT_ENCODED, o)), void 0 !== e.query && (e.query = String(e.query).replace(r.PCT_ENCODED, t).replace(r.NOT_QUERY, b).replace(r.PCT_ENCODED, o)), void 0 !== e.fragment && (e.fragment = String(e.fragment).replace(r.PCT_ENCODED, t).replace(r.NOT_FRAGMENT, b).replace(r.PCT_ENCODED, o)), e;
                }
                function I(e) {
                    return e.replace(/^0*(.*)/, "$1") || "0";
                }
                function F(e, r) {
                    var t = e.match(r.IPV4ADDRESS) || [], n = u(t, 2)[1];
                    return n ? n.split(".").map(I).join(".") : e;
                }
                function N(e, r) {
                    var t = e.match(r.IPV6ADDRESS) || [], n = u(t, 3), o = n[1], a = n[2];
                    if (o) {
                        for(var i = o.toLowerCase().split("::").reverse(), s = u(i, 2), c = s[0], p = s[1], h = p ? p.split(":").map(I) : [], f = c.split(":").map(I), l = r.IPV4ADDRESS.test(f[f.length - 1]), v = l ? 7 : 8, d = f.length - v, g = Array(v), m = 0; m < v; ++m)g[m] = h[m] || f[d + m] || "";
                        l && (g[v - 1] = F(g[v - 1], r));
                        var E = g.reduce(function(e, r, t) {
                            if (!r || "0" === r) {
                                var n = e[e.length - 1];
                                n && n.index + n.length === t ? n.length++ : e.push({
                                    index: t,
                                    length: 1
                                });
                            }
                            return e;
                        }, []).sort(function(e, r) {
                            return r.length - e.length;
                        })[0], C = void 0;
                        if (E && E.length > 1) {
                            var y = g.slice(0, E.index), S = g.slice(E.index + E.length);
                            C = y.join(":") + "::" + S.join(":");
                        } else C = g.join(":");
                        return a && (C += "%" + a), C;
                    }
                    return e;
                }
                var R = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, T = void 0 === "".match(/(){0}/)[1];
                function _(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, t = {}, n = !1 !== r.iri ? s : i;
                    "suffix" === r.reference && (e = (r.scheme ? r.scheme + ":" : "") + "//" + e);
                    var o = e.match(R);
                    if (o) {
                        T ? (t.scheme = o[1], t.userinfo = o[3], t.host = o[4], t.port = parseInt(o[5], 10), t.path = o[6] || "", t.query = o[7], t.fragment = o[8], isNaN(t.port) && (t.port = o[5])) : (t.scheme = o[1] || void 0, t.userinfo = -1 !== e.indexOf("@") ? o[3] : void 0, t.host = -1 !== e.indexOf("//") ? o[4] : void 0, t.port = parseInt(o[5], 10), t.path = o[6] || "", t.query = -1 !== e.indexOf("?") ? o[7] : void 0, t.fragment = -1 !== e.indexOf("#") ? o[8] : void 0, isNaN(t.port) && (t.port = e.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? o[4] : void 0)), t.host && (t.host = N(F(t.host, n), n)), void 0 !== t.scheme || void 0 !== t.userinfo || void 0 !== t.host || void 0 !== t.port || t.path || void 0 !== t.query ? void 0 === t.scheme ? t.reference = "relative" : void 0 === t.fragment ? t.reference = "absolute" : t.reference = "uri" : t.reference = "same-document", r.reference && "suffix" !== r.reference && r.reference !== t.reference && (t.error = t.error || "URI is not a " + r.reference + " reference.");
                        var a = w[(r.scheme || t.scheme || "").toLowerCase()];
                        if (r.unicodeSupport || a && a.unicodeSupport) O(t, n);
                        else {
                            if (t.host && (r.domainHost || a && a.domainHost)) try {
                                t.host = D.toASCII(t.host.replace(n.PCT_ENCODED, x).toLowerCase());
                            } catch (u) {
                                t.error = t.error || "Host's domain name can not be converted to ASCII via punycode: " + u;
                            }
                            O(t, i);
                        }
                        a && a.parse && a.parse(t, r);
                    } else t.error = t.error || "URI can not be parsed.";
                    return t;
                }
                var P = /^\.\.?\//, U = /^\/\.(\/|$)/, j = /^\/\.\.(\/|$)/, q = /^\/?(?:.|\n)*?(?=\/|$)/;
                function H(e) {
                    for(var r = []; e.length;)if (e.match(P)) e = e.replace(P, "");
                    else if (e.match(U)) e = e.replace(U, "/");
                    else if (e.match(j)) e = e.replace(j, "/"), r.pop();
                    else if ("." === e || ".." === e) e = "";
                    else {
                        var t = e.match(q);
                        if (!t) throw new Error("Unexpected dot segment condition");
                        var n = t[0];
                        e = e.slice(n.length), r.push(n);
                    }
                    return r.join("");
                }
                function z(e) {
                    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, t = r.iri ? s : i, n = [], o = w[(r.scheme || e.scheme || "").toLowerCase()];
                    if (o && o.serialize && o.serialize(e, r), e.host) {
                        if (t.IPV6ADDRESS.test(e.host)) ;
                        else if (r.domainHost || o && o.domainHost) try {
                            e.host = r.iri ? D.toUnicode(e.host) : D.toASCII(e.host.replace(t.PCT_ENCODED, x).toLowerCase());
                        } catch (c) {
                            e.error = e.error || "Host's domain name can not be converted to " + (r.iri ? "Unicode" : "ASCII") + " via punycode: " + c;
                        }
                    }
                    O(e, t), "suffix" !== r.reference && e.scheme && (n.push(e.scheme), n.push(":"));
                    var a = function(e, r) {
                        var t = !1 !== r.iri ? s : i, n = [];
                        return void 0 !== e.userinfo && (n.push(e.userinfo), n.push("@")), void 0 !== e.host && n.push(N(F(String(e.host), t), t).replace(t.IPV6ADDRESS, function(e, r, t) {
                            return "[" + r + (t ? "%25" + t : "") + "]";
                        })), "number" == typeof e.port && (n.push(":"), n.push(e.port.toString(10))), n.length ? n.join("") : void 0;
                    }(e, r);
                    if (void 0 !== a && ("suffix" !== r.reference && n.push("//"), n.push(a), e.path && "/" !== e.path.charAt(0) && n.push("/")), void 0 !== e.path) {
                        var u = e.path;
                        r.absolutePath || o && o.absolutePath || (u = H(u)), void 0 === a && (u = u.replace(/^\/\//, "/%2F")), n.push(u);
                    }
                    return void 0 !== e.query && (n.push("?"), n.push(e.query)), void 0 !== e.fragment && (n.push("#"), n.push(e.fragment)), n.join("");
                }
                function L(e, r) {
                    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = {};
                    return arguments[3] || (e = _(z(e, t), t), r = _(z(r, t), t)), !(t = t || {}).tolerant && r.scheme ? (n.scheme = r.scheme, n.userinfo = r.userinfo, n.host = r.host, n.port = r.port, n.path = H(r.path || ""), n.query = r.query) : (void 0 !== r.userinfo || void 0 !== r.host || void 0 !== r.port ? (n.userinfo = r.userinfo, n.host = r.host, n.port = r.port, n.path = H(r.path || ""), n.query = r.query) : (r.path ? ("/" === r.path.charAt(0) ? n.path = H(r.path) : (void 0 === e.userinfo && void 0 === e.host && void 0 === e.port || e.path ? e.path ? n.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + r.path : n.path = r.path : n.path = "/" + r.path, n.path = H(n.path)), n.query = r.query) : (n.path = e.path, void 0 !== r.query ? n.query = r.query : n.query = e.query), n.userinfo = e.userinfo, n.host = e.host, n.port = e.port), n.scheme = e.scheme), n.fragment = r.fragment, n;
                }
                function $(e, r) {
                    return e && e.toString().replace(r && r.iri ? s.PCT_ENCODED : i.PCT_ENCODED, x);
                }
                var V = {
                    scheme: "http",
                    domainHost: !0,
                    parse: function(e, r) {
                        return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
                    },
                    serialize: function(e, r) {
                        return e.port !== ("https" !== String(e.scheme).toLowerCase() ? 80 : 443) && "" !== e.port || (e.port = void 0), e.path || (e.path = "/"), e;
                    }
                }, M = {
                    scheme: "https",
                    domainHost: V.domainHost,
                    parse: V.parse,
                    serialize: V.serialize
                }, Z = {}, k = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", G = "[0-9A-Fa-f]", Q = t(t("%[EFef][0-9A-Fa-f]%" + G + G + "%" + G + G) + "|" + t("%[89A-Fa-f][0-9A-Fa-f]%" + G + G) + "|" + t("%" + G + G)), Y = r("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), B = new RegExp(k, "g"), J = new RegExp(Q, "g"), K = new RegExp(r("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', Y), "g"), W = new RegExp(r("[^]", k, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"), X = W;
                function ee(e) {
                    var r = x(e);
                    return r.match(B) ? r : e;
                }
                var re = {
                    scheme: "mailto",
                    parse: function(e, r) {
                        var t = e, n = t.to = t.path ? t.path.split(",") : [];
                        if (t.path = void 0, t.query) {
                            for(var o = !1, a = {}, i = t.query.split("&"), s = 0, u = i.length; s < u; ++s){
                                var c = i[s].split("=");
                                switch(c[0]){
                                    case "to":
                                        for(var p = c[1].split(","), h = 0, f = p.length; h < f; ++h)n.push(p[h]);
                                        break;
                                    case "subject":
                                        t.subject = $(c[1], r);
                                        break;
                                    case "body":
                                        t.body = $(c[1], r);
                                        break;
                                    default:
                                        o = !0, a[$(c[0], r)] = $(c[1], r);
                                }
                            }
                            o && (t.headers = a);
                        }
                        t.query = void 0;
                        for(var l = 0, v = n.length; l < v; ++l){
                            var d = n[l].split("@");
                            if (d[0] = $(d[0]), r.unicodeSupport) d[1] = $(d[1], r).toLowerCase();
                            else try {
                                d[1] = D.toASCII($(d[1], r).toLowerCase());
                            } catch (g) {
                                t.error = t.error || "Email address's domain name can not be converted to ASCII via punycode: " + g;
                            }
                            n[l] = d.join("@");
                        }
                        return t;
                    },
                    serialize: function(e, r) {
                        var t, n = e, a = null != (t = e.to) ? t instanceof Array ? t : "number" != typeof t.length || t.split || t.setInterval || t.call ? [
                            t
                        ] : Array.prototype.slice.call(t) : [];
                        if (a) {
                            for(var i = 0, s = a.length; i < s; ++i){
                                var u = String(a[i]), c = u.lastIndexOf("@"), p = u.slice(0, c).replace(J, ee).replace(J, o).replace(K, b), h = u.slice(c + 1);
                                try {
                                    h = r.iri ? D.toUnicode(h) : D.toASCII($(h, r).toLowerCase());
                                } catch (d) {
                                    n.error = n.error || "Email address's domain name can not be converted to " + (r.iri ? "Unicode" : "ASCII") + " via punycode: " + d;
                                }
                                a[i] = p + "@" + h;
                            }
                            n.path = a.join(",");
                        }
                        var f = e.headers = e.headers || {};
                        e.subject && (f.subject = e.subject), e.body && (f.body = e.body);
                        var l = [];
                        for(var v in f)f[v] !== Z[v] && l.push(v.replace(J, ee).replace(J, o).replace(W, b) + "=" + f[v].replace(J, ee).replace(J, o).replace(X, b));
                        return l.length && (n.query = l.join("&")), n;
                    }
                }, te = /^([^\:]+)\:(.*)/, ne = {
                    scheme: "urn",
                    parse: function(e, r) {
                        var t = e.path && e.path.match(te), n = e;
                        if (t) {
                            var o = r.scheme || n.scheme || "urn", a = t[1].toLowerCase(), i = t[2], s = o + ":" + (r.nid || a), u = w[s];
                            n.nid = a, n.nss = i, n.path = void 0, u && (n = u.parse(n, r));
                        } else n.error = n.error || "URN can not be parsed.";
                        return n;
                    },
                    serialize: function(e, r) {
                        var t = r.scheme || e.scheme || "urn", n = e.nid, o = t + ":" + (r.nid || n), a = w[o];
                        a && (e = a.serialize(e, r));
                        var i = e, s = e.nss;
                        return i.path = (n || r.nid) + ":" + s, i;
                    }
                }, oe = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, ae = {
                    scheme: "urn:uuid",
                    parse: function(e, r) {
                        var t = e;
                        return t.uuid = t.nss, t.nss = void 0, r.tolerant || t.uuid && t.uuid.match(oe) || (t.error = t.error || "UUID is not valid."), t;
                    },
                    serialize: function(e, r) {
                        var t = e;
                        return t.nss = (e.uuid || "").toLowerCase(), t;
                    }
                };
                w[V.scheme] = V, w[M.scheme] = M, w[re.scheme] = re, w[ne.scheme] = ne, w[ae.scheme] = ae, e.SCHEMES = w, e.pctEncChar = b, e.pctDecChars = x, e.parse = _, e.removeDotSegments = H, e.serialize = z, e.resolveComponents = L, e.resolve = function(e, r, t) {
                    var n = function(e, r) {
                        var t = e;
                        if (r) for(var n in r)t[n] = r[n];
                        return t;
                    }({
                        scheme: "null"
                    }, t);
                    return z(L(_(e, n), _(r, n), n, !0), n);
                }, e.normalize = function(e, r) {
                    return "string" == typeof e ? e = z(_(e, r), r) : "object" === n(e) && (e = _(z(e, r), r)), e;
                }, e.equal = function(e, r, t) {
                    return "string" == typeof e ? e = z(_(e, t), t) : "object" === n(e) && (e = z(e, t)), "string" == typeof r ? r = z(_(r, t), t) : "object" === n(r) && (r = z(r, t)), e === r;
                }, e.escapeComponent = function(e, r) {
                    return e && e.toString().replace(r && r.iri ? s.ESCAPE : i.ESCAPE, b);
                }, e.unescapeComponent = $, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        },
        {}
    ],
    "dPQH": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function r(t, e) {
                if (t === e) return !0;
                if (t && e && "object" == typeof t && "object" == typeof e) {
                    if (t.constructor !== e.constructor) return !1;
                    var o, n, u;
                    if (Array.isArray(t)) {
                        if ((o = t.length) != e.length) return !1;
                        for(n = o; 0 != n--;)if (!r(t[n], e[n])) return !1;
                        return !0;
                    }
                    if (t.constructor === RegExp) return t.source === e.source && t.flags === e.flags;
                    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === e.valueOf();
                    if (t.toString !== Object.prototype.toString) return t.toString() === e.toString();
                    if ((o = (u = Object.keys(t)).length) !== Object.keys(e).length) return !1;
                    for(n = o; 0 != n--;)if (!Object.prototype.hasOwnProperty.call(e, u[n])) return !1;
                    for(n = o; 0 != n--;){
                        var f = u[n];
                        if (!r(t[f], e[f])) return !1;
                    }
                    return !0;
                }
                return t != t && e != e;
            };
        },
        {}
    ],
    "rD0p": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r) {
                for(var t, e = 0, o = r.length, c = 0; c < o;)e++, (t = r.charCodeAt(c++)) >= 55296 && t <= 56319 && c < o && 56320 == (64512 & (t = r.charCodeAt(c))) && c++;
                return e;
            };
        },
        {}
    ],
    "Q1F7": [
        function(require1, module1, exports) {
            "use strict";
            function e(e, r) {
                for(var n in r = r || {}, e)r[n] = e[n];
                return r;
            }
            function r(e, r, n, t) {
                var a = t ? " !== " : " === ", o = t ? " || " : " && ", u = t ? "!" : "", c = t ? "" : "!";
                switch(e){
                    case "null":
                        return r + a + "null";
                    case "array":
                        return u + "Array.isArray(" + r + ")";
                    case "object":
                        return "(" + u + r + o + "typeof " + r + a + '"object"' + o + c + "Array.isArray(" + r + "))";
                    case "integer":
                        return "(typeof " + r + a + '"number"' + o + c + "(" + r + " % 1)" + o + r + a + r + (n ? o + u + "isFinite(" + r + ")" : "") + ")";
                    case "number":
                        return "(typeof " + r + a + '"' + e + '"' + (n ? o + u + "isFinite(" + r + ")" : "") + ")";
                    default:
                        return "typeof " + r + a + '"' + e + '"';
                }
            }
            function n(e, n, t) {
                switch(e.length){
                    case 1:
                        return r(e[0], n, t, !0);
                    default:
                        var a = "", u = o(e);
                        for(var c in u.array && u.object && (a = u.null ? "(" : "(!" + n + " || ", a += "typeof " + n + ' !== "object")', delete u.null, delete u.array, delete u.object), u.number && delete u.integer, u)a += (a ? " && " : "") + r(c, n, t, !0);
                        return a;
                }
            }
            module1.exports = {
                copy: e,
                checkDataType: r,
                checkDataTypes: n,
                coerceToTypes: a,
                toHash: o,
                getProperty: i,
                escapeQuotes: l,
                equal: require1("fast-deep-equal"),
                ucs2length: require1("./ucs2length"),
                varOccurences: f,
                varReplace: s,
                schemaHasRules: p,
                schemaHasRulesExcept: g,
                schemaUnknownRules: y,
                toQuotedString: h,
                getPathExpr: v,
                getPath: d,
                getData: w,
                unescapeFragment: E,
                unescapeJsonPointer: A,
                escapeFragment: R,
                escapeJsonPointer: x
            };
            var t = o([
                "string",
                "number",
                "integer",
                "boolean",
                "null"
            ]);
            function a(e, r) {
                if (Array.isArray(r)) {
                    for(var n = [], a = 0; a < r.length; a++){
                        var o = r[a];
                        t[o] ? n[n.length] = o : "array" === e && "array" === o && (n[n.length] = o);
                    }
                    if (n.length) return n;
                } else {
                    if (t[r]) return [
                        r
                    ];
                    if ("array" === e && "array" === r) return [
                        "array"
                    ];
                }
            }
            function o(e) {
                for(var r = {}, n = 0; n < e.length; n++)r[e[n]] = !0;
                return r;
            }
            var u = /^[a-z$_][a-z$_0-9]*$/i, c = /'|\\/g;
            function i(e) {
                return "number" == typeof e ? "[" + e + "]" : u.test(e) ? "." + e : "['" + l(e) + "']";
            }
            function l(e) {
                return e.replace(c, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
            }
            function f(e, r) {
                r += "[^0-9]";
                var n = e.match(new RegExp(r, "g"));
                return n ? n.length : 0;
            }
            function s(e, r, n) {
                return r += "([^0-9])", n = n.replace(/\$/g, "$$$$"), e.replace(new RegExp(r, "g"), n + "$1");
            }
            function p(e, r) {
                if ("boolean" == typeof e) return !e;
                for(var n in e)if (r[n]) return !0;
            }
            function g(e, r, n) {
                if ("boolean" == typeof e) return !e && "not" != n;
                for(var t in e)if (t != n && r[t]) return !0;
            }
            function y(e, r) {
                if ("boolean" != typeof e) {
                    for(var n in e)if (!r[n]) return n;
                }
            }
            function h(e) {
                return "'" + l(e) + "'";
            }
            function v(e, r, n, t) {
                return $(e, n ? "'/' + " + r + (t ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : t ? "'[' + " + r + " + ']'" : "'[\\'' + " + r + " + '\\']'");
            }
            function d(e, r, n) {
                return $(e, h(n ? "/" + x(r) : i(r)));
            }
            var m = /^\/(?:[^~]|~0|~1)*$/, b = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
            function w(e, r, n) {
                var t, a, o, u;
                if ("" === e) return "rootData";
                if ("/" == e[0]) {
                    if (!m.test(e)) throw new Error("Invalid JSON-pointer: " + e);
                    a = e, o = "rootData";
                } else {
                    if (!(u = e.match(b))) throw new Error("Invalid JSON-pointer: " + e);
                    if (t = +u[1], "#" == (a = u[2])) {
                        if (t >= r) throw new Error("Cannot access property/index " + t + " levels up, current level is " + r);
                        return n[r - t];
                    }
                    if (t > r) throw new Error("Cannot access data " + t + " levels up, current level is " + r);
                    if (o = "data" + (r - t || ""), !a) return o;
                }
                for(var c = o, l = a.split("/"), f = 0; f < l.length; f++){
                    var s = l[f];
                    s && (c += " && " + (o += i(A(s))));
                }
                return c;
            }
            function $(e, r) {
                return '""' == e ? r : (e + " + " + r).replace(/([^\\])' \+ '/g, "$1");
            }
            function E(e) {
                return A(decodeURIComponent(e));
            }
            function R(e) {
                return encodeURIComponent(x(e));
            }
            function x(e) {
                return e.replace(/~/g, "~0").replace(/\//g, "~1");
            }
            function A(e) {
                return e.replace(/~1/g, "/").replace(/~0/g, "~");
            }
        },
        {
            "fast-deep-equal": "dPQH",
            "./ucs2length": "rD0p"
        }
    ],
    "HHLG": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("./util");
            function e(e) {
                t.copy(e, this);
            }
            module1.exports = e;
        },
        {
            "./util": "Q1F7"
        }
    ],
    "uMRE": [
        function(require1, module1, exports) {
            "use strict";
            var e = module1.exports = function(e, i, t) {
                "function" == typeof i && (t = i, i = {}), r(i, "function" == typeof (t = i.cb || t) ? t : t.pre || function() {}, t.post || function() {}, e, "", e);
            };
            function r(t, n, o, s, a, m, p, f, u, y) {
                if (s && "object" == typeof s && !Array.isArray(s)) {
                    for(var c in n(s, a, m, p, f, u, y), s){
                        var d = s[c];
                        if (Array.isArray(d)) {
                            if (c in e.arrayKeywords) for(var l = 0; l < d.length; l++)r(t, n, o, d[l], a + "/" + c + "/" + l, m, a, c, s, l);
                        } else if (c in e.propsKeywords) {
                            if (d && "object" == typeof d) for(var w in d)r(t, n, o, d[w], a + "/" + c + "/" + i(w), m, a, c, s, w);
                        } else (c in e.keywords || t.allKeys && !(c in e.skipKeywords)) && r(t, n, o, d, a + "/" + c, m, a, c, s);
                    }
                    o(s, a, m, p, f, u, y);
                }
            }
            function i(e) {
                return e.replace(/~/g, "~0").replace(/\//g, "~1");
            }
            e.keywords = {
                additionalItems: !0,
                items: !0,
                contains: !0,
                additionalProperties: !0,
                propertyNames: !0,
                not: !0
            }, e.arrayKeywords = {
                items: !0,
                allOf: !0,
                anyOf: !0,
                oneOf: !0
            }, e.propsKeywords = {
                definitions: !0,
                properties: !0,
                patternProperties: !0,
                dependencies: !0
            }, e.skipKeywords = {
                default: !0,
                enum: !0,
                const: !0,
                required: !0,
                maximum: !0,
                minimum: !0,
                exclusiveMaximum: !0,
                exclusiveMinimum: !0,
                multipleOf: !0,
                maxLength: !0,
                minLength: !0,
                pattern: !0,
                format: !0,
                maxItems: !0,
                minItems: !0,
                uniqueItems: !0,
                maxProperties: !0,
                minProperties: !0
            };
        },
        {}
    ],
    "w10T": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("uri-js"), r = require1("fast-deep-equal"), t = require1("./util"), i = require1("./schema_obj"), s = require1("json-schema-traverse");
            function a(e, r, t) {
                var s = this._refs[t];
                if ("string" == typeof s) {
                    if (!this._refs[s]) return a.call(this, e, r, s);
                    s = this._refs[s];
                }
                if ((s = s || this._schemas[t]) instanceof i) return u(s.schema, this._opts.inlineRefs) ? s.schema : s.validate || this._compile(s);
                var o, f, c, h = n.call(this, r, t);
                return h && (o = h.schema, r = h.root, c = h.baseId), o instanceof i ? f = o.validate || e.call(this, o.schema, r, void 0, c) : void 0 !== o && (f = u(o, this._opts.inlineRefs) ? o : e.call(this, o, r, void 0, c)), f;
            }
            function n(r, t) {
                var s = e.parse(t), a = d(s), n = v(this._getId(r.schema));
                if (0 === Object.keys(r.schema).length || a !== n) {
                    var f = g(a), h = this._refs[f];
                    if ("string" == typeof h) return o.call(this, r, h, s);
                    if (h instanceof i) h.validate || this._compile(h), r = h;
                    else {
                        if (!((h = this._schemas[f]) instanceof i)) return;
                        if (h.validate || this._compile(h), f == g(t)) return {
                            schema: h,
                            root: r,
                            baseId: n
                        };
                        r = h;
                    }
                    if (!r.schema) return;
                    n = v(this._getId(r.schema));
                }
                return c.call(this, s, n, r.schema, r);
            }
            function o(e, r, t) {
                var i = n.call(this, e, r);
                if (i) {
                    var s = i.schema, a = i.baseId;
                    e = i.root;
                    var o = this._getId(s);
                    return o && (a = _(a, o)), c.call(this, t, a, s, e);
                }
            }
            module1.exports = a, a.normalizeId = g, a.fullPath = v, a.url = _, a.ids = y, a.inlineRef = u, a.schema = n;
            var f = t.toHash([
                "properties",
                "patternProperties",
                "enum",
                "dependencies",
                "definitions"
            ]);
            function c(e, r, i, s) {
                if (e.fragment = e.fragment || "", "/" == e.fragment.slice(0, 1)) {
                    for(var a = e.fragment.split("/"), o = 1; o < a.length; o++){
                        var c = a[o];
                        if (c) {
                            if (void 0 === (i = i[c = t.unescapeFragment(c)])) break;
                            var h;
                            if (!f[c] && ((h = this._getId(i)) && (r = _(r, h)), i.$ref)) {
                                var u = _(r, i.$ref), l = n.call(this, s, u);
                                l && (i = l.schema, s = l.root, r = l.baseId);
                            }
                        }
                    }
                    return void 0 !== i && i !== s.schema ? {
                        schema: i,
                        root: s,
                        baseId: r
                    } : void 0;
                }
            }
            var h = t.toHash([
                "type",
                "format",
                "pattern",
                "maxLength",
                "minLength",
                "maxProperties",
                "minProperties",
                "maxItems",
                "minItems",
                "maximum",
                "minimum",
                "uniqueItems",
                "multipleOf",
                "required",
                "enum"
            ]);
            function u(e, r) {
                return !1 !== r && (void 0 === r || !0 === r ? l(e) : r ? m(e) <= r : void 0);
            }
            function l(e) {
                var r;
                if (Array.isArray(e)) {
                    for(var t = 0; t < e.length; t++)if ("object" == typeof (r = e[t]) && !l(r)) return !1;
                } else for(var i in e){
                    if ("$ref" == i) return !1;
                    if ("object" == typeof (r = e[i]) && !l(r)) return !1;
                }
                return !0;
            }
            function m(e) {
                var r, t = 0;
                if (Array.isArray(e)) {
                    for(var i = 0; i < e.length; i++)if ("object" == typeof (r = e[i]) && (t += m(r)), t == 1 / 0) return 1 / 0;
                } else for(var s in e){
                    if ("$ref" == s) return 1 / 0;
                    if (h[s]) t++;
                    else if ("object" == typeof (r = e[s]) && (t += m(r) + 1), t == 1 / 0) return 1 / 0;
                }
                return t;
            }
            function v(r, t) {
                return !1 !== t && (r = g(r)), d(e.parse(r));
            }
            function d(r) {
                return e.serialize(r).split("#")[0] + "#";
            }
            var p = /#\/?$/;
            function g(e) {
                return e ? e.replace(p, "") : "";
            }
            function _(r, t) {
                return t = g(t), e.resolve(r, t);
            }
            function y(i) {
                var a = g(this._getId(i)), n = {
                    "": a
                }, o = {
                    "": v(a, !1)
                }, f = {}, c = this;
                return s(i, {
                    allKeys: !0
                }, function(i, s, a, h, u, l, m) {
                    if ("" !== s) {
                        var v = c._getId(i), d = n[h], p = o[h] + "/" + u;
                        if (void 0 !== m && (p += "/" + ("number" == typeof m ? m : t.escapeFragment(m))), "string" == typeof v) {
                            v = d = g(d ? e.resolve(d, v) : v);
                            var _ = c._refs[v];
                            if ("string" == typeof _ && (_ = c._refs[_]), _ && _.schema) {
                                if (!r(i, _.schema)) throw new Error('id "' + v + '" resolves to more than one schema');
                            } else if (v != g(p)) {
                                if ("#" == v[0]) {
                                    if (f[v] && !r(i, f[v])) throw new Error('id "' + v + '" resolves to more than one schema');
                                    f[v] = i;
                                } else c._refs[v] = p;
                            }
                        }
                        n[s] = d, o[s] = p;
                    }
                }), f;
            }
        },
        {
            "uri-js": "wWOq",
            "fast-deep-equal": "dPQH",
            "./util": "Q1F7",
            "./schema_obj": "HHLG",
            "json-schema-traverse": "uMRE"
        }
    ],
    "OtNE": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./resolve");
            function t(e) {
                this.message = "validation failed", this.errors = e, this.ajv = this.validation = !0;
            }
            function i(t, s, r) {
                this.message = r || i.message(t, s), this.missingRef = e.url(t, s), this.missingSchema = e.normalizeId(e.fullPath(this.missingRef));
            }
            function s(e) {
                return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
            }
            module1.exports = {
                Validation: s(t),
                MissingRef: s(i)
            }, i.message = function(e, t) {
                return "can't resolve reference " + t + " from id " + e;
            };
        },
        {
            "./resolve": "w10T"
        }
    ],
    "Xb3N": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r, t) {
                t || (t = {}), "function" == typeof t && (t = {
                    cmp: t
                });
                var e, n = "boolean" == typeof t.cycles && t.cycles, i = t.cmp && (e = t.cmp, function(r) {
                    return function(t, n) {
                        var i = {
                            key: t,
                            value: r[t]
                        }, u = {
                            key: n,
                            value: r[n]
                        };
                        return e(i, u);
                    };
                }), u = [];
                return function r(t) {
                    if (t && t.toJSON && "function" == typeof t.toJSON && (t = t.toJSON()), void 0 !== t) {
                        if ("number" == typeof t) return isFinite(t) ? "" + t : "null";
                        if ("object" != typeof t) return JSON.stringify(t);
                        var e, o;
                        if (Array.isArray(t)) {
                            for(o = "[", e = 0; e < t.length; e++)e && (o += ","), o += r(t[e]) || "null";
                            return o + "]";
                        }
                        if (null === t) return "null";
                        if (-1 !== u.indexOf(t)) {
                            if (n) return JSON.stringify("__cycle__");
                            throw new TypeError("Converting circular structure to JSON");
                        }
                        var f = u.push(t) - 1, c = Object.keys(t).sort(i && i(t));
                        for(o = "", e = 0; e < c.length; e++){
                            var l = c[e], y = r(t[l]);
                            y && (o && (o += ","), o += JSON.stringify(l) + ":" + y);
                        }
                        return u.splice(f, 1), "{" + o + "}";
                    }
                }(r);
            };
        },
        {}
    ],
    "yhC1": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t = "", s = !0 === e.schema.$async, o = e.util.schemaHasRulesExcept(e.schema, e.RULES.all, "$ref"), l = e.self._getId(e.schema);
                if (e.opts.strictKeywords) {
                    var i = e.util.schemaUnknownRules(e.schema, e.RULES.keywords);
                    if (i) {
                        var n = "unknown keyword: " + i;
                        if ("log" !== e.opts.strictKeywords) throw new Error(n);
                        e.logger.warn(n);
                    }
                }
                if (e.isTop && (t += " var validate = ", s && (e.async = !0, t += "async "), t += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", l && (e.opts.sourceCode || e.opts.processCode) && (t += " /*# sourceURL=" + l + " */ ")), "boolean" == typeof e.schema || !o && !e.schema.$ref) {
                    var c = e.level, f = e.dataLevel, h = e.schema["false schema"], u = e.schemaPath + e.util.getProperty("false schema"), p = e.errSchemaPath + "/false schema", d = !e.opts.allErrors, m = "data" + (f || ""), v = "valid" + c;
                    if (!1 === e.schema) {
                        e.isTop ? d = !0 : t += " var " + v + " = false; ", (W = W || []).push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: {} ", !1 !== e.opts.messages && (t += " , message: 'boolean schema is false' "), e.opts.verbose && (t += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                        var y = t;
                        t = W.pop(), !e.compositeRule && d ? e.async ? t += " throw new ValidationError([" + y + "]); " : t += " validate.errors = [" + y + "]; return false; " : t += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    } else e.isTop ? t += s ? " return data; " : " validate.errors = null; return true; " : t += " var " + v + " = true; ";
                    return e.isTop && (t += " }; return validate; "), t;
                }
                if (e.isTop) {
                    var g = e.isTop;
                    c = e.level = 0, f = e.dataLevel = 0, m = "data";
                    if (e.rootId = e.resolve.fullPath(e.self._getId(e.root.schema)), e.baseId = e.baseId || e.rootId, delete e.isTop, e.dataPathArr = [
                        ""
                    ], void 0 !== e.schema.default && e.opts.useDefaults && e.opts.strictDefaults) {
                        var w = "default is ignored in the schema root";
                        if ("log" !== e.opts.strictDefaults) throw new Error(w);
                        e.logger.warn(w);
                    }
                    t += " var vErrors = null; ", t += " var errors = 0;     ", t += " if (rootData === undefined) rootData = data; ";
                } else {
                    c = e.level, m = "data" + ((f = e.dataLevel) || "");
                    if (l && (e.baseId = e.resolve.url(e.baseId, l)), s && !e.async) throw new Error("async schema in sync schema");
                    t += " var errs_" + c + " = errors;";
                }
                v = "valid" + c, d = !e.opts.allErrors;
                var E = "", P = "", b = e.schema.type, D = Array.isArray(b);
                if (b && e.opts.nullable && !0 === e.schema.nullable && (D ? -1 == b.indexOf("null") && (b = b.concat("null")) : "null" != b && (b = [
                    b,
                    "null"
                ], D = !0)), D && 1 == b.length && (b = b[0], D = !1), e.schema.$ref && o) {
                    if ("fail" == e.opts.extendRefs) throw new Error('$ref: validation keywords used in schema at path "' + e.errSchemaPath + '" (see option extendRefs)');
                    !0 !== e.opts.extendRefs && (o = !1, e.logger.warn('$ref: keywords ignored in schema at path "' + e.errSchemaPath + '"'));
                }
                if (e.schema.$comment && e.opts.$comment && (t += " " + e.RULES.all.$comment.code(e, "$comment")), b) {
                    if (e.opts.coerceTypes) var S = e.util.coerceToTypes(e.opts.coerceTypes, b);
                    var R = e.RULES.types[b];
                    if (S || D || !0 === R || R && !X(R)) {
                        u = e.schemaPath + ".type", p = e.errSchemaPath + "/type", u = e.schemaPath + ".type", p = e.errSchemaPath + "/type";
                        var T = D ? "checkDataTypes" : "checkDataType";
                        if (t += " if (" + e.util[T](b, m, e.opts.strictNumbers, !0) + ") { ", S) {
                            var k = "dataType" + c, $ = "coerced" + c;
                            t += " var " + k + " = typeof " + m + "; var " + $ + " = undefined; ", "array" == e.opts.coerceTypes && (t += " if (" + k + " == 'object' && Array.isArray(" + m + ") && " + m + ".length == 1) { " + m + " = " + m + "[0]; " + k + " = typeof " + m + "; if (" + e.util.checkDataType(e.schema.type, m, e.opts.strictNumbers) + ") " + $ + " = " + m + "; } "), t += " if (" + $ + " !== undefined) ; ";
                            var L = S;
                            if (L) for(var j, A = -1, I = L.length - 1; A < I;)"string" == (j = L[A += 1]) ? t += " else if (" + k + " == 'number' || " + k + " == 'boolean') " + $ + " = '' + " + m + "; else if (" + m + " === null) " + $ + " = ''; " : "number" == j || "integer" == j ? (t += " else if (" + k + " == 'boolean' || " + m + " === null || (" + k + " == 'string' && " + m + " && " + m + " == +" + m + " ", "integer" == j && (t += " && !(" + m + " % 1)"), t += ")) " + $ + " = +" + m + "; ") : "boolean" == j ? t += " else if (" + m + " === 'false' || " + m + " === 0 || " + m + " === null) " + $ + " = false; else if (" + m + " === 'true' || " + m + " === 1) " + $ + " = true; " : "null" == j ? t += " else if (" + m + " === '' || " + m + " === 0 || " + m + " === false) " + $ + " = null; " : "array" == e.opts.coerceTypes && "array" == j && (t += " else if (" + k + " == 'string' || " + k + " == 'number' || " + k + " == 'boolean' || " + m + " == null) " + $ + " = [" + m + "]; ");
                            t += " else {   ", (W = W || []).push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: { type: '", t += D ? "" + b.join(",") : "" + b, t += "' } ", !1 !== e.opts.messages && (t += " , message: 'should be ", t += D ? "" + b.join(",") : "" + b, t += "' "), e.opts.verbose && (t += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                            y = t;
                            t = W.pop(), !e.compositeRule && d ? e.async ? t += " throw new ValidationError([" + y + "]); " : t += " validate.errors = [" + y + "]; return false; " : t += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } if (" + $ + " !== undefined) {  ";
                            var U = f ? "data" + (f - 1 || "") : "parentData";
                            t += " " + m + " = " + $ + "; ", f || (t += "if (" + U + " !== undefined)"), t += " " + U + "[" + (f ? e.dataPathArr[f] : "parentDataProperty") + "] = " + $ + "; } ";
                        } else {
                            (W = W || []).push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: { type: '", t += D ? "" + b.join(",") : "" + b, t += "' } ", !1 !== e.opts.messages && (t += " , message: 'should be ", t += D ? "" + b.join(",") : "" + b, t += "' "), e.opts.verbose && (t += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                            y = t;
                            t = W.pop(), !e.compositeRule && d ? e.async ? t += " throw new ValidationError([" + y + "]); " : t += " validate.errors = [" + y + "]; return false; " : t += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                        }
                        t += " } ";
                    }
                }
                if (e.schema.$ref && !o) t += " " + e.RULES.all.$ref.code(e, "$ref") + " ", d && (t += " } if (errors === ", t += g ? "0" : "errs_" + c, t += ") { ", P += "}");
                else {
                    var x = e.RULES;
                    if (x) {
                        for(var _ = -1, N = x.length - 1; _ < N;)if (X(R = x[_ += 1])) {
                            if (R.type && (t += " if (" + e.util.checkDataType(R.type, m, e.opts.strictNumbers) + ") { "), e.opts.useDefaults) {
                                if ("object" == R.type && e.schema.properties) {
                                    h = e.schema.properties;
                                    var V = Object.keys(h);
                                    if (V) {
                                        for(var O, Q = -1, C = V.length - 1; Q < C;)if (void 0 !== (H = h[O = V[Q += 1]]).default) {
                                            var J = m + e.util.getProperty(O);
                                            if (e.compositeRule) {
                                                if (e.opts.strictDefaults) {
                                                    w = "default is ignored for: " + J;
                                                    if ("log" !== e.opts.strictDefaults) throw new Error(w);
                                                    e.logger.warn(w);
                                                }
                                            } else t += " if (" + J + " === undefined ", "empty" == e.opts.useDefaults && (t += " || " + J + " === null || " + J + " === '' "), t += " ) " + J + " = ", "shared" == e.opts.useDefaults ? t += " " + e.useDefault(H.default) + " " : t += " " + JSON.stringify(H.default) + " ", t += "; ";
                                        }
                                    }
                                } else if ("array" == R.type && Array.isArray(e.schema.items)) {
                                    var K = e.schema.items;
                                    if (K) {
                                        A = -1;
                                        for(var H, q = K.length - 1; A < q;)if (void 0 !== (H = K[A += 1]).default) {
                                            J = m + "[" + A + "]";
                                            if (e.compositeRule) {
                                                if (e.opts.strictDefaults) {
                                                    w = "default is ignored for: " + J;
                                                    if ("log" !== e.opts.strictDefaults) throw new Error(w);
                                                    e.logger.warn(w);
                                                }
                                            } else t += " if (" + J + " === undefined ", "empty" == e.opts.useDefaults && (t += " || " + J + " === null || " + J + " === '' "), t += " ) " + J + " = ", "shared" == e.opts.useDefaults ? t += " " + e.useDefault(H.default) + " " : t += " " + JSON.stringify(H.default) + " ", t += "; ";
                                        }
                                    }
                                }
                            }
                            var z = R.rules;
                            if (z) {
                                for(var B, F = -1, G = z.length - 1; F < G;)if (Y(B = z[F += 1])) {
                                    var M = B.code(e, B.keyword, R.type);
                                    M && (t += " " + M + " ", d && (E += "}"));
                                }
                            }
                            if (d && (t += " " + E + " ", E = ""), R.type && (t += " } ", b && b === R.type && !S)) {
                                t += " else { ";
                                var W;
                                u = e.schemaPath + ".type", p = e.errSchemaPath + "/type";
                                (W = W || []).push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(p) + " , params: { type: '", t += D ? "" + b.join(",") : "" + b, t += "' } ", !1 !== e.opts.messages && (t += " , message: 'should be ", t += D ? "" + b.join(",") : "" + b, t += "' "), e.opts.verbose && (t += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                                y = t;
                                t = W.pop(), !e.compositeRule && d ? e.async ? t += " throw new ValidationError([" + y + "]); " : t += " validate.errors = [" + y + "]; return false; " : t += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } ";
                            }
                            d && (t += " if (errors === ", t += g ? "0" : "errs_" + c, t += ") { ", P += "}");
                        }
                    }
                }
                function X(e) {
                    for(var r = e.rules, a = 0; a < r.length; a++)if (Y(r[a])) return !0;
                }
                function Y(r) {
                    return void 0 !== e.schema[r.keyword] || r.implements && function(r) {
                        for(var a = r.implements, t = 0; t < a.length; t++)if (void 0 !== e.schema[a[t]]) return !0;
                    }(r);
                }
                return d && (t += " " + P + " "), g ? (s ? (t += " if (errors === 0) return data;           ", t += " else throw new ValidationError(vErrors); ") : (t += " validate.errors = vErrors; ", t += " return errors === 0;       "), t += " }; return validate;") : t += " var " + v + " = errors === errs_" + c + ";", t;
            };
        },
        {}
    ],
    "qdYs": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./resolve"), r = require1("./util"), t = require1("./error_classes"), i = require1("fast-json-stable-stringify"), o = require1("../dotjs/validate"), a = r.ucs2length, n = require1("fast-deep-equal"), s = t.Validation;
            function l(f, g, y, w) {
                var R = this, V = this._opts, S = [
                    void 0
                ], _ = {}, b = [], E = {}, q = [], j = {}, x = [];
                g = g || {
                    schema: f,
                    refVal: S,
                    refs: _
                };
                var $ = c.call(this, f, g, w), k = this._compilations[$.index];
                if ($.compiling) return k.callValidate = function e() {
                    var r = k.validate;
                    var t = r.apply(this, arguments);
                    e.errors = r.errors;
                    return t;
                };
                var C = this._formats, P = this.RULES;
                try {
                    var I = U(f, g, y, w);
                    k.validate = I;
                    var L = k.callValidate;
                    return L && (L.schema = I.schema, L.errors = null, L.refs = I.refs, L.refVal = I.refVal, L.root = I.root, L.$async = I.$async, V.sourceCode && (L.source = I.source)), I;
                } finally{
                    u.call(this, f, g, w);
                }
                function U(i, c, u, f) {
                    var y = !c || c && c.schema == i;
                    if (c.schema != g.schema) return l.call(R, i, c, u, f);
                    var w, E = !0 === i.$async, j = o({
                        isTop: !0,
                        schema: i,
                        isRoot: y,
                        baseId: f,
                        root: c,
                        schemaPath: "",
                        errSchemaPath: "#",
                        errorPath: '""',
                        MissingRefError: t.MissingRef,
                        RULES: P,
                        validate: o,
                        util: r,
                        resolve: e,
                        resolveRef: M,
                        usePattern: T,
                        useDefault: D,
                        useCustomRule: F,
                        opts: V,
                        formats: C,
                        logger: R.logger,
                        self: R
                    });
                    j = p(S, h) + p(b, d) + p(q, v) + p(x, m) + j, V.processCode && (j = V.processCode(j, i));
                    try {
                        w = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", j)(R, P, C, g, S, q, x, n, a, s), S[0] = w;
                    } catch ($) {
                        throw R.logger.error("Error compiling schema, function code:", j), $;
                    }
                    return w.schema = i, w.errors = null, w.refs = _, w.refVal = S, w.root = y ? w : c, E && (w.$async = !0), !0 === V.sourceCode && (w.source = {
                        code: j,
                        patterns: b,
                        defaults: q
                    }), w;
                }
                function M(r, t, i) {
                    t = e.url(r, t);
                    var o, a, n = _[t];
                    if (void 0 !== n) return Q(o = S[n], a = "refVal[" + n + "]");
                    if (!i && g.refs) {
                        var s = g.refs[t];
                        if (void 0 !== s) return Q(o = g.refVal[s], a = O(t, o));
                    }
                    a = O(t);
                    var c = e.call(R, U, g, t);
                    if (void 0 === c) {
                        var u = y && y[t];
                        u && (c = e.inlineRef(u, V.inlineRefs) ? u : l.call(R, u, g, y, r));
                    }
                    if (void 0 !== c) return function(e, r) {
                        var t = _[e];
                        S[t] = r;
                    }(t, c), Q(c, a);
                    !function(e) {
                        delete _[e];
                    }(t);
                }
                function O(e, r) {
                    var t = S.length;
                    return S[t] = r, _[e] = t, "refVal" + t;
                }
                function Q(e, r) {
                    return "object" == typeof e || "boolean" == typeof e ? {
                        code: r,
                        schema: e,
                        inline: !0
                    } : {
                        code: r,
                        $async: e && !!e.$async
                    };
                }
                function T(e) {
                    var r = E[e];
                    return void 0 === r && (r = E[e] = b.length, b[r] = e), "pattern" + r;
                }
                function D(e) {
                    switch(typeof e){
                        case "boolean":
                        case "number":
                            return "" + e;
                        case "string":
                            return r.toQuotedString(e);
                        case "object":
                            if (null === e) return "null";
                            var t = i(e), o = j[t];
                            return void 0 === o && (o = j[t] = q.length, q[o] = e), "default" + o;
                    }
                }
                function F(e, r, t, i) {
                    if (!1 !== R._opts.validateSchema) {
                        var o = e.definition.dependencies;
                        if (o && !o.every(function(e) {
                            return Object.prototype.hasOwnProperty.call(t, e);
                        })) throw new Error("parent schema must have all required keywords: " + o.join(","));
                        var a = e.definition.validateSchema;
                        if (a) {
                            if (!a(r)) {
                                var n = "keyword schema is invalid: " + R.errorsText(a.errors);
                                if ("log" != R._opts.validateSchema) throw new Error(n);
                                R.logger.error(n);
                            }
                        }
                    }
                    var s, l = e.definition.compile, c = e.definition.inline, u = e.definition.macro;
                    if (l) s = l.call(R, r, t, i);
                    else if (u) s = u.call(R, r, t, i), !1 !== V.validateSchema && R.validateSchema(s, !0);
                    else if (c) s = c.call(R, i, e.keyword, r, t);
                    else if (!(s = e.definition.validate)) return;
                    if (void 0 === s) throw new Error('custom keyword "' + e.keyword + '"failed to compile');
                    var f = x.length;
                    return x[f] = s, {
                        code: "customRule" + f,
                        validate: s
                    };
                }
            }
            function c(e, r, t) {
                var i = f.call(this, e, r, t);
                return i >= 0 ? {
                    index: i,
                    compiling: !0
                } : (i = this._compilations.length, this._compilations[i] = {
                    schema: e,
                    root: r,
                    baseId: t
                }, {
                    index: i,
                    compiling: !1
                });
            }
            function u(e, r, t) {
                var i = f.call(this, e, r, t);
                i >= 0 && this._compilations.splice(i, 1);
            }
            function f(e, r, t) {
                for(var i = 0; i < this._compilations.length; i++){
                    var o = this._compilations[i];
                    if (o.schema == e && o.root == r && o.baseId == t) return i;
                }
                return -1;
            }
            function d(e, t) {
                return "var pattern" + e + " = new RegExp(" + r.toQuotedString(t[e]) + ");";
            }
            function v(e) {
                return "var default" + e + " = defaults[" + e + "];";
            }
            function h(e, r) {
                return void 0 === r[e] ? "" : "var refVal" + e + " = refVal[" + e + "];";
            }
            function m(e) {
                return "var customRule" + e + " = customRules[" + e + "];";
            }
            function p(e, r) {
                if (!e.length) return "";
                for(var t = "", i = 0; i < e.length; i++)t += r(i, e);
                return t;
            }
            module1.exports = l;
        },
        {
            "./resolve": "w10T",
            "./util": "Q1F7",
            "./error_classes": "OtNE",
            "fast-json-stable-stringify": "Xb3N",
            "../dotjs/validate": "yhC1",
            "fast-deep-equal": "dPQH"
        }
    ],
    "fXCy": [
        function(require1, module1, exports) {
            "use strict";
            var t = module1.exports = function() {
                this._cache = {};
            };
            t.prototype.put = function(t, e) {
                this._cache[t] = e;
            }, t.prototype.get = function(t) {
                return this._cache[t];
            }, t.prototype.del = function(t) {
                delete this._cache[t];
            }, t.prototype.clear = function() {
                this._cache = {};
            };
        },
        {}
    ],
    "dfAH": [
        function(require1, module1, exports) {
            "use strict";
            var d = require1("./util"), a = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, u = [
                0,
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ], F = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i, f = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i, D = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, t = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, r = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, e = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, i = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, z = /^(?:\/(?:[^~/]|~0|~1)*)*$/, $ = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, n = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
            function s(a) {
                return a = "full" == a ? "full" : "fast", d.copy(s[a]);
            }
            function x(d) {
                return d % 4 == 0 && (d % 100 != 0 || d % 400 == 0);
            }
            function _(d) {
                var F = d.match(a);
                if (!F) return !1;
                var f = +F[1], D = +F[2], t = +F[3];
                return D >= 1 && D <= 12 && t >= 1 && t <= (2 == D && x(f) ? 29 : u[D]);
            }
            function o(d, a) {
                var u = d.match(F);
                if (!u) return !1;
                var f = u[1], D = u[2], t = u[3], r = u[5];
                return (f <= 23 && D <= 59 && t <= 59 || 23 == f && 59 == D && 60 == t) && (!a || r);
            }
            module1.exports = s, s.fast = {
                date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
                time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
                "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
                uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
                "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
                "uri-template": r,
                url: e,
                email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
                hostname: f,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: v,
                uuid: i,
                "json-pointer": z,
                "json-pointer-uri-fragment": $,
                "relative-json-pointer": n
            }, s.full = {
                date: _,
                time: o,
                "date-time": B,
                uri: l,
                "uri-reference": t,
                "uri-template": r,
                url: e,
                email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
                hostname: f,
                ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
                ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
                regex: v,
                uuid: i,
                "json-pointer": z,
                "json-pointer-uri-fragment": $,
                "relative-json-pointer": n
            };
            var E = /t|\s/i;
            function B(d) {
                var a = d.split(E);
                return 2 == a.length && _(a[0]) && o(a[1], !0);
            }
            var C = /\/|:/;
            function l(d) {
                return C.test(d) && D.test(d);
            }
            var p = /[^\\]\\Z/;
            function v(d) {
                if (p.test(d)) return !1;
                try {
                    return new RegExp(d), !0;
                } catch (a) {
                    return !1;
                }
            }
        },
        {
            "./util": "Q1F7"
        }
    ],
    "a2na": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r, e, a) {
                var s, t, o = " ", i = r.level, l = r.dataLevel, c = r.schema[e], n = r.errSchemaPath + "/" + e, h = !r.opts.allErrors, v = "data" + (l || ""), f = "valid" + i;
                if ("#" == c || "#/" == c) r.isRoot ? (s = r.async, t = "validate") : (s = !0 === r.root.schema.$async, t = "root.refVal[0]");
                else {
                    var d = r.resolveRef(r.baseId, c, r.isRoot);
                    if (void 0 === d) {
                        var p = r.MissingRefError.message(r.baseId, c);
                        if ("fail" == r.opts.missingRefs) {
                            r.logger.error(p), (g = g || []).push(o), o = "", !1 !== r.createErrors ? (o += " { keyword: '$ref' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(n) + " , params: { ref: '" + r.util.escapeQuotes(c) + "' } ", !1 !== r.opts.messages && (o += " , message: 'can\\'t resolve reference " + r.util.escapeQuotes(c) + "' "), r.opts.verbose && (o += " , schema: " + r.util.toQuotedString(c) + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + v + " "), o += " } ") : o += " {} ";
                            var m = o;
                            o = g.pop(), !r.compositeRule && h ? r.async ? o += " throw new ValidationError([" + m + "]); " : o += " validate.errors = [" + m + "]; return false; " : o += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h && (o += " if (false) { ");
                        } else {
                            if ("ignore" != r.opts.missingRefs) throw new r.MissingRefError(r.baseId, c, p);
                            r.logger.warn(p), h && (o += " if (true) { ");
                        }
                    } else if (d.inline) {
                        var u = r.util.copy(r);
                        u.level++;
                        var E = "valid" + u.level;
                        u.schema = d.schema, u.schemaPath = "", u.errSchemaPath = c, o += " " + r.validate(u).replace(/validate\.schema/g, d.code) + " ", h && (o += " if (" + E + ") { ");
                    } else s = !0 === d.$async || r.async && !1 !== d.$async, t = d.code;
                }
                if (t) {
                    var g;
                    (g = g || []).push(o), o = "", r.opts.passContext ? o += " " + t + ".call(this, " : o += " " + t + "( ", o += " " + v + ", (dataPath || '')", '""' != r.errorPath && (o += " + " + r.errorPath);
                    var y = o += " , " + (l ? "data" + (l - 1 || "") : "parentData") + " , " + (l ? r.dataPathArr[l] : "parentDataProperty") + ", rootData)  ";
                    if (o = g.pop(), s) {
                        if (!r.async) throw new Error("async schema referenced by sync schema");
                        h && (o += " var " + f + "; "), o += " try { await " + y + "; ", h && (o += " " + f + " = true; "), o += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", h && (o += " " + f + " = false; "), o += " } ", h && (o += " if (" + f + ") { ");
                    } else o += " if (!" + y + ") { if (vErrors === null) vErrors = " + t + ".errors; else vErrors = vErrors.concat(" + t + ".errors); errors = vErrors.length; } ", h && (o += " else { ");
                }
                return o;
            };
        },
        {}
    ],
    "hRgn": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, t, a) {
                var r = " ", s = e.schema[t], l = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, h = !e.opts.allErrors, i = e.util.copy(e), o = "";
                i.level++;
                var u = "valid" + i.level, m = i.baseId, v = !0, d = s;
                if (d) for(var f, p = -1, n = d.length - 1; p < n;)f = d[p += 1], (e.opts.strictKeywords ? "object" == typeof f && Object.keys(f).length > 0 || !1 === f : e.util.schemaHasRules(f, e.RULES.all)) && (v = !1, i.schema = f, i.schemaPath = l + "[" + p + "]", i.errSchemaPath = c + "/" + p, r += "  " + e.validate(i) + " ", i.baseId = m, h && (r += " if (" + u + ") { ", o += "}"));
                return h && (r += v ? " if (true) { " : " " + o.slice(0, -1) + " "), r;
            };
        },
        {}
    ],
    "lo6J": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var s = " ", t = e.level, o = e.dataLevel, l = e.schema[r], i = e.schemaPath + e.util.getProperty(r), c = e.errSchemaPath + "/" + r, h = !e.opts.allErrors, v = "data" + (o || ""), m = "valid" + t, u = "errs__" + t, n = e.util.copy(e), d = "";
                n.level++;
                var p = "valid" + n.level;
                if (l.every(function(r) {
                    return e.opts.strictKeywords ? "object" == typeof r && Object.keys(r).length > 0 || !1 === r : e.util.schemaHasRules(r, e.RULES.all);
                })) {
                    var f = n.baseId;
                    s += " var " + u + " = errors; var " + m + " = false;  ";
                    var E = e.compositeRule;
                    e.compositeRule = n.compositeRule = !0;
                    var y = l;
                    if (y) for(var P, R = -1, g = y.length - 1; R < g;)P = y[R += 1], n.schema = P, n.schemaPath = i + "[" + R + "]", n.errSchemaPath = c + "/" + R, s += "  " + e.validate(n) + " ", n.baseId = f, s += " " + m + " = " + m + " || " + p + "; if (!" + m + ") { ", d += "}";
                    e.compositeRule = n.compositeRule = E, s += " " + d + " if (!" + m + ") {   var err =   ", !1 !== e.createErrors ? (s += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", !1 !== e.opts.messages && (s += " , message: 'should match some schema in anyOf' "), e.opts.verbose && (s += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && h && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; "), s += " } else {  errors = " + u + "; if (vErrors !== null) { if (" + u + ") vErrors.length = " + u + "; else vErrors = null; } ", e.opts.allErrors && (s += " } ");
                } else h && (s += " if (true) { ");
                return s;
            };
        },
        {}
    ],
    "Kkzr": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(t, o, e) {
                var r = " ", s = t.schema[o], n = t.errSchemaPath + "/" + o, c = (t.opts.allErrors, t.util.toQuotedString(s));
                return !0 === t.opts.$comment ? r += " console.log(" + c + ");" : "function" == typeof t.opts.$comment && (r += " self._opts.$comment(" + c + ", " + t.util.toQuotedString(n) + ", validate.root.schema);"), r;
            };
        },
        {}
    ],
    "U4sD": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(a, e, r) {
                var t = " ", s = a.level, o = a.dataLevel, l = a.schema[e], h = a.schemaPath + a.util.getProperty(e), c = a.errSchemaPath + "/" + e, d = !a.opts.allErrors, m = "data" + (o || ""), v = "valid" + s, u = a.opts.$data && l && l.$data;
                u && (t += " var schema" + s + " = " + a.util.getData(l.$data, o, a.dataPathArr) + "; "), u || (t += " var schema" + s + " = validate.schema" + h + ";"), t += "var " + v + " = equal(" + m + ", schema" + s + "); if (!" + v + ") {   ";
                var i = i || [];
                i.push(t), t = "", !1 !== a.createErrors ? (t += " { keyword: 'const' , dataPath: (dataPath || '') + " + a.errorPath + " , schemaPath: " + a.util.toQuotedString(c) + " , params: { allowedValue: schema" + s + " } ", !1 !== a.opts.messages && (t += " , message: 'should be equal to constant' "), a.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + a.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                var n = t;
                return t = i.pop(), !a.compositeRule && d ? a.async ? t += " throw new ValidationError([" + n + "]); " : t += " validate.errors = [" + n + "]; return false; " : t += " var err = " + n + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " }", d && (t += " else { "), t;
            };
        },
        {}
    ],
    "EypH": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t = " ", s = e.level, l = e.dataLevel, o = e.schema[r], i = e.schemaPath + e.util.getProperty(r), v = e.errSchemaPath + "/" + r, h = !e.opts.allErrors, c = "data" + (l || ""), u = "valid" + s, d = "errs__" + s, m = e.util.copy(e);
                m.level++;
                var p = "valid" + m.level, n = "i" + s, P = m.dataLevel = e.dataLevel + 1, f = "data" + P, E = e.baseId, g = e.opts.strictKeywords ? "object" == typeof o && Object.keys(o).length > 0 || !1 === o : e.util.schemaHasRules(o, e.RULES.all);
                if (t += "var " + d + " = errors;var " + u + ";", g) {
                    var R = e.compositeRule;
                    e.compositeRule = m.compositeRule = !0, m.schema = o, m.schemaPath = i, m.errSchemaPath = v, t += " var " + p + " = false; for (var " + n + " = 0; " + n + " < " + c + ".length; " + n + "++) { ", m.errorPath = e.util.getPathExpr(e.errorPath, n, e.opts.jsonPointers, !0);
                    var y = c + "[" + n + "]";
                    m.dataPathArr[P] = n;
                    var b = e.validate(m);
                    m.baseId = E, e.util.varOccurences(b, f) < 2 ? t += " " + e.util.varReplace(b, f, y) + " " : t += " var " + f + " = " + y + "; " + b + " ", t += " if (" + p + ") break; }  ", e.compositeRule = m.compositeRule = R, t += "  if (!" + p + ") {";
                } else t += " if (" + c + ".length == 0) {";
                var S = S || [];
                S.push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(v) + " , params: {} ", !1 !== e.opts.messages && (t += " , message: 'should contain a valid item' "), e.opts.verbose && (t += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + c + " "), t += " } ") : t += " {} ";
                var w = t;
                return t = S.pop(), !e.compositeRule && h ? e.async ? t += " throw new ValidationError([" + w + "]); " : t += " validate.errors = [" + w + "]; return false; " : t += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } else { ", g && (t += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; } "), e.opts.allErrors && (t += " } "), t;
            };
        },
        {}
    ],
    "Cpp7": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, t) {
                var a = " ", s = e.level, o = e.dataLevel, p = e.schema[r], i = e.schemaPath + e.util.getProperty(r), l = e.errSchemaPath + "/" + r, u = !e.opts.allErrors, n = "data" + (o || ""), h = "errs__" + s, c = e.util.copy(e), d = "";
                c.level++;
                var v = "valid" + c.level, P = {}, m = {}, y = e.opts.ownProperties;
                for(j in p)if ("__proto__" != j) {
                    var g = p[j], f = Array.isArray(g) ? m : P;
                    f[j] = g;
                }
                a += "var " + h + " = errors;";
                var Q = e.errorPath;
                for(var j in a += "var missing" + s + ";", m)if ((f = m[j]).length) {
                    if (a += " if ( " + n + e.util.getProperty(j) + " !== undefined ", y && (a += " && Object.prototype.hasOwnProperty.call(" + n + ", '" + e.util.escapeQuotes(j) + "') "), u) {
                        a += " && ( ";
                        var w = f;
                        if (w) for(var E = -1, b = w.length - 1; E < b;)x = w[E += 1], E && (a += " || "), a += " ( ( " + (I = n + (D = e.util.getProperty(x))) + " === undefined ", y && (a += " || ! Object.prototype.hasOwnProperty.call(" + n + ", '" + e.util.escapeQuotes(x) + "') "), a += ") && (missing" + s + " = " + e.util.toQuotedString(e.opts.jsonPointers ? x : D) + ") ) ";
                        a += ")) {  ";
                        var O = "missing" + s, S = "' + " + O + " + '";
                        e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(Q, O, !0) : Q + " + " + O);
                        var _ = _ || [];
                        _.push(a), a = "", !1 !== e.createErrors ? (a += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { property: '" + e.util.escapeQuotes(j) + "', missingProperty: '" + S + "', depsCount: " + f.length + ", deps: '" + e.util.escapeQuotes(1 == f.length ? f[0] : f.join(", ")) + "' } ", !1 !== e.opts.messages && (a += " , message: 'should have ", 1 == f.length ? a += "property " + e.util.escapeQuotes(f[0]) : a += "properties " + e.util.escapeQuotes(f.join(", ")), a += " when property " + e.util.escapeQuotes(j) + " is present' "), e.opts.verbose && (a += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + n + " "), a += " } ") : a += " {} ";
                        var k = a;
                        a = _.pop(), !e.compositeRule && u ? e.async ? a += " throw new ValidationError([" + k + "]); " : a += " validate.errors = [" + k + "]; return false; " : a += " var err = " + k + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    } else {
                        a += " ) { ";
                        var R = f;
                        if (R) for(var x, A = -1, C = R.length - 1; A < C;){
                            x = R[A += 1];
                            var D = e.util.getProperty(x), I = (S = e.util.escapeQuotes(x), n + D);
                            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(Q, x, e.opts.jsonPointers)), a += " if ( " + I + " === undefined ", y && (a += " || ! Object.prototype.hasOwnProperty.call(" + n + ", '" + e.util.escapeQuotes(x) + "') "), a += ") {  var err =   ", !1 !== e.createErrors ? (a += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { property: '" + e.util.escapeQuotes(j) + "', missingProperty: '" + S + "', depsCount: " + f.length + ", deps: '" + e.util.escapeQuotes(1 == f.length ? f[0] : f.join(", ")) + "' } ", !1 !== e.opts.messages && (a += " , message: 'should have ", 1 == f.length ? a += "property " + e.util.escapeQuotes(f[0]) : a += "properties " + e.util.escapeQuotes(f.join(", ")), a += " when property " + e.util.escapeQuotes(j) + " is present' "), e.opts.verbose && (a += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + n + " "), a += " } ") : a += " {} ", a += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    a += " }   ", u && (d += "}", a += " else { ");
                }
                e.errorPath = Q;
                var L = c.baseId;
                for(var j in P){
                    g = P[j];
                    (e.opts.strictKeywords ? "object" == typeof g && Object.keys(g).length > 0 || !1 === g : e.util.schemaHasRules(g, e.RULES.all)) && (a += " " + v + " = true; if ( " + n + e.util.getProperty(j) + " !== undefined ", y && (a += " && Object.prototype.hasOwnProperty.call(" + n + ", '" + e.util.escapeQuotes(j) + "') "), a += ") { ", c.schema = g, c.schemaPath = i + e.util.getProperty(j), c.errSchemaPath = l + "/" + e.util.escapeFragment(j), a += "  " + e.validate(c) + " ", c.baseId = L, a += " }  ", u && (a += " if (" + v + ") { ", d += "}"));
                }
                return u && (a += "   " + d + " if (" + h + " == errors) {"), a;
            };
        },
        {}
    ],
    "fqDY": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(a, e, r) {
                var t = " ", s = a.level, l = a.dataLevel, o = a.schema[e], h = a.schemaPath + a.util.getProperty(e), d = a.errSchemaPath + "/" + e, i = !a.opts.allErrors, u = "data" + (l || ""), m = "valid" + s, v = a.opts.$data && o && o.$data;
                v && (t += " var schema" + s + " = " + a.util.getData(o.$data, l, a.dataPathArr) + "; ");
                var c = "i" + s, n = "schema" + s;
                v || (t += " var " + n + " = validate.schema" + h + ";"), t += "var " + m + ";", v && (t += " if (schema" + s + " === undefined) " + m + " = true; else if (!Array.isArray(schema" + s + ")) " + m + " = false; else {"), t += m + " = false;for (var " + c + "=0; " + c + "<" + n + ".length; " + c + "++) if (equal(" + u + ", " + n + "[" + c + "])) { " + m + " = true; break; }", v && (t += "  }  "), t += " if (!" + m + ") {   ";
                var p = p || [];
                p.push(t), t = "", !1 !== a.createErrors ? (t += " { keyword: 'enum' , dataPath: (dataPath || '') + " + a.errorPath + " , schemaPath: " + a.util.toQuotedString(d) + " , params: { allowedValues: schema" + s + " } ", !1 !== a.opts.messages && (t += " , message: 'should be equal to one of the allowed values' "), a.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + a.schemaPath + " , data: " + u + " "), t += " } ") : t += " {} ";
                var f = t;
                return t = p.pop(), !a.compositeRule && i ? a.async ? t += " throw new ValidationError([" + f + "]); " : t += " validate.errors = [" + f + "]; return false; " : t += " var err = " + f + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " }", i && (t += " else { "), t;
            };
        },
        {}
    ],
    "avoW": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(a, t, r) {
                var e = " ", o = a.level, s = a.dataLevel, i = a.schema[t], n = a.schemaPath + a.util.getProperty(t), f = a.errSchemaPath + "/" + t, c = !a.opts.allErrors, u = "data" + (s || "");
                if (!1 === a.opts.format) return c && (e += " if (true) { "), e;
                var m, h = a.opts.$data && i && i.$data;
                h ? (e += " var schema" + o + " = " + a.util.getData(i.$data, s, a.dataPathArr) + "; ", m = "schema" + o) : m = i;
                var l = a.opts.unknownFormats, d = Array.isArray(l);
                if (h) e += " var " + (p = "format" + o) + " = formats[" + m + "]; var " + (v = "isObject" + o) + " = typeof " + p + " == 'object' && !(" + p + " instanceof RegExp) && " + p + ".validate; var " + (y = "formatType" + o) + " = " + v + " && " + p + ".type || 'string'; if (" + v + ") { ", a.async && (e += " var async" + o + " = " + p + ".async; "), e += " " + p + " = " + p + ".validate; } if (  ", h && (e += " (" + m + " !== undefined && typeof " + m + " != 'string') || "), e += " (", "ignore" != l && (e += " (" + m + " && !" + p + " ", d && (e += " && self._opts.unknownFormats.indexOf(" + m + ") == -1 "), e += ") || "), e += " (" + p + " && " + y + " == '" + r + "' && !(typeof " + p + " == 'function' ? ", a.async ? e += " (async" + o + " ? await " + p + "(" + u + ") : " + p + "(" + u + ")) " : e += " " + p + "(" + u + ") ", e += " : " + p + ".test(" + u + "))))) {";
                else {
                    var p;
                    if (!(p = a.formats[i])) {
                        if ("ignore" == l) return a.logger.warn('unknown format "' + i + '" ignored in schema at path "' + a.errSchemaPath + '"'), c && (e += " if (true) { "), e;
                        if (d && l.indexOf(i) >= 0) return c && (e += " if (true) { "), e;
                        throw new Error('unknown format "' + i + '" is used in schema at path "' + a.errSchemaPath + '"');
                    }
                    var v, y = (v = "object" == typeof p && !(p instanceof RegExp) && p.validate) && p.type || "string";
                    if (v) {
                        var g = !0 === p.async;
                        p = p.validate;
                    }
                    if (y != r) return c && (e += " if (true) { "), e;
                    if (g) {
                        if (!a.async) throw new Error("async format in sync schema");
                        e += " if (!(await " + (w = "formats" + a.util.getProperty(i) + ".validate") + "(" + u + "))) { ";
                    } else {
                        e += " if (! ";
                        var w = "formats" + a.util.getProperty(i);
                        v && (w += ".validate"), e += "function" == typeof p ? " " + w + "(" + u + ") " : " " + w + ".test(" + u + ") ", e += ") { ";
                    }
                }
                var P = P || [];
                P.push(e), e = "", !1 !== a.createErrors ? (e += " { keyword: 'format' , dataPath: (dataPath || '') + " + a.errorPath + " , schemaPath: " + a.util.toQuotedString(f) + " , params: { format:  ", e += h ? "" + m : "" + a.util.toQuotedString(i), e += "  } ", !1 !== a.opts.messages && (e += " , message: 'should match format \"", e += h ? "' + " + m + " + '" : "" + a.util.escapeQuotes(i), e += "\"' "), a.opts.verbose && (e += " , schema:  ", e += h ? "validate.schema" + n : "" + a.util.toQuotedString(i), e += "         , parentSchema: validate.schema" + a.schemaPath + " , data: " + u + " "), e += " } ") : e += " {} ";
                var E = e;
                return e = P.pop(), !a.compositeRule && c ? a.async ? e += " throw new ValidationError([" + E + "]); " : e += " validate.errors = [" + E + "]; return false; " : e += " var err = " + E + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", e += " } ", c && (e += " else { "), e;
            };
        },
        {}
    ],
    "JHQ3": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var s = " ", t = e.level, l = e.dataLevel, h = e.schema[r], o = e.schemaPath + e.util.getProperty(r), c = e.errSchemaPath + "/" + r, i = !e.opts.allErrors, m = "data" + (l || ""), v = "valid" + t, u = "errs__" + t, d = e.util.copy(e);
                d.level++;
                var n = "valid" + d.level, p = e.schema.then, P = e.schema.else, f = void 0 !== p && (e.opts.strictKeywords ? "object" == typeof p && Object.keys(p).length > 0 || !1 === p : e.util.schemaHasRules(p, e.RULES.all)), E = void 0 !== P && (e.opts.strictKeywords ? "object" == typeof P && Object.keys(P).length > 0 || !1 === P : e.util.schemaHasRules(P, e.RULES.all)), y = d.baseId;
                if (f || E) {
                    var R;
                    d.createErrors = !1, d.schema = h, d.schemaPath = o, d.errSchemaPath = c, s += " var " + u + " = errors; var " + v + " = true;  ";
                    var S = e.compositeRule;
                    e.compositeRule = d.compositeRule = !0, s += "  " + e.validate(d) + " ", d.baseId = y, d.createErrors = !0, s += "  errors = " + u + "; if (vErrors !== null) { if (" + u + ") vErrors.length = " + u + "; else vErrors = null; }  ", e.compositeRule = d.compositeRule = S, f ? (s += " if (" + n + ") {  ", d.schema = e.schema.then, d.schemaPath = e.schemaPath + ".then", d.errSchemaPath = e.errSchemaPath + "/then", s += "  " + e.validate(d) + " ", d.baseId = y, s += " " + v + " = " + n + "; ", f && E ? s += " var " + (R = "ifClause" + t) + " = 'then'; " : R = "'then'", s += " } ", E && (s += " else { ")) : s += " if (!" + n + ") { ", E && (d.schema = e.schema.else, d.schemaPath = e.schemaPath + ".else", d.errSchemaPath = e.errSchemaPath + "/else", s += "  " + e.validate(d) + " ", d.baseId = y, s += " " + v + " = " + n + "; ", f && E ? s += " var " + (R = "ifClause" + t) + " = 'else'; " : R = "'else'", s += " } "), s += " if (!" + v + ") {   var err =   ", !1 !== e.createErrors ? (s += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { failingKeyword: " + R + " } ", !1 !== e.opts.messages && (s += " , message: 'should match \"' + " + R + " + '\" schema' "), e.opts.verbose && (s += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && i && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; "), s += " }   ", i && (s += " else { ");
                } else i && (s += " if (true) { ");
                return s;
            };
        },
        {}
    ],
    "aiPb": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, a, r) {
                var t = " ", s = e.level, l = e.dataLevel, h = e.schema[a], o = e.schemaPath + e.util.getProperty(a), i = e.errSchemaPath + "/" + a, c = !e.opts.allErrors, v = "data" + (l || ""), d = "valid" + s, n = "errs__" + s, m = e.util.copy(e), u = "";
                m.level++;
                var P = "valid" + m.level, p = "i" + s, f = m.dataLevel = e.dataLevel + 1, g = "data" + f, y = e.baseId;
                if (t += "var " + n + " = errors;var " + d + ";", Array.isArray(h)) {
                    var b = e.schema.additionalItems;
                    if (!1 === b) {
                        t += " " + d + " = " + v + ".length <= " + h.length + "; ";
                        var E = i;
                        i = e.errSchemaPath + "/additionalItems", t += "  if (!" + d + ") {   ";
                        var S = S || [];
                        S.push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(i) + " , params: { limit: " + h.length + " } ", !1 !== e.opts.messages && (t += " , message: 'should NOT have more than " + h.length + " items' "), e.opts.verbose && (t += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), t += " } ") : t += " {} ";
                        var j = t;
                        t = S.pop(), !e.compositeRule && c ? e.async ? t += " throw new ValidationError([" + j + "]); " : t += " validate.errors = [" + j + "]; return false; " : t += " var err = " + j + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } ", i = E, c && (u += "}", t += " else { ");
                    }
                    var R = h;
                    if (R) {
                        for(var I, O = -1, k = R.length - 1; O < k;)if (I = R[O += 1], e.opts.strictKeywords ? "object" == typeof I && Object.keys(I).length > 0 || !1 === I : e.util.schemaHasRules(I, e.RULES.all)) {
                            t += " " + P + " = true; if (" + v + ".length > " + O + ") { ";
                            var w = v + "[" + O + "]";
                            m.schema = I, m.schemaPath = o + "[" + O + "]", m.errSchemaPath = i + "/" + O, m.errorPath = e.util.getPathExpr(e.errorPath, O, e.opts.jsonPointers, !0), m.dataPathArr[f] = O;
                            var L = e.validate(m);
                            m.baseId = y, e.util.varOccurences(L, g) < 2 ? t += " " + e.util.varReplace(L, g, w) + " " : t += " var " + g + " = " + w + "; " + L + " ", t += " }  ", c && (t += " if (" + P + ") { ", u += "}");
                        }
                    }
                    if ("object" == typeof b && (e.opts.strictKeywords ? "object" == typeof b && Object.keys(b).length > 0 || !1 === b : e.util.schemaHasRules(b, e.RULES.all))) {
                        m.schema = b, m.schemaPath = e.schemaPath + ".additionalItems", m.errSchemaPath = e.errSchemaPath + "/additionalItems", t += " " + P + " = true; if (" + v + ".length > " + h.length + ") {  for (var " + p + " = " + h.length + "; " + p + " < " + v + ".length; " + p + "++) { ", m.errorPath = e.util.getPathExpr(e.errorPath, p, e.opts.jsonPointers, !0);
                        w = v + "[" + p + "]";
                        m.dataPathArr[f] = p;
                        L = e.validate(m);
                        m.baseId = y, e.util.varOccurences(L, g) < 2 ? t += " " + e.util.varReplace(L, g, w) + " " : t += " var " + g + " = " + w + "; " + L + " ", c && (t += " if (!" + P + ") break; "), t += " } }  ", c && (t += " if (" + P + ") { ", u += "}");
                    }
                } else if (e.opts.strictKeywords ? "object" == typeof h && Object.keys(h).length > 0 || !1 === h : e.util.schemaHasRules(h, e.RULES.all)) {
                    m.schema = h, m.schemaPath = o, m.errSchemaPath = i, t += "  for (var " + p + " = 0; " + p + " < " + v + ".length; " + p + "++) { ", m.errorPath = e.util.getPathExpr(e.errorPath, p, e.opts.jsonPointers, !0);
                    w = v + "[" + p + "]";
                    m.dataPathArr[f] = p;
                    L = e.validate(m);
                    m.baseId = y, e.util.varOccurences(L, g) < 2 ? t += " " + e.util.varReplace(L, g, w) + " " : t += " var " + g + " = " + w + "; " + L + " ", c && (t += " if (!" + P + ") break; "), t += " }";
                }
                return c && (t += " " + u + " if (" + n + " == errors) {"), t;
            };
        },
        {}
    ],
    "UJAl": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t, s = " ", o = e.level, i = e.dataLevel, m = e.schema[r], h = e.schemaPath + e.util.getProperty(r), u = e.errSchemaPath + "/" + r, l = !e.opts.allErrors, d = "data" + (i || ""), n = e.opts.$data && m && m.$data;
                n ? (s += " var schema" + o + " = " + e.util.getData(m.$data, i, e.dataPathArr) + "; ", t = "schema" + o) : t = m;
                var c = "maximum" == r, v = c ? "exclusiveMaximum" : "exclusiveMinimum", p = e.schema[v], f = e.opts.$data && p && p.$data, b = c ? "<" : ">", P = c ? ">" : "<", E = void 0;
                if (!n && "number" != typeof m && void 0 !== m) throw new Error(r + " must be number");
                if (!f && void 0 !== p && "number" != typeof p && "boolean" != typeof p) throw new Error(v + " must be number or boolean");
                if (f) {
                    var y = e.util.getData(p.$data, i, e.dataPathArr), x = "exclusive" + o, w = "exclType" + o, g = "exclIsNumber" + o, S = "' + " + (k = "op" + o) + " + '";
                    s += " var schemaExcl" + o + " = " + y + "; ", s += " var " + x + "; var " + w + " = typeof " + (y = "schemaExcl" + o) + "; if (" + w + " != 'boolean' && " + w + " != 'undefined' && " + w + " != 'number') { ";
                    var $;
                    E = v;
                    ($ = $ || []).push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (E || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", !1 !== e.opts.messages && (s += " , message: '" + v + " should be boolean' "), e.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), s += " } ") : s += " {} ";
                    var M = s;
                    s = $.pop(), !e.compositeRule && l ? e.async ? s += " throw new ValidationError([" + M + "]); " : s += " validate.errors = [" + M + "]; return false; " : s += " var err = " + M + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += " } else if ( ", n && (s += " (" + t + " !== undefined && typeof " + t + " != 'number') || "), s += " " + w + " == 'number' ? ( (" + x + " = " + t + " === undefined || " + y + " " + b + "= " + t + ") ? " + d + " " + P + "= " + y + " : " + d + " " + P + " " + t + " ) : ( (" + x + " = " + y + " === true) ? " + d + " " + P + "= " + t + " : " + d + " " + P + " " + t + " ) || " + d + " !== " + d + ") { var op" + o + " = " + x + " ? '" + b + "' : '" + b + "='; ", void 0 === m && (E = v, u = e.errSchemaPath + "/" + v, t = y, n = f);
                } else {
                    S = b;
                    if ((g = "number" == typeof p) && n) {
                        var k = "'" + S + "'";
                        s += " if ( ", n && (s += " (" + t + " !== undefined && typeof " + t + " != 'number') || "), s += " ( " + t + " === undefined || " + p + " " + b + "= " + t + " ? " + d + " " + P + "= " + p + " : " + d + " " + P + " " + t + " ) || " + d + " !== " + d + ") { ";
                    } else {
                        g && void 0 === m ? (x = !0, E = v, u = e.errSchemaPath + "/" + v, t = p, P += "=") : (g && (t = Math[c ? "min" : "max"](p, m)), p === (!g || t) ? (x = !0, E = v, u = e.errSchemaPath + "/" + v, P += "=") : (x = !1, S += "="));
                        k = "'" + S + "'";
                        s += " if ( ", n && (s += " (" + t + " !== undefined && typeof " + t + " != 'number') || "), s += " " + d + " " + P + " " + t + " || " + d + " !== " + d + ") { ";
                    }
                }
                E = E || r, ($ = $ || []).push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (E || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { comparison: " + k + ", limit: " + t + ", exclusive: " + x + " } ", !1 !== e.opts.messages && (s += " , message: 'should be " + S + " ", s += n ? "' + " + t : t + "'"), e.opts.verbose && (s += " , schema:  ", s += n ? "validate.schema" + h : "" + m, s += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), s += " } ") : s += " {} ";
                M = s;
                return s = $.pop(), !e.compositeRule && l ? e.async ? s += " throw new ValidationError([" + M + "]); " : s += " validate.errors = [" + M + "]; return false; " : s += " var err = " + M + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += " } ", l && (s += " else { "), s;
            };
        },
        {}
    ],
    "W8ih": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t, s = " ", o = e.level, m = e.dataLevel, h = e.schema[r], l = e.schemaPath + e.util.getProperty(r), i = e.errSchemaPath + "/" + r, d = !e.opts.allErrors, u = "data" + (m || ""), n = e.opts.$data && h && h.$data;
                if (n ? (s += " var schema" + o + " = " + e.util.getData(h.$data, m, e.dataPathArr) + "; ", t = "schema" + o) : t = h, !n && "number" != typeof h) throw new Error(r + " must be number");
                s += "if ( ", n && (s += " (" + t + " !== undefined && typeof " + t + " != 'number') || "), s += " " + u + ".length " + ("maxItems" == r ? ">" : "<") + " " + t + ") { ";
                var c = r, p = p || [];
                p.push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (c || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(i) + " , params: { limit: " + t + " } ", !1 !== e.opts.messages && (s += " , message: 'should NOT have ", s += "maxItems" == r ? "more" : "fewer", s += " than ", s += n ? "' + " + t + " + '" : "" + h, s += " items' "), e.opts.verbose && (s += " , schema:  ", s += n ? "validate.schema" + l : "" + h, s += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), s += " } ") : s += " {} ";
                var v = s;
                return s = p.pop(), !e.compositeRule && d ? e.async ? s += " throw new ValidationError([" + v + "]); " : s += " validate.errors = [" + v + "]; return false; " : s += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", d && (s += " else { "), s;
            };
        },
        {}
    ],
    "fZGX": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t, s = " ", o = e.level, h = e.dataLevel, l = e.schema[r], m = e.schemaPath + e.util.getProperty(r), n = e.errSchemaPath + "/" + r, i = !e.opts.allErrors, u = "data" + (h || ""), c = e.opts.$data && l && l.$data;
                if (c ? (s += " var schema" + o + " = " + e.util.getData(l.$data, h, e.dataPathArr) + "; ", t = "schema" + o) : t = l, !c && "number" != typeof l) throw new Error(r + " must be number");
                var d = "maxLength" == r ? ">" : "<";
                s += "if ( ", c && (s += " (" + t + " !== undefined && typeof " + t + " != 'number') || "), !1 === e.opts.unicode ? s += " " + u + ".length " : s += " ucs2length(" + u + ") ", s += " " + d + " " + t + ") { ";
                var p = r, v = v || [];
                v.push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (p || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(n) + " , params: { limit: " + t + " } ", !1 !== e.opts.messages && (s += " , message: 'should NOT be ", s += "maxLength" == r ? "longer" : "shorter", s += " than ", s += c ? "' + " + t + " + '" : "" + l, s += " characters' "), e.opts.verbose && (s += " , schema:  ", s += c ? "validate.schema" + m : "" + l, s += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + u + " "), s += " } ") : s += " {} ";
                var g = s;
                return s = v.pop(), !e.compositeRule && i ? e.async ? s += " throw new ValidationError([" + g + "]); " : s += " validate.errors = [" + g + "]; return false; " : s += " var err = " + g + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", i && (s += " else { "), s;
            };
        },
        {}
    ],
    "JAEr": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t, s = " ", o = e.level, h = e.dataLevel, m = e.schema[r], i = e.schemaPath + e.util.getProperty(r), l = e.errSchemaPath + "/" + r, p = !e.opts.allErrors, d = "data" + (h || ""), u = e.opts.$data && m && m.$data;
                if (u ? (s += " var schema" + o + " = " + e.util.getData(m.$data, h, e.dataPathArr) + "; ", t = "schema" + o) : t = m, !u && "number" != typeof m) throw new Error(r + " must be number");
                s += "if ( ", u && (s += " (" + t + " !== undefined && typeof " + t + " != 'number') || "), s += " Object.keys(" + d + ").length " + ("maxProperties" == r ? ">" : "<") + " " + t + ") { ";
                var n = r, c = c || [];
                c.push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: '" + (n || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { limit: " + t + " } ", !1 !== e.opts.messages && (s += " , message: 'should NOT have ", s += "maxProperties" == r ? "more" : "fewer", s += " than ", s += u ? "' + " + t + " + '" : "" + m, s += " properties' "), e.opts.verbose && (s += " , schema:  ", s += u ? "validate.schema" + i : "" + m, s += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), s += " } ") : s += " {} ";
                var v = s;
                return s = c.pop(), !e.compositeRule && p ? e.async ? s += " throw new ValidationError([" + v + "]); " : s += " validate.errors = [" + v + "]; return false; " : s += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", p && (s += " else { "), s;
            };
        },
        {}
    ],
    "oNPH": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t, s = " ", i = e.level, o = e.dataLevel, l = e.schema[r], d = e.schemaPath + e.util.getProperty(r), h = e.errSchemaPath + "/" + r, n = !e.opts.allErrors, m = "data" + (o || ""), u = e.opts.$data && l && l.$data;
                if (u ? (s += " var schema" + i + " = " + e.util.getData(l.$data, o, e.dataPathArr) + "; ", t = "schema" + i) : t = l, !u && "number" != typeof l) throw new Error(r + " must be number");
                s += "var division" + i + ";if (", u && (s += " " + t + " !== undefined && ( typeof " + t + " != 'number' || "), s += " (division" + i + " = " + m + " / " + t + ", ", e.opts.multipleOfPrecision ? s += " Math.abs(Math.round(division" + i + ") - division" + i + ") > 1e-" + e.opts.multipleOfPrecision + " " : s += " division" + i + " !== parseInt(division" + i + ") ", s += " ) ", u && (s += "  )  "), s += " ) {   ";
                var p = p || [];
                p.push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(h) + " , params: { multipleOf: " + t + " } ", !1 !== e.opts.messages && (s += " , message: 'should be multiple of ", s += u ? "' + " + t : t + "'"), e.opts.verbose && (s += " , schema:  ", s += u ? "validate.schema" + d : "" + l, s += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), s += " } ") : s += " {} ";
                var v = s;
                return s = p.pop(), !e.compositeRule && n ? e.async ? s += " throw new ValidationError([" + v + "]); " : s += " validate.errors = [" + v + "]; return false; " : s += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", n && (s += " else { "), s;
            };
        },
        {}
    ],
    "mmjm": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r, e, a) {
                var s = " ", t = r.level, o = r.dataLevel, l = r.schema[e], h = r.schemaPath + r.util.getProperty(e), c = r.errSchemaPath + "/" + e, i = !r.opts.allErrors, m = "data" + (o || ""), v = "errs__" + t, p = r.util.copy(r);
                p.level++;
                var u = "valid" + p.level;
                if (r.opts.strictKeywords ? "object" == typeof l && Object.keys(l).length > 0 || !1 === l : r.util.schemaHasRules(l, r.RULES.all)) {
                    p.schema = l, p.schemaPath = h, p.errSchemaPath = c, s += " var " + v + " = errors;  ";
                    var d, E = r.compositeRule;
                    r.compositeRule = p.compositeRule = !0, p.createErrors = !1, p.opts.allErrors && (d = p.opts.allErrors, p.opts.allErrors = !1), s += " " + r.validate(p) + " ", p.createErrors = !0, d && (p.opts.allErrors = d), r.compositeRule = p.compositeRule = E, s += " if (" + u + ") {   ";
                    var n = n || [];
                    n.push(s), s = "", !1 !== r.createErrors ? (s += " { keyword: 'not' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(c) + " , params: {} ", !1 !== r.opts.messages && (s += " , message: 'should NOT be valid' "), r.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + m + " "), s += " } ") : s += " {} ";
                    var P = s;
                    s = n.pop(), !r.compositeRule && i ? r.async ? s += " throw new ValidationError([" + P + "]); " : s += " validate.errors = [" + P + "]; return false; " : s += " var err = " + P + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += " } else {  errors = " + v + "; if (vErrors !== null) { if (" + v + ") vErrors.length = " + v + "; else vErrors = null; } ", r.opts.allErrors && (s += " } ");
                } else s += "  var err =   ", !1 !== r.createErrors ? (s += " { keyword: 'not' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(c) + " , params: {} ", !1 !== r.opts.messages && (s += " , message: 'should NOT be valid' "), r.opts.verbose && (s += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + m + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i && (s += " if (false) { ");
                return s;
            };
        },
        {}
    ],
    "SSWF": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var s = " ", t = e.level, l = e.dataLevel, o = e.schema[r], i = e.schemaPath + e.util.getProperty(r), c = e.errSchemaPath + "/" + r, h = !e.opts.allErrors, v = "data" + (l || ""), m = "valid" + t, u = "errs__" + t, n = e.util.copy(e), p = "";
                n.level++;
                var d = "valid" + n.level, f = n.baseId, E = "prevValid" + t, P = "passingSchemas" + t;
                s += "var " + u + " = errors , " + E + " = false , " + m + " = false , " + P + " = null; ";
                var g = e.compositeRule;
                e.compositeRule = n.compositeRule = !0;
                var y = o;
                if (y) for(var R, S = -1, b = y.length - 1; S < b;)R = y[S += 1], (e.opts.strictKeywords ? "object" == typeof R && Object.keys(R).length > 0 || !1 === R : e.util.schemaHasRules(R, e.RULES.all)) ? (n.schema = R, n.schemaPath = i + "[" + S + "]", n.errSchemaPath = c + "/" + S, s += "  " + e.validate(n) + " ", n.baseId = f) : s += " var " + d + " = true; ", S && (s += " if (" + d + " && " + E + ") { " + m + " = false; " + P + " = [" + P + ", " + S + "]; } else { ", p += "}"), s += " if (" + d + ") { " + m + " = " + E + " = true; " + P + " = " + S + "; }";
                return e.compositeRule = n.compositeRule = g, s += p + "if (!" + m + ") {   var err =   ", !1 !== e.createErrors ? (s += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { passingSchemas: " + P + " } ", !1 !== e.opts.messages && (s += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (s += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), s += " } ") : s += " {} ", s += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && h && (e.async ? s += " throw new ValidationError(vErrors); " : s += " validate.errors = vErrors; return false; "), s += "} else {  errors = " + u + "; if (vErrors !== null) { if (" + u + ") vErrors.length = " + u + "; else vErrors = null; }", e.opts.allErrors && (s += " } "), s;
            };
        },
        {}
    ],
    "mGZS": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, t, a) {
                var r, s = " ", o = e.level, h = e.dataLevel, l = e.schema[t], u = e.schemaPath + e.util.getProperty(t), d = e.errSchemaPath + "/" + t, i = !e.opts.allErrors, n = "data" + (h || ""), p = e.opts.$data && l && l.$data;
                p ? (s += " var schema" + o + " = " + e.util.getData(l.$data, h, e.dataPathArr) + "; ", r = "schema" + o) : r = l, s += "if ( ", p && (s += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), s += " !" + (p ? "(new RegExp(" + r + "))" : e.usePattern(l)) + ".test(" + n + ") ) {   ";
                var c = c || [];
                c.push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(d) + " , params: { pattern:  ", s += p ? "" + r : "" + e.util.toQuotedString(l), s += "  } ", !1 !== e.opts.messages && (s += " , message: 'should match pattern \"", s += p ? "' + " + r + " + '" : "" + e.util.escapeQuotes(l), s += "\"' "), e.opts.verbose && (s += " , schema:  ", s += p ? "validate.schema" + u : "" + e.util.toQuotedString(l), s += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + n + " "), s += " } ") : s += " {} ";
                var m = s;
                return s = c.pop(), !e.compositeRule && i ? e.async ? s += " throw new ValidationError([" + m + "]); " : s += " validate.errors = [" + m + "]; return false; " : s += " var err = " + m + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", s += "} ", i && (s += " else { "), s;
            };
        },
        {}
    ],
    "jFnx": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, t) {
                var a = " ", o = e.level, s = e.dataLevel, i = e.schema[r], l = e.schemaPath + e.util.getProperty(r), h = e.errSchemaPath + "/" + r, p = !e.opts.allErrors, d = "data" + (s || ""), n = "errs__" + o, c = e.util.copy(e), P = "";
                c.level++;
                var u = "valid" + c.level, v = "key" + o, f = "idx" + o, m = c.dataLevel = e.dataLevel + 1, g = "data" + m, y = "dataProperties" + o, b = Object.keys(i || {}).filter(x), j = e.schema.patternProperties || {}, O = Object.keys(j).filter(x), S = e.schema.additionalProperties, E = b.length || O.length, R = !1 === S, k = "object" == typeof S && Object.keys(S).length, w = e.opts.removeAdditional, _ = R || k || w, Q = e.opts.ownProperties, A = e.baseId, D = e.schema.required;
                if (D && (!e.opts.$data || !D.$data) && D.length < e.opts.loopRequired) var q = e.util.toHash(D);
                function x(e) {
                    return "__proto__" !== e;
                }
                if (a += "var " + n + " = errors;var " + u + " = true;", Q && (a += " var " + y + " = undefined;"), _) {
                    if (a += Q ? " " + y + " = " + y + " || Object.keys(" + d + "); for (var " + f + "=0; " + f + "<" + y + ".length; " + f + "++) { var " + v + " = " + y + "[" + f + "]; " : " for (var " + v + " in " + d + ") { ", E) {
                        if (a += " var isAdditional" + o + " = !(false ", b.length) {
                            if (b.length > 8) a += " || validate.schema" + l + ".hasOwnProperty(" + v + ") ";
                            else {
                                var I = b;
                                if (I) for(var L = -1, H = I.length - 1; L < H;)M = I[L += 1], a += " || " + v + " == " + e.util.toQuotedString(M) + " ";
                            }
                        }
                        if (O.length) {
                            var F = O;
                            if (F) for(var K = -1, U = F.length - 1; K < U;)se = F[K += 1], a += " || " + e.usePattern(se) + ".test(" + v + ") ";
                        }
                        a += " ); if (isAdditional" + o + ") { ";
                    }
                    if ("all" == w) a += " delete " + d + "[" + v + "]; ";
                    else {
                        var V = e.errorPath, $ = "' + " + v + " + '";
                        if (e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers)), R) {
                            if (w) a += " delete " + d + "[" + v + "]; ";
                            else {
                                a += " " + u + " = false; ";
                                var N = h;
                                h = e.errSchemaPath + "/additionalProperties", (te = te || []).push(a), a = "", !1 !== e.createErrors ? (a += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(h) + " , params: { additionalProperty: '" + $ + "' } ", !1 !== e.opts.messages && (a += " , message: '", e.opts._errorDataPathProperty ? a += "is an invalid additional property" : a += "should NOT have additional properties", a += "' "), e.opts.verbose && (a += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), a += " } ") : a += " {} ";
                                var T = a;
                                a = te.pop(), !e.compositeRule && p ? e.async ? a += " throw new ValidationError([" + T + "]); " : a += " validate.errors = [" + T + "]; return false; " : a += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h = N, p && (a += " break; ");
                            }
                        } else if (k) {
                            if ("failing" == w) {
                                a += " var " + n + " = errors;  ";
                                var z = e.compositeRule;
                                e.compositeRule = c.compositeRule = !0, c.schema = S, c.schemaPath = e.schemaPath + ".additionalProperties", c.errSchemaPath = e.errSchemaPath + "/additionalProperties", c.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers);
                                var B = d + "[" + v + "]";
                                c.dataPathArr[m] = v;
                                var C = e.validate(c);
                                c.baseId = A, e.util.varOccurences(C, g) < 2 ? a += " " + e.util.varReplace(C, g, B) + " " : a += " var " + g + " = " + B + "; " + C + " ", a += " if (!" + u + ") { errors = " + n + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + d + "[" + v + "]; }  ", e.compositeRule = c.compositeRule = z;
                            } else {
                                c.schema = S, c.schemaPath = e.schemaPath + ".additionalProperties", c.errSchemaPath = e.errSchemaPath + "/additionalProperties", c.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers);
                                B = d + "[" + v + "]";
                                c.dataPathArr[m] = v;
                                C = e.validate(c);
                                c.baseId = A, e.util.varOccurences(C, g) < 2 ? a += " " + e.util.varReplace(C, g, B) + " " : a += " var " + g + " = " + B + "; " + C + " ", p && (a += " if (!" + u + ") break; ");
                            }
                        }
                        e.errorPath = V;
                    }
                    E && (a += " } "), a += " }  ", p && (a += " if (" + u + ") { ", P += "}");
                }
                var G = e.opts.useDefaults && !e.compositeRule;
                if (b.length) {
                    var J = b;
                    if (J) for(var M, W = -1, X = J.length - 1; W < X;){
                        var Y = i[M = J[W += 1]];
                        if (e.opts.strictKeywords ? "object" == typeof Y && Object.keys(Y).length > 0 || !1 === Y : e.util.schemaHasRules(Y, e.RULES.all)) {
                            var Z = e.util.getProperty(M), ee = (B = d + Z, G && void 0 !== Y.default);
                            c.schema = Y, c.schemaPath = l + Z, c.errSchemaPath = h + "/" + e.util.escapeFragment(M), c.errorPath = e.util.getPath(e.errorPath, M, e.opts.jsonPointers), c.dataPathArr[m] = e.util.toQuotedString(M);
                            C = e.validate(c);
                            if (c.baseId = A, e.util.varOccurences(C, g) < 2) {
                                C = e.util.varReplace(C, g, B);
                                var re = B;
                            } else {
                                re = g;
                                a += " var " + g + " = " + B + "; ";
                            }
                            if (ee) a += " " + C + " ";
                            else {
                                if (q && q[M]) {
                                    a += " if ( " + re + " === undefined ", Q && (a += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(M) + "') "), a += ") { " + u + " = false; ";
                                    V = e.errorPath, N = h;
                                    var te, ae = e.util.escapeQuotes(M);
                                    e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(V, M, e.opts.jsonPointers)), h = e.errSchemaPath + "/required", (te = te || []).push(a), a = "", !1 !== e.createErrors ? (a += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(h) + " , params: { missingProperty: '" + ae + "' } ", !1 !== e.opts.messages && (a += " , message: '", e.opts._errorDataPathProperty ? a += "is a required property" : a += "should have required property \\'" + ae + "\\'", a += "' "), e.opts.verbose && (a += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), a += " } ") : a += " {} ";
                                    T = a;
                                    a = te.pop(), !e.compositeRule && p ? e.async ? a += " throw new ValidationError([" + T + "]); " : a += " validate.errors = [" + T + "]; return false; " : a += " var err = " + T + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", h = N, e.errorPath = V, a += " } else { ";
                                } else p ? (a += " if ( " + re + " === undefined ", Q && (a += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(M) + "') "), a += ") { " + u + " = true; } else { ") : (a += " if (" + re + " !== undefined ", Q && (a += " &&   Object.prototype.hasOwnProperty.call(" + d + ", '" + e.util.escapeQuotes(M) + "') "), a += " ) { ");
                                a += " " + C + " } ";
                            }
                        }
                        p && (a += " if (" + u + ") { ", P += "}");
                    }
                }
                if (O.length) {
                    var oe = O;
                    if (oe) for(var se, ie = -1, le = oe.length - 1; ie < le;){
                        Y = j[se = oe[ie += 1]];
                        if (e.opts.strictKeywords ? "object" == typeof Y && Object.keys(Y).length > 0 || !1 === Y : e.util.schemaHasRules(Y, e.RULES.all)) {
                            c.schema = Y, c.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(se), c.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(se), a += Q ? " " + y + " = " + y + " || Object.keys(" + d + "); for (var " + f + "=0; " + f + "<" + y + ".length; " + f + "++) { var " + v + " = " + y + "[" + f + "]; " : " for (var " + v + " in " + d + ") { ", a += " if (" + e.usePattern(se) + ".test(" + v + ")) { ", c.errorPath = e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers);
                            B = d + "[" + v + "]";
                            c.dataPathArr[m] = v;
                            C = e.validate(c);
                            c.baseId = A, e.util.varOccurences(C, g) < 2 ? a += " " + e.util.varReplace(C, g, B) + " " : a += " var " + g + " = " + B + "; " + C + " ", p && (a += " if (!" + u + ") break; "), a += " } ", p && (a += " else " + u + " = true; "), a += " }  ", p && (a += " if (" + u + ") { ", P += "}");
                        }
                    }
                }
                return p && (a += " " + P + " if (" + n + " == errors) {"), a;
            };
        },
        {}
    ],
    "XxjR": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r, e, a) {
                var t = " ", s = r.level, o = r.dataLevel, l = r.schema[e], i = r.schemaPath + r.util.getProperty(e), v = r.errSchemaPath + "/" + e, c = !r.opts.allErrors, p = "data" + (o || ""), m = "errs__" + s, h = r.util.copy(r);
                h.level++;
                var d = "valid" + h.level;
                if (t += "var " + m + " = errors;", r.opts.strictKeywords ? "object" == typeof l && Object.keys(l).length > 0 || !1 === l : r.util.schemaHasRules(l, r.RULES.all)) {
                    h.schema = l, h.schemaPath = i, h.errSchemaPath = v;
                    var u = "key" + s, n = "idx" + s, y = "i" + s, E = "' + " + u + " + '", P = "data" + (h.dataLevel = r.dataLevel + 1), f = "dataProperties" + s, R = r.opts.ownProperties, b = r.baseId;
                    R && (t += " var " + f + " = undefined; "), t += R ? " " + f + " = " + f + " || Object.keys(" + p + "); for (var " + n + "=0; " + n + "<" + f + ".length; " + n + "++) { var " + u + " = " + f + "[" + n + "]; " : " for (var " + u + " in " + p + ") { ", t += " var startErrs" + s + " = errors; ";
                    var g = u, k = r.compositeRule;
                    r.compositeRule = h.compositeRule = !0;
                    var w = r.validate(h);
                    h.baseId = b, r.util.varOccurences(w, P) < 2 ? t += " " + r.util.varReplace(w, P, g) + " " : t += " var " + P + " = " + g + "; " + w + " ", r.compositeRule = h.compositeRule = k, t += " if (!" + d + ") { for (var " + y + "=startErrs" + s + "; " + y + "<errors; " + y + "++) { vErrors[" + y + "].propertyName = " + u + "; }   var err =   ", !1 !== r.createErrors ? (t += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(v) + " , params: { propertyName: '" + E + "' } ", !1 !== r.opts.messages && (t += " , message: 'property name \\'" + E + "\\' is invalid' "), r.opts.verbose && (t += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + p + " "), t += " } ") : t += " {} ", t += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !r.compositeRule && c && (r.async ? t += " throw new ValidationError(vErrors); " : t += " validate.errors = vErrors; return false; "), c && (t += " break; "), t += " } }";
                }
                return c && (t += "  if (" + m + " == errors) {"), t;
            };
        },
        {}
    ],
    "Dht1": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r, e, a) {
                var t = " ", s = r.level, o = r.dataLevel, i = r.schema[e], h = r.schemaPath + r.util.getProperty(e), p = r.errSchemaPath + "/" + e, l = !r.opts.allErrors, d = "data" + (o || ""), u = "valid" + s, P = r.opts.$data && i && i.$data;
                P && (t += " var schema" + s + " = " + r.util.getData(i.$data, o, r.dataPathArr) + "; ");
                var n = "schema" + s;
                if (!P) {
                    if (i.length < r.opts.loopRequired && r.schema.properties && Object.keys(r.schema.properties).length) {
                        var c = [], m = i;
                        if (m) for(var v, y = -1, g = m.length - 1; y < g;){
                            v = m[y += 1];
                            var f = r.schema.properties[v];
                            f && (r.opts.strictKeywords ? "object" == typeof f && Object.keys(f).length > 0 || !1 === f : r.util.schemaHasRules(f, r.RULES.all)) || (c[c.length] = v);
                        }
                    } else c = i;
                }
                if (P || c.length) {
                    var E = r.errorPath, q = P || c.length >= r.opts.loopRequired, w = r.opts.ownProperties;
                    if (l) {
                        if (t += " var missing" + s + "; ", q) {
                            P || (t += " var " + n + " = validate.schema" + h + "; ");
                            var b = "' + " + (_ = "schema" + s + "[" + (D = "i" + s) + "]") + " + '";
                            r.opts._errorDataPathProperty && (r.errorPath = r.util.getPathExpr(E, _, r.opts.jsonPointers)), t += " var " + u + " = true; ", P && (t += " if (schema" + s + " === undefined) " + u + " = true; else if (!Array.isArray(schema" + s + ")) " + u + " = false; else {"), t += " for (var " + D + " = 0; " + D + " < " + n + ".length; " + D + "++) { " + u + " = " + d + "[" + n + "[" + D + "]] !== undefined ", w && (t += " &&   Object.prototype.hasOwnProperty.call(" + d + ", " + n + "[" + D + "]) "), t += "; if (!" + u + ") break; } ", P && (t += "  }  "), t += "  if (!" + u + ") {   ", (Q = Q || []).push(t), t = "", !1 !== r.createErrors ? (t += " { keyword: 'required' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(p) + " , params: { missingProperty: '" + b + "' } ", !1 !== r.opts.messages && (t += " , message: '", r.opts._errorDataPathProperty ? t += "is a required property" : t += "should have required property \\'" + b + "\\'", t += "' "), r.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + d + " "), t += " } ") : t += " {} ";
                            var S = t;
                            t = Q.pop(), !r.compositeRule && l ? r.async ? t += " throw new ValidationError([" + S + "]); " : t += " validate.errors = [" + S + "]; return false; " : t += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } else { ";
                        } else {
                            t += " if ( ";
                            var j = c;
                            if (j) for(var D = -1, O = j.length - 1; D < O;)R = j[D += 1], D && (t += " || "), t += " ( ( " + (L = d + ($ = r.util.getProperty(R))) + " === undefined ", w && (t += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + r.util.escapeQuotes(R) + "') "), t += ") && (missing" + s + " = " + r.util.toQuotedString(r.opts.jsonPointers ? R : $) + ") ) ";
                            t += ") {  ";
                            var Q;
                            b = "' + " + (_ = "missing" + s) + " + '";
                            r.opts._errorDataPathProperty && (r.errorPath = r.opts.jsonPointers ? r.util.getPathExpr(E, _, !0) : E + " + " + _), (Q = Q || []).push(t), t = "", !1 !== r.createErrors ? (t += " { keyword: 'required' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(p) + " , params: { missingProperty: '" + b + "' } ", !1 !== r.opts.messages && (t += " , message: '", r.opts._errorDataPathProperty ? t += "is a required property" : t += "should have required property \\'" + b + "\\'", t += "' "), r.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + d + " "), t += " } ") : t += " {} ";
                            S = t;
                            t = Q.pop(), !r.compositeRule && l ? r.async ? t += " throw new ValidationError([" + S + "]); " : t += " validate.errors = [" + S + "]; return false; " : t += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " } else { ";
                        }
                    } else if (q) {
                        P || (t += " var " + n + " = validate.schema" + h + "; ");
                        var _;
                        b = "' + " + (_ = "schema" + s + "[" + (D = "i" + s) + "]") + " + '";
                        r.opts._errorDataPathProperty && (r.errorPath = r.util.getPathExpr(E, _, r.opts.jsonPointers)), P && (t += " if (" + n + " && !Array.isArray(" + n + ")) {  var err =   ", !1 !== r.createErrors ? (t += " { keyword: 'required' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(p) + " , params: { missingProperty: '" + b + "' } ", !1 !== r.opts.messages && (t += " , message: '", r.opts._errorDataPathProperty ? t += "is a required property" : t += "should have required property \\'" + b + "\\'", t += "' "), r.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + d + " "), t += " } ") : t += " {} ", t += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + n + " !== undefined) { "), t += " for (var " + D + " = 0; " + D + " < " + n + ".length; " + D + "++) { if (" + d + "[" + n + "[" + D + "]] === undefined ", w && (t += " || ! Object.prototype.hasOwnProperty.call(" + d + ", " + n + "[" + D + "]) "), t += ") {  var err =   ", !1 !== r.createErrors ? (t += " { keyword: 'required' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(p) + " , params: { missingProperty: '" + b + "' } ", !1 !== r.opts.messages && (t += " , message: '", r.opts._errorDataPathProperty ? t += "is a required property" : t += "should have required property \\'" + b + "\\'", t += "' "), r.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + d + " "), t += " } ") : t += " {} ", t += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", P && (t += "  }  ");
                    } else {
                        var k = c;
                        if (k) for(var R, A = -1, x = k.length - 1; A < x;){
                            R = k[A += 1];
                            var $ = r.util.getProperty(R), L = (b = r.util.escapeQuotes(R), d + $);
                            r.opts._errorDataPathProperty && (r.errorPath = r.util.getPath(E, R, r.opts.jsonPointers)), t += " if ( " + L + " === undefined ", w && (t += " || ! Object.prototype.hasOwnProperty.call(" + d + ", '" + r.util.escapeQuotes(R) + "') "), t += ") {  var err =   ", !1 !== r.createErrors ? (t += " { keyword: 'required' , dataPath: (dataPath || '') + " + r.errorPath + " , schemaPath: " + r.util.toQuotedString(p) + " , params: { missingProperty: '" + b + "' } ", !1 !== r.opts.messages && (t += " , message: '", r.opts._errorDataPathProperty ? t += "is a required property" : t += "should have required property \\'" + b + "\\'", t += "' "), r.opts.verbose && (t += " , schema: validate.schema" + h + " , parentSchema: validate.schema" + r.schemaPath + " , data: " + d + " "), t += " } ") : t += " {} ", t += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                        }
                    }
                    r.errorPath = E;
                } else l && (t += " if (true) {");
                return t;
            };
        },
        {}
    ],
    "mmFQ": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, a, r) {
                var t, i = " ", s = e.level, o = e.dataLevel, m = e.schema[a], l = e.schemaPath + e.util.getProperty(a), c = e.errSchemaPath + "/" + a, u = !e.opts.allErrors, d = "data" + (o || ""), h = "valid" + s, n = e.opts.$data && m && m.$data;
                if (n ? (i += " var schema" + s + " = " + e.util.getData(m.$data, o, e.dataPathArr) + "; ", t = "schema" + s) : t = m, (m || n) && !1 !== e.opts.uniqueItems) {
                    n && (i += " var " + h + "; if (" + t + " === false || " + t + " === undefined) " + h + " = true; else if (typeof " + t + " != 'boolean') " + h + " = false; else { "), i += " var i = " + d + ".length , " + h + " = true , j; if (i > 1) { ";
                    var f = e.schema.items && e.schema.items.type, v = Array.isArray(f);
                    if (!f || "object" == f || "array" == f || v && (f.indexOf("object") >= 0 || f.indexOf("array") >= 0)) i += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + d + "[i], " + d + "[j])) { " + h + " = false; break outer; } } } ";
                    else {
                        i += " var itemIndices = {}, item; for (;i--;) { var item = " + d + "[i]; ";
                        var p = "checkDataType" + (v ? "s" : "");
                        i += " if (" + e.util[p](f, "item", e.opts.strictNumbers, !0) + ") continue; ", v && (i += " if (typeof item == 'string') item = '\"' + item; "), i += " if (typeof itemIndices[item] == 'number') { " + h + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
                    }
                    i += " } ", n && (i += "  }  "), i += " if (!" + h + ") {   ";
                    var y = y || [];
                    y.push(i), i = "", !1 !== e.createErrors ? (i += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { i: i, j: j } ", !1 !== e.opts.messages && (i += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (i += " , schema:  ", i += n ? "validate.schema" + l : "" + m, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), i += " } ") : i += " {} ";
                    var j = i;
                    i = y.pop(), !e.compositeRule && u ? e.async ? i += " throw new ValidationError([" + j + "]); " : i += " validate.errors = [" + j + "]; return false; " : i += " var err = " + j + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", u && (i += " else { ");
                } else u && (i += " if (true) { ");
                return i;
            };
        },
        {}
    ],
    "Czyc": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = {
                $ref: require1("./ref"),
                allOf: require1("./allOf"),
                anyOf: require1("./anyOf"),
                $comment: require1("./comment"),
                const: require1("./const"),
                contains: require1("./contains"),
                dependencies: require1("./dependencies"),
                enum: require1("./enum"),
                format: require1("./format"),
                if: require1("./if"),
                items: require1("./items"),
                maximum: require1("./_limit"),
                minimum: require1("./_limit"),
                maxItems: require1("./_limitItems"),
                minItems: require1("./_limitItems"),
                maxLength: require1("./_limitLength"),
                minLength: require1("./_limitLength"),
                maxProperties: require1("./_limitProperties"),
                minProperties: require1("./_limitProperties"),
                multipleOf: require1("./multipleOf"),
                not: require1("./not"),
                oneOf: require1("./oneOf"),
                pattern: require1("./pattern"),
                properties: require1("./properties"),
                propertyNames: require1("./propertyNames"),
                required: require1("./required"),
                uniqueItems: require1("./uniqueItems"),
                validate: require1("./validate")
            };
        },
        {
            "./ref": "a2na",
            "./allOf": "hRgn",
            "./anyOf": "lo6J",
            "./comment": "Kkzr",
            "./const": "U4sD",
            "./contains": "EypH",
            "./dependencies": "Cpp7",
            "./enum": "fqDY",
            "./format": "avoW",
            "./if": "JHQ3",
            "./items": "aiPb",
            "./_limit": "UJAl",
            "./_limitItems": "W8ih",
            "./_limitLength": "fZGX",
            "./_limitProperties": "JAEr",
            "./multipleOf": "oNPH",
            "./not": "mmjm",
            "./oneOf": "SSWF",
            "./pattern": "mGZS",
            "./properties": "jFnx",
            "./propertyNames": "XxjR",
            "./required": "Dht1",
            "./uniqueItems": "mmFQ",
            "./validate": "yhC1"
        }
    ],
    "vBP0": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("../dotjs"), t = require1("./util").toHash;
            module1.exports = function() {
                var n = [
                    {
                        type: "number",
                        rules: [
                            {
                                maximum: [
                                    "exclusiveMaximum"
                                ]
                            },
                            {
                                minimum: [
                                    "exclusiveMinimum"
                                ]
                            },
                            "multipleOf",
                            "format"
                        ]
                    },
                    {
                        type: "string",
                        rules: [
                            "maxLength",
                            "minLength",
                            "pattern",
                            "format"
                        ]
                    },
                    {
                        type: "array",
                        rules: [
                            "maxItems",
                            "minItems",
                            "items",
                            "contains",
                            "uniqueItems"
                        ]
                    },
                    {
                        type: "object",
                        rules: [
                            "maxProperties",
                            "minProperties",
                            "required",
                            "dependencies",
                            "propertyNames",
                            {
                                properties: [
                                    "additionalProperties",
                                    "patternProperties"
                                ]
                            }
                        ]
                    },
                    {
                        rules: [
                            "$ref",
                            "const",
                            "enum",
                            "not",
                            "anyOf",
                            "oneOf",
                            "allOf",
                            "if"
                        ]
                    }
                ], r = [
                    "type",
                    "$comment"
                ];
                return n.all = t(r), n.types = t([
                    "number",
                    "integer",
                    "string",
                    "array",
                    "object",
                    "boolean",
                    "null"
                ]), n.forEach(function(t) {
                    t.rules = t.rules.map(function(t) {
                        var i;
                        if ("object" == typeof t) {
                            var o = Object.keys(t)[0];
                            i = t[o], t = o, i.forEach(function(e) {
                                r.push(e), n.all[e] = !0;
                            });
                        }
                        return r.push(t), n.all[t] = {
                            keyword: t,
                            code: e[t],
                            implements: i
                        };
                    }), n.all.$comment = {
                        keyword: "$comment",
                        code: e.$comment
                    }, t.type && (n.types[t.type] = t);
                }), n.keywords = t(r.concat([
                    "$schema",
                    "$id",
                    "id",
                    "$data",
                    "$async",
                    "title",
                    "description",
                    "default",
                    "definitions",
                    "examples",
                    "readOnly",
                    "writeOnly",
                    "contentMediaType",
                    "contentEncoding",
                    "additionalItems",
                    "then",
                    "else"
                ])), n.custom = {}, n;
            };
        },
        {
            "../dotjs": "Czyc",
            "./util": "Q1F7"
        }
    ],
    "BunE": [
        function(require1, module1, exports) {
            "use strict";
            var e = [
                "multipleOf",
                "maximum",
                "exclusiveMaximum",
                "minimum",
                "exclusiveMinimum",
                "maxLength",
                "minLength",
                "pattern",
                "additionalItems",
                "maxItems",
                "minItems",
                "uniqueItems",
                "maxProperties",
                "minProperties",
                "required",
                "additionalProperties",
                "enum",
                "format",
                "const"
            ];
            module1.exports = function(t, i) {
                for(var r = 0; r < i.length; r++){
                    t = JSON.parse(JSON.stringify(t));
                    var m, a = i[r].split("/"), n = t;
                    for(m = 1; m < a.length; m++)n = n[a[m]];
                    for(m = 0; m < e.length; m++){
                        var s = e[m], o = n[s];
                        o && (n[s] = {
                            anyOf: [
                                o,
                                {
                                    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                                }
                            ]
                        });
                    }
                }
                return t;
            };
        },
        {}
    ],
    "mNRF": [
        function(require1, module1, exports) {
            "use strict";
            var n = require1("./error_classes").MissingRef;
            function e(t, r, o) {
                var i = this;
                if ("function" != typeof this._opts.loadSchema) throw new Error("options.loadSchema should be a function");
                "function" == typeof r && (o = r, r = void 0);
                var a = c(t).then(function() {
                    var e = i._addSchema(t, void 0, r);
                    return e.validate || function e(t) {
                        try {
                            return i._compile(t);
                        } catch (a) {
                            if (a instanceof n) return function o(e) {
                                var o = e.missingSchema;
                                if (h(o)) throw new Error("Schema " + o + " is loaded but " + e.missingRef + " cannot be resolved");
                                var a = i._loadingSchemas[o];
                                a || (a = i._loadingSchemas[o] = i._opts.loadSchema(o)).then(s, s);
                                return a.then(function(n) {
                                    if (!h(o)) return c(n).then(function() {
                                        h(o) || i.addSchema(n, o, void 0, r);
                                    });
                                }).then(function() {
                                    return function t(o) {
                                        try {
                                            return i._compile(o);
                                        } catch (e) {
                                            if (e instanceof n) return a(e);
                                            throw e;
                                        }
                                        function a(n) {
                                            var e = n.missingSchema;
                                            if (h(e)) throw new Error("Schema " + e + " is loaded but " + n.missingRef + " cannot be resolved");
                                            var a = i._loadingSchemas[e];
                                            return a || (a = i._loadingSchemas[e] = i._opts.loadSchema(e)).then(s, s), a.then(function(n) {
                                                if (!h(e)) return c(n).then(function() {
                                                    h(e) || i.addSchema(n, e, void 0, r);
                                                });
                                            }).then(function() {
                                                return t(o);
                                            });
                                            function s() {
                                                delete i._loadingSchemas[e];
                                            }
                                            function h(n) {
                                                return i._refs[n] || i._schemas[n];
                                            }
                                        }
                                    }(t);
                                });
                                function s() {
                                    delete i._loadingSchemas[o];
                                }
                                function h(n) {
                                    return i._refs[n] || i._schemas[n];
                                }
                            }(a);
                            throw a;
                        }
                        function o(n) {
                            var o = n.missingSchema;
                            if (h(o)) throw new Error("Schema " + o + " is loaded but " + n.missingRef + " cannot be resolved");
                            var a = i._loadingSchemas[o];
                            return a || (a = i._loadingSchemas[o] = i._opts.loadSchema(o)).then(s, s), a.then(function(n) {
                                if (!h(o)) return c(n).then(function() {
                                    h(o) || i.addSchema(n, o, void 0, r);
                                });
                            }).then(function() {
                                return e(t);
                            });
                            function s() {
                                delete i._loadingSchemas[o];
                            }
                            function h(n) {
                                return i._refs[n] || i._schemas[n];
                            }
                        }
                    }(e);
                });
                return o && a.then(function(n) {
                    o(null, n);
                }, o), a;
                function c(n) {
                    var t = n.$schema;
                    return t && !i.getSchema(t) ? e.call(i, {
                        $ref: t
                    }, !0) : Promise.resolve();
                }
            }
            module1.exports = e;
        },
        {
            "./error_classes": "OtNE"
        }
    ],
    "Mzku": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(a, r, e) {
                var t, s, o = " ", i = a.level, h = a.dataLevel, d = a.schema[r], l = a.schemaPath + a.util.getProperty(r), v = a.errSchemaPath + "/" + r, c = !a.opts.allErrors, n = "data" + (h || ""), m = "valid" + i, u = "errs__" + i, p = a.opts.$data && d && d.$data;
                p ? (o += " var schema" + i + " = " + a.util.getData(d.$data, h, a.dataPathArr) + "; ", s = "schema" + i) : s = d;
                var f, P, y, E, w, k = "definition" + i, g = this.definition, R = "";
                if (p && g.$data) {
                    w = "keywordValidate" + i;
                    var S = g.validateSchema;
                    o += " var " + k + " = RULES.custom['" + r + "'].definition; var " + w + " = " + k + ".validate;";
                } else {
                    if (!(E = a.useCustomRule(this, d, a.schema, a))) return;
                    s = "validate.schema" + l, w = E.code, f = g.compile, P = g.inline, y = g.macro;
                }
                var b = w + ".errors", $ = "i" + i, A = "ruleErr" + i, D = g.async;
                if (D && !a.async) throw new Error("async keyword in sync schema");
                if (P || y || (o += b + " = null;"), o += "var " + u + " = errors;var " + m + ";", p && g.$data && (R += "}", o += " if (" + s + " === undefined) { " + m + " = true; } else { ", S && (R += "}", o += " " + m + " = " + k + ".validateSchema(" + s + "); if (" + m + ") { ")), P) g.statements ? o += " " + E.validate + " " : o += " " + m + " = " + E.validate + "; ";
                else if (y) {
                    var V = a.util.copy(a);
                    R = "";
                    V.level++;
                    var x = "valid" + V.level;
                    V.schema = E.validate, V.schemaPath = "";
                    var C = a.compositeRule;
                    a.compositeRule = V.compositeRule = !0;
                    var L = a.validate(V).replace(/validate\.schema/g, w);
                    a.compositeRule = V.compositeRule = C, o += " " + L;
                } else {
                    (j = j || []).push(o), o = "", o += "  " + w + ".call( ", a.opts.passContext ? o += "this" : o += "self", f || !1 === g.schema ? o += " , " + n + " " : o += " , " + s + " , " + n + " , validate.schema" + a.schemaPath + " ", o += " , (dataPath || '')", '""' != a.errorPath && (o += " + " + a.errorPath);
                    var Q = h ? "data" + (h - 1 || "") : "parentData", _ = h ? a.dataPathArr[h] : "parentDataProperty", U = o += " , " + Q + " , " + _ + " , rootData )  ";
                    o = j.pop(), !1 === g.errors ? (o += " " + m + " = ", D && (o += "await "), o += U + "; ") : o += D ? " var " + (b = "customErrors" + i) + " = null; try { " + m + " = await " + U + "; } catch (e) { " + m + " = false; if (e instanceof ValidationError) " + b + " = e.errors; else throw e; } " : " " + b + " = null; " + m + " = " + U + "; ";
                }
                if (g.modifying && (o += " if (" + Q + ") " + n + " = " + Q + "[" + _ + "];"), o += "" + R, g.valid) c && (o += " if (true) { ");
                else {
                    var j;
                    o += " if ( ", void 0 === g.valid ? (o += " !", o += y ? "" + x : "" + m) : o += " " + !g.valid + " ", o += ") { ", t = this.keyword, (j = j || []).push(o), o = "", (j = j || []).push(o), o = "", !1 !== a.createErrors ? (o += " { keyword: '" + (t || "custom") + "' , dataPath: (dataPath || '') + " + a.errorPath + " , schemaPath: " + a.util.toQuotedString(v) + " , params: { keyword: '" + this.keyword + "' } ", !1 !== a.opts.messages && (o += " , message: 'should pass \"" + this.keyword + "\" keyword validation' "), a.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + a.schemaPath + " , data: " + n + " "), o += " } ") : o += " {} ";
                    var q = o;
                    o = j.pop(), !a.compositeRule && c ? a.async ? o += " throw new ValidationError([" + q + "]); " : o += " validate.errors = [" + q + "]; return false; " : o += " var err = " + q + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    var z = o;
                    o = j.pop(), P ? g.errors ? "full" != g.errors && (o += "  for (var " + $ + "=" + u + "; " + $ + "<errors; " + $ + "++) { var " + A + " = vErrors[" + $ + "]; if (" + A + ".dataPath === undefined) " + A + ".dataPath = (dataPath || '') + " + a.errorPath + "; if (" + A + ".schemaPath === undefined) { " + A + '.schemaPath = "' + v + '"; } ', a.opts.verbose && (o += " " + A + ".schema = " + s + "; " + A + ".data = " + n + "; "), o += " } ") : !1 === g.errors ? o += " " + z + " " : (o += " if (" + u + " == errors) { " + z + " } else {  for (var " + $ + "=" + u + "; " + $ + "<errors; " + $ + "++) { var " + A + " = vErrors[" + $ + "]; if (" + A + ".dataPath === undefined) " + A + ".dataPath = (dataPath || '') + " + a.errorPath + "; if (" + A + ".schemaPath === undefined) { " + A + '.schemaPath = "' + v + '"; } ', a.opts.verbose && (o += " " + A + ".schema = " + s + "; " + A + ".data = " + n + "; "), o += " } } ") : y ? (o += "   var err =   ", !1 !== a.createErrors ? (o += " { keyword: '" + (t || "custom") + "' , dataPath: (dataPath || '') + " + a.errorPath + " , schemaPath: " + a.util.toQuotedString(v) + " , params: { keyword: '" + this.keyword + "' } ", !1 !== a.opts.messages && (o += " , message: 'should pass \"" + this.keyword + "\" keyword validation' "), a.opts.verbose && (o += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + a.schemaPath + " , data: " + n + " "), o += " } ") : o += " {} ", o += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !a.compositeRule && c && (a.async ? o += " throw new ValidationError(vErrors); " : o += " validate.errors = vErrors; return false; ")) : !1 === g.errors ? o += " " + z + " " : (o += " if (Array.isArray(" + b + ")) { if (vErrors === null) vErrors = " + b + "; else vErrors = vErrors.concat(" + b + "); errors = vErrors.length;  for (var " + $ + "=" + u + "; " + $ + "<errors; " + $ + "++) { var " + A + " = vErrors[" + $ + "]; if (" + A + ".dataPath === undefined) " + A + ".dataPath = (dataPath || '') + " + a.errorPath + ";  " + A + '.schemaPath = "' + v + '";  ', a.opts.verbose && (o += " " + A + ".schema = " + s + "; " + A + ".data = " + n + "; "), o += " } } else { " + z + " } "), o += " } ", c && (o += " else { ");
                }
                return o;
            };
        },
        {}
    ],
    "ve7q": [
        function(require1, module1, exports) {
            module1.exports = {
                $schema: "http://json-schema.org/draft-07/schema#",
                $id: "http://json-schema.org/draft-07/schema#",
                title: "Core schema meta-schema",
                definitions: {
                    schemaArray: {
                        type: "array",
                        minItems: 1,
                        items: {
                            $ref: "#"
                        }
                    },
                    nonNegativeInteger: {
                        type: "integer",
                        minimum: 0
                    },
                    nonNegativeIntegerDefault0: {
                        allOf: [
                            {
                                $ref: "#/definitions/nonNegativeInteger"
                            },
                            {
                                default: 0
                            }
                        ]
                    },
                    simpleTypes: {
                        enum: [
                            "array",
                            "boolean",
                            "integer",
                            "null",
                            "number",
                            "object",
                            "string"
                        ]
                    },
                    stringArray: {
                        type: "array",
                        items: {
                            type: "string"
                        },
                        uniqueItems: !0,
                        default: []
                    }
                },
                type: [
                    "object",
                    "boolean"
                ],
                properties: {
                    $id: {
                        type: "string",
                        format: "uri-reference"
                    },
                    $schema: {
                        type: "string",
                        format: "uri"
                    },
                    $ref: {
                        type: "string",
                        format: "uri-reference"
                    },
                    $comment: {
                        type: "string"
                    },
                    title: {
                        type: "string"
                    },
                    description: {
                        type: "string"
                    },
                    default: !0,
                    readOnly: {
                        type: "boolean",
                        default: !1
                    },
                    examples: {
                        type: "array",
                        items: !0
                    },
                    multipleOf: {
                        type: "number",
                        exclusiveMinimum: 0
                    },
                    maximum: {
                        type: "number"
                    },
                    exclusiveMaximum: {
                        type: "number"
                    },
                    minimum: {
                        type: "number"
                    },
                    exclusiveMinimum: {
                        type: "number"
                    },
                    maxLength: {
                        $ref: "#/definitions/nonNegativeInteger"
                    },
                    minLength: {
                        $ref: "#/definitions/nonNegativeIntegerDefault0"
                    },
                    pattern: {
                        type: "string",
                        format: "regex"
                    },
                    additionalItems: {
                        $ref: "#"
                    },
                    items: {
                        anyOf: [
                            {
                                $ref: "#"
                            },
                            {
                                $ref: "#/definitions/schemaArray"
                            }
                        ],
                        default: !0
                    },
                    maxItems: {
                        $ref: "#/definitions/nonNegativeInteger"
                    },
                    minItems: {
                        $ref: "#/definitions/nonNegativeIntegerDefault0"
                    },
                    uniqueItems: {
                        type: "boolean",
                        default: !1
                    },
                    contains: {
                        $ref: "#"
                    },
                    maxProperties: {
                        $ref: "#/definitions/nonNegativeInteger"
                    },
                    minProperties: {
                        $ref: "#/definitions/nonNegativeIntegerDefault0"
                    },
                    required: {
                        $ref: "#/definitions/stringArray"
                    },
                    additionalProperties: {
                        $ref: "#"
                    },
                    definitions: {
                        type: "object",
                        additionalProperties: {
                            $ref: "#"
                        },
                        default: {}
                    },
                    properties: {
                        type: "object",
                        additionalProperties: {
                            $ref: "#"
                        },
                        default: {}
                    },
                    patternProperties: {
                        type: "object",
                        additionalProperties: {
                            $ref: "#"
                        },
                        propertyNames: {
                            format: "regex"
                        },
                        default: {}
                    },
                    dependencies: {
                        type: "object",
                        additionalProperties: {
                            anyOf: [
                                {
                                    $ref: "#"
                                },
                                {
                                    $ref: "#/definitions/stringArray"
                                }
                            ]
                        }
                    },
                    propertyNames: {
                        $ref: "#"
                    },
                    const: !0,
                    enum: {
                        type: "array",
                        items: !0,
                        minItems: 1,
                        uniqueItems: !0
                    },
                    type: {
                        anyOf: [
                            {
                                $ref: "#/definitions/simpleTypes"
                            },
                            {
                                type: "array",
                                items: {
                                    $ref: "#/definitions/simpleTypes"
                                },
                                minItems: 1,
                                uniqueItems: !0
                            }
                        ]
                    },
                    format: {
                        type: "string"
                    },
                    contentMediaType: {
                        type: "string"
                    },
                    contentEncoding: {
                        type: "string"
                    },
                    if: {
                        $ref: "#"
                    },
                    then: {
                        $ref: "#"
                    },
                    else: {
                        $ref: "#"
                    },
                    allOf: {
                        $ref: "#/definitions/schemaArray"
                    },
                    anyOf: {
                        $ref: "#/definitions/schemaArray"
                    },
                    oneOf: {
                        $ref: "#/definitions/schemaArray"
                    },
                    not: {
                        $ref: "#"
                    }
                },
                default: !0
            };
        },
        {}
    ],
    "GIYw": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./refs/json-schema-draft-07.json");
            module1.exports = {
                $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
                definitions: {
                    simpleTypes: e.definitions.simpleTypes
                },
                type: "object",
                dependencies: {
                    schema: [
                        "validate"
                    ],
                    $data: [
                        "validate"
                    ],
                    statements: [
                        "inline"
                    ],
                    valid: {
                        not: {
                            required: [
                                "macro"
                            ]
                        }
                    }
                },
                properties: {
                    type: e.properties.type,
                    schema: {
                        type: "boolean"
                    },
                    statements: {
                        type: "boolean"
                    },
                    dependencies: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    },
                    metaSchema: {
                        type: "object"
                    },
                    modifying: {
                        type: "boolean"
                    },
                    valid: {
                        type: "boolean"
                    },
                    $data: {
                        type: "boolean"
                    },
                    async: {
                        type: "boolean"
                    },
                    errors: {
                        anyOf: [
                            {
                                type: "boolean"
                            },
                            {
                                const: "full"
                            }
                        ]
                    }
                }
            };
        },
        {
            "./refs/json-schema-draft-07.json": "ve7q"
        }
    ],
    "UVv5": [
        function(require1, module1, exports) {
            "use strict";
            var e = /^[a-z_$][a-z0-9_$-]*$/i, r = require1("./dotjs/custom"), t = require1("./definition_schema");
            function i(t, i) {
                var o = this.RULES;
                if (o.keywords[t]) throw new Error("Keyword " + t + " is already defined");
                if (!e.test(t)) throw new Error("Keyword " + t + " is not a valid identifier");
                if (i) {
                    this.validateKeyword(i, !0);
                    var a = i.type;
                    if (Array.isArray(a)) for(var s = 0; s < a.length; s++)d(t, a[s], i);
                    else d(t, a, i);
                    var n = i.metaSchema;
                    n && (i.$data && this._opts.$data && (n = {
                        anyOf: [
                            n,
                            {
                                $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                            }
                        ]
                    }), i.validateSchema = this.compile(n, !0));
                }
                function d(e, t, i) {
                    for(var a, s = 0; s < o.length; s++){
                        var n = o[s];
                        if (n.type == t) {
                            a = n;
                            break;
                        }
                    }
                    a || (a = {
                        type: t,
                        rules: []
                    }, o.push(a));
                    var d = {
                        keyword: e,
                        definition: i,
                        custom: !0,
                        code: r,
                        implements: i.implements
                    };
                    a.rules.push(d), o.custom[e] = d;
                }
                return o.keywords[t] = o.all[t] = !0, this;
            }
            function o(e) {
                var r = this.RULES.custom[e];
                return r ? r.definition : this.RULES.keywords[e] || !1;
            }
            function a(e) {
                var r = this.RULES;
                delete r.keywords[e], delete r.all[e], delete r.custom[e];
                for(var t = 0; t < r.length; t++)for(var i = r[t].rules, o = 0; o < i.length; o++)if (i[o].keyword == e) {
                    i.splice(o, 1);
                    break;
                }
                return this;
            }
            function s(e, r) {
                s.errors = null;
                var i = this._validateKeyword = this._validateKeyword || this.compile(t, !0);
                if (i(e)) return !0;
                if (s.errors = i.errors, r) throw new Error("custom keyword definition is invalid: " + this.errorsText(i.errors));
                return !1;
            }
            module1.exports = {
                add: i,
                get: o,
                remove: a,
                validate: s
            };
        },
        {
            "./dotjs/custom": "Mzku",
            "./definition_schema": "GIYw"
        }
    ],
    "xbmT": [
        function(require1, module1, exports) {
            module1.exports = {
                $schema: "http://json-schema.org/draft-07/schema#",
                $id: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
                description: "Meta-schema for $data reference (JSON Schema extension proposal)",
                type: "object",
                required: [
                    "$data"
                ],
                properties: {
                    $data: {
                        type: "string",
                        anyOf: [
                            {
                                format: "relative-json-pointer"
                            },
                            {
                                format: "json-pointer"
                            }
                        ]
                    }
                },
                additionalProperties: !1
            };
        },
        {}
    ],
    "hi5j": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./compile"), t = require1("./compile/resolve"), r = require1("./cache"), a = require1("./compile/schema_obj"), i = require1("fast-json-stable-stringify"), s = require1("./compile/formats"), o = require1("./compile/rules"), h = require1("./data"), n = require1("./compile/util");
            module1.exports = p, p.prototype.validate = u, p.prototype.compile = v, p.prototype.addSchema = _, p.prototype.addMetaSchema = g, p.prototype.validateSchema = y, p.prototype.getSchema = S, p.prototype.removeSchema = q, p.prototype.addFormat = x, p.prototype.errorsText = k, p.prototype._addSchema = E, p.prototype._compile = I, p.prototype.compileAsync = require1("./compile/async");
            var c = require1("./keyword");
            p.prototype.addKeyword = c.add, p.prototype.getKeyword = c.get, p.prototype.removeKeyword = c.remove, p.prototype.validateKeyword = c.validate;
            var d = require1("./compile/error_classes");
            p.ValidationError = d.Validation, p.MissingRefError = d.MissingRef, p.$dataMetaSchema = h;
            var l = "http://json-schema.org/draft-07/schema", m = [
                "removeAdditional",
                "useDefaults",
                "coerceTypes",
                "strictDefaults"
            ], f = [
                "/properties"
            ];
            function p(e) {
                if (!(this instanceof p)) return new p(e);
                e = this._opts = n.copy(e) || {}, O(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = s(e.format), this._cache = e.cache || new r, this._loadingSchemas = {}, this._compilations = [], this.RULES = o(), this._getId = M(e), e.loopRequired = e.loopRequired || 1 / 0, "property" == e.errorDataPath && (e._errorDataPathProperty = !0), void 0 === e.serialize && (e.serialize = i), this._metaOpts = F(this), e.formats && D(this), e.keywords && P(this), A(this), "object" == typeof e.meta && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", {
                    metaSchema: {
                        type: "boolean"
                    }
                }), V(this);
            }
            function u(e, t) {
                var r;
                if ("string" == typeof e) {
                    if (!(r = this.getSchema(e))) throw new Error('no schema with key or ref "' + e + '"');
                } else {
                    var a = this._addSchema(e);
                    r = a.validate || this._compile(a);
                }
                var i = r(t);
                return !0 !== r.$async && (this.errors = r.errors), i;
            }
            function v(e, t) {
                var r = this._addSchema(e, void 0, t);
                return r.validate || this._compile(r);
            }
            function _(e, r, a, i) {
                if (Array.isArray(e)) {
                    for(var s = 0; s < e.length; s++)this.addSchema(e[s], void 0, a, i);
                    return this;
                }
                var o = this._getId(e);
                if (void 0 !== o && "string" != typeof o) throw new Error("schema id must be string");
                return T(this, r = t.normalizeId(r || o)), this._schemas[r] = this._addSchema(e, a, i, !0), this;
            }
            function g(e, t, r) {
                return this.addSchema(e, t, r, !0), this;
            }
            function y(e, t) {
                var r = e.$schema;
                if (void 0 !== r && "string" != typeof r) throw new Error("$schema must be a string");
                if (!(r = r || this._opts.defaultMeta || w(this))) return this.logger.warn("meta-schema not available"), this.errors = null, !0;
                var a = this.validate(r, e);
                if (!a && t) {
                    var i = "schema is invalid: " + this.errorsText();
                    if ("log" != this._opts.validateSchema) throw new Error(i);
                    this.logger.error(i);
                }
                return a;
            }
            function w(e) {
                var t = e._opts.meta;
                return e._opts.defaultMeta = "object" == typeof t ? e._getId(t) || t : e.getSchema(l) ? l : void 0, e._opts.defaultMeta;
            }
            function S(e) {
                var t = $(this, e);
                switch(typeof t){
                    case "object":
                        return t.validate || this._compile(t);
                    case "string":
                        return this.getSchema(t);
                    case "undefined":
                        return b(this, e);
                }
            }
            function b(r, i) {
                var s = t.schema.call(r, {
                    schema: {}
                }, i);
                if (s) {
                    var o = s.schema, h = s.root, n = s.baseId, c = e.call(r, o, h, void 0, n);
                    return r._fragments[i] = new a({
                        ref: i,
                        fragment: !0,
                        schema: o,
                        root: h,
                        baseId: n,
                        validate: c
                    }), c;
                }
            }
            function $(e, r) {
                return r = t.normalizeId(r), e._schemas[r] || e._refs[r] || e._fragments[r];
            }
            function q(e) {
                if (e instanceof RegExp) return j(this, this._schemas, e), j(this, this._refs, e), this;
                switch(typeof e){
                    case "undefined":
                        return j(this, this._schemas), j(this, this._refs), this._cache.clear(), this;
                    case "string":
                        var r = $(this, e);
                        return r && this._cache.del(r.cacheKey), delete this._schemas[e], delete this._refs[e], this;
                    case "object":
                        var a = this._opts.serialize, i = a ? a(e) : e;
                        this._cache.del(i);
                        var s = this._getId(e);
                        s && (s = t.normalizeId(s), delete this._schemas[s], delete this._refs[s]);
                }
                return this;
            }
            function j(e, t, r) {
                for(var a in t){
                    var i = t[a];
                    i.meta || r && !r.test(a) || (e._cache.del(i.cacheKey), delete t[a]);
                }
            }
            function E(e, r, i, s) {
                if ("object" != typeof e && "boolean" != typeof e) throw new Error("schema should be object or boolean");
                var o = this._opts.serialize, h = o ? o(e) : e, n = this._cache.get(h);
                if (n) return n;
                s = s || !1 !== this._opts.addUsedSchema;
                var c = t.normalizeId(this._getId(e));
                c && s && T(this, c);
                var d, l = !1 !== this._opts.validateSchema && !r;
                l && !(d = c && c == t.normalizeId(e.$schema)) && this.validateSchema(e, !0);
                var m = t.ids.call(this, e), f = new a({
                    id: c,
                    schema: e,
                    localRefs: m,
                    cacheKey: h,
                    meta: i
                });
                return "#" != c[0] && s && (this._refs[c] = f), this._cache.put(h, f), l && d && this.validateSchema(e, !0), f;
            }
            function I(t, r) {
                if (t.compiling) return t.validate = s, s.schema = t.schema, s.errors = null, s.root = r || s, !0 === t.schema.$async && (s.$async = !0), s;
                var a, i;
                t.compiling = !0, t.meta && (a = this._opts, this._opts = this._metaOpts);
                try {
                    i = e.call(this, t.schema, r, t.localRefs);
                } catch (o) {
                    throw delete t.validate, o;
                } finally{
                    t.compiling = !1, t.meta && (this._opts = a);
                }
                return t.validate = i, t.refs = i.refs, t.refVal = i.refVal, t.root = i.root, i;
                function s() {
                    var e = t.validate, r = e.apply(this, arguments);
                    return s.errors = e.errors, r;
                }
            }
            function M(e) {
                switch(e.schemaId){
                    case "auto":
                        return R;
                    case "id":
                        return z;
                    default:
                        return K;
                }
            }
            function z(e) {
                return e.$id && this.logger.warn("schema $id ignored", e.$id), e.id;
            }
            function K(e) {
                return e.id && this.logger.warn("schema id ignored", e.id), e.$id;
            }
            function R(e) {
                if (e.$id && e.id && e.$id != e.id) throw new Error("schema $id is different from id");
                return e.$id || e.id;
            }
            function k(e, t) {
                if (!(e = e || this.errors)) return "No errors";
                for(var r = void 0 === (t = t || {}).separator ? ", " : t.separator, a = void 0 === t.dataVar ? "data" : t.dataVar, i = "", s = 0; s < e.length; s++){
                    var o = e[s];
                    o && (i += a + o.dataPath + " " + o.message + r);
                }
                return i.slice(0, -r.length);
            }
            function x(e, t) {
                return "string" == typeof t && (t = new RegExp(t)), this._formats[e] = t, this;
            }
            function A(e) {
                var t;
                if (e._opts.$data && (t = require1("./refs/data.json"), e.addMetaSchema(t, t.$id, !0)), !1 !== e._opts.meta) {
                    var r = require1("./refs/json-schema-draft-07.json");
                    e._opts.$data && (r = h(r, f)), e.addMetaSchema(r, l, !0), e._refs["http://json-schema.org/schema"] = l;
                }
            }
            function V(e) {
                var t = e._opts.schemas;
                if (t) {
                    if (Array.isArray(t)) e.addSchema(t);
                    else for(var r in t)e.addSchema(t[r], r);
                }
            }
            function D(e) {
                for(var t in e._opts.formats){
                    var r = e._opts.formats[t];
                    e.addFormat(t, r);
                }
            }
            function P(e) {
                for(var t in e._opts.keywords){
                    var r = e._opts.keywords[t];
                    e.addKeyword(t, r);
                }
            }
            function T(e, t) {
                if (e._schemas[t] || e._refs[t]) throw new Error('schema with key or id "' + t + '" already exists');
            }
            function F(e) {
                for(var t = n.copy(e._opts), r = 0; r < m.length; r++)delete t[m[r]];
                return t;
            }
            function O(e) {
                var t = e._opts.logger;
                if (!1 === t) e.logger = {
                    log: U,
                    warn: U,
                    error: U
                };
                else {
                    if (void 0 === t && (t = console), !("object" == typeof t && t.log && t.warn && t.error)) throw new Error("logger must implement log, warn and error methods");
                    e.logger = t;
                }
            }
            function U() {}
        },
        {
            "./compile": "qdYs",
            "./compile/resolve": "w10T",
            "./cache": "fXCy",
            "./compile/schema_obj": "HHLG",
            "fast-json-stable-stringify": "Xb3N",
            "./compile/formats": "dfAH",
            "./compile/rules": "vBP0",
            "./data": "BunE",
            "./compile/util": "Q1F7",
            "./compile/async": "mNRF",
            "./keyword": "UVv5",
            "./compile/error_classes": "OtNE",
            "./refs/data.json": "xbmT",
            "./refs/json-schema-draft-07.json": "ve7q"
        }
    ],
    "dhP9": [
        function(require1, module1, exports) {
            var Buffer = require1("buffer").Buffer;
            var r = require1("buffer").Buffer, e = {
                Object: Object,
                Array: Array,
                Function: Function,
                Number: Number,
                String: String,
                Date: Date,
                RegExp: RegExp
            };
            module1.exports = function n(t) {
                return void 0 !== r && (e.Buffer = r), "undefined" != typeof Promise && (e.Promise = Promise), n.definition = {
                    compile: function(r) {
                        if ("string" == typeof r) {
                            var e = i(r);
                            return function(r) {
                                return r instanceof e;
                            };
                        }
                        var n = r.map(i);
                        return function(r) {
                            for(var e = 0; e < n.length; e++)if (r instanceof n[e]) return !0;
                            return !1;
                        };
                    },
                    CONSTRUCTORS: e,
                    metaSchema: {
                        anyOf: [
                            {
                                type: "string"
                            },
                            {
                                type: "array",
                                items: {
                                    type: "string"
                                }
                            }
                        ]
                    }
                }, t.addKeyword("instanceof", n.definition), t;
                function i(r) {
                    var n = e[r];
                    if (n) return n;
                    throw new Error('invalid "instanceof" keyword value ' + r);
                }
            };
        },
        {
            "buffer": "dskh"
        }
    ],
    "uBCt": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(n) {
                return e.definition = {
                    type: "number",
                    macro: function(e, n) {
                        var r = e[0], i = e[1], o = n.exclusiveRange;
                        return function(e, n, r) {
                            if (void 0 !== r && "boolean" != typeof r) throw new Error("Invalid schema for exclusiveRange keyword, should be boolean");
                            if (e > n || r && e == n) throw new Error("There are no numbers in range");
                        }(r, i, o), !0 === o ? {
                            exclusiveMinimum: r,
                            exclusiveMaximum: i
                        } : {
                            minimum: r,
                            maximum: i
                        };
                    },
                    metaSchema: {
                        type: "array",
                        minItems: 2,
                        maxItems: 2,
                        items: {
                            type: "number"
                        }
                    }
                }, n.addKeyword("range", e.definition), n.addKeyword("exclusiveRange"), n;
            };
        },
        {}
    ],
    "AtCq": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(t) {
                return e.definition = {
                    type: "string",
                    inline: function(e, t, r) {
                        return function() {
                            try {
                                if ("object" == typeof r) return new RegExp(r.pattern, r.flags);
                                var e = r.match(/^\/(.*)\/([gimuy]*)$/);
                                if (e) return new RegExp(e[1], e[2]);
                                throw new Error("cannot parse string into RegExp");
                            } catch (t) {
                                throw console.error("regular expression", r, "is invalid"), t;
                            }
                        }() + ".test(data" + (e.dataLevel || "") + ")";
                    },
                    metaSchema: {
                        type: [
                            "string",
                            "object"
                        ],
                        properties: {
                            pattern: {
                                type: "string"
                            },
                            flags: {
                                type: "string"
                            }
                        },
                        required: [
                            "pattern"
                        ],
                        additionalProperties: !1
                    }
                }, t.addKeyword("regexp", e.definition), t;
            };
        },
        {}
    ],
    "yoml": [
        function(require1, module1, exports) {
            "use strict";
            var e = [
                "undefined",
                "string",
                "number",
                "object",
                "function",
                "boolean",
                "symbol"
            ];
            module1.exports = function t(n) {
                return t.definition = {
                    inline: function(e, t, n) {
                        var i = "data" + (e.dataLevel || "");
                        return "string" == typeof n ? "typeof " + i + ' == "' + n + '"' : (n = "validate.schema" + e.schemaPath + "." + t) + ".indexOf(typeof " + i + ") >= 0";
                    },
                    metaSchema: {
                        anyOf: [
                            {
                                type: "string",
                                enum: e
                            },
                            {
                                type: "array",
                                items: {
                                    type: "string",
                                    enum: e
                                }
                            }
                        ]
                    }
                }, n.addKeyword("typeof", t.definition), n;
            };
        },
        {}
    ],
    "FbE8": [
        function(require1, module1, exports) {
            "use strict";
            var t = {}, n = {
                timestamp: function() {
                    return Date.now();
                },
                datetime: function() {
                    return (new Date).toISOString();
                },
                date: function() {
                    return (new Date).toISOString().slice(0, 10);
                },
                time: function() {
                    return (new Date).toISOString().slice(11);
                },
                random: function() {
                    return Math.random();
                },
                randomint: function(t) {
                    var n = t && t.max || 2;
                    return function() {
                        return Math.floor(Math.random() * n);
                    };
                },
                seq: function(n) {
                    var r = n && n.name || "";
                    return t[r] = t[r] || 0, function() {
                        return t[r]++;
                    };
                }
            };
            module1.exports = function t(r) {
                return t.definition = {
                    compile: function(t, n, r) {
                        var i = {};
                        for(var o in t){
                            var u = t[o], a = e("string" == typeof u ? u : u.func);
                            i[o] = a.length ? a(u.args) : a;
                        }
                        return r.opts.useDefaults && !r.compositeRule ? function(n) {
                            for(var e in t)void 0 !== n[e] && ("empty" != r.opts.useDefaults || null !== n[e] && "" !== n[e]) || (n[e] = i[e]());
                            return !0;
                        } : function() {
                            return !0;
                        };
                    },
                    DEFAULTS: n,
                    metaSchema: {
                        type: "object",
                        additionalProperties: {
                            type: [
                                "string",
                                "object"
                            ],
                            additionalProperties: !1,
                            required: [
                                "func",
                                "args"
                            ],
                            properties: {
                                func: {
                                    type: "string"
                                },
                                args: {
                                    type: "object"
                                }
                            }
                        }
                    }
                }, r.addKeyword("dynamicDefaults", t.definition), r;
                function e(t) {
                    var r = n[t];
                    if (r) return r;
                    throw new Error('invalid "dynamicDefaults" keyword property value: ' + t);
                }
            };
        },
        {}
    ],
    "CJDR": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(r) {
                return e.definition = {
                    type: "object",
                    macro: function(e, r) {
                        if (!e) return !0;
                        var t = Object.keys(r.properties);
                        return 0 == t.length || {
                            required: t
                        };
                    },
                    metaSchema: {
                        type: "boolean"
                    },
                    dependencies: [
                        "properties"
                    ]
                }, r.addKeyword("allRequired", e.definition), r;
            };
        },
        {}
    ],
    "n1DR": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(t) {
                return e.definition = {
                    type: "object",
                    macro: function(e) {
                        return 0 == e.length || (1 == e.length ? {
                            required: e
                        } : {
                            anyOf: e.map(function(e) {
                                return {
                                    required: [
                                        e
                                    ]
                                };
                            })
                        });
                    },
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                }, t.addKeyword("anyRequired", e.definition), t;
            };
        },
        {}
    ],
    "XrCF": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(t) {
                return e.definition = {
                    type: "object",
                    macro: function(e) {
                        return 0 == e.length || (1 == e.length ? {
                            required: e
                        } : {
                            oneOf: e.map(function(e) {
                                return {
                                    required: [
                                        e
                                    ]
                                };
                            })
                        });
                    },
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                }, t.addKeyword("oneRequired", e.definition), t;
            };
        },
        {}
    ],
    "MFGI": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(t) {
                return e.definition = {
                    type: "object",
                    macro: function(e) {
                        return 0 == e.length || (1 == e.length ? {
                            not: {
                                required: e
                            }
                        } : {
                            not: {
                                anyOf: e.map(function(e) {
                                    return {
                                        required: [
                                            e
                                        ]
                                    };
                                })
                            }
                        });
                    },
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                }, t.addKeyword("prohibited", e.definition), t;
            };
        },
        {}
    ],
    "m7Ap": [
        function(require1, module1, exports) {
            "use strict";
            var e = [
                "number",
                "integer",
                "string",
                "boolean",
                "null"
            ];
            function r(r, t) {
                return r.map(function(r) {
                    var n = t.items && t.items.properties, i = n && n[r] && n[r].type;
                    return Array.isArray(i) ? i.indexOf("object") < 0 && i.indexOf("array") < 0 : e.indexOf(i) >= 0;
                });
            }
            module1.exports = function e(t) {
                return e.definition = {
                    type: "array",
                    compile: function(e, t, n) {
                        var i = n.util.equal, o = r(e, t);
                        return function(r) {
                            if (r.length > 1) for(var t = 0; t < e.length; t++){
                                var n, f = e[t];
                                if (o[t]) {
                                    var a = {};
                                    for(n = r.length; n--;)if (r[n] && "object" == typeof r[n]) {
                                        var u = r[n][f];
                                        if (!u || "object" != typeof u) {
                                            if ("string" == typeof u && (u = '"' + u), a[u]) return !1;
                                            a[u] = !0;
                                        }
                                    }
                                } else for(n = r.length; n--;)if (r[n] && "object" == typeof r[n]) {
                                    for(var p = n; p--;)if (r[p] && "object" == typeof r[p] && i(r[n][f], r[p][f])) return !1;
                                }
                            }
                            return !0;
                        };
                    },
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string"
                        }
                    }
                }, t.addKeyword("uniqueItemProperties", e.definition), t;
            };
        },
        {}
    ],
    "R4Fp": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = {
                metaSchemaRef: t
            };
            var e = "http://json-schema.org/draft-07/schema";
            function t(t) {
                var a = t._opts.defaultMeta;
                return "string" == typeof a ? {
                    $ref: a
                } : t.getSchema(e) ? {
                    $ref: e
                } : (console.warn("meta schema not defined"), {});
            }
        },
        {}
    ],
    "kIuQ": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./_util");
            function r(e, r) {
                for(var i = e.split("/"), o = {}, n = o, a = 1; a < i.length; a++){
                    var p = i[a], s = a == i.length - 1;
                    p = t(p);
                    var u = n.properties = {}, f = void 0;
                    if (/[0-9]+/.test(p)) {
                        var c = +p;
                        for(f = n.items = []; c--;)f.push({});
                    }
                    n = s ? r : {}, u[p] = n, f && f.push(n);
                }
                return o;
            }
            function t(e) {
                return e.replace(/~1/g, "/").replace(/~0/g, "~");
            }
            module1.exports = function t(i) {
                return t.definition = {
                    type: "object",
                    macro: function(e) {
                        var t = [];
                        for(var i in e)t.push(r(i, e[i]));
                        return {
                            allOf: t
                        };
                    },
                    metaSchema: {
                        type: "object",
                        propertyNames: {
                            type: "string",
                            format: "json-pointer"
                        },
                        additionalProperties: e.metaSchemaRef(i)
                    }
                }, i.addKeyword("deepProperties", t.definition), i;
            };
        },
        {
            "./_util": "R4Fp"
        }
    ],
    "KB8y": [
        function(require1, module1, exports) {
            "use strict";
            function e(e, t) {
                var r = "data" + (t || "");
                if (!e) return r;
                for(var n = r, o = e.split("/"), u = 1; u < o.length; u++)n += " && " + (r += i(a(o[u])));
                return n;
            }
            module1.exports = function t(r) {
                return t.definition = {
                    type: "object",
                    inline: function(t, r, n) {
                        for(var i = "", a = 0; a < n.length; a++)a && (i += " && "), i += "(" + e(n[a], t.dataLevel) + " !== undefined)";
                        return i;
                    },
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string",
                            format: "json-pointer"
                        }
                    }
                }, r.addKeyword("deepRequired", t.definition), r;
            };
            var t = /^[a-z$_][a-z$_0-9]*$/i, r = /^[0-9]+$/, n = /'|\\/g;
            function i(e) {
                return r.test(e) ? "[" + e + "]" : t.test(e) ? "." + e : "['" + e.replace(n, "\\$&") + "']";
            }
            function a(e) {
                return e.replace(/~1/g, "/").replace(/~0/g, "~");
            }
        },
        {}
    ],
    "KeB4": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, a, r) {
                var t = " ", s = e.level, o = e.dataLevel, i = e.schema[a], l = e.schemaPath + e.util.getProperty(a), u = e.errSchemaPath + "/" + a, d = !e.opts.allErrors, m = "data" + (o || ""), f = "valid" + s;
                if (t += "var " + f + " = undefined;", !1 === e.opts.format) return t += " " + f + " = true; ";
                var n = e.schema.format, h = e.opts.$data && n.$data, c = "";
                if (h) t += " var " + (v = "format" + s) + " = formats[" + e.util.getData(n.$data, o, e.dataPathArr) + "] , " + (p = "compare" + s) + " = " + v + " && " + v + ".compare;";
                else {
                    var v;
                    if (!(v = e.formats[n]) || !v.compare) return t += "  " + f + " = true; ";
                    var p = "formats" + e.util.getProperty(n) + ".compare";
                }
                var g, P = "formatMaximum" == a, E = "formatExclusive" + (P ? "Maximum" : "Minimum"), x = e.schema[E], y = e.opts.$data && x && x.$data, S = P ? "<" : ">", $ = "result" + s, Q = e.opts.$data && i && i.$data;
                if (Q ? (t += " var schema" + s + " = " + e.util.getData(i.$data, o, e.dataPathArr) + "; ", g = "schema" + s) : g = i, y) {
                    var b = e.util.getData(x.$data, o, e.dataPathArr), w = "exclusive" + s, A = "' + " + (M = "op" + s) + " + '";
                    t += " var schemaExcl" + s + " = " + b + "; ", t += " if (typeof " + (b = "schemaExcl" + s) + " != 'boolean' && " + b + " !== undefined) { " + f + " = false; ";
                    var D = E;
                    (k = k || []).push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: '" + (D || "_formatExclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", !1 !== e.opts.messages && (t += " , message: '" + E + " should be boolean' "), e.opts.verbose && (t += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                    var L = t;
                    t = k.pop(), !e.compositeRule && d ? e.async ? t += " throw new ValidationError([" + L + "]); " : t += " validate.errors = [" + L + "]; return false; " : t += " var err = " + L + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += " }  ", d && (c += "}", t += " else { "), Q && (t += " if (" + g + " === undefined) " + f + " = true; else if (typeof " + g + " != 'string') " + f + " = false; else { ", c += "}"), h && (t += " if (!" + p + ") " + f + " = true; else { ", c += "}"), t += " var " + $ + " = " + p + "(" + m + ",  ", t += Q ? "" + g : "" + e.util.toQuotedString(i), t += " ); if (" + $ + " === undefined) " + f + " = false; var " + w + " = " + b + " === true; if (" + f + " === undefined) { " + f + " = " + w + " ? " + $ + " " + S + " 0 : " + $ + " " + S + "= 0; } if (!" + f + ") var op" + s + " = " + w + " ? '" + S + "' : '" + S + "=';";
                } else {
                    A = S;
                    (w = !0 === x) || (A += "=");
                    var M = "'" + A + "'";
                    Q && (t += " if (" + g + " === undefined) " + f + " = true; else if (typeof " + g + " != 'string') " + f + " = false; else { ", c += "}"), h && (t += " if (!" + p + ") " + f + " = true; else { ", c += "}"), t += " var " + $ + " = " + p + "(" + m + ",  ", t += Q ? "" + g : "" + e.util.toQuotedString(i), t += " ); if (" + $ + " === undefined) " + f + " = false; if (" + f + " === undefined) " + f + " = " + $ + " " + S, w || (t += "="), t += " 0;";
                }
                t += c + "if (!" + f + ") { ";
                var k;
                D = a;
                (k = k || []).push(t), t = "", !1 !== e.createErrors ? (t += " { keyword: '" + (D || "_formatLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { comparison: " + M + ", limit:  ", t += Q ? "" + g : "" + e.util.toQuotedString(i), t += " , exclusive: " + w + " } ", !1 !== e.opts.messages && (t += " , message: 'should be " + A + ' "', t += Q ? "' + " + g + " + '" : "" + e.util.escapeQuotes(i), t += "\"' "), e.opts.verbose && (t += " , schema:  ", t += Q ? "validate.schema" + l : "" + e.util.toQuotedString(i), t += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + m + " "), t += " } ") : t += " {} ";
                L = t;
                return t = k.pop(), !e.compositeRule && d ? e.async ? t += " throw new ValidationError([" + L + "]); " : t += " validate.errors = [" + L + "]; return false; " : t += " var err = " + L + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", t += "}";
            };
        },
        {}
    ],
    "mYD7": [
        function(require1, module1, exports) {
            "use strict";
            var t = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i, e = /t|\s/i, i = {
                date: n,
                time: o,
                "date-time": d
            }, r = {
                type: "object",
                required: [
                    "$data"
                ],
                properties: {
                    $data: {
                        type: "string",
                        anyOf: [
                            {
                                format: "relative-json-pointer"
                            },
                            {
                                format: "json-pointer"
                            }
                        ]
                    }
                },
                additionalProperties: !1
            };
            function a(t) {
                var e = t._formats;
                for(var r in i){
                    var a = e[r];
                    ("object" != typeof a || a instanceof RegExp || !a.validate) && (a = e[r] = {
                        validate: a
                    }), a.compare || (a.compare = i[r]);
                }
            }
            function n(t, e) {
                if (t && e) return t > e ? 1 : t < e ? -1 : t === e ? 0 : void 0;
            }
            function o(e, i) {
                if (e && i && (e = e.match(t), i = i.match(t), e && i)) return (e = e[1] + e[2] + e[3] + (e[4] || "")) > (i = i[1] + i[2] + i[3] + (i[4] || "")) ? 1 : e < i ? -1 : e === i ? 0 : void 0;
            }
            function d(t, i) {
                if (t && i) {
                    t = t.split(e), i = i.split(e);
                    var r = n(t[0], i[0]);
                    if (void 0 !== r) return r || o(t[1], i[1]);
                }
            }
            module1.exports = function(t) {
                var e = "format" + t;
                return function i(n) {
                    return i.definition = {
                        type: "string",
                        inline: require1("./dotjs/_formatLimit"),
                        statements: !0,
                        errors: "full",
                        dependencies: [
                            "format"
                        ],
                        metaSchema: {
                            anyOf: [
                                {
                                    type: "string"
                                },
                                r
                            ]
                        }
                    }, n.addKeyword(e, i.definition), n.addKeyword("formatExclusive" + t, {
                        dependencies: [
                            "format" + t
                        ],
                        metaSchema: {
                            anyOf: [
                                {
                                    type: "boolean"
                                },
                                r
                            ]
                        }
                    }), a(n), n;
                };
            };
        },
        {
            "./dotjs/_formatLimit": "KeB4"
        }
    ],
    "J927": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = require1("./_formatLimit")("Minimum");
        },
        {
            "./_formatLimit": "mYD7"
        }
    ],
    "dgLz": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = require1("./_formatLimit")("Maximum");
        },
        {
            "./_formatLimit": "mYD7"
        }
    ],
    "OTUE": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var t = " ", s = e.level, o = e.dataLevel, h = e.schema[r], i = e.schemaPath + e.util.getProperty(r), l = e.errSchemaPath + "/" + r, v = !e.opts.allErrors, n = "data" + (o || ""), d = "valid" + s, p = "key" + s, c = "idx" + s, u = "patternMatched" + s, m = "dataProperties" + s, P = "", f = e.opts.ownProperties;
                t += "var " + d + " = true;", f && (t += " var " + m + " = undefined;");
                var g = h;
                if (g) for(var y, E = -1, k = g.length - 1; E < k;){
                    y = g[E += 1], t += " var " + u + " = false;  ", t += f ? " " + m + " = " + m + " || Object.keys(" + n + "); for (var " + c + "=0; " + c + "<" + m + ".length; " + c + "++) { var " + p + " = " + m + "[" + c + "]; " : " for (var " + p + " in " + n + ") { ", t += " " + u + " = " + e.usePattern(y) + ".test(" + p + "); if (" + u + ") break; } ";
                    var b = e.util.escapeQuotes(y);
                    t += " if (!" + u + ") { " + d + " = false;  var err =   ", !1 !== e.createErrors ? (t += " { keyword: 'patternRequired' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(l) + " , params: { missingPattern: '" + b + "' } ", !1 !== e.opts.messages && (t += " , message: 'should have property matching pattern \\'" + b + "\\'' "), e.opts.verbose && (t += " , schema: validate.schema" + i + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + n + " "), t += " } ") : t += " {} ", t += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; }   ", v && (P += "}", t += " else { ");
                }
                return t += "" + P;
            };
        },
        {}
    ],
    "u2zM": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(t) {
                return e.definition = {
                    type: "object",
                    inline: require1("./dotjs/patternRequired"),
                    statements: !0,
                    errors: "full",
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string",
                            format: "regex"
                        },
                        uniqueItems: !0
                    }
                }, t.addKeyword("patternRequired", e.definition), t;
            };
        },
        {
            "./dotjs/patternRequired": "OTUE"
        }
    ],
    "mlCb": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r, a) {
                var s = " ", t = e.level, o = e.dataLevel, h = e.schema[r], l = e.schemaPath + e.util.getProperty(r), i = e.errSchemaPath + "/" + r, c = !e.opts.allErrors, v = "data" + (o || ""), n = "valid" + t, d = "errs__" + t, m = e.util.copy(e), p = "";
                m.level++;
                var u, f = "valid" + m.level, P = "ifPassed" + e.level, E = m.baseId;
                s += "var " + P + ";";
                var w = h;
                if (w) for(var y, b = -1, g = w.length - 1; b < g;){
                    if (y = w[b += 1], b && !u && (s += " if (!" + P + ") { ", p += "}"), y.if && (e.opts.strictKeywords ? "object" == typeof y.if && Object.keys(y.if).length > 0 : e.util.schemaHasRules(y.if, e.RULES.all))) {
                        s += " var " + d + " = errors;   ";
                        var R = e.compositeRule;
                        if (e.compositeRule = m.compositeRule = !0, m.createErrors = !1, m.schema = y.if, m.schemaPath = l + "[" + b + "].if", m.errSchemaPath = i + "/" + b + "/if", s += "  " + e.validate(m) + " ", m.baseId = E, m.createErrors = !0, e.compositeRule = m.compositeRule = R, s += " " + P + " = " + f + "; if (" + P + ") {  ", "boolean" == typeof y.then) {
                            if (!1 === y.then) {
                                (I = I || []).push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: 'switch' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(i) + " , params: { caseIndex: " + b + " } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"switch\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), s += " } ") : s += " {} ";
                                var S = s;
                                s = I.pop(), !e.compositeRule && c ? e.async ? s += " throw new ValidationError([" + S + "]); " : s += " validate.errors = [" + S + "]; return false; " : s += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            }
                            s += " var " + f + " = " + y.then + "; ";
                        } else m.schema = y.then, m.schemaPath = l + "[" + b + "].then", m.errSchemaPath = i + "/" + b + "/then", s += "  " + e.validate(m) + " ", m.baseId = E;
                        s += "  } else {  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; } } ";
                    } else if (s += " " + P + " = true;  ", "boolean" == typeof y.then) {
                        if (!1 === y.then) {
                            var I;
                            (I = I || []).push(s), s = "", !1 !== e.createErrors ? (s += " { keyword: 'switch' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(i) + " , params: { caseIndex: " + b + " } ", !1 !== e.opts.messages && (s += " , message: 'should pass \"switch\" keyword validation' "), e.opts.verbose && (s += " , schema: validate.schema" + l + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), s += " } ") : s += " {} ";
                            S = s;
                            s = I.pop(), !e.compositeRule && c ? e.async ? s += " throw new ValidationError([" + S + "]); " : s += " validate.errors = [" + S + "]; return false; " : s += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                        }
                        s += " var " + f + " = " + y.then + "; ";
                    } else m.schema = y.then, m.schemaPath = l + "[" + b + "].then", m.errSchemaPath = i + "/" + b + "/then", s += "  " + e.validate(m) + " ", m.baseId = E;
                    u = y.continue;
                }
                return s += p + "var " + n + " = " + f + ";";
            };
        },
        {}
    ],
    "KC2b": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./_util");
            module1.exports = function i(t) {
                if (!t.RULES.keywords.switch || !t.RULES.keywords.if) {
                    var r = e.metaSchemaRef(t);
                    return i.definition = {
                        inline: require1("./dotjs/switch"),
                        statements: !0,
                        errors: "full",
                        metaSchema: {
                            type: "array",
                            items: {
                                required: [
                                    "then"
                                ],
                                properties: {
                                    if: r,
                                    then: {
                                        anyOf: [
                                            {
                                                type: "boolean"
                                            },
                                            r
                                        ]
                                    },
                                    continue: {
                                        type: "boolean"
                                    }
                                },
                                additionalProperties: !1,
                                dependencies: {
                                    continue: [
                                        "if"
                                    ]
                                }
                            }
                        }
                    }, t.addKeyword("switch", i.definition), t;
                }
            };
        },
        {
            "./_util": "R4Fp",
            "./dotjs/switch": "mlCb"
        }
    ],
    "mwue": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./_util");
            module1.exports = function r(t) {
                if (!t._opts.$data) return console.warn("keyword select requires $data option"), t;
                var a = e.metaSchemaRef(t), n = [];
                return r.definition = {
                    validate: function e(r, t, a) {
                        if (void 0 === a.selectCases) throw new Error('keyword "selectCases" is absent');
                        var n = o(a, !1), i = n.cases[r];
                        if (void 0 === i && (i = n.default), "boolean" == typeof i) return i;
                        var s = i(t);
                        return s || (e.errors = i.errors), s;
                    },
                    $data: !0,
                    metaSchema: {
                        type: [
                            "string",
                            "number",
                            "boolean",
                            "null"
                        ]
                    }
                }, t.addKeyword("select", r.definition), t.addKeyword("selectCases", {
                    compile: function(e, r) {
                        var t = o(r);
                        for(var a in e)t.cases[a] = i(e[a]);
                        return function() {
                            return !0;
                        };
                    },
                    valid: !0,
                    metaSchema: {
                        type: "object",
                        additionalProperties: a
                    }
                }), t.addKeyword("selectDefault", {
                    compile: function(e, r) {
                        return o(r).default = i(e), function() {
                            return !0;
                        };
                    },
                    valid: !0,
                    metaSchema: a
                }), t;
                function o(e, r) {
                    var t;
                    return n.some(function(r) {
                        if (r.parentSchema === e) return t = r, !0;
                    }), t || !1 === r || (t = {
                        parentSchema: e,
                        cases: {},
                        default: !0
                    }, n.push(t)), t;
                }
                function i(e) {
                    return "boolean" == typeof e ? e : t.compile(e);
                }
            };
        },
        {
            "./_util": "R4Fp"
        }
    ],
    "selR": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function e(r) {
                var n = {
                    trimLeft: function(e) {
                        return e.replace(/^[\s]+/, "");
                    },
                    trimRight: function(e) {
                        return e.replace(/[\s]+$/, "");
                    },
                    trim: function(e) {
                        return e.trim();
                    },
                    toLowerCase: function(e) {
                        return e.toLowerCase();
                    },
                    toUpperCase: function(e) {
                        return e.toUpperCase();
                    },
                    toEnumCase: function(e, r) {
                        return r.hash[t(e)] || e;
                    }
                };
                return e.definition = {
                    type: "string",
                    errors: !1,
                    modifying: !0,
                    valid: !0,
                    compile: function(e, r) {
                        var i;
                        if (-1 !== e.indexOf("toEnumCase")) {
                            if (i = {
                                hash: {}
                            }, !r.enum) throw new Error('Missing enum. To use `transform:["toEnumCase"]`, `enum:[...]` is required.');
                            for(var o = r.enum.length; o--; o){
                                var u = r.enum[o];
                                if ("string" == typeof u) {
                                    var s = t(u);
                                    if (i.hash[s]) throw new Error('Invalid enum uniqueness. To use `transform:["toEnumCase"]`, all values must be unique when case insensitive.');
                                    i.hash[s] = u;
                                }
                            }
                        }
                        return function(r, t, o, u) {
                            if (o) {
                                for(var s = 0, a = e.length; s < a; s++)r = n[e[s]](r, i);
                                o[u] = r;
                            }
                        };
                    },
                    metaSchema: {
                        type: "array",
                        items: {
                            type: "string",
                            enum: [
                                "trimLeft",
                                "trimRight",
                                "trim",
                                "toLowerCase",
                                "toUpperCase",
                                "toEnumCase"
                            ]
                        }
                    }
                }, r.addKeyword("transform", e.definition), r;
                function t(e) {
                    return e.toLowerCase();
                }
            };
        },
        {}
    ],
    "KP4Q": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = {
                instanceof: require1("./instanceof"),
                range: require1("./range"),
                regexp: require1("./regexp"),
                typeof: require1("./typeof"),
                dynamicDefaults: require1("./dynamicDefaults"),
                allRequired: require1("./allRequired"),
                anyRequired: require1("./anyRequired"),
                oneRequired: require1("./oneRequired"),
                prohibited: require1("./prohibited"),
                uniqueItemProperties: require1("./uniqueItemProperties"),
                deepProperties: require1("./deepProperties"),
                deepRequired: require1("./deepRequired"),
                formatMinimum: require1("./formatMinimum"),
                formatMaximum: require1("./formatMaximum"),
                patternRequired: require1("./patternRequired"),
                switch: require1("./switch"),
                select: require1("./select"),
                transform: require1("./transform")
            };
        },
        {
            "./instanceof": "dhP9",
            "./range": "uBCt",
            "./regexp": "AtCq",
            "./typeof": "yoml",
            "./dynamicDefaults": "FbE8",
            "./allRequired": "CJDR",
            "./anyRequired": "n1DR",
            "./oneRequired": "XrCF",
            "./prohibited": "MFGI",
            "./uniqueItemProperties": "m7Ap",
            "./deepProperties": "kIuQ",
            "./deepRequired": "KB8y",
            "./formatMinimum": "J927",
            "./formatMaximum": "dgLz",
            "./patternRequired": "u2zM",
            "./switch": "KC2b",
            "./select": "mwue",
            "./transform": "selR"
        }
    ],
    "n1A8": [
        function(require1, module1, exports) {
            "use strict";
            var r = require1("./keywords");
            function e(e, t) {
                if (Array.isArray(t)) {
                    for(var o = 0; o < t.length; o++)n(t[o])(e);
                    return e;
                }
                if (t) return n(t)(e), e;
                for(t in r)n(t)(e);
                return e;
            }
            function n(e) {
                var n = r[e];
                if (!n) throw new Error("Unknown keyword " + e);
                return n;
            }
            module1.exports = e, e.get = n;
        },
        {
            "./keywords": "KP4Q"
        }
    ],
    "STvH": [
        function(require1, module1, exports) {
            "use strict";
            function r(r) {
                if ("undefined" == typeof Symbol || null == r[Symbol.iterator]) {
                    if (Array.isArray(r) || (r = n(r))) {
                        var t = 0, e = function() {};
                        return {
                            s: e,
                            n: function() {
                                return t >= r.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: r[t++]
                                };
                            },
                            e: function(r) {
                                throw r;
                            },
                            f: e
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var o, a, i = !0, u = !1;
                return {
                    s: function() {
                        o = r[Symbol.iterator]();
                    },
                    n: function() {
                        var r = o.next();
                        return i = r.done, r;
                    },
                    e: function(r) {
                        u = !0, a = r;
                    },
                    f: function() {
                        try {
                            i || null == o.return || o.return();
                        } finally{
                            if (u) throw a;
                        }
                    }
                };
            }
            function t(r) {
                return a(r) || o(r) || n(r) || e();
            }
            function e() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function n(r, t) {
                if (r) {
                    if ("string" == typeof r) return i(r, t);
                    var e = Object.prototype.toString.call(r).slice(8, -1);
                    return "Object" === e && r.constructor && (e = r.constructor.name), "Map" === e || "Set" === e ? Array.from(e) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? i(r, t) : void 0;
                }
            }
            function o(r) {
                if ("undefined" != typeof Symbol && Symbol.iterator in Object(r)) return Array.from(r);
            }
            function a(r) {
                if (Array.isArray(r)) return i(r);
            }
            function i(r, t) {
                (null == t || t > r.length) && (t = r.length);
                for(var e = 0, n = new Array(t); e < t; e++)n[e] = r[e];
                return n;
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.validate = y, Object.defineProperty(exports, "ValidationError", {
                enumerable: !0,
                get: function() {
                    return c.default;
                }
            });
            var u = f(require1("./keywords/absolutePath")), c = f(require1("./ValidationError"));
            function f(r) {
                return r && r.__esModule ? r : {
                    default: r
                };
            }
            var l = require1("ajv"), d = require1("ajv-keywords"), s = new l({
                allErrors: !0,
                verbose: !0,
                $data: !0
            });
            function y(r, e, n) {
                var o = [];
                if (Array.isArray(e) ? ((o = Array.from(e, function(t) {
                    return h(r, t);
                })).forEach(function(r, t) {
                    r.forEach(function r(e) {
                        e.dataPath = "[".concat(t, "]").concat(e.dataPath), e.children && e.children.forEach(r);
                    });
                }), o = o.reduce(function(r, e) {
                    return r.push.apply(r, t(e)), r;
                }, [])) : o = h(r, e), o.length > 0) throw new c.default(o, r, n);
            }
            function h(r, t) {
                var e = s.compile(r);
                return e(t) ? [] : e.errors ? m(e.errors) : [];
            }
            function m(t) {
                var e, n = [], o = r(t);
                try {
                    var a = function() {
                        var r = e.value, t = r.dataPath, o = [];
                        n = n.filter(function(r) {
                            return !r.dataPath.includes(t) || (r.children && (o = o.concat(r.children.slice(0))), r.children = void 0, o.push(r), !1);
                        }), o.length && (r.children = o), n.push(r);
                    };
                    for(o.s(); !(e = o.n()).done;)a();
                } catch (i) {
                    o.e(i);
                } finally{
                    o.f();
                }
                return n;
            }
            d(s, [
                "instanceof",
                "formatMinimum",
                "formatMaximum",
                "patternRequired"
            ]), (0, u.default)(s);
        },
        {
            "./keywords/absolutePath": "iIhC",
            "./ValidationError": "ySUA",
            "ajv": "hi5j",
            "ajv-keywords": "n1A8"
        }
    ],
    "pA46": [
        function(require1, module1, exports) {
            "use strict";
            var a = require1("./validate"), r = a.validate, i = a.ValidationError;
            module1.exports = {
                validate: r,
                ValidationError: i
            };
        },
        {
            "./validate": "STvH"
        }
    ],
    "t7hQ": [
        function(require1, module1, exports) {
            function r(r, n) {
                return i(r) || o(r, n) || e(r, n) || t();
            }
            function t() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function e(r, t) {
                if (r) {
                    if ("string" == typeof r) return n(r, t);
                    var e = Object.prototype.toString.call(r).slice(8, -1);
                    return "Object" === e && r.constructor && (e = r.constructor.name), "Map" === e || "Set" === e ? Array.from(e) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? n(r, t) : void 0;
                }
            }
            function n(r, t) {
                (null == t || t > r.length) && (t = r.length);
                for(var e = 0, n = new Array(t); e < t; e++)n[e] = r[e];
                return n;
            }
            function o(r, t) {
                if ("undefined" != typeof Symbol && Symbol.iterator in Object(r)) {
                    var e = [], n = !0, o = !1, i = void 0;
                    try {
                        for(var a, u = r[Symbol.iterator](); !(n = (a = u.next()).done) && (e.push(a.value), !t || e.length !== t); n = !0);
                    } catch (l) {
                        o = !0, i = l;
                    } finally{
                        try {
                            n || null == u.return || u.return();
                        } finally{
                            if (o) throw i;
                        }
                    }
                    return e;
                }
            }
            function i(r) {
                if (Array.isArray(r)) return r;
            }
            var a = require1("schema-utils"), u = a.validate;
            function l(r, t) {
                u(t, r);
            }
            function c(t, e) {
                for(var n = {}, o = 0, i = Object.entries(e); o < i.length; o++){
                    var a = r(i[o], 2), u = a[0], l = a[1];
                    n[u] = t[u], void 0 === n[u] && (n[u] = l.default), l.process && (n[u] = l.process(n[u]));
                }
                return n;
            }
            module1.exports = {
                validateOptions: l,
                processOptions: c
            };
        },
        {
            "schema-utils": "pA46"
        }
    ],
    "uYXM": [
        function(require1, module1, exports) {
            module1.exports = {
                type: "object",
                properties: {
                    filerDir: {
                        type: "string"
                    },
                    shimsDir: {
                        type: "string"
                    },
                    shimFs: {
                        type: "boolean"
                    },
                    shimPath: {
                        type: "boolean"
                    },
                    fsProvider: {
                        type: "string"
                    },
                    fsProviderDir: {
                        type: "string"
                    }
                }
            };
        },
        {}
    ],
    "qUtu": [
        function(require1, module1, exports) {
            var process = require1("process");
            var e = require1("process"), r = require1("path"), s = "<rootDir>", o = e.cwd();
            module1.exports = {
                filerDir: {
                    process: function(e) {
                        return e ? r.resolve(e.replace(s, o)) : r.join(o, "node_modules", "filer");
                    }
                },
                shimsDir: {
                    process: function(e) {
                        return e ? r.resolve(e.replace(s, o)) : r.join(o, "node_modules", "filer", "shims");
                    }
                },
                fsProviderDir: {
                    process: function(e) {
                        return e ? r.resolve(e.replace(s, o)) : r.join(o, "node_modules", "filer", "shims", "providers");
                    }
                },
                shimFs: {
                    default: !0
                },
                shimPath: {
                    default: !0
                },
                fsProvider: {
                    default: "default"
                }
            };
        },
        {
            "path": "UUq2",
            "process": "pBGv"
        }
    ],
    "Ge14": [
        function(require1, module1, exports) {
            function e(e, r) {
                if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
            }
            function r(e, r) {
                for(var i = 0; i < r.length; i++){
                    var o = r[i];
                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                }
            }
            function i(e, i, o) {
                return i && r(e.prototype, i), o && r(e, o), e;
            }
            var o = require1("path"), s = require1("./utils"), t = "filer-webpack-plugin", n = require1("./schema"), a = require1("./processors");
            module1.exports = function() {
                function r() {
                    var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    e(this, r), s.validateOptions(i, n), this.options = s.processOptions(i, a);
                }
                return i(r, [
                    {
                        key: "apply",
                        value: function(e) {
                            var r = this;
                            e.hooks.normalModuleFactory.tap(t, function(e) {
                                e.hooks.resolve.tap(t, function(e) {
                                    if ("fsProvider" === e.request && e.context === r.options.shimsDir) return r.resolveFsProvider(e);
                                    if (!e.context.startsWith(r.options.filerDir)) switch(e.request){
                                        case "fs":
                                            if (!r.options.shimFs) return;
                                            return r.applyFsShim(e);
                                        case "path":
                                            if (!r.options.shimPath) return;
                                            return r.applyPathShim(e);
                                        default:
                                            return;
                                    }
                                });
                            });
                        }
                    },
                    {
                        key: "resolveFsProvider",
                        value: function(e) {
                            switch(this.options.fsProvider){
                                case "default":
                                    e.request = o.join(this.options.fsProviderDir, "default.js");
                                    break;
                                case "indexeddb":
                                    e.request = o.join(this.options.fsProviderDir, "indexeddb.js");
                                    break;
                                case "memory":
                                    e.request = o.join(this.options.fsProviderDir, "memory.js");
                                    break;
                                case "custom":
                                    e.request = o.join(this.options.fsProviderDir, "custom.js");
                                    break;
                                default:
                                    throw new Error([
                                        "Invalid option for fsProvider.",
                                        "fsProvider must be one of 'default', 'indexeddb', 'memory' or 'custom'.",
                                        "If using a custom fsProvider, you must also provide the fsProviderDir option."
                                    ].join(" "));
                            }
                        }
                    },
                    {
                        key: "applyFsShim",
                        value: function(e) {
                            e.request = o.join(this.options.shimsDir, "fs.js");
                        }
                    },
                    {
                        key: "applyPathShim",
                        value: function(e) {
                            e.request = o.join(this.options.shimsDir, "path.js");
                        }
                    }
                ]), r;
            }();
        },
        {
            "path": "UUq2",
            "./utils": "t7hQ",
            "./schema": "uYXM",
            "./processors": "qUtu"
        }
    ],
    "Focm": [
        function(require1, module1, exports) {
            var Buffer = require1("buffer").Buffer;
            var e = require1("buffer").Buffer, r = null, l = null;
            module1.exports = l = {
                FileSystem: require1("./filesystem/interface.js"),
                Buffer: e,
                Path: require1("./path.js"),
                path: require1("./path.js"),
                Errors: require1("./errors.js"),
                Shell: require1("./shell/shell.js"),
                FilerWebpackPlugin: require1("./webpack-plugin")
            }, Object.defineProperty(l, "fs", {
                enumerable: !0,
                get: function() {
                    return r || (r = new l.FileSystem), r;
                }
            });
        },
        {
            "./filesystem/interface.js": "GMi4",
            "./path.js": "UzoP",
            "./errors.js": "p8GN",
            "./shell/shell.js": "D1Ra",
            "./webpack-plugin": "Ge14",
            "buffer": "dskh"
        }
    ]
}, {}, [
    "Focm"
], "Filer") //# sourceMappingURL=/filer.min.js.map
;


var $6e2b186194ca9ee7$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $6e2b186194ca9ee7$var$R = typeof Reflect === "object" ? Reflect : null;
var $6e2b186194ca9ee7$var$ReflectApply = $6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.apply === "function" ? $6e2b186194ca9ee7$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $6e2b186194ca9ee7$var$ReflectOwnKeys;
if ($6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.ownKeys === "function") $6e2b186194ca9ee7$var$ReflectOwnKeys = $6e2b186194ca9ee7$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $6e2b186194ca9ee7$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $6e2b186194ca9ee7$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $6e2b186194ca9ee7$var$EventEmitter() {
    $6e2b186194ca9ee7$var$EventEmitter.init.call(this);
}
$6e2b186194ca9ee7$exports = $6e2b186194ca9ee7$var$EventEmitter;
$6e2b186194ca9ee7$exports.once = $6e2b186194ca9ee7$var$once;
// Backwards-compat with node 0.10.x
$6e2b186194ca9ee7$var$EventEmitter.EventEmitter = $6e2b186194ca9ee7$var$EventEmitter;
$6e2b186194ca9ee7$var$EventEmitter.prototype._events = undefined;
$6e2b186194ca9ee7$var$EventEmitter.prototype._eventsCount = 0;
$6e2b186194ca9ee7$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $6e2b186194ca9ee7$var$defaultMaxListeners = 10;
function $6e2b186194ca9ee7$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($6e2b186194ca9ee7$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $6e2b186194ca9ee7$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $6e2b186194ca9ee7$var$defaultMaxListeners = arg;
    }
});
$6e2b186194ca9ee7$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6e2b186194ca9ee7$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $6e2b186194ca9ee7$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $6e2b186194ca9ee7$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $6e2b186194ca9ee7$var$_getMaxListeners(this);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $6e2b186194ca9ee7$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $6e2b186194ca9ee7$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$6e2b186194ca9ee7$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $6e2b186194ca9ee7$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $6e2b186194ca9ee7$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $6e2b186194ca9ee7$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, false);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.on = $6e2b186194ca9ee7$var$EventEmitter.prototype.addListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, true);
};
function $6e2b186194ca9ee7$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $6e2b186194ca9ee7$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $6e2b186194ca9ee7$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.once = function once(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.on(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.prependListener(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $6e2b186194ca9ee7$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.off = $6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $6e2b186194ca9ee7$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $6e2b186194ca9ee7$var$unwrapListeners(evlistener) : $6e2b186194ca9ee7$var$arrayClone(evlistener, evlistener.length);
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, true);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, false);
};
$6e2b186194ca9ee7$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $6e2b186194ca9ee7$var$listenerCount.call(emitter, type);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.listenerCount = $6e2b186194ca9ee7$var$listenerCount;
function $6e2b186194ca9ee7$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $6e2b186194ca9ee7$var$ReflectOwnKeys(this._events) : [];
};
function $6e2b186194ca9ee7$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $6e2b186194ca9ee7$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $6e2b186194ca9ee7$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $6e2b186194ca9ee7$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


let $d2d6477b44a50ea0$var$virtualGlobalObject = {};
let $d2d6477b44a50ea0$var$env = "browser";
function $d2d6477b44a50ea0$var$setupGlobalObject() {
    if (typeof window !== "undefined") {
        window.globalObject = window;
        $d2d6477b44a50ea0$var$env = "browser";
        return window; // browser
    }
    if (typeof self !== "undefined") {
        self.globalObject = self;
        self.import = importScripts;
        $d2d6477b44a50ea0$var$env = "web-worker";
        return self; // web worker
    }
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.globalObject = $parcel$global;
        $d2d6477b44a50ea0$var$env = "nodejs. Not sure why you need virtual fs in node!";
        return $parcel$global; //nodejs
    }
    return $d2d6477b44a50ea0$var$virtualGlobalObject;
}
$d2d6477b44a50ea0$var$setupGlobalObject();
const $d2d6477b44a50ea0$var$urlParams = new URLSearchParams(location.search);
globalObject.Filer = $8f57302d7f35c9a9$exports;
if (!globalObject.Buffer) globalObject.Buffer = $d2d6477b44a50ea0$require$Buffer;
if (!globalObject.EventEmitter) globalObject.EventEmitter = $6e2b186194ca9ee7$exports;
globalObject.virtualfs = {
    urlParams: $d2d6477b44a50ea0$var$urlParams,
    debugMode: globalObject.debugMode || $d2d6477b44a50ea0$var$urlParams.get("debug") === "true",
    env: $d2d6477b44a50ea0$var$env
};
console.log(`PhoenixFS: virtual fs started in debugMode:${virtualfs.debugMode} on environment: ${virtualfs.env}`);
var $fe07aa8563a4b855$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ // Ensure globalObject is available in both browser and web worker contexts
// virtualfs.js sets this up, but we need a fallback for safety
var $3c12ae0d63e57f9f$exports = {};
"use strict";

var $aavGG = parcelRequire("aavGG");
var $3c12ae0d63e57f9f$require$Buffer = $aavGG.Buffer;
var $3a89adc249496c19$export$e46ffb123c920c9f;
//------------------------------------------------------------------------------
var $3a89adc249496c19$export$99ac9f64d7386375;
"use strict";
var $3a89adc249496c19$var$BOMChar = "\uFEFF";
$3a89adc249496c19$export$e46ffb123c920c9f = $3a89adc249496c19$var$PrependBOMWrapper;
function $3a89adc249496c19$var$PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
$3a89adc249496c19$var$PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = $3a89adc249496c19$var$BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
$3a89adc249496c19$var$PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
};
$3a89adc249496c19$export$99ac9f64d7386375 = $3a89adc249496c19$var$StripBOMWrapper;
function $3a89adc249496c19$var$StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
$3a89adc249496c19$var$StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === $3a89adc249496c19$var$BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === "function") this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
$3a89adc249496c19$var$StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};


var $3c12ae0d63e57f9f$var$iconv = $3c12ae0d63e57f9f$exports;
// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
$3c12ae0d63e57f9f$var$iconv.encodings = null;
// Characters emitted in case of error.
$3c12ae0d63e57f9f$var$iconv.defaultCharUnicode = "�";
$3c12ae0d63e57f9f$var$iconv.defaultCharSingleByte = "?";
// Public API.
$3c12ae0d63e57f9f$var$iconv.encode = function encode(str, encoding, options) {
    str = "" + (str || ""); // Ensure string.
    var encoder = $3c12ae0d63e57f9f$var$iconv.getEncoder(encoding, options);
    var res = encoder.write(str);
    var trail = encoder.end();
    return trail && trail.length > 0 ? $3c12ae0d63e57f9f$require$Buffer.concat([
        res,
        trail
    ]) : res;
};
$3c12ae0d63e57f9f$var$iconv.decode = function decode(buf, encoding, options) {
    if (typeof buf === "string") {
        if (!$3c12ae0d63e57f9f$var$iconv.skipDecodeWarning) {
            console.error("Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding");
            $3c12ae0d63e57f9f$var$iconv.skipDecodeWarning = true;
        }
        buf = $3c12ae0d63e57f9f$require$Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
    }
    var decoder = $3c12ae0d63e57f9f$var$iconv.getDecoder(encoding, options);
    var res = decoder.write(buf);
    var trail = decoder.end();
    return trail ? res + trail : res;
};
$3c12ae0d63e57f9f$var$iconv.encodingExists = function encodingExists(enc) {
    try {
        $3c12ae0d63e57f9f$var$iconv.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
};
// Legacy aliases to convert functions
$3c12ae0d63e57f9f$var$iconv.toEncoding = $3c12ae0d63e57f9f$var$iconv.encode;
$3c12ae0d63e57f9f$var$iconv.fromEncoding = $3c12ae0d63e57f9f$var$iconv.decode;
// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
$3c12ae0d63e57f9f$var$iconv._codecDataCache = {};

$3c12ae0d63e57f9f$var$iconv.getCodec = function getCodec(encoding) {
    if (!$3c12ae0d63e57f9f$var$iconv.encodings) $3c12ae0d63e57f9f$var$iconv.encodings = (parcelRequire("9rkWe")); // Lazy load all encoding definitions.
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = $3c12ae0d63e57f9f$var$iconv._canonicalizeEncoding(encoding);
    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while(true){
        var codec = $3c12ae0d63e57f9f$var$iconv._codecDataCache[enc];
        if (codec) return codec;
        var codecDef = $3c12ae0d63e57f9f$var$iconv.encodings[enc];
        switch(typeof codecDef){
            case "string":
                enc = codecDef;
                break;
            case "object":
                for(var key in codecDef)codecOptions[key] = codecDef[key];
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                enc = codecDef.type;
                break;
            case "function":
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, $3c12ae0d63e57f9f$var$iconv);
                $3c12ae0d63e57f9f$var$iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;
            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
        }
    }
};
$3c12ae0d63e57f9f$var$iconv._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return ("" + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
};
$3c12ae0d63e57f9f$var$iconv.getEncoder = function getEncoder(encoding, options) {
    var codec = $3c12ae0d63e57f9f$var$iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
    if (codec.bomAware && options && options.addBOM) encoder = new $3a89adc249496c19$export$e46ffb123c920c9f(encoder, options);
    return encoder;
};
$3c12ae0d63e57f9f$var$iconv.getDecoder = function getDecoder(encoding, options) {
    var codec = $3c12ae0d63e57f9f$var$iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new $3a89adc249496c19$export$99ac9f64d7386375(decoder, options);
    return decoder;
};

// Streaming API
// NOTE: Streaming API naturally depends on 'stream' module from Node.js. Unfortunately in browser environments this module can add
// up to 100Kb to the output bundle. To avoid unnecessary code bloat, we don't enable Streaming API in browser by default.
// If you would like to enable it explicitly, please add the following code to your app:
// > iconv.enableStreamingAPI(require('stream'));
$3c12ae0d63e57f9f$var$iconv.enableStreamingAPI = function enableStreamingAPI(stream_module) {
    if ($3c12ae0d63e57f9f$var$iconv.supportsStreams) return;
    // Dependency-inject stream module to create IconvLite stream classes.
    var streams = (parcelRequire("dGogL"))(stream_module);
    // Not public API yet, but expose the stream classes.
    $3c12ae0d63e57f9f$var$iconv.IconvLiteEncoderStream = streams.IconvLiteEncoderStream;
    $3c12ae0d63e57f9f$var$iconv.IconvLiteDecoderStream = streams.IconvLiteDecoderStream;
    // Streaming API.
    $3c12ae0d63e57f9f$var$iconv.encodeStream = function encodeStream(encoding, options) {
        return new $3c12ae0d63e57f9f$var$iconv.IconvLiteEncoderStream($3c12ae0d63e57f9f$var$iconv.getEncoder(encoding, options), options);
    };
    $3c12ae0d63e57f9f$var$iconv.decodeStream = function decodeStream(encoding, options) {
        return new $3c12ae0d63e57f9f$var$iconv.IconvLiteDecoderStream($3c12ae0d63e57f9f$var$iconv.getDecoder(encoding, options), options);
    };
    $3c12ae0d63e57f9f$var$iconv.supportsStreams = true;
};
// Enable Streaming API automatically if 'stream' module is available and non-empty (the majority of environments).
var $3c12ae0d63e57f9f$var$stream_module;

try {
    $3c12ae0d63e57f9f$var$stream_module = (parcelRequire("foUwZ"));
} catch (e) {}
if ($3c12ae0d63e57f9f$var$stream_module && $3c12ae0d63e57f9f$var$stream_module.Transform) $3c12ae0d63e57f9f$var$iconv.enableStreamingAPI($3c12ae0d63e57f9f$var$stream_module);
else // In rare cases where 'stream' module is not available by default, throw a helpful exception.
$3c12ae0d63e57f9f$var$iconv.encodeStream = $3c12ae0d63e57f9f$var$iconv.decodeStream = function() {
    throw new Error("iconv-lite Streaming API is not enabled. Use iconv.enableStreamingAPI(require('stream')); to enable it.");
};



var $ibaza = parcelRequire("ibaza");
if (typeof globalObject === "undefined") {
    if (typeof window !== "undefined") window.globalObject = window;
    else if (typeof self !== "undefined") self.globalObject = self;
}
var $505970e6c1eacf0c$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 * Copyright (c) 2012-2015 Rod Vagg (@rvagg)
 * Based on : https://github.com/rvagg/node-errno
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*eslint-env es6*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ /** All phoenix shell errors and their description.
 *
 * This module should be functionally as light weight as possible with minimal deps as it is a shell component.
 * **/ const $505970e6c1eacf0c$var$ERROR_CODES = {
    ENOENT: "ENOENT",
    UNKNOWN: "UNKNOWN",
    OK: "OK",
    EOF: "EOF",
    EADDRINFO: "EADDRINFO",
    EACCES: "EACCES",
    EAGAIN: "EAGAIN",
    EADDRINUSE: "EADDRINUSE",
    EADDRNOTAVAIL: "EADDRNOTAVAIL",
    EAFNOSUPPORT: "EAFNOSUPPORT",
    EALREADY: "EALREADY",
    EBADF: "EBADF",
    EBUSY: "EBUSY",
    ECONNABORTED: "ECONNABORTED",
    ECONNREFUSED: "ECONNREFUSED",
    ECONNRESET: "ECONNRESET",
    EDESTADDRREQ: "EDESTADDRREQ",
    EFAULT: "EFAULT",
    EHOSTUNREACH: "EHOSTUNREACH",
    EINTR: "EINTR",
    EINVAL: "EINVAL",
    EISCONN: "EISCONN",
    EMFILE: "EMFILE",
    EMSGSIZE: "EMSGSIZE",
    ENETDOWN: "ENETDOWN",
    ENETUNREACH: "ENETUNREACH",
    ENFILE: "ENFILE",
    ENOBUFS: "ENOBUFS",
    ENOMEM: "ENOMEM",
    ENOTDIR: "ENOTDIR",
    EISDIR: "EISDIR",
    ENONET: "ENONET",
    ENOTCONN: "ENOTCONN",
    ENOTSOCK: "ENOTSOCK",
    ENOTSUP: "ENOTSUP",
    ENOSYS: "ENOSYS",
    EPIPE: "EPIPE",
    EPROTO: "EPROTO",
    EPROTONOSUPPORT: "EPROTONOSUPPORT",
    EPROTOTYPE: "EPROTOTYPE",
    ETIMEDOUT: "ETIMEDOUT",
    ECHARSET: "ECHARSET",
    EAIFAMNOSUPPORT: "EAIFAMNOSUPPORT",
    EAISERVICE: "EAISERVICE",
    EAISOCKTYPE: "EAISOCKTYPE",
    ESHUTDOWN: "ESHUTDOWN",
    EEXIST: "EEXIST",
    ESRCH: "ESRCH",
    ENAMETOOLONG: "ENAMETOOLONG",
    EPERM: "EPERM",
    ELOOP: "ELOOP",
    EXDEV: "EXDEV",
    ENOTEMPTY: "ENOTEMPTY",
    ENOSPC: "ENOSPC",
    EIO: "EIO",
    EROFS: "EROFS",
    ENODEV: "ENODEV",
    ESPIPE: "ESPIPE",
    ECANCELED: "ECANCELED"
};
const $505970e6c1eacf0c$var$FS_ERROR_CODES = {
    ENOENT: $505970e6c1eacf0c$var$ERROR_CODES.ENOENT,
    EOF: $505970e6c1eacf0c$var$ERROR_CODES.EOF,
    EACCES: $505970e6c1eacf0c$var$ERROR_CODES.EACCES,
    EAGAIN: $505970e6c1eacf0c$var$ERROR_CODES.EAGAIN,
    EBADF: $505970e6c1eacf0c$var$ERROR_CODES.EBADF,
    EBUSY: $505970e6c1eacf0c$var$ERROR_CODES.EBUSY,
    EINVAL: $505970e6c1eacf0c$var$ERROR_CODES.EINVAL,
    EMFILE: $505970e6c1eacf0c$var$ERROR_CODES.EMFILE,
    ENFILE: $505970e6c1eacf0c$var$ERROR_CODES.ENFILE,
    ENOBUFS: $505970e6c1eacf0c$var$ERROR_CODES.ENOBUFS,
    ENOTDIR: $505970e6c1eacf0c$var$ERROR_CODES.ENOTDIR,
    EISDIR: $505970e6c1eacf0c$var$ERROR_CODES.EISDIR,
    ENOSYS: $505970e6c1eacf0c$var$ERROR_CODES.ENOSYS,
    ECHARSET: $505970e6c1eacf0c$var$ERROR_CODES.ECHARSET,
    EEXIST: $505970e6c1eacf0c$var$ERROR_CODES.EEXIST,
    ENAMETOOLONG: $505970e6c1eacf0c$var$ERROR_CODES.ENAMETOOLONG,
    EPERM: $505970e6c1eacf0c$var$ERROR_CODES.EPERM,
    ELOOP: $505970e6c1eacf0c$var$ERROR_CODES.ELOOP,
    EXDEV: $505970e6c1eacf0c$var$ERROR_CODES.EXDEV,
    ENOTEMPTY: $505970e6c1eacf0c$var$ERROR_CODES.ENOTEMPTY,
    ENOSPC: $505970e6c1eacf0c$var$ERROR_CODES.ENOSPC,
    EIO: $505970e6c1eacf0c$var$ERROR_CODES.EIO,
    EROFS: $505970e6c1eacf0c$var$ERROR_CODES.EROFS,
    ESPIPE: $505970e6c1eacf0c$var$ERROR_CODES.ESPIPE,
    ECANCELED: $505970e6c1eacf0c$var$ERROR_CODES.ECANCELED //operation canceled
};
const $505970e6c1eacf0c$var$ALL_ERRORS = [
    {
        errno: -2,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOENT,
        description: "no such file or directory"
    },
    {
        errno: -1,
        code: $505970e6c1eacf0c$var$ERROR_CODES.UNKNOWN,
        description: "unknown error"
    },
    {
        errno: 0,
        code: $505970e6c1eacf0c$var$ERROR_CODES.OK,
        description: "success"
    },
    {
        errno: 1,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EOF,
        description: "end of file"
    },
    {
        errno: 2,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EADDRINFO,
        description: "getaddrinfo error"
    },
    {
        errno: 3,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EACCES,
        description: "permission denied"
    },
    {
        errno: 4,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EAGAIN,
        description: "resource temporarily unavailable"
    },
    {
        errno: 5,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EADDRINUSE,
        description: "address already in use"
    },
    {
        errno: 6,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EADDRNOTAVAIL,
        description: "address not available"
    },
    {
        errno: 7,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EAFNOSUPPORT,
        description: "address family not supported"
    },
    {
        errno: 8,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EALREADY,
        description: "connection already in progress"
    },
    {
        errno: 9,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EBADF,
        description: "bad file descriptor"
    },
    {
        errno: 10,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EBUSY,
        description: "resource busy or locked"
    },
    {
        errno: 11,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ECONNABORTED,
        description: "software caused connection abort"
    },
    {
        errno: 12,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ECONNREFUSED,
        description: "connection refused"
    },
    {
        errno: 13,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ECONNRESET,
        description: "connection reset by peer"
    },
    {
        errno: 14,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EDESTADDRREQ,
        description: "destination address required"
    },
    {
        errno: 15,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EFAULT,
        description: "bad address in system call argument"
    },
    {
        errno: 16,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EHOSTUNREACH,
        description: "host is unreachable"
    },
    {
        errno: 17,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EINTR,
        description: "interrupted system call"
    },
    {
        errno: 18,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EINVAL,
        description: "invalid argument"
    },
    {
        errno: 19,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EISCONN,
        description: "socket is already connected"
    },
    {
        errno: 20,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EMFILE,
        description: "too many open files"
    },
    {
        errno: 21,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EMSGSIZE,
        description: "message/datagram too long"
    },
    {
        errno: 22,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENETDOWN,
        description: "network is down"
    },
    {
        errno: 23,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENETUNREACH,
        description: "network is unreachable"
    },
    {
        errno: 24,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENFILE,
        description: "file table overflow"
    },
    {
        errno: 25,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOBUFS,
        description: "no buffer space available"
    },
    {
        errno: 26,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOMEM,
        description: "not enough memory/ high virtual memory usage"
    },
    {
        errno: 27,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOTDIR,
        description: "not a directory"
    },
    {
        errno: 28,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EISDIR,
        description: "illegal operation on a directory"
    },
    {
        errno: 29,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENONET,
        description: "machine is not on the network"
    },
    {
        errno: 31,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOTCONN,
        description: "socket is not connected"
    },
    {
        errno: 32,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOTSOCK,
        description: "socket operation on non-socket"
    },
    {
        errno: 33,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOTSUP,
        description: "operation not supported on socket"
    },
    {
        errno: 34,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOENT,
        description: "no such file or directory"
    },
    {
        errno: 35,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOSYS,
        description: "function not implemented"
    },
    {
        errno: 36,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EPIPE,
        description: "broken pipe"
    },
    {
        errno: 37,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EPROTO,
        description: "protocol error"
    },
    {
        errno: 38,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EPROTONOSUPPORT,
        description: "protocol not supported"
    },
    {
        errno: 39,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EPROTOTYPE,
        description: "protocol wrong type for socket"
    },
    {
        errno: 40,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ETIMEDOUT,
        description: "connection timed out"
    },
    {
        errno: 41,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ECHARSET,
        description: "invalid Unicode character"
    },
    {
        errno: 42,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EAIFAMNOSUPPORT,
        description: "address family for hostname not supported"
    },
    {
        errno: 44,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EAISERVICE,
        description: "servname not supported for ai_socktype"
    },
    {
        errno: 45,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EAISOCKTYPE,
        description: "ai_socktype not supported"
    },
    {
        errno: 46,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ESHUTDOWN,
        description: "cannot send after transport endpoint shutdown"
    },
    {
        errno: 47,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EEXIST,
        description: "file already exists"
    },
    {
        errno: 48,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ESRCH,
        description: "no such process"
    },
    {
        errno: 49,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENAMETOOLONG,
        description: "name too long"
    },
    {
        errno: 50,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EPERM,
        description: "operation not permitted"
    },
    {
        errno: 51,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ELOOP,
        description: "too many symbolic links encountered"
    },
    {
        errno: 52,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EXDEV,
        description: "cross-device link not permitted"
    },
    {
        errno: 53,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOTEMPTY,
        description: "directory not empty"
    },
    {
        errno: 54,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENOSPC,
        description: "no space left on device"
    },
    {
        errno: 55,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EIO,
        description: "i/o error"
    },
    {
        errno: 56,
        code: $505970e6c1eacf0c$var$ERROR_CODES.EROFS,
        description: "read-only file system"
    },
    {
        errno: 57,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ENODEV,
        description: "no such device"
    },
    {
        errno: 58,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ESPIPE,
        description: "invalid seek"
    },
    {
        errno: 59,
        code: $505970e6c1eacf0c$var$ERROR_CODES.ECANCELED,
        description: "operation canceled"
    }
];
let $505970e6c1eacf0c$var$ERRNO_TO_ERROR_MAP = {};
let $505970e6c1eacf0c$var$CODE_TO_ERROR_MAP = {};
$505970e6c1eacf0c$var$ALL_ERRORS.forEach(function(error) {
    $505970e6c1eacf0c$var$ERRNO_TO_ERROR_MAP[error.errno] = error;
    $505970e6c1eacf0c$var$CODE_TO_ERROR_MAP[error.code] = error;
});
const $505970e6c1eacf0c$var$ERR_CODES = {
    ERROR_CODES: $505970e6c1eacf0c$var$ERROR_CODES,
    FS_ERROR_CODES: $505970e6c1eacf0c$var$FS_ERROR_CODES,
    ALL_ERRORS: $505970e6c1eacf0c$var$ALL_ERRORS,
    ERRNO_TO_ERROR_MAP: $505970e6c1eacf0c$var$ERRNO_TO_ERROR_MAP,
    CODE_TO_ERROR_MAP: $505970e6c1eacf0c$var$CODE_TO_ERROR_MAP
};
const $505970e6c1eacf0c$var$Errors = {};
[
    /**
     * node.js errors - we only use some of these, add as needed.
     */ //'-1:UNKNOWN:unknown error',
    //'0:OK:success',
    "1:EOF:end of file",
    //'2:EADDRINFO:getaddrinfo error',
    "3:EACCES:permission denied",
    "4:EAGAIN:resource temporarily unavailable",
    //'5:EADDRINUSE:address already in use',
    //'6:EADDRNOTAVAIL:address not available',
    //'7:EAFNOSUPPORT:address family not supported',
    //'8:EALREADY:connection already in progress',
    "9:EBADF:bad file descriptor",
    "10:EBUSY:resource busy or locked",
    //'11:ECONNABORTED:software caused connection abort',
    //'12:ECONNREFUSED:connection refused',
    //'13:ECONNRESET:connection reset by peer',
    //'14:EDESTADDRREQ:destination address required',
    //'15:EFAULT:bad address in system call argument',
    //'16:EHOSTUNREACH:host is unreachable',
    //'17:EINTR:interrupted system call',
    "18:EINVAL:invalid argument",
    //'19:EISCONN:socket is already connected',
    "20:EMFILE:too many open files",
    //'21:EMSGSIZE:message too long',
    //'22:ENETDOWN:network is down',
    //'23:ENETUNREACH:network is unreachable',
    "24:ENFILE:file table overflow",
    "25:ENOBUFS:no buffer space available",
    //'26:ENOMEM:not enough memory',
    "27:ENOTDIR:not a directory",
    "28:EISDIR:illegal operation on a directory",
    //'29:ENONET:machine is not on the network',
    // errno 30 skipped, as per https://github.com/rvagg/node-errno/blob/master/errno.js
    //'31:ENOTCONN:socket is not connected',
    //'32:ENOTSOCK:socket operation on non-socket',
    //'33:ENOTSUP:operation not supported on socket',
    "34:ENOENT:no such file or directory",
    "35:ENOSYS:function not implemented",
    //'36:EPIPE:broken pipe',
    //'37:EPROTO:protocol error',
    //'38:EPROTONOSUPPORT:protocol not supported',
    //'39:EPROTOTYPE:protocol wrong type for socket',
    //'40:ETIMEDOUT:connection timed out',
    "41:ECHARSET:invalid Unicode character",
    //'42:EAIFAMNOSUPPORT:address family for hostname not supported',
    // errno 43 skipped, as per https://github.com/rvagg/node-errno/blob/master/errno.js
    //'44:EAISERVICE:servname not supported for ai_socktype',
    //'45:EAISOCKTYPE:ai_socktype not supported',
    //'46:ESHUTDOWN:cannot send after transport endpoint shutdown',
    "47:EEXIST:file already exists",
    //'48:ESRCH:no such process',
    "49:ENAMETOOLONG:name too long",
    "50:EPERM:operation not permitted",
    "51:ELOOP:too many symbolic links encountered",
    "52:EXDEV:cross-device link not permitted",
    "53:ENOTEMPTY:directory not empty",
    "54:ENOSPC:no space left on device",
    "55:EIO:i/o error",
    "56:EROFS:read-only file system",
    //'57:ENODEV:no such device',
    "58:ESPIPE:invalid seek",
    "59:ECANCELED:operation canceled",
    /**
     * Phoenix/Filer specific errors
     */ "1000:ENOTMOUNTED:not mounted",
    "1001:EFILESYSTEMERROR:missing super node, use 'FORMAT' flag to format filesystem.",
    "1002:ENOATTR:attribute does not exist"
].forEach(function(e) {
    e = e.split(":");
    var errno = +e[0];
    var errName = e[1];
    var defaultMessage = e[2];
    function FilerError(msg, path) {
        Error.call(this);
        this.name = errName;
        this.code = errName;
        this.errno = errno;
        this.message = msg || defaultMessage;
        if (path) this.path = path;
        this.stack = new Error(this.message).stack;
    }
    FilerError.prototype = Object.create(Error.prototype);
    FilerError.prototype.constructor = FilerError;
    FilerError.prototype.toString = function() {
        var pathInfo = this.path ? ", '" + this.path + "'" : "";
        return this.name + ": " + this.message + pathInfo;
    };
    // We expose the error as both Errors.EINVAL and Errors[18]
    $505970e6c1eacf0c$var$Errors[errName] = $505970e6c1eacf0c$var$Errors[errno] = FilerError;
});
$505970e6c1eacf0c$exports = {
    Errors: $505970e6c1eacf0c$var$Errors,
    ERR_CODES: $505970e6c1eacf0c$var$ERR_CODES
};


var $fe07aa8563a4b855$require$ERR_CODES = $505970e6c1eacf0c$exports.ERR_CODES;
var $fe07aa8563a4b855$require$Errors = $505970e6c1eacf0c$exports.Errors;
var $93a77513e637ad12$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ 
var $N0o3H = parcelRequire("N0o3H");
var $93a77513e637ad12$require$Buffer = $N0o3H.Buffer;
var $aa3c82cc608bd675$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ 
var $aa3c82cc608bd675$require$Errors = $505970e6c1eacf0c$exports.Errors;
var $5d5bda998e954df2$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ /**
 * Persists serialised mounted native file system handles to indexed db to usage across tabs and sessions.
**/ var $53cc2e000314a49f$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ /* jshint ignore:start */ const $53cc2e000314a49f$var$Constants = {
    MOUNT_DEVICE_NAME: "nativeFsAccess",
    ELECTRON_DEVICE_NAME: "electron",
    TAURI_DEVICE_NAME: "tauri",
    TAURI_WS_DEVICE_NAME: "tauriWS",
    KIND_FILE: "file",
    KIND_DIRECTORY: "directory",
    NODE_TYPE_FILE: "FILE",
    NODE_TYPE_DIRECTORY: "DIRECTORY",
    IDB_RW_TYPE: "readwrite",
    MOUNT_POINT_ROOT: "/mnt",
    TAURI_ROOT: "/tauri",
    BINARY_ENCODING: "binary",
    BYTE_ARRAY_ENCODING: "byte_array",
    WATCH_EVENTS: {
        ADD_FILE: "add",
        ADD_DIR: "addDir",
        CHANGE: "change",
        UNLINK_FILE: "unlink",
        UNLINK_DIR: "unlinkDir"
    }
};
$53cc2e000314a49f$exports = {
    Constants: $53cc2e000314a49f$var$Constants
};


var $5d5bda998e954df2$require$Constants = $53cc2e000314a49f$exports.Constants;
var $a1c01bdca744e04f$exports = {};
const $a1c01bdca744e04f$var$idb = function(e) {
    "use strict";
    let t, n;
    const r = new WeakMap, o = new WeakMap, s = new WeakMap, a = new WeakMap, i = new WeakMap;
    let c = {
        get (e, t, n) {
            if (e instanceof IDBTransaction) {
                if ("done" === t) return o.get(e);
                if ("objectStoreNames" === t) return e.objectStoreNames || s.get(e);
                if ("store" === t) return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
            }
            return p(e[t]);
        },
        set: (e, t, n)=>(e[t] = n, !0),
        has: (e, t)=>e instanceof IDBTransaction && ("done" === t || "store" === t) || t in e
    };
    function u(e) {
        return e !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype ? (n || (n = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey
        ])).includes(e) ? function(...t) {
            return e.apply(f(this), t), p(r.get(this));
        } : function(...t) {
            return p(e.apply(f(this), t));
        } : function(t, ...n) {
            const r = e.call(f(this), t, ...n);
            return s.set(r, t.sort ? t.sort() : [
                t
            ]), p(r);
        };
    }
    function d(e) {
        var n;
        return "function" == typeof e ? u(e) : (e instanceof IDBTransaction && function(e) {
            if (o.has(e)) return;
            const t = new Promise((t, n)=>{
                const r = ()=>{
                    e.removeEventListener("complete", o), e.removeEventListener("error", s), e.removeEventListener("abort", s);
                }, o = ()=>{
                    t(), r();
                }, s = ()=>{
                    n(e.error || new DOMException("AbortError", "AbortError")), r();
                };
                e.addEventListener("complete", o), e.addEventListener("error", s), e.addEventListener("abort", s);
            });
            o.set(e, t);
        }(e), n = e, (t || (t = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction
        ])).some((e)=>n instanceof e) ? new Proxy(e, c) : e);
    }
    function p(e) {
        if (e instanceof IDBRequest) return function(e) {
            const t = new Promise((t, n)=>{
                const r = ()=>{
                    e.removeEventListener("success", o), e.removeEventListener("error", s);
                }, o = ()=>{
                    t(p(e.result)), r();
                }, s = ()=>{
                    n(e.error), r();
                };
                e.addEventListener("success", o), e.addEventListener("error", s);
            });
            return t.then((t)=>{
                t instanceof IDBCursor && r.set(t, e);
            }).catch(()=>{}), i.set(t, e), t;
        }(e);
        if (a.has(e)) return a.get(e);
        const t = d(e);
        return t !== e && (a.set(e, t), i.set(t, e)), t;
    }
    const f = (e)=>i.get(e);
    const l = [
        "get",
        "getKey",
        "getAll",
        "getAllKeys",
        "count"
    ], D = [
        "put",
        "add",
        "delete",
        "clear"
    ], v = new Map;
    function b(e, t) {
        if (!(e instanceof IDBDatabase) || t in e || "string" != typeof t) return;
        if (v.get(t)) return v.get(t);
        const n = t.replace(/FromIndex$/, ""), r = t !== n, o = D.includes(n);
        if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || !o && !l.includes(n)) return;
        const s = async function(e, ...t) {
            const s = this.transaction(e, o ? "readwrite" : "readonly");
            let a = s.store;
            return r && (a = a.index(t.shift())), (await Promise.all([
                a[n](...t),
                o && s.done
            ]))[0];
        };
        return v.set(t, s), s;
    }
    return c = ((e)=>({
            ...e,
            get: (t, n, r)=>b(t, n) || e.get(t, n, r),
            has: (t, n)=>!!b(t, n) || e.has(t, n)
        }))(c), e.deleteDB = function(e, { blocked: t } = {}) {
        const n = indexedDB.deleteDatabase(e);
        return t && n.addEventListener("blocked", ()=>t()), p(n).then(()=>{});
    }, e.openDB = function(e, t, { blocked: n, upgrade: r, blocking: o, terminated: s } = {}) {
        const a = indexedDB.open(e, t), i = p(a);
        return r && a.addEventListener("upgradeneeded", (e)=>{
            r(p(a.result), e.oldVersion, e.newVersion, p(a.transaction));
        }), n && a.addEventListener("blocked", ()=>n()), i.then((e)=>{
            s && e.addEventListener("close", ()=>s()), o && e.addEventListener("versionchange", ()=>o());
        }).catch(()=>{}), i;
    }, e.unwrap = f, e.wrap = p, e;
}({});
$a1c01bdca744e04f$exports = {
    idb: $a1c01bdca744e04f$var$idb
};


var $5d5bda998e954df2$require$idb = $a1c01bdca744e04f$exports.idb;
const $5d5bda998e954df2$var$PHOENIX_MOUNTS_DB_NAME = "PHOENIX_MOUNTS";
const $5d5bda998e954df2$var$STORE_NAME = "FS_ACCESS";
const $5d5bda998e954df2$var$MOUNT_POINTS_KEY = "MOUNT_POINTS";
const $5d5bda998e954df2$var$VERSION_1 = 1;
let $5d5bda998e954df2$var$db = null;
let $5d5bda998e954df2$var$_currentMounts = {};
async function $5d5bda998e954df2$var$_ensureDB() {
    if ($5d5bda998e954df2$var$db) return;
    $5d5bda998e954df2$var$db = await $5d5bda998e954df2$require$idb.openDB($5d5bda998e954df2$var$PHOENIX_MOUNTS_DB_NAME, $5d5bda998e954df2$var$VERSION_1, {
        upgrade (db) {
            db.createObjectStore($5d5bda998e954df2$var$STORE_NAME);
        }
    });
}
async function $5d5bda998e954df2$var$addMountPoint(mountName, handle) {
    await $5d5bda998e954df2$var$_ensureDB();
    const tx = $5d5bda998e954df2$var$db.transaction($5d5bda998e954df2$var$STORE_NAME, $5d5bda998e954df2$require$Constants.IDB_RW_TYPE);
    const store = tx.objectStore($5d5bda998e954df2$var$STORE_NAME);
    $5d5bda998e954df2$var$_currentMounts = await store.get($5d5bda998e954df2$var$MOUNT_POINTS_KEY) || {};
    $5d5bda998e954df2$var$_currentMounts[mountName] = handle;
    await store.put($5d5bda998e954df2$var$_currentMounts, $5d5bda998e954df2$var$MOUNT_POINTS_KEY);
    await tx.done;
}
async function $5d5bda998e954df2$var$refreshMountPoints() {
    await $5d5bda998e954df2$var$_ensureDB();
    const tx = $5d5bda998e954df2$var$db.transaction($5d5bda998e954df2$var$STORE_NAME, $5d5bda998e954df2$require$Constants.IDB_RW_TYPE);
    const store = tx.objectStore($5d5bda998e954df2$var$STORE_NAME);
    $5d5bda998e954df2$var$_currentMounts = await store.get($5d5bda998e954df2$var$MOUNT_POINTS_KEY) || {};
    await tx.done;
    return $5d5bda998e954df2$var$_currentMounts;
}
function $5d5bda998e954df2$var$getMountPoints() {
    return $5d5bda998e954df2$var$_currentMounts;
}
const $5d5bda998e954df2$var$MountPointsStore = {
    addMountPoint: $5d5bda998e954df2$var$addMountPoint,
    getMountPoints: $5d5bda998e954df2$var$getMountPoints,
    refreshMountPoints: $5d5bda998e954df2$var$refreshMountPoints
};
$5d5bda998e954df2$exports = {
    MountPointsStore: $5d5bda998e954df2$var$MountPointsStore
};


var $aa3c82cc608bd675$require$MountPointsStore = $5d5bda998e954df2$exports.MountPointsStore;

var $aa3c82cc608bd675$require$Constants = $53cc2e000314a49f$exports.Constants;
const $aa3c82cc608bd675$var$MOUNT_POINT_CHANGED_NOTIFICATION = "PHOENIX_MOUNT_POINT_CHANGED_NOTIFICATION";
let $aa3c82cc608bd675$var$MAX_NUM_MOUNTS = 1000000;
let $aa3c82cc608bd675$var$_channel = null;
/**
 * Check if the given path is a subpath of the '/mnt' folder.
 * @param path
 */ function $aa3c82cc608bd675$var$isMountSubPath(path) {
    if (typeof path !== "string") return false;
    let mntSubPathStart = $aa3c82cc608bd675$require$Constants.MOUNT_POINT_ROOT + "/";
    if (path) {
        path = globalObject.path.normalize(path);
        if (path.startsWith(mntSubPathStart) && path.length > mntSubPathStart.length) return true;
    }
    return false;
}
/**
 * Check if the given path is '/mnt' folder.
 * @param path
 */ function $aa3c82cc608bd675$var$isMountPath(path) {
    if (typeof path !== "string") return false;
    if (path) {
        path = globalObject.path.normalize(path);
        if (path === $aa3c82cc608bd675$require$Constants.MOUNT_POINT_ROOT) return true;
    }
    return false;
}
function $aa3c82cc608bd675$var$_setupBroadcastChannel() {
    if ($aa3c82cc608bd675$var$_channel) return;
    if (typeof BroadcastChannel === "undefined") {
        /* eslint no-console: 0 */ console.warn("BroadcastChannel not supported. Mount point changes wont reflect across tabs.");
        return;
    }
    $aa3c82cc608bd675$var$_channel = new BroadcastChannel($aa3c82cc608bd675$var$MOUNT_POINT_CHANGED_NOTIFICATION);
}
function $aa3c82cc608bd675$var$_broadcastMountPointChanged() {
    $aa3c82cc608bd675$var$_setupBroadcastChannel();
    $aa3c82cc608bd675$var$_channel.postMessage($aa3c82cc608bd675$var$MOUNT_POINT_CHANGED_NOTIFICATION);
}
function $aa3c82cc608bd675$var$_listenToMountPointChanges() {
    $aa3c82cc608bd675$var$_setupBroadcastChannel();
    $aa3c82cc608bd675$var$_channel.onmessage = async function(event) {
        if (event.data === $aa3c82cc608bd675$var$MOUNT_POINT_CHANGED_NOTIFICATION) await $aa3c82cc608bd675$require$MountPointsStore.refreshMountPoints();
    };
}
/**
 * Checks if the given handleToMount is same as or a subdir of all existing mounts
 * @param handleToMount
 * @returns {*[]} array of details of handleToMount relative to existing mount
 * @private
 */ function $aa3c82cc608bd675$var$_resolveFileHandle(handleToMount) {
    let allMountPointResolutions = [];
    const currentMounts = $aa3c82cc608bd675$require$MountPointsStore.getMountPoints();
    for (const [mountName, handle] of Object.entries(currentMounts))allMountPointResolutions.push(new Promise((resolve)=>{
        const isSameEntryPromise = handle.isSameEntry(handleToMount);
        const isSubEntryPromise = handle.resolve(handleToMount);
        Promise.all([
            isSameEntryPromise,
            isSubEntryPromise
        ]).then((mountDetail)=>{
            let isSameEntry = mountDetail[0] || false;
            let subPathList = mountDetail[1] || [];
            resolve({
                existingMountName: mountName,
                isSameEntry: isSameEntry,
                subPath: subPathList.join("/")
            });
        });
    }));
    return allMountPointResolutions;
}
function $aa3c82cc608bd675$var$_getPathIfAlreadyMounted(handleToMount) {
    return new Promise((resolve)=>{
        let allMountPointResolutions = $aa3c82cc608bd675$var$_resolveFileHandle(handleToMount);
        Promise.all(allMountPointResolutions).then((values)=>{
            for(let i = 0; i < values.length; i++){
                let mountName = values[i].existingMountName;
                if (values[i].isSameEntry) {
                    resolve(`${$aa3c82cc608bd675$require$Constants.MOUNT_POINT_ROOT}/${mountName}`);
                    return;
                } else if (values[i].subPath.length >= 1) {
                    resolve(`${$aa3c82cc608bd675$require$Constants.MOUNT_POINT_ROOT}/${mountName}/${values[i].subPath}`);
                    return;
                }
            }
            resolve(null);
        });
    });
}
function $aa3c82cc608bd675$var$_getNewMountName(handleToMount) {
    let name = handleToMount.name;
    const currentMounts = $aa3c82cc608bd675$require$MountPointsStore.getMountPoints();
    if (!currentMounts[name]) return name;
    for(let i = 0; i < $aa3c82cc608bd675$var$MAX_NUM_MOUNTS; i++){
        let mountName = `${name}_${i}`;
        if (!currentMounts[mountName]) return mountName;
    }
}
/**
 * If the new handle is the same as or a subdir of an existing mount, we return the existing mount path
 * resolved to the given handle. Eg, if a folder `a` with subdir `b` is mounted to `mnt/a`;if we try to mount subdir `b`
 * then, we will return `mnt/a/b` as `b` is a subdirectory of an already mounted directory.
 * @param handleToMount
 * @param currentMounts {mountName1:handle1, ...}
 * @private
 */ function $aa3c82cc608bd675$var$_mountHandle(handleToMount) {
    return new Promise(async (resolve, reject)=>{
        // eslint async executors are needed here. we explicitly catch so it's fine.
        try {
            let path = await $aa3c82cc608bd675$var$_getPathIfAlreadyMounted(handleToMount);
            if (path) resolve(path);
            else {
                let mountName = $aa3c82cc608bd675$var$_getNewMountName(handleToMount);
                if (!mountName) reject("Mount name not fount");
                else {
                    await $aa3c82cc608bd675$require$MountPointsStore.addMountPoint(mountName, handleToMount);
                    resolve(`${$aa3c82cc608bd675$require$Constants.MOUNT_POINT_ROOT}/${mountName}`);
                }
            }
        } catch (e) {
            reject(e);
        }
    });
}
/**
 * Mounts a native folder, using a provided directory handle or prompting the user with a directory picker if no handle is provided.
 *
 * @param {Object|null} [optionalDirHandle] - An optional directory handle to use for mounting. If not provided, the function will prompt the user to select a directory.
 * @param {Function} callback - A callback function that will be called once the mounting process completes or fails. The callback will be passed two parameters: an error (or null if no error) and an array containing the mounted path (or null if mounting failed).
 *
 * @example
 * // Using the directory picker
 * mountNativeFolder(function(error, [mountPath]) {
 *     if (error) {
 *         console.error("Error mounting directory:", error);
 *     } else {
 *         console.log("Directory mounted at:", mountPath);
 *     }
 * });
 *
 * @example
 * // Using a provided directory handle
 * const dirHandle = { /* ... directory handle ... * / };
 * mountNativeFolder(dirHandle, function(error, [mountPath]) {
 *     if (error) {
 *         console.error("Error mounting directory:", error);
 *     } else {
 *         console.log("Directory mounted at:", mountPath);
 *     }
 * });
 */ function $aa3c82cc608bd675$var$mountNativeFolder(optionalDirHandle, callback) {
    if (!callback) {
        callback = optionalDirHandle;
        optionalDirHandle = null;
    }
    let mountedPath = null;
    let error = null;
    $aa3c82cc608bd675$require$MountPointsStore.refreshMountPoints().then(()=>optionalDirHandle || globalObject.showDirectoryPicker()).then((directoryHandle)=>$aa3c82cc608bd675$var$_mountHandle(directoryHandle)).then((mountPath)=>mountedPath = mountPath).then(()=>$aa3c82cc608bd675$var$_broadcastMountPointChanged()).catch(function(err) {
        error = new $aa3c82cc608bd675$require$Errors.ENOTMOUNTED(err);
    }).finally(()=>{
        if (callback) callback(error, [
            mountedPath
        ]);
        else if (error) throw new $aa3c82cc608bd675$require$Errors.ENOTMOUNTED(error);
    });
}
async function $aa3c82cc608bd675$var$_verifyOrRequestPermission(handle) {
    const options = {
        mode: "read"
    };
    // Check if permission was already granted. If so, return true.
    try {
        let status = await handle.queryPermission(options);
        if (status === "granted") return null;
        status = await handle.requestPermission(options);
        if (status === "granted") return null;
        else return new $aa3c82cc608bd675$require$Errors.EACCES(`Dir permissions not granted ${handle.name}`);
    } catch (e) {
        if (e.code === e.NOT_FOUND_ERR) return new $aa3c82cc608bd675$require$Errors.ENOENT(`Dir does not exist ${handle.name}`, e);
        else return new $aa3c82cc608bd675$require$Errors.EIO(`Phoenix fs could not read directory ${handle.name}`, e);
    }
}
async function $aa3c82cc608bd675$var$_findLeafNode(currentNode, pathArray, currentIndex, callback) {
    let pathLength = pathArray.length;
    if (currentIndex === pathLength) {
        callback(null, currentNode);
        return;
    }
    let childName = pathArray[currentIndex];
    let childDirHandle = null;
    let childFileHandle = null;
    try {
        childDirHandle = await currentNode.getDirectoryHandle(childName);
    } catch (e) {
    // do nothing
    }
    try {
        childFileHandle = await currentNode.getFileHandle(childName);
    } catch (e) {
    // do nothing
    }
    if (childFileHandle && currentIndex === pathLength - 1) // the last node is a file
    callback(null, childFileHandle);
    else if (childDirHandle) $aa3c82cc608bd675$var$_findLeafNode(childDirHandle, pathArray, currentIndex + 1, callback);
    else {
        let path = pathArray.join("/");
        callback(new $aa3c82cc608bd675$require$Errors.ENOENT("File/Dir does not exist: ", path));
    }
}
async function $aa3c82cc608bd675$var$getHandleFromPath(normalisedPath, callback) {
    const pathNodes = normalisedPath.split("/");
    const currentMounts = $aa3c82cc608bd675$require$MountPointsStore.getMountPoints();
    if (pathNodes.length < 3 || pathNodes[0] !== "" || pathNodes[1] !== "mnt") callback(new $aa3c82cc608bd675$require$Errors.EINVAL("Cannot operate on path " + normalisedPath));
    let mountPoint = currentMounts[pathNodes[2]];
    if (!mountPoint) {
        callback(new $aa3c82cc608bd675$require$Errors.ENOENT("Path does not exist: ", normalisedPath));
        return;
    }
    let error = await $aa3c82cc608bd675$var$_verifyOrRequestPermission(mountPoint);
    if (error) {
        callback(error);
        return;
    }
    $aa3c82cc608bd675$var$_findLeafNode(mountPoint, pathNodes, 3, callback);
}
async function $aa3c82cc608bd675$var$getHandleFromPathIfPresent(normalisedPath) {
    return new Promise((resolve)=>{
        $aa3c82cc608bd675$var$getHandleFromPath(normalisedPath, (err, handle)=>{
            if (err) resolve(null);
            else resolve(handle);
        });
    });
}
function $aa3c82cc608bd675$var$getMountPoints() {
    return $aa3c82cc608bd675$require$MountPointsStore.getMountPoints();
}
function $aa3c82cc608bd675$var$refreshMountPoints() {
    return $aa3c82cc608bd675$require$MountPointsStore.refreshMountPoints();
}
$aa3c82cc608bd675$var$_listenToMountPointChanges();
const $aa3c82cc608bd675$var$Mounts = {
    mountNativeFolder: $aa3c82cc608bd675$var$mountNativeFolder,
    isMountPath: $aa3c82cc608bd675$var$isMountPath,
    isMountSubPath: $aa3c82cc608bd675$var$isMountSubPath,
    getHandleFromPath: $aa3c82cc608bd675$var$getHandleFromPath,
    getMountPoints: $aa3c82cc608bd675$var$getMountPoints,
    refreshMountPoints: $aa3c82cc608bd675$var$refreshMountPoints,
    getHandleFromPathIfPresent: $aa3c82cc608bd675$var$getHandleFromPathIfPresent
};
$aa3c82cc608bd675$exports = {
    Mounts: $aa3c82cc608bd675$var$Mounts
};


var $93a77513e637ad12$require$Mounts = $aa3c82cc608bd675$exports.Mounts;

var $93a77513e637ad12$require$Errors = $505970e6c1eacf0c$exports.Errors;
var $93a77513e637ad12$require$ERR_CODES = $505970e6c1eacf0c$exports.ERR_CODES;

var $93a77513e637ad12$require$Constants = $53cc2e000314a49f$exports.Constants;
var $e1f0b8fa1ae2171c$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ /*global globalObject*/ // jshint ignore: start
/*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ 


var $N0o3H = parcelRequire("N0o3H");
var $e1f0b8fa1ae2171c$require$Buffer = $N0o3H.Buffer;

var $e1f0b8fa1ae2171c$require$Constants = $53cc2e000314a49f$exports.Constants;
const $e1f0b8fa1ae2171c$var$TAURI_PATH_PREFIX = $e1f0b8fa1ae2171c$require$Constants.TAURI_ROOT + "/";
const $e1f0b8fa1ae2171c$var$IS_WINDOWS = navigator.userAgent.includes("Windows");
function $e1f0b8fa1ae2171c$var$_dateFromMs(ms) {
    if (ms === null || ms === undefined) return null;
    return new Date(Number(ms));
}
function $e1f0b8fa1ae2171c$var$Stats(path, fileNode, devName) {
    this.dev = devName;
    this.node = fileNode.id;
    this.type = fileNode.type;
    this.size = fileNode.size;
    this.nlinks = fileNode.nlinks;
    this.nlink = fileNode.nlinks;
    // Date objects
    this.atime = $e1f0b8fa1ae2171c$var$_dateFromMs(fileNode.atime);
    this.mtime = $e1f0b8fa1ae2171c$var$_dateFromMs(fileNode.mtime);
    this.ctime = $e1f0b8fa1ae2171c$var$_dateFromMs(fileNode.ctime);
    // Unix timestamp MS Numbers
    this.atimeMs = fileNode.atime;
    this.mtimeMs = fileNode.mtime;
    this.ctimeMs = fileNode.ctime;
    this.version = fileNode.version;
    this.mode = fileNode.mode;
    this.readonly = fileNode.readonly;
    this.name = globalObject.path.basename(path);
}
$e1f0b8fa1ae2171c$var$Stats.prototype.isFile = function() {
    return this.type === $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_FILE;
};
$e1f0b8fa1ae2171c$var$Stats.prototype.isDirectory = function() {
    return this.type === $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_DIRECTORY;
};
$e1f0b8fa1ae2171c$var$Stats.prototype.isSymbolicLink = function() {
    return this.type === $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_SYMBOLIC_LINK;
};
// These will always be false in Filer.
$e1f0b8fa1ae2171c$var$Stats.prototype.isSocket = $e1f0b8fa1ae2171c$var$Stats.prototype.isFIFO = $e1f0b8fa1ae2171c$var$Stats.prototype.isCharacterDevice = $e1f0b8fa1ae2171c$var$Stats.prototype.isBlockDevice = function() {
    return false;
};
function $e1f0b8fa1ae2171c$var$_getType(handle) {
    switch(handle.kind){
        case $e1f0b8fa1ae2171c$require$Constants.KIND_FILE:
            return $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_FILE;
        case $e1f0b8fa1ae2171c$require$Constants.KIND_DIRECTORY:
            return $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_DIRECTORY;
        default:
            return null;
    }
}
async function $e1f0b8fa1ae2171c$var$_getDetails(nativeFsHandle) {
    let file = null;
    let details = {};
    switch(nativeFsHandle.kind){
        case $e1f0b8fa1ae2171c$require$Constants.KIND_FILE:
            file = await nativeFsHandle.getFile();
            details.size = file.size;
            details.mtime = file.lastModified;
            return details;
        case $e1f0b8fa1ae2171c$require$Constants.KIND_DIRECTORY:
        default:
            return details;
    }
}
const $e1f0b8fa1ae2171c$var$createStatObject = async function(path, handle) {
    let details = await $e1f0b8fa1ae2171c$var$_getDetails(handle);
    let fileDetails = {
        type: $e1f0b8fa1ae2171c$var$_getType(handle),
        size: details.size,
        mtime: details.mtime
    };
    return new $e1f0b8fa1ae2171c$var$Stats(path, fileDetails, $e1f0b8fa1ae2171c$require$Constants.MOUNT_DEVICE_NAME);
};
const $e1f0b8fa1ae2171c$var$createDummyStatObject = function(path, isDir, deviceName) {
    let fileDetails = {
        type: isDir ? $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_DIRECTORY : $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_FILE,
        size: 0
    };
    return new $e1f0b8fa1ae2171c$var$Stats(path, fileDetails, deviceName);
};
const $e1f0b8fa1ae2171c$var$createFromTauriStat = function(vfsPath, stats) {
    let type = $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_DIRECTORY;
    if (stats.isFile) type = $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_FILE;
    else if (stats.isSymlink) type = $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_SYMBOLIC_LINK;
    stats.permissions = stats.permissions || {};
    let fileDetails = {
        type: type,
        size: stats.size,
        mode: stats.mode || stats.permissions.mode,
        readonly: stats.permissions.readonly,
        ctime: stats.createdAtMs,
        atime: stats.accessedAtMs,
        mtime: stats.modifiedAtMs,
        nlinks: stats.nlink
    };
    return new $e1f0b8fa1ae2171c$var$Stats(vfsPath, fileDetails, `${$e1f0b8fa1ae2171c$require$Constants.TAURI_DEVICE_NAME}_${stats.dev}`);
};
const $e1f0b8fa1ae2171c$var$createFromNodeStat = function(vfsPath, stats, deviceNamePrefix) {
    let type = $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_DIRECTORY;
    if (stats.isFile) type = $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_FILE;
    else if (stats.isSymbolicLink) type = $e1f0b8fa1ae2171c$require$Constants.NODE_TYPE_SYMBOLIC_LINK;
    stats.permissions = stats.permissions || {};
    let fileDetails = {
        type: type,
        size: stats.size,
        mode: stats.mode,
        readonly: stats.readonly,
        ctime: stats.ctimeMs,
        atime: stats.atimeMs,
        mtime: stats.mtimeMs,
        nlinks: stats.nlink
    };
    return new $e1f0b8fa1ae2171c$var$Stats(vfsPath, fileDetails, `${deviceNamePrefix}_${stats.dev}`);
};
function $e1f0b8fa1ae2171c$var$validateFileOptions(options, enc, fileMode) {
    if (!options || typeof options === "function") options = {
        encoding: enc,
        flag: fileMode
    };
    else if (typeof options === "string") options = {
        encoding: options,
        flag: fileMode
    };
    options.encoding = options.encoding || enc;
    options.flag = options.flag || fileMode;
    return options;
}
const $e1f0b8fa1ae2171c$var$NATIVE_ENCODINGS = [
    "utf8",
    "UTF8",
    "utf-8",
    "UTF-8"
];
// ArrayBuffer to string
function $e1f0b8fa1ae2171c$var$getDecodedString(arrayBuffer, encoding) {
    if (!(arrayBuffer instanceof ArrayBuffer)) throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL(`ArrayBuffer expected to decode ${encoding}`);
    if (encoding === $e1f0b8fa1ae2171c$require$Constants.BYTE_ARRAY_ENCODING) encoding = $e1f0b8fa1ae2171c$require$Constants.BINARY_ENCODING;
    try {
        if ($e1f0b8fa1ae2171c$var$NATIVE_ENCODINGS[encoding]) // for utf8 we use the browser native decoder.
        // The browser encoder does only utf-8, so we only use the native encoder/decoder for utf8.
        return new TextDecoder(encoding).decode(arrayBuffer);
        else return $3c12ae0d63e57f9f$exports.decode($e1f0b8fa1ae2171c$require$Buffer.from(arrayBuffer), encoding);
    } catch (e) {
        throw new (0, $505970e6c1eacf0c$exports.Errors).ECHARSET(`${encoding} not supported ${e.message}`);
    }
}
function $e1f0b8fa1ae2171c$var$getDecodedStringFromBuffer(buf, encoding) {
    if (!$e1f0b8fa1ae2171c$require$Buffer.isBuffer(buf)) throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL(`Buffer expected to decode ${encoding}`);
    if (encoding === $e1f0b8fa1ae2171c$require$Constants.BYTE_ARRAY_ENCODING) encoding = $e1f0b8fa1ae2171c$require$Constants.BINARY_ENCODING;
    try {
        // for buffer, we directly use iconv for even utf 8 to prevent large file array copys
        return $3c12ae0d63e57f9f$exports.decode(buf, encoding);
    } catch (e) {
        throw new (0, $505970e6c1eacf0c$exports.Errors).ECHARSET(`${encoding} not supported ${e.message}`);
    }
}
// getEncodedArrayBuffer and getEncodedBuffer for performance. filer natively uses Buffer and tauri/fs access
// uses array buffer. So we have both to prevent unnecessary large data buffer<>arrayBuffer conversions.
function $e1f0b8fa1ae2171c$var$getEncodedArrayBuffer(str, encoding) {
    if (typeof str !== "string") throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL(`String expected to Encode ${encoding} but got ${typeof str}`);
    if (encoding === $e1f0b8fa1ae2171c$require$Constants.BYTE_ARRAY_ENCODING) encoding = $e1f0b8fa1ae2171c$require$Constants.BINARY_ENCODING;
    try {
        if ($e1f0b8fa1ae2171c$var$NATIVE_ENCODINGS[encoding]) {
            // for utf8 we use the browser native decoder.
            // The browser encoder does only utf-8, so we only use the native encoder/decoder for utf8.
            let encoder = new TextEncoder(encoding);
            return encoder.encode(str).buffer;
        } else {
            let buf = $3c12ae0d63e57f9f$exports.encode(str, encoding);
            return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
        }
    } catch (e) {
        throw new (0, $505970e6c1eacf0c$exports.Errors).ECHARSET(`${encoding} not supported ${e.message}`);
    }
}
// getEncodedArrayBuffer and getEncodedBuffer for performance. filer natively uses Buffer and tauri/fs access
// uses array buffer. So we have both to prevent unnecessary large data buffer<>arrayBuffer conversions.
function $e1f0b8fa1ae2171c$var$getEncodedBuffer(str, encoding) {
    if (typeof str !== "string") throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL(`String expected to Encode ${encoding} but got ${typeof str}`);
    if (encoding === $e1f0b8fa1ae2171c$require$Constants.BYTE_ARRAY_ENCODING) encoding = $e1f0b8fa1ae2171c$require$Constants.BINARY_ENCODING;
    try {
        if ($e1f0b8fa1ae2171c$var$NATIVE_ENCODINGS[encoding]) {
            // for utf8 we use the browser native decoder.
            // The browser encoder does only utf-8, so we only use the native encoder/decoder for utf8.
            let encoder = new TextEncoder(encoding);
            return $e1f0b8fa1ae2171c$require$Buffer.from(encoder.encode(str).buffer);
        } else return $3c12ae0d63e57f9f$exports.encode(str, encoding);
    } catch (e) {
        throw new (0, $505970e6c1eacf0c$exports.Errors).ECHARSET(`${encoding} not supported ${e.message}`);
    }
}
/**
 * Converts a buffer to an `ArrayBuffer`.
 *
 * @param {Buffer} buf The buffer to convert
 * @return {ArrayBuffer} Converted buffer
 * @public
 */ function $e1f0b8fa1ae2171c$var$toArrayBuffer(buf) {
    if (buf.length === buf.buffer.byteLength) return buf.buffer;
    return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.length);
}
/**
 *
 * @param metadata {Object} Max size can be 4GB
 * @param bufferData {ArrayBuffer} [optional]
 * @return {ArrayBuffer}
 * @private
 */ function $e1f0b8fa1ae2171c$var$mergeMetadataAndArrayBuffer(metadata, bufferData = new ArrayBuffer(0)) {
    if (typeof metadata !== "object") throw new Error("metadata should be an object, but was " + typeof metadata);
    if (!(bufferData instanceof ArrayBuffer)) throw new Error("Expected bufferData to be an instance of ArrayBuffer, but was " + typeof bufferData);
    const metadataString = JSON.stringify(metadata);
    const metadataUint8Array = new TextEncoder().encode(metadataString);
    const metadataBuffer = metadataUint8Array.buffer;
    const sizePrefixLength = 4; // 4 bytes for a 32-bit integer
    if (metadataBuffer.byteLength > 4294000000) throw new Error("metadata too large. Should be below 4,294MB, but was " + metadataBuffer.byteLength);
    const concatenatedBuffer = new ArrayBuffer(sizePrefixLength + metadataBuffer.byteLength + bufferData.byteLength);
    const concatenatedUint8Array = new Uint8Array(concatenatedBuffer);
    // Write the length of metadataBuffer as a 32-bit integer
    new DataView(concatenatedBuffer).setUint32(0, metadataBuffer.byteLength, true);
    // Copy the metadataUint8Array and bufferData (if provided) to the concatenatedUint8Array
    concatenatedUint8Array.set(metadataUint8Array, sizePrefixLength);
    if (bufferData.byteLength > 0) concatenatedUint8Array.set(new Uint8Array(bufferData), sizePrefixLength + metadataBuffer.byteLength);
    return concatenatedBuffer;
}
function $e1f0b8fa1ae2171c$var$splitMetadataAndBuffer(concatenatedBuffer) {
    if (!(concatenatedBuffer instanceof ArrayBuffer)) throw new Error("Expected ArrayBuffer message from websocket");
    const sizePrefixLength = 4;
    const buffer1Length = new DataView(concatenatedBuffer).getUint32(0, true); // Little endian
    const buffer1 = concatenatedBuffer.slice(sizePrefixLength, sizePrefixLength + buffer1Length);
    let buffer2;
    if (concatenatedBuffer.byteLength > sizePrefixLength + buffer1Length) buffer2 = concatenatedBuffer.slice(sizePrefixLength + buffer1Length);
    return {
        metadata: JSON.parse(new TextDecoder().decode(buffer1)),
        bufferData: buffer2
    };
}
/**
 * Convert Phoenix virtual file system path to platform-specific paths.
 * For Windows, `/tauri/c/d/a.txt` will correspond to `c:\d\a.txt`.
 * For *nix systems (Linux/Mac/Unix), `/tauri/x/y/a.txt` will correspond to `/x/y/a.txt`.
 *
 * @param {string} phoenixFSPath - The Phoenix virtual file system path to be converted.
 * @returns {string} The platform-specific path.
 *
 * @throws {Errors.EINVAL} If the provided path doesn't start with `/tauri/` or cannot resolve to system path.
 *
 * @example
 * // On a Windows system
 * getTauriPlatformPath('/tauri/c/users/user/a.txt');  // Returns: 'c:\users\user\a.txt'
 *
 * // On a *nix system
 * getTauriPlatformPath('/tauri/home/user/a.txt');  // Returns: '/home/user/a.txt'
 */ function $e1f0b8fa1ae2171c$var$getTauriPlatformPath(phoenixFSPath) {
    if (phoenixFSPath === $e1f0b8fa1ae2171c$require$Constants.TAURI_ROOT) phoenixFSPath = $e1f0b8fa1ae2171c$var$TAURI_PATH_PREFIX;
    if (!phoenixFSPath.startsWith($e1f0b8fa1ae2171c$var$TAURI_PATH_PREFIX)) throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL("Invalid Phoenix FS path- tauri path prefix expected: " + phoenixFSPath);
    if ($e1f0b8fa1ae2171c$var$IS_WINDOWS) {
        let parts = phoenixFSPath.split("/").slice(2);
        if (!parts[0].length) // maps to just ":\", no drive prefix available
        throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL("Invalid Phoenix FS path for windows: " + phoenixFSPath);
        return `${parts[0]}:\\${parts.slice(1).join("\\")}`;
    } else return phoenixFSPath.slice($e1f0b8fa1ae2171c$require$Constants.TAURI_ROOT.length);
}
/**
 * Convert platform-specific Tauri paths to Phoenix virtual file system path.
 * For Windows, `c:\d\a.txt` will correspond to `/tauri/c/d/a.txt`.
 * For *nix systems (Linux/Mac/Unix), `/x/y/a.txt` will correspond to `/tauri/x/y/a.txt`.
 *
 * @param {string} platformPath - The platform-specific path to be converted.
 * @returns {string} The Phoenix virtual file system path.
 *
 * @throws {Errors.EINVAL} If the provided path cannot be converted to Phoenix FS path.
 *
 * @example
 * // On a Windows system
 * getTauriVirtualPath('c:\users\user\a.txt');  // Returns: '/tauri/c/users/user/a.txt'
 *
 * // On a *nix system
 * getTauriVirtualPath('/home/user/a.txt');  // Returns: '/tauri/home/user/a.txt'
 */ function $e1f0b8fa1ae2171c$var$getTauriVirtualPath(platformPath) {
    if ($e1f0b8fa1ae2171c$var$IS_WINDOWS) {
        // For Windows, we split using both forward and backward slashes because users might use either
        let parts = platformPath.split(/[\\/]/);
        if (!parts[0].endsWith(":") || parts[0].length !== 2) throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL("Invalid Windows path format: " + platformPath);
        let driveLetter = parts[0].slice(0, -1); // Remove the ':' from 'c:'
        return `/tauri/${driveLetter}/${parts.slice(1).join("/")}`;
    } else {
        if (!platformPath.startsWith("/")) throw new (0, $505970e6c1eacf0c$exports.Errors).EINVAL("Invalid Unix path format: " + platformPath);
        return $e1f0b8fa1ae2171c$require$Constants.TAURI_ROOT + platformPath;
    }
}
/**
 * Check if the given path is a subpath of the '/tauri' folder.
 * @param path
 */ function $e1f0b8fa1ae2171c$var$isTauriSubPath(path) {
    if (typeof path !== "string") return false;
    if (path) {
        path = globalObject.path.normalize(path);
        if (path.startsWith($e1f0b8fa1ae2171c$var$TAURI_PATH_PREFIX) && path.length > $e1f0b8fa1ae2171c$var$TAURI_PATH_PREFIX.length) return true;
    }
    return false;
}
/**
 * Check if the given path is '/tauri' folder.
 * @param path
 */ function $e1f0b8fa1ae2171c$var$isTauriPath(path) {
    if (typeof path !== "string") return false;
    if (path) {
        path = globalObject.path.normalize(path);
        if (path === $e1f0b8fa1ae2171c$require$Constants.TAURI_ROOT) return true;
    }
    return false;
}
const $e1f0b8fa1ae2171c$var$Utils = {
    createStatObject: $e1f0b8fa1ae2171c$var$createStatObject,
    createDummyStatObject: $e1f0b8fa1ae2171c$var$createDummyStatObject,
    createFromTauriStat: $e1f0b8fa1ae2171c$var$createFromTauriStat,
    createFromNodeStat: $e1f0b8fa1ae2171c$var$createFromNodeStat,
    isTauriSubPath: $e1f0b8fa1ae2171c$var$isTauriSubPath,
    isTauriPath: $e1f0b8fa1ae2171c$var$isTauriPath,
    getTauriPlatformPath: $e1f0b8fa1ae2171c$var$getTauriPlatformPath,
    getTauriVirtualPath: $e1f0b8fa1ae2171c$var$getTauriVirtualPath,
    validateFileOptions: $e1f0b8fa1ae2171c$var$validateFileOptions,
    toArrayBuffer: $e1f0b8fa1ae2171c$var$toArrayBuffer,
    getDecodedString: $e1f0b8fa1ae2171c$var$getDecodedString,
    getDecodedStringFromBuffer: $e1f0b8fa1ae2171c$var$getDecodedStringFromBuffer,
    getEncodedArrayBuffer: $e1f0b8fa1ae2171c$var$getEncodedArrayBuffer,
    getEncodedBuffer: $e1f0b8fa1ae2171c$var$getEncodedBuffer,
    mergeMetadataAndArrayBuffer: $e1f0b8fa1ae2171c$var$mergeMetadataAndArrayBuffer,
    splitMetadataAndBuffer: $e1f0b8fa1ae2171c$var$splitMetadataAndBuffer
};
$e1f0b8fa1ae2171c$exports = {
    Utils: $e1f0b8fa1ae2171c$var$Utils
};


var $93a77513e637ad12$require$Utils = $e1f0b8fa1ae2171c$exports.Utils;
async function $93a77513e637ad12$var$_listDir(path, handle, options, callback) {
    let dirEntryNames = [];
    try {
        for await (const [key, value] of handle.entries()){
            let entry = key;
            if (options["withFileTypes"]) entry = await $93a77513e637ad12$require$Utils.createStatObject(globalObject.path.join(path, key), value);
            dirEntryNames.push(entry);
        }
        if (callback) callback(null, dirEntryNames);
        return dirEntryNames;
    } catch (e) {
        if (e.code === e.NOT_FOUND_ERR) callback(new $93a77513e637ad12$require$Errors.ENOENT(`Dir does not exist ${handle.name}`, e));
        else callback(new $93a77513e637ad12$require$Errors.EIO(`Phoenix fs could not read directory ${handle.name}`, e));
    }
}
// never throws
async function $93a77513e637ad12$var$_subDirectoryExists(parentDirHandle, dirName) {
    try {
        await parentDirHandle.getDirectoryHandle(dirName);
        return true;
    } catch (e) {
        return false;
    }
}
async function $93a77513e637ad12$var$_mkdir(parentDirHandle, dirName, callback) {
    try {
        let alreadyExists = await $93a77513e637ad12$var$_subDirectoryExists(parentDirHandle, dirName);
        if (alreadyExists) {
            callback(new $93a77513e637ad12$require$Errors.EEXIST(`Folder ${dirName} already exists`));
            return;
        }
        let childDirHandle = await parentDirHandle.getDirectoryHandle(dirName, {
            create: true
        });
        if (callback) callback(null);
        return childDirHandle;
    } catch (e) {
        if (callback) {
            callback(new $93a77513e637ad12$require$Errors.EIO("Filer native fs.mkdir failed.", e));
            return;
        }
        throw new $93a77513e637ad12$require$Errors.EIO("Filer native fs function not yet supported.", e);
    }
}
function $93a77513e637ad12$var$mkdir(path, mode, callback) {
    if (arguments.length < 3) callback = mode;
    path = globalObject.path.normalize(path);
    let dirname = globalObject.path.dirname(path);
    let subdirName = globalObject.path.basename(path);
    $93a77513e637ad12$require$Mounts.getHandleFromPath(dirname, (err, handle)=>{
        if (err) callback(err);
        else if (handle.kind === $93a77513e637ad12$require$Constants.KIND_FILE) callback(new $93a77513e637ad12$require$Errors.ENOTDIR("Parent path is not a directory."));
        else $93a77513e637ad12$var$_mkdir(handle, subdirName, callback);
    });
}
function $93a77513e637ad12$var$readdir(path, options, callback) {
    path = globalObject.path.normalize(path);
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    if (path === $93a77513e637ad12$require$Constants.MOUNT_POINT_ROOT) {
        const mountPoints = $93a77513e637ad12$require$Mounts.getMountPoints();
        let mountPointNames = Object.keys(mountPoints);
        if (options["withFileTypes"]) {
            let stats = [];
            for (let mountPointName of mountPointNames)stats.push($93a77513e637ad12$require$Utils.createStatObject(globalObject.path.join(path, mountPointName), mountPoints[mountPointName]));
            Promise.all(stats).then((results)=>{
                callback(null, results);
            }).catch((err)=>{
                callback(new $93a77513e637ad12$require$Errors.EIO("Failed reading directory: " + path + err));
            });
            return;
        }
        callback(null, mountPointNames);
    } else $93a77513e637ad12$require$Mounts.getHandleFromPath(path, (err, handle)=>{
        if (err) callback(err);
        else if (handle.kind === $93a77513e637ad12$require$Constants.KIND_FILE) callback(new $93a77513e637ad12$require$Errors.ENOTDIR("Path is not a directory."));
        else $93a77513e637ad12$var$_listDir(path, handle, options, callback);
    });
}
async function $93a77513e637ad12$var$_getFileContents(fileHandle, encoding, callback, path) {
    try {
        let file = await fileHandle.getFile();
        const arrayBuffer = await file.arrayBuffer();
        if (encoding === $93a77513e637ad12$require$Constants.BYTE_ARRAY_ENCODING) {
            callback(null, arrayBuffer, encoding);
            return;
        } else if (encoding === $93a77513e637ad12$require$Constants.BINARY_ENCODING) {
            const buffer = $93a77513e637ad12$require$Buffer.from(arrayBuffer);
            callback(null, buffer, encoding);
            return;
        }
        let decodedString = $93a77513e637ad12$require$Utils.getDecodedString(arrayBuffer, encoding);
        callback(null, decodedString, encoding);
    } catch (e) {
        if ($93a77513e637ad12$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $93a77513e637ad12$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
function $93a77513e637ad12$var$readFile(path, options, callback) {
    try {
        path = globalObject.path.normalize(path);
        callback = arguments[arguments.length - 1];
        options = $93a77513e637ad12$require$Utils.validateFileOptions(options, $93a77513e637ad12$require$Constants.BINARY_ENCODING, "r");
        $93a77513e637ad12$require$Mounts.getHandleFromPath(path, (err, handle)=>{
            if (err) callback(err);
            else if (handle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY) callback(new $93a77513e637ad12$require$Errors.EISDIR("Path is a directory."));
            else $93a77513e637ad12$var$_getFileContents(handle, options.encoding, callback, path);
        });
    } catch (e) {
        if ($93a77513e637ad12$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $93a77513e637ad12$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
function $93a77513e637ad12$var$stat(path, callback) {
    path = globalObject.path.normalize(path);
    $93a77513e637ad12$require$Mounts.getHandleFromPath(path, (err, handle)=>{
        if (err) callback(err);
        else $93a77513e637ad12$require$Utils.createStatObject(path, handle).then((pathStat)=>{
            callback(null, pathStat);
        }).catch((error)=>{
            callback(error);
        });
    });
}
async function $93a77513e637ad12$var$_writeFileWithName(paretDirHandle, fileName, encoding, data, callback) {
    try {
        const newFileHandle = await paretDirHandle.getFileHandle(fileName, {
            create: true
        });
        const writable = await newFileHandle.createWritable();
        await writable.write(data);
        await writable.close();
        callback(null);
    } catch (e) {
        callback(e);
    }
}
function $93a77513e637ad12$var$writeFile(path, data, options, callback) {
    try {
        callback = arguments[arguments.length - 1];
        options = $93a77513e637ad12$require$Utils.validateFileOptions(options, $93a77513e637ad12$require$Constants.BINARY_ENCODING, "w");
        let arrayBuffer;
        if (data instanceof ArrayBuffer) arrayBuffer = data;
        else if ($93a77513e637ad12$require$Buffer.isBuffer(data)) arrayBuffer = $93a77513e637ad12$require$Utils.toArrayBuffer(data);
        else {
            if (typeof data === "number") data = "" + data;
            data = data || ""; // this should be after number check as if data = 0, things break
            if (typeof data !== "string") data = data.toString();
            arrayBuffer = $93a77513e637ad12$require$Utils.getEncodedArrayBuffer(data, options.encoding);
        }
        path = globalObject.path.normalize(path);
        let dirname = globalObject.path.dirname(path);
        let fileName = globalObject.path.basename(path);
        $93a77513e637ad12$require$Mounts.getHandleFromPath(dirname, (err, handle)=>{
            if (err) callback(err);
            else if (handle.kind === $93a77513e637ad12$require$Constants.KIND_FILE) callback(new $93a77513e637ad12$require$Errors.ENOTDIR("Parent path is not a directory."));
            else $93a77513e637ad12$var$_writeFileWithName(handle, fileName, options.encoding, arrayBuffer, callback);
        });
    } catch (e) {
        if ($93a77513e637ad12$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $93a77513e637ad12$require$Errors.EIO(`IO error while processing data write from file on path: ${path}`, path));
    }
}
async function $93a77513e637ad12$var$_deleteEntry(dirHandle, entryNameToDelete, callback, path) {
    try {
        await dirHandle.removeEntry(entryNameToDelete, {
            recursive: true
        });
        callback(null);
    } catch (err) {
        callback(new $93a77513e637ad12$require$Errors.EIO(`Error while deleting path: ${path}, ${err.message}`, path));
    }
}
async function $93a77513e637ad12$var$unlink(path, callback) {
    path = globalObject.path.normalize(path);
    let dirPath = globalObject.path.dirname(path);
    let baseName = globalObject.path.basename(path);
    $93a77513e637ad12$var$stat(path, (_err)=>{
        if (_err) {
            // enoent or other error means delete will mostly fail. pass it through.
            callback(_err);
            return;
        }
        $93a77513e637ad12$require$Mounts.getHandleFromPath(dirPath, async (err, dirHandle)=>{
            if (err) callback(err);
            else $93a77513e637ad12$var$_deleteEntry(dirHandle, baseName, callback, path);
        });
    });
}
async function $93a77513e637ad12$var$_getDestinationHandleForCopy(dst, srcBaseName, handleKindToCreate) {
    return new Promise(async (resolve, reject)=>{
        // eslint async executors are needed here. we explicitly catch so it's fine.
        try {
            dst = globalObject.path.normalize(dst);
            let dirPath = globalObject.path.dirname(dst);
            let dstBaseName = globalObject.path.basename(dst);
            let dstHandle = await $93a77513e637ad12$require$Mounts.getHandleFromPathIfPresent(dst);
            let dstParentHandle = await $93a77513e637ad12$require$Mounts.getHandleFromPathIfPresent(dirPath);
            if (dstHandle && dstHandle.kind === $93a77513e637ad12$require$Constants.KIND_FILE) reject(new $93a77513e637ad12$require$Errors.EEXIST(`Destination file already exists: ${dst}`));
            else if (dstHandle && dstHandle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY && handleKindToCreate === $93a77513e637ad12$require$Constants.KIND_FILE) {
                const fileHandle = await dstHandle.getFileHandle(srcBaseName, {
                    create: true
                });
                const dstPath = `${dst}/${srcBaseName}`;
                resolve({
                    handle: fileHandle,
                    path: dstPath
                });
            } else if (dstHandle && dstHandle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY && handleKindToCreate === $93a77513e637ad12$require$Constants.KIND_DIRECTORY) {
                let dstChildHandle = await $93a77513e637ad12$require$Mounts.getHandleFromPathIfPresent(`${dst}/${srcBaseName}`);
                if (dstChildHandle) {
                    reject(new $93a77513e637ad12$require$Errors.EEXIST(`Copy destination already exists: ${dst}/${srcBaseName}`));
                    return;
                }
                const directoryHandle = await dstHandle.getDirectoryHandle(srcBaseName, {
                    create: true
                });
                const dstPath = `${dst}/${srcBaseName}`;
                resolve({
                    handle: directoryHandle,
                    path: dstPath
                });
            } else if (!dstHandle && dstParentHandle && dstParentHandle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY && handleKindToCreate === $93a77513e637ad12$require$Constants.KIND_FILE) {
                const fileHandle = await dstParentHandle.getFileHandle(dstBaseName, {
                    create: true
                });
                const dstPath = `${dirPath}/${dstBaseName}`;
                resolve({
                    handle: fileHandle,
                    path: dstPath
                });
            } else if (!dstHandle && dstParentHandle && dstParentHandle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY && handleKindToCreate === $93a77513e637ad12$require$Constants.KIND_DIRECTORY) {
                const fileHandle = await dstParentHandle.getDirectoryHandle(dstBaseName, {
                    create: true
                });
                const dstPath = `${dirPath}/${dstBaseName}`;
                resolve({
                    handle: fileHandle,
                    path: dstPath
                });
            } else reject(new $93a77513e637ad12$require$Errors.ENOENT(`Copy destination doesnt exist: ${dst}`));
        } catch (e) {
            reject(e);
        }
    });
}
async function $93a77513e637ad12$var$_copyFileFromHandles(srcFileHandle, dstHandle, optionalName) {
    // TODO Add retry mechanisms when copying large folders
    try {
        if (optionalName) dstHandle = await dstHandle.getFileHandle(optionalName, {
            create: true
        });
        const srcFile = await srcFileHandle.getFile();
        const srcStream = await srcFile.stream();
        const writable = await dstHandle.createWritable();
        await srcStream.pipeTo(writable);
    } catch (e) {
        console.error(`PhoenixFS: Error while copying ${dstHandle.name}/${optionalName} : ${e}`);
        throw e;
    }
}
async function $93a77513e637ad12$var$_copyFileWithHandle(srcFileHandle, dst, srcFileName, callback) {
    try {
        let { handle: handle, path: path } = await $93a77513e637ad12$var$_getDestinationHandleForCopy(dst, srcFileName, $93a77513e637ad12$require$Constants.KIND_FILE);
        await $93a77513e637ad12$var$_copyFileFromHandles(srcFileHandle, handle);
        callback(null, path);
    } catch (e) {
        callback(e);
    }
}
async function $93a77513e637ad12$var$_treeCopy(srcFolderHandle, dstFolderHandle, recursive) {
    let allDonePromises = [];
    for await (const [key, srcHandle] of srcFolderHandle.entries()){
        if (srcHandle.kind === $93a77513e637ad12$require$Constants.KIND_FILE) allDonePromises.push($93a77513e637ad12$var$_copyFileFromHandles(srcHandle, dstFolderHandle, key));
        else if (srcHandle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY) {
            const childDirHandle = await $93a77513e637ad12$var$_mkdir(dstFolderHandle, key);
            if (recursive && childDirHandle) allDonePromises.push($93a77513e637ad12$var$_treeCopy(srcHandle, childDirHandle, recursive));
        }
    }
    await Promise.all(allDonePromises);
}
async function $93a77513e637ad12$var$_copyFolderWithHandle(srcFolderHandle, dst, srcFileName, callback, recursive) {
    try {
        let { handle: handle, path: path } = await $93a77513e637ad12$var$_getDestinationHandleForCopy(dst, srcFileName, $93a77513e637ad12$require$Constants.KIND_DIRECTORY);
        await $93a77513e637ad12$var$_treeCopy(srcFolderHandle, handle, recursive);
        callback(null, path);
    } catch (e) {
        callback(e);
    }
}
async function $93a77513e637ad12$var$copy(src, dst, callback, recursive = true) {
    let srcFile = globalObject.path.normalize(src);
    let srcFileName = globalObject.path.basename(srcFile);
    $93a77513e637ad12$require$Mounts.getHandleFromPath(srcFile, async (err, srcHandle)=>{
        if (err) callback(err);
        else if (srcHandle.kind === $93a77513e637ad12$require$Constants.KIND_FILE) return $93a77513e637ad12$var$_copyFileWithHandle(srcHandle, dst, srcFileName, callback);
        else if (srcHandle.kind === $93a77513e637ad12$require$Constants.KIND_DIRECTORY) return $93a77513e637ad12$var$_copyFolderWithHandle(srcHandle, dst, srcFileName, callback, recursive);
        else callback(new $93a77513e637ad12$require$Errors.EIO(`Cannot copy src: ${srcFile}`));
    });
}
async function $93a77513e637ad12$var$rename(oldPath, newPath, cb) {
    $93a77513e637ad12$var$copy(oldPath, newPath, (err)=>{
        if (err) cb(err);
        else setTimeout(()=>{
            $93a77513e637ad12$var$unlink(oldPath, cb);
        }, 0);
    });
}
// this is when in windows/macos, the fs is not case-sensitive, you have to rename "a.txt" to "A.TXT".
// We have to have an intermediate name
async function $93a77513e637ad12$var$renameSameNameDiffCase(oldPath, newPath, cb) {
    const tempPath = globalObject.path.normalize(oldPath) + "_" + Math.floor(Math.random() * 4294967296);
    $93a77513e637ad12$var$rename(oldPath, tempPath, (err)=>{
        if (err) cb(err);
        else setTimeout(()=>{
            $93a77513e637ad12$var$rename(tempPath, newPath, cb);
        }, 0);
    });
}
function $93a77513e637ad12$var$mountNativeFolder(...args) {
    $93a77513e637ad12$require$Mounts.mountNativeFolder(...args);
}
function $93a77513e637ad12$var$refreshMountPoints() {
    $93a77513e637ad12$require$Mounts.refreshMountPoints();
}
const $93a77513e637ad12$var$NativeFS = {
    mountNativeFolder: $93a77513e637ad12$var$mountNativeFolder,
    refreshMountPoints: $93a77513e637ad12$var$refreshMountPoints,
    mkdir: $93a77513e637ad12$var$mkdir,
    readdir: $93a77513e637ad12$var$readdir,
    stat: $93a77513e637ad12$var$stat,
    readFile: $93a77513e637ad12$var$readFile,
    writeFile: $93a77513e637ad12$var$writeFile,
    unlink: $93a77513e637ad12$var$unlink,
    copy: $93a77513e637ad12$var$copy,
    rename: $93a77513e637ad12$var$rename,
    renameSameNameDiffCase: $93a77513e637ad12$var$renameSameNameDiffCase
};
$93a77513e637ad12$exports = {
    NativeFS: $93a77513e637ad12$var$NativeFS
};


var $fe07aa8563a4b855$require$NativeFS = $93a77513e637ad12$exports.NativeFS;
var $ca2f37f7bc08d808$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global __TAURI__, globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ // Ensure globalObject is available in both browser and web worker contexts

var $N0o3H = parcelRequire("N0o3H");
var $ca2f37f7bc08d808$require$Buffer = $N0o3H.Buffer;
if (typeof globalObject === "undefined") {
    if (typeof window !== "undefined") window.globalObject = window;
    else if (typeof self !== "undefined") self.globalObject = self;
}

var $ca2f37f7bc08d808$require$Constants = $53cc2e000314a49f$exports.Constants;

var $ca2f37f7bc08d808$require$Errors = $505970e6c1eacf0c$exports.Errors;
var $ca2f37f7bc08d808$require$ERR_CODES = $505970e6c1eacf0c$exports.ERR_CODES;

var $ca2f37f7bc08d808$require$Utils = $e1f0b8fa1ae2171c$exports.Utils;
var $f66b1ce3442ad51c$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global */ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ 

var $f66b1ce3442ad51c$require$Errors = $505970e6c1eacf0c$exports.Errors;

var $f66b1ce3442ad51c$require$Utils = $e1f0b8fa1ae2171c$exports.Utils;

var $f66b1ce3442ad51c$require$Constants = $53cc2e000314a49f$exports.Constants;
const $f66b1ce3442ad51c$var$IS_WINDOWS = navigator.userAgent.includes("Windows");
const $f66b1ce3442ad51c$var$WS_COMMAND = {
    PING: "ping",
    RESPONSE: "response",
    EVENT: "event",
    LARGE_DATA_SOCKET_ANNOUNCE: "largeDataSock",
    CONTROL_SOCKET_ANNOUNCE: "controlSock",
    GET_WINDOWS_DRIVES: "getWinDrives",
    READ_DIR: "readDir",
    STAT: "stat",
    READ_BIN_FILE: "readBinFile",
    WRITE_BIN_FILE: "writeBinFile",
    MKDIR: "mkdir",
    RENAME: "rename",
    COPY: "copy",
    UNLINK: "unlink",
    WATCH: "watch",
    UNWATCH: "unwatch"
};
// each browser context belongs to a single socket group. So multiple websocket connections can be pooled
// to increase throughput. Note that socketGroupID will be different for each web workers/threads in the window as
// they are separate contexts.
const $f66b1ce3442ad51c$var$socketGroupID = Math.floor(Math.random() * 4294967296);
let $f66b1ce3442ad51c$var$commandIdCounter = 1; // should be greater than 0!
let $f66b1ce3442ad51c$var$wssEndpoint, $f66b1ce3442ad51c$var$controlSocket, $f66b1ce3442ad51c$var$dataSocket;
const $f66b1ce3442ad51c$var$SOCKET_TYPE_DATA = "data", $f66b1ce3442ad51c$var$SOCKET_TYPE_CONTROL = "control";
const $f66b1ce3442ad51c$var$LARGE_DATA_THRESHOLD = 2097152; // 2MB
const $f66b1ce3442ad51c$var$MAX_RECONNECT_BACKOFF_TIME_MS = 1000;
function $f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(nodeError, path, userMessage = "") {
    let error;
    switch(nodeError.code){
        case "ENOENT":
            error = new $f66b1ce3442ad51c$require$Errors.ENOENT(userMessage + ` No such File or Directory: ${path} ` + nodeError.message, path);
            break;
        case "EEXIST":
            error = new $f66b1ce3442ad51c$require$Errors.EEXIST(userMessage + ` File exists: ${path} ` + nodeError.message, path);
            break;
        case "ENOTEMPTY":
            error = new $f66b1ce3442ad51c$require$Errors.ENOTEMPTY(userMessage + ` Directory not empty: ${path} ` + nodeError.message, path);
            break;
        case "ENOTDIR":
            error = new $f66b1ce3442ad51c$require$Errors.ENOTDIR(userMessage + ` Not a Directory: ${path} ` + nodeError.message, path);
            break;
        case "EACCES":
            error = new $f66b1ce3442ad51c$require$Errors.EACCES(userMessage + ` Permission denied: ${path} ` + nodeError.message, path);
            break;
        case "EISDIR":
            error = new $f66b1ce3442ad51c$require$Errors.EISDIR(userMessage + ` Is a directory: ${path} ` + nodeError.message, path);
            break;
        case "EBADF":
            error = new $f66b1ce3442ad51c$require$Errors.EBADF(userMessage + ` Bad file number: ${path} ` + nodeError.message, path);
            break;
        case "EROFS":
            error = new $f66b1ce3442ad51c$require$Errors.EROFS(userMessage + ` Read-only file system: ${path} ` + nodeError.message, path);
            break;
        case "ENOSPC":
            error = new $f66b1ce3442ad51c$require$Errors.ENOSPC(userMessage + ` No space left on device: ${path} ` + nodeError.message, path);
            break;
        case "EBUSY":
            error = new $f66b1ce3442ad51c$require$Errors.EBUSY(userMessage + ` Device or resource busy: ${path} ` + nodeError.message, path);
            break;
        case "EINVAL":
            error = new $f66b1ce3442ad51c$require$Errors.EINVAL(userMessage + ` Invalid argument: ${path} ` + nodeError.message, path);
            break;
    }
    if (!error && $f66b1ce3442ad51c$require$Errors[nodeError.code]) error = new $f66b1ce3442ad51c$require$Errors[nodeError.code](userMessage + ` Error for: ${path} ` + nodeError.message, path);
    else if (!error) error = new $f66b1ce3442ad51c$require$Errors.EIO(userMessage + ` IO error on path: ${path} ` + nodeError.message + "\nNode Error stack: " + nodeError.nodeStack, path);
    error.nodeStack = nodeError.nodeStack;
    return error;
}
function $f66b1ce3442ad51c$var$_getCommand(command, data) {
    return {
        commandCode: command,
        commandId: $f66b1ce3442ad51c$var$commandIdCounter++,
        socketGroupID: $f66b1ce3442ad51c$var$socketGroupID,
        data: data
    };
}
function $f66b1ce3442ad51c$var$_silentlyCloseSocket(socket) {
    if (!socket) return;
    try {
        socket.autoReconnect = false;
        socket.close();
    } catch (e) {
        console.error("PhoenixFS: ", e);
    }
}
function $f66b1ce3442ad51c$var$_isSocketOpen(socket) {
    return socket && socket.readyState === WebSocket.OPEN;
}
let $f66b1ce3442ad51c$var$isNodeWsConnected = false;
/**
 * Returns true if the node websocket connection is established and ready to take requests.
 * @returns {boolean}
 */ function $f66b1ce3442ad51c$var$isNodeWSReady() {
    return $f66b1ce3442ad51c$var$isNodeWsConnected;
}
function $f66b1ce3442ad51c$var$updateConnectionState() {
    $f66b1ce3442ad51c$var$isNodeWsConnected = $f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$controlSocket) || $f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$dataSocket);
}
const $f66b1ce3442ad51c$var$_pendingCommandQueue = [], $f66b1ce3442ad51c$var$commandIdMap = {};
function $f66b1ce3442ad51c$var$_execCommandInternal(command, commandData, binaryData, resolve, reject) {
    let socketToUse = $f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$controlSocket) ? $f66b1ce3442ad51c$var$controlSocket : $f66b1ce3442ad51c$var$dataSocket;
    if (binaryData && binaryData.byteLength > $f66b1ce3442ad51c$var$LARGE_DATA_THRESHOLD && $f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$dataSocket)) socketToUse = $f66b1ce3442ad51c$var$dataSocket;
    const commandToSend = $f66b1ce3442ad51c$var$_getCommand(command, commandData);
    $f66b1ce3442ad51c$var$commandIdMap[commandToSend.commandId] = {
        resolve: resolve,
        reject: reject
    };
    socketToUse.send($f66b1ce3442ad51c$require$Utils.mergeMetadataAndArrayBuffer(commandToSend, binaryData));
}
/**
 *
 * @param command {string}
 * @param commandData {Object}
 * @param binaryData {ArrayBuffer}
 * @returns {Promise<{metadata: Object, bufferData: ArrayBuffer}>} A promise that resolves with an object containing `metadata` and `bufferData` or rejects with error.
 */ function $f66b1ce3442ad51c$var$_execCommand(command, commandData = null, binaryData) {
    return new Promise((resolve, reject)=>{
        if (!$f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$controlSocket) && !$f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$dataSocket)) {
            $f66b1ce3442ad51c$var$_pendingCommandQueue.push({
                command: command,
                commandData: commandData,
                binaryData: binaryData,
                resolve: resolve,
                reject: reject
            });
            return;
        }
        $f66b1ce3442ad51c$var$_execCommandInternal(command, commandData, binaryData, resolve, reject);
    });
}
function $f66b1ce3442ad51c$var$_execPendingCommands() {
    if (!$f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$controlSocket) && !$f66b1ce3442ad51c$var$_isSocketOpen($f66b1ce3442ad51c$var$dataSocket)) return;
    let cmd = $f66b1ce3442ad51c$var$_pendingCommandQueue.pop();
    while(cmd){
        $f66b1ce3442ad51c$var$_execCommandInternal(cmd.command, cmd.commandData, cmd.binaryData, cmd.resolve, cmd.reject);
        cmd = $f66b1ce3442ad51c$var$_pendingCommandQueue.pop();
    }
}
const $f66b1ce3442ad51c$var$_eventEmitter = {};
/**
 * you can only use this to listen to events emitter from node. Calling the emit function on the returned emitter
 * will not dispatch any events to node, but only within the browser context.
 * @param eventEmitterID - this is supplied in from node, typically from an exec metadata containing the id.
 * @returns {EventEmitter}
 * @private
 */ function $f66b1ce3442ad51c$var$getNodeEventListener(eventEmitterID) {
    if (!eventEmitterID) throw new $f66b1ce3442ad51c$require$Errors.EIO(`No such node event emitter, ${eventEmitterID}`);
    if ($f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID]) return $f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID];
    $f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID] = new $6e2b186194ca9ee7$exports();
    $f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID].eventEmitterID = eventEmitterID;
    return $f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID];
}
function $f66b1ce3442ad51c$var$removeNodeEventListener(eventEmitter) {
    if (eventEmitter.allreadyClosed) return;
    eventEmitter.removeAllListeners();
    eventEmitter.on = function() {
        throw new $f66b1ce3442ad51c$require$Errors.EIO("The File watcher is closed. Please use `fs.watchAsync` if you want to watch again.");
    };
    eventEmitter.allreadyClosed = true;
    const eventEmitterID = eventEmitter.eventEmitterID;
    if (!eventEmitterID) throw new $f66b1ce3442ad51c$require$Errors.EIO(`No such node event emitter, ${eventEmitterID}`);
    if ($f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID]) delete $f66b1ce3442ad51c$var$_eventEmitter[eventEmitterID];
}
function $f66b1ce3442ad51c$var$_processEvent(metadata, bufferData) {
    const eventEmitter = $f66b1ce3442ad51c$var$_eventEmitter[metadata.eventEmitterID];
    if (eventEmitter) {
        if (metadata.data.path) metadata.data.path = $f66b1ce3442ad51c$require$Utils.getTauriVirtualPath(metadata.data.path);
        eventEmitter.emit(metadata.eventName, metadata.data, bufferData);
    } else console.error("PhoenixFS: Received stray event: ", metadata);
}
function $f66b1ce3442ad51c$var$_processMessage(data) {
    const { metadata: metadata, bufferData: bufferData } = $f66b1ce3442ad51c$require$Utils.splitMetadataAndBuffer(data);
    if (metadata.eventEmitterID) {
        $f66b1ce3442ad51c$var$_processEvent(metadata, bufferData);
        return;
    }
    if (!metadata.commandId || !$f66b1ce3442ad51c$var$commandIdMap[metadata.commandId]) throw new Error("CommandID not found in ws response! " + metadata);
    const { resolve: resolve, reject: reject } = $f66b1ce3442ad51c$var$commandIdMap[metadata.commandId];
    if (metadata.error) reject(metadata.error);
    else resolve({
        metadata: metadata,
        bufferData: bufferData
    });
    delete $f66b1ce3442ad51c$var$commandIdMap[metadata.commandId];
}
function $f66b1ce3442ad51c$var$_wait(timeMS) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeMS);
    });
}
async function $f66b1ce3442ad51c$var$_establishAndMaintainConnection(socketType, firstConnectCB) {
    let ws = new WebSocket($f66b1ce3442ad51c$var$wssEndpoint);
    ws.binaryType = "arraybuffer";
    ws.autoReconnect = true;
    const resolved = false;
    while(ws.autoReconnect){
        let wsClosePromiseResolve;
        const wsClosePromise = new Promise((resolve)=>{
            wsClosePromiseResolve = resolve;
        });
        if (socketType === $f66b1ce3442ad51c$var$SOCKET_TYPE_CONTROL) $f66b1ce3442ad51c$var$controlSocket = ws;
        else {
            ws.isLargeDataWS = true;
            $f66b1ce3442ad51c$var$dataSocket = ws;
        }
        ws.addEventListener("open", ()=>{
            ws.backoffTime = 0;
            if (!resolved) firstConnectCB();
            if (ws.isLargeDataWS) $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.LARGE_DATA_SOCKET_ANNOUNCE).catch((err)=>console.error("PhoenixFS: ", err));
            else $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.CONTROL_SOCKET_ANNOUNCE).catch((err)=>console.error("PhoenixFS: ", err));
            $f66b1ce3442ad51c$var$_execPendingCommands();
            $f66b1ce3442ad51c$var$updateConnectionState();
        });
        ws.addEventListener("message", function(event) {
            $f66b1ce3442ad51c$var$_processMessage(event.data);
        });
        ws.addEventListener("error", function(event) {
            console.error("PhoenixFS websocket error event: ", event);
        });
        ws.addEventListener("close", function() {
            wsClosePromiseResolve();
            $f66b1ce3442ad51c$var$updateConnectionState();
        });
        await wsClosePromise;
        const backoffTime = Math.min(ws.backoffTime * 2, $f66b1ce3442ad51c$var$MAX_RECONNECT_BACKOFF_TIME_MS) || 1;
        ws.backoffTime = backoffTime;
        await $f66b1ce3442ad51c$var$_wait(backoffTime);
        if (ws.autoReconnect) {
            ws = new WebSocket($f66b1ce3442ad51c$var$wssEndpoint);
            ws.backoffTime = backoffTime;
            ws.binaryType = "arraybuffer";
            ws.autoReconnect = true;
        }
    }
}
/**
 * Sets the websocket endpoint and returns a promise that resolves when the tauri node fs is open. It keeps the socket
 * open across failures and auto-reconnects as needed.
 * @param websocketEndpoint
 * @return {Promise<void>}
 */ async function $f66b1ce3442ad51c$var$setNodeWSEndpoint(websocketEndpoint) {
    return new Promise((resolve, reject)=>{
        if (websocketEndpoint === $f66b1ce3442ad51c$var$wssEndpoint) reject(new $f66b1ce3442ad51c$require$Errors.EEXIST("A connection on the same websocket address is in progress: ", websocketEndpoint));
        $f66b1ce3442ad51c$var$_silentlyCloseSocket($f66b1ce3442ad51c$var$controlSocket);
        $f66b1ce3442ad51c$var$controlSocket = null;
        $f66b1ce3442ad51c$var$_silentlyCloseSocket($f66b1ce3442ad51c$var$dataSocket);
        $f66b1ce3442ad51c$var$dataSocket = null;
        $f66b1ce3442ad51c$var$wssEndpoint = websocketEndpoint;
        let resolved = false;
        function firstConnectCB() {
            if (!resolved) {
                resolve();
                resolved = true;
            }
        }
        $f66b1ce3442ad51c$var$_establishAndMaintainConnection($f66b1ce3442ad51c$var$SOCKET_TYPE_CONTROL, firstConnectCB);
        $f66b1ce3442ad51c$var$_establishAndMaintainConnection($f66b1ce3442ad51c$var$SOCKET_TYPE_DATA, firstConnectCB);
    });
}
function $f66b1ce3442ad51c$var$stopNodeWSEndpoint() {
    $f66b1ce3442ad51c$var$_silentlyCloseSocket($f66b1ce3442ad51c$var$controlSocket);
    $f66b1ce3442ad51c$var$controlSocket = null;
    $f66b1ce3442ad51c$var$_silentlyCloseSocket($f66b1ce3442ad51c$var$dataSocket);
    $f66b1ce3442ad51c$var$dataSocket = null;
    $f66b1ce3442ad51c$var$wssEndpoint = null;
}
function $f66b1ce3442ad51c$var$getNodeWSEndpoint() {
    return $f66b1ce3442ad51c$var$wssEndpoint;
}
function $f66b1ce3442ad51c$var$testNodeWsEndpoint(wsEndPoint, echoData, echoBuffer) {
    return new Promise((resolve, reject)=>{
        const ws = new WebSocket(wsEndPoint);
        ws.binaryType = "arraybuffer";
        let commandSent, opened = false;
        ws.addEventListener("open", ()=>{
            console.log("testNodeWsPort: Ws connected");
            opened = true;
            commandSent = $f66b1ce3442ad51c$var$_getCommand($f66b1ce3442ad51c$var$WS_COMMAND.PING, echoData);
            commandSent.socketGroupID = Math.floor(Math.random() * 4294967296); // use different for tests
            ws.send($f66b1ce3442ad51c$require$Utils.mergeMetadataAndArrayBuffer(commandSent, echoBuffer));
        });
        ws.addEventListener("message", function(event) {
            console.log("testNodeWsPort: received ws data", event.data);
            const { metadata: metadata, bufferData: bufferData } = $f66b1ce3442ad51c$require$Utils.splitMetadataAndBuffer(event.data);
            console.log("testNodeWsPort: received ws data", metadata, bufferData);
            ws.close();
            if (metadata.commandCode !== $f66b1ce3442ad51c$var$WS_COMMAND.RESPONSE) reject(new $f66b1ce3442ad51c$require$Errors.EIO(`Expected commandCode ${metadata.commandCode} to be ${$f66b1ce3442ad51c$var$WS_COMMAND.RESPONSE}`, wsEndPoint));
            else if (metadata.commandId !== commandSent.commandId) reject(new $f66b1ce3442ad51c$require$Errors.EIO(`Mismatched commandId ${metadata.commandId} to be ${commandSent.commandId}`, wsEndPoint));
            else if (metadata.socketGroupID !== commandSent.socketGroupID) reject(new $f66b1ce3442ad51c$require$Errors.EIO(`Mismatched socketGroupID ${metadata.socketGroupID} to be ${commandSent.socketGroupID}`, wsEndPoint));
            else resolve({
                echoData: metadata.data,
                echoBuffer: bufferData
            });
        });
        ws.addEventListener("error", function(event) {
            console.error("testNodeWsPort: ", event);
            reject(new $f66b1ce3442ad51c$require$Errors.EIO("Websocket error", wsEndPoint));
            ws.close();
        });
        ws.addEventListener("close", function(event) {
            console.log("PhoenixFS: WebSocket connection closed:", event.code, event.reason);
            if (!opened) reject(new $f66b1ce3442ad51c$require$Errors.EIO("Socket not opened: " + event.reason, wsEndPoint));
        });
    });
}
function $f66b1ce3442ad51c$var$_readDirWindowsDrives(path, options, callback) {
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.GET_WINDOWS_DRIVES).then(({ metadata: metadata })=>{
        const drives = metadata.data.drives;
        if (!options.withFileTypes) {
            callback(null, drives);
            return;
        }
        let entries = [];
        for (let drive of drives)entries.push($f66b1ce3442ad51c$require$Utils.createDummyStatObject(`${path}/${drive}`, true, $f66b1ce3442ad51c$require$Constants.TAURI_WS_DEVICE_NAME));
        callback(null, entries);
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to get drives: "));
    });
}
function $f66b1ce3442ad51c$var$readdir(path, options, callback) {
    if ($f66b1ce3442ad51c$var$IS_WINDOWS && path === $f66b1ce3442ad51c$require$Constants.TAURI_ROOT) {
        $f66b1ce3442ad51c$var$_readDirWindowsDrives(path, options, callback);
        return;
    }
    let platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.READ_DIR, {
        path: platformPath,
        options: options
    }).then(({ metadata: metadata })=>{
        if (metadata.data.contents) callback(null, metadata.data.contents);
        else if (metadata.data.contentStats) {
            let stats = [];
            for (let contentStat of metadata.data.contentStats)stats.push($f66b1ce3442ad51c$require$Utils.createFromNodeStat(`${path}/${contentStat.name}`, contentStat, $f66b1ce3442ad51c$require$Constants.TAURI_WS_DEVICE_NAME));
            callback(null, stats);
        } else callback(new $f66b1ce3442ad51c$require$Errors.EIO("Failed readdir as node ws connector returned empty", path));
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to read directory: "));
    });
}
function $f66b1ce3442ad51c$var$stat(path, callback) {
    let platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.STAT, {
        path: platformPath
    }).then(({ metadata: metadata })=>{
        callback(null, $f66b1ce3442ad51c$require$Utils.createFromNodeStat(`${path}/${metadata.data.stat.name}`, metadata.data.stat, $f66b1ce3442ad51c$require$Constants.TAURI_WS_DEVICE_NAME));
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to get stat: "));
    });
}
function $f66b1ce3442ad51c$var$readBinaryFile(path) {
    return new Promise((resolve, reject)=>{
        const platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
        $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.READ_BIN_FILE, {
            path: platformPath
        }).then(({ bufferData: bufferData })=>{
            resolve(bufferData);
        }).catch((err)=>{
            reject($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to read file: "));
        });
    });
}
function $f66b1ce3442ad51c$var$writeBinaryFile(path, mode, flag, dataArrayBuffer) {
    return new Promise((resolve, reject)=>{
        const platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
        $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.WRITE_BIN_FILE, {
            path: platformPath,
            mode: mode,
            flag: flag
        }, dataArrayBuffer).then(()=>{
            resolve();
        }).catch((err)=>{
            reject($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to write file: "));
        });
    });
}
function $f66b1ce3442ad51c$var$mkdirs(path, mode, recursive, callback) {
    const platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.MKDIR, {
        path: platformPath,
        mode: mode,
        recursive: recursive
    }).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to mkdir: "));
    });
}
function $f66b1ce3442ad51c$var$rename(oldPath, newPath, callback) {
    const oldPlatformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(oldPath);
    const newPlatformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(newPath);
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.RENAME, {
        oldPath: oldPlatformPath,
        newPath: newPlatformPath
    }).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, oldPath, `Failed to rename: ${oldPath} to ${newPath}`));
    });
}
function $f66b1ce3442ad51c$var$unlink(path, callback) {
    const platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.UNLINK, {
        path: platformPath
    }).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, "Failed to unlink: "));
    });
}
/**
 *
 * @param {string} path
 * @param {string|Array<string>} gitIgnorePaths The contents of the gitIgnore file as text. The watcher will ignore all files matching git ignore.
 * @returns {Promise<EventEmitter>} That will be resolved with a watcher once the watcher is ready.
 */ async function $f66b1ce3442ad51c$var$watchAsync(path, gitIgnorePaths = "") {
    return new Promise((resolve, reject)=>{
        const platformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(path);
        $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.WATCH, {
            path: platformPath,
            gitIgnorePaths: gitIgnorePaths
        }).then(({ metadata: metadata })=>{
            const eventEmitter = $f66b1ce3442ad51c$var$getNodeEventListener(metadata.data.eventEmitterID);
            eventEmitter.watchPath = path;
            resolve(eventEmitter);
        }).catch((err)=>{
            reject($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, path, `Failed to watch path: ${path}`));
        });
    });
}
/**
 * Stops the fs watcher given the EventEmitter returned by watchAsync API.
 * @param eventEmitter
 * @returns {Promise<void>} That will be resolved with a watcher stops. The event emitter will no longer work after this call.
 */ function $f66b1ce3442ad51c$var$unwatchAsync(eventEmitter) {
    return new Promise((resolve, reject)=>{
        $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.UNWATCH, {
            eventEmitterID: eventEmitter.eventEmitterID
        }).then(()=>{
            $f66b1ce3442ad51c$var$removeNodeEventListener(eventEmitter);
            resolve();
        }).catch((err)=>{
            reject($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, eventEmitter.watchPath, `Failed to unwatch path: ${eventEmitter.watchPath}`));
        });
    });
}
async function $f66b1ce3442ad51c$var$copy(src, dst, callback) {
    const srcPlatformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(src);
    const dstPlatformPath = $f66b1ce3442ad51c$require$Utils.getTauriPlatformPath(dst);
    $f66b1ce3442ad51c$var$_execCommand($f66b1ce3442ad51c$var$WS_COMMAND.COPY, {
        src: srcPlatformPath,
        dst: dstPlatformPath
    }).then(({ metadata: metadata })=>{
        callback(null, $f66b1ce3442ad51c$require$Utils.getTauriVirtualPath(metadata.data.copiedPath));
    }).catch((err)=>{
        callback($f66b1ce3442ad51c$var$mapNodeTauriErrorMessage(err, src, `Failed to copy: ${src} to ${dst}`));
    });
}
const $f66b1ce3442ad51c$var$NodeTauriFS = {
    testNodeWsEndpoint: $f66b1ce3442ad51c$var$testNodeWsEndpoint,
    setNodeWSEndpoint: $f66b1ce3442ad51c$var$setNodeWSEndpoint,
    stopNodeWSEndpoint: $f66b1ce3442ad51c$var$stopNodeWSEndpoint,
    getNodeWSEndpoint: $f66b1ce3442ad51c$var$getNodeWSEndpoint,
    isNodeWSReady: $f66b1ce3442ad51c$var$isNodeWSReady,
    readdir: $f66b1ce3442ad51c$var$readdir,
    mkdirs: $f66b1ce3442ad51c$var$mkdirs,
    stat: $f66b1ce3442ad51c$var$stat,
    readBinaryFile: $f66b1ce3442ad51c$var$readBinaryFile,
    writeBinaryFile: $f66b1ce3442ad51c$var$writeBinaryFile,
    rename: $f66b1ce3442ad51c$var$rename,
    unlink: $f66b1ce3442ad51c$var$unlink,
    watchAsync: $f66b1ce3442ad51c$var$watchAsync,
    unwatchAsync: $f66b1ce3442ad51c$var$unwatchAsync,
    copy: $f66b1ce3442ad51c$var$copy
};
$f66b1ce3442ad51c$exports = {
    NodeTauriFS: $f66b1ce3442ad51c$var$NodeTauriFS
};


var $ca2f37f7bc08d808$require$NodeTauriFS = $f66b1ce3442ad51c$exports.NodeTauriFS;
const $ca2f37f7bc08d808$var$IS_WINDOWS = navigator.userAgent.includes("Windows");
let $ca2f37f7bc08d808$var$preferNodeWs = false, $ca2f37f7bc08d808$var$forceNodeWs = false;
/**
 * Opens the Tauri file picker asynchronously with given options. If options aren't provided, defaults to picking a single file.
 * If the `defaultPath` option isn't provided, it will default to the user's document directory.
 *
 * @param {Object} [options] - Configuration options for the Tauri file picker.
 * @param {boolean} [options.directory=false] - Whether it is directory or file to be picked.
 * @param {boolean} [options.multiple=false] - Whether to allow picking multiple files.
 * @param {string} [options.defaultPath] - Default directory to open in the file picker. Defaults to document directory if not provided.
 * @param {string} [options.title] - The title of the dialog window.
 * @param {Array<{name: string, extensions: string[]}>} [options.filters] - Extension filters for the file dialog.
 *   filters: [{
 *     name: 'Image',
 *     extensions: ['png', 'jpeg']
 *   }]
 *
 * @returns {Promise<null|string|Array<string>>} A promise that resolves to null if user dismissed the dialogue, a string (selected filepath), or an array of strings (multiple selected filepaths).
 */ async function $ca2f37f7bc08d808$var$openTauriFilePickerAsync(options) {
    options = options || {
        multiple: false
    };
    if (!options.defaultPath) options.defaultPath = await __TAURI__.path.documentDir();
    return new Promise((resolve, reject)=>{
        __TAURI__.dialog.open(options).then((filePaths)=>{
            if (typeof filePaths === "string") resolve($ca2f37f7bc08d808$require$Utils.getTauriVirtualPath(filePaths));
            else if (Array.isArray(filePaths)) {
                let virtualPaths = [];
                for (let platformPath of filePaths)virtualPaths.push($ca2f37f7bc08d808$require$Utils.getTauriVirtualPath(platformPath));
                resolve(virtualPaths);
            } else resolve(null);
        }).catch(reject);
    });
}
/**
 * Opens the Tauri file save dialogue asynchronously using the provided options.
 * If `defaultPath` option isn't provided, it defaults to the user's document directory.
 *
 * @async
 * @param {Object} [options] - Configuration options for the Tauri file save dialogue.
 * @param {string} [options.defaultPath] - Initial directory or file path. If it's a directory path, the dialog interface will change to that folder. If it's not an existing directory, the file name will be set to the dialog's file name input and the dialog will be set to the parent folder. If not provided, defaults to the user's document directory.
 * @param {string} [options.title] - The title of the dialog window.
 * @param {Array<{name: string, extensions: string[]}>} [options.filters] - Extension filters for the file dialog.
 *   filters: [{
 *     name: 'Image',
 *     extensions: ['png', 'jpeg']
 *   }]
 *
 * @returns {Promise<string|null>} A promise that resolves to the selected file path if a location was chosen, or null if the dialogue was cancelled.
 *
 * @example
 * openTauriFileSaveDialogueAsync({
 *     defaultPath: '/path/to/example.txt',
 *     filters: [{ name: 'Text Files', extensions: ['txt'] }]
 * }).then(savePath => {
 *     if (savePath) {
 *         console.log("File will be saved at:", savePath);
 *     } else {
 *         console.log("Save dialogue was cancelled");
 *     }
 * });
 */ async function $ca2f37f7bc08d808$var$openTauriFileSaveDialogueAsync(options) {
    options = options || {};
    if (!options.defaultPath) options.defaultPath = await __TAURI__.path.documentDir();
    return new Promise((resolve, reject)=>{
        __TAURI__.dialog.save(options).then((filePath)=>{
            if (typeof filePath === "string") resolve($ca2f37f7bc08d808$require$Utils.getTauriVirtualPath(filePath));
            else resolve(null);
        }).catch(reject);
    });
}
function $ca2f37f7bc08d808$var$extractErrorNumber(str) {
    const regex = /\(os error (\d+)\)/;
    const match = str.match(regex);
    if (match && match[1]) return match[1];
    else return null;
}
function $ca2f37f7bc08d808$var$mapOSTauriErrorMessage(tauriErrorMessage, path, userMessage = "") {
    let errorNumber = $ca2f37f7bc08d808$var$extractErrorNumber(tauriErrorMessage);
    switch(errorNumber){
        case "2":
            return new $ca2f37f7bc08d808$require$Errors.ENOENT(userMessage + ` No such File or Directory: ${path} ` + tauriErrorMessage, path);
        case "3":
            return new $ca2f37f7bc08d808$require$Errors.ENOENT(userMessage + ` System cannot find the path specified: ${path} ` + tauriErrorMessage, path); // windows
        case "17":
            return new $ca2f37f7bc08d808$require$Errors.EEXIST(userMessage + ` File exists: ${path} ` + tauriErrorMessage, path);
        case "183":
            return new $ca2f37f7bc08d808$require$Errors.EEXIST(userMessage + ` File exists: ${path} ` + tauriErrorMessage, path); // windows
        case "39":
            return new $ca2f37f7bc08d808$require$Errors.ENOTEMPTY(userMessage + ` Directory not empty: ${path} ` + tauriErrorMessage, path);
        case "20":
            return new $ca2f37f7bc08d808$require$Errors.ENOTDIR(userMessage + ` Not a Directory: ${path} ` + tauriErrorMessage, path);
        case "13":
            return new $ca2f37f7bc08d808$require$Errors.EACCES(userMessage + ` Permission denied: ${path} ` + tauriErrorMessage, path);
        case "21":
            return new $ca2f37f7bc08d808$require$Errors.EISDIR(userMessage + ` Is a directory: ${path} ` + tauriErrorMessage, path);
        case "9":
            return new $ca2f37f7bc08d808$require$Errors.EBADF(userMessage + ` Bad file number: ${path} ` + tauriErrorMessage, path);
        case "30":
            return new $ca2f37f7bc08d808$require$Errors.EROFS(userMessage + ` Read-only file system: ${path} ` + tauriErrorMessage, path);
        case "28":
            return new $ca2f37f7bc08d808$require$Errors.ENOSPC(userMessage + ` No space left on device: ${path} ` + tauriErrorMessage, path);
        case "16":
            return new $ca2f37f7bc08d808$require$Errors.EBUSY(userMessage + ` Device or resource busy: ${path} ` + tauriErrorMessage, path);
        case "22":
            return new $ca2f37f7bc08d808$require$Errors.EINVAL(userMessage + ` Invalid argument: ${path} ` + tauriErrorMessage, path);
        default:
            return new $ca2f37f7bc08d808$require$Errors.EIO(userMessage + ` IO error on path: ${path} ` + tauriErrorMessage, path);
    }
}
async function $ca2f37f7bc08d808$var$_getTauriStat(vfsPath) {
    let stats = await globalObject.__TAURI__.invoke("plugin:fs-extra|metadata", {
        path: globalObject.fs.getTauriPlatformPath(vfsPath)
    });
    return $ca2f37f7bc08d808$require$Utils.createFromTauriStat(vfsPath, stats);
}
function $ca2f37f7bc08d808$var$_readDirHelper(entries, path, options, callback, useDummyStats) {
    let children = [];
    for (const entry of entries){
        if (!options.withFileTypes) children.push(entry.name);
        else if (useDummyStats) children.push($ca2f37f7bc08d808$require$Utils.createDummyStatObject(`${path}/${entry.name}`, true, $ca2f37f7bc08d808$require$Constants.TAURI_DEVICE_NAME));
        else children.push($ca2f37f7bc08d808$var$_getTauriStat(`${path}/${entry.name}`));
    }
    if (!options.withFileTypes || useDummyStats) callback(null, children);
    else Promise.all(children).then((results)=>{
        callback(null, results);
    }).catch((err)=>{
        callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, "Failed to read directory: "));
    });
}
/**
 * Reads the contents of a directory. This method will list all the entries of a directory
 * as an array of strings(filenames , directory names, or symbolic link names).
 * If the `withFileTypes` option is set to `true`, it will return file stat objects array instead of strings.
 *
 * @param {string} path - The path to the directory that needs to be read.
 * @param {Object} [options] - Options for reading the directory.
 * @param {boolean} [options.withFileTypes=false] - Set to `true` to return stats of each content file/dir. Defaults to `false`.
 * @param {function} callback - A callback function to execute once the directory is read.
 *                              This function gets two arguments: (err, entries).
 *                              `err` will be set if an error occurred during reading. `entries` is an array of file names or fs stat objects.
 *
 * @example
 * // Using withFileTypes option
 * fs.readdir("/tauri/some/path", { withFileTypes: true }, function(err, entries) {
 *   if (err) throw err;
 *   console.log(entries); // Outputs file stats
 * });
 *
 * @example
 * // Without specifying withFileTypes option
 * fs.readdir("/tauri/some/path", function(err, entries) {
 *   if (err) throw err;
 *   console.log(entries); // Outputs an array of file/dir names
 * });
 *
 * @returns {void}
 */ function $ca2f37f7bc08d808$var$readdir(path, options, callback) {
    path = globalObject.path.normalize(path);
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) return $ca2f37f7bc08d808$require$NodeTauriFS.readdir(path, options, callback);
    if ($ca2f37f7bc08d808$var$IS_WINDOWS && path === $ca2f37f7bc08d808$require$Constants.TAURI_ROOT) {
        globalObject.__TAURI__.invoke("_get_windows_drives").then((drives)=>{
            let entries = [];
            for (let drive of drives)entries.push({
                name: drive
            });
            $ca2f37f7bc08d808$var$_readDirHelper(entries, path, options, callback, true);
        }).catch((err)=>{
            callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, "Failed to get drives: "));
        });
        return;
    }
    let platformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(path);
    __TAURI__.fs.readDir(platformPath).then((entries)=>{
        $ca2f37f7bc08d808$var$_readDirHelper(entries, path, options, callback);
    }).catch((err)=>{
        callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, "Failed to read directory: "));
    });
}
/**
 * Creates a directory with optional mode and recursion(create all intermediate directories if those don't exist).
 *
 * @param {string} path - The path where the directory should be created.
 * @param {(number)} [mode=0o777] - The directory permissions. Defaults to `0o777` if not provided.
 * @param {(boolean)} [recursive=false] - Whether to create directories recursively. Defaults to `false` if not provided.
 * @param {function} [callback] - Callback to execute once directory creation is done. Called with an error as the first argument on failure, and null on success.
 *
 * @example
 * // Create directory without recursion and with default mode, and a callback.
 * fs.mkdirs("/tauri/some/path", callback);
 *
 * // Create directory with specified mode, without recursion, and a callback.
 * fs.mkdirs("/tauri/some/path", 0o755, callback);
 *
 * // Create directory with specified mode, with recursion, and a callback.
 * fs.mkdirs("/tauri/some/path", 0o755, true, callback);
 *
 * // Create directory without recursion, without mode, and without a callback.
 * fs.mkdirs("/tauri/some/path");
 *
 * @returns {void}
 */ function $ca2f37f7bc08d808$var$mkdirs(path, mode, recursive, callback) {
    // Determine if 'mode' is provided
    if (typeof mode !== "number") {
        callback = recursive;
        recursive = mode;
        mode = 511; // Default mode (or any other default you'd like to set)
    }
    // Determine if 'recursive' is provided
    if (typeof recursive !== "boolean") {
        callback = recursive;
        recursive = false;
    }
    // Determine if 'callback' is provided
    if (typeof callback !== "function") callback = function() {
    // Do Nothing
    };
    if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) {
        $ca2f37f7bc08d808$require$NodeTauriFS.mkdirs(path, mode, recursive, callback);
        return;
    }
    let platformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(path);
    __TAURI__.fs.createDir(platformPath, {
        recursive: recursive
    }).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, "Failed to create directory: "));
    });
}
/**
 * Retrieves the status of a file or directory. The result will be an object with detailed information.
 * The provided callback function will be called with either an error (as the first argument) or the stat object (as the second argument).
 *
 * @param {string} path - The path to the file or directory to retrieve the status for.
 * @param {function} callback - The callback function that is executed when the operation is complete.
 *                              The callback function will receive two arguments:
 *                              1. An error object if an error occurred, otherwise null.
 *                              2. The stat object containing the details about the file or directory.
 *
 * The stat object has the following properties:
 * - 'name' : The base name of the file or directory.
 * - 'isFile()', 'isDirectory()' and 'isSymbolicLink()'- functions that does what its name suggests.
 * - 'type': Indicates the type of the node, which can be a string indicating directory, file, or symbolic link.
 *           Prefer above `isFile()` type check over this.
 * - `size`: The size of the file in bytes.
 * - `mode`: The file's mode. It's an integer that represents the file's permission mode.
 * - `readonly`: A boolean indicating if the file is read-only.
 * - `ctime`: The time the file was created, in milliseconds since the POSIX Epoch.
 * - `atime`: The time the file was last accessed, in milliseconds since the POSIX Epoch.
 * - `mtime`: The time the file was last modified, in milliseconds since the POSIX Epoch.
 * - `nlinks`: The number of hard links.
 *
 * @example
 * fs.stat("/tauri/some/path", function(err, statObj) {
 *   if (err) throw err;
 *   console.log(statObj);
 * });
 *
 * @returns {void}
 */ function $ca2f37f7bc08d808$var$stat(path, callback, options = {}) {
    path = globalObject.path.normalize(path);
    if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) return $ca2f37f7bc08d808$require$NodeTauriFS.stat(path, callback, options);
    $ca2f37f7bc08d808$var$_getTauriStat(path).then((stat)=>{
        callback(null, stat);
    }).catch((err)=>{
        callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, "Failed to get stat"));
    });
}
function $ca2f37f7bc08d808$var$unlink(path, callback) {
    path = globalObject.path.normalize(path);
    if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) return $ca2f37f7bc08d808$require$NodeTauriFS.unlink(path, callback);
    function errCallback(err) {
        callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, "Failed to unlink"));
    }
    $ca2f37f7bc08d808$var$_getTauriStat(path).then((stat)=>{
        let platformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(path);
        if (stat.isDirectory()) __TAURI__.fs.removeDir(platformPath, {
            recursive: true
        }).then(()=>{
            callback(null);
        }).catch(errCallback);
        else __TAURI__.fs.removeFile(platformPath).then(()=>{
            callback(null);
        }).catch(errCallback);
    }).catch(errCallback);
}
function $ca2f37f7bc08d808$var$rename(oldPath, newPath, callback) {
    oldPath = globalObject.path.normalize(oldPath);
    newPath = globalObject.path.normalize(newPath);
    if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) {
        $ca2f37f7bc08d808$require$NodeTauriFS.rename(oldPath, newPath, callback);
        return;
    }
    const oldPlatformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(oldPath);
    const newPlatformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(newPath);
    __TAURI__.invoke("_rename_path", {
        oldPath: oldPlatformPath,
        newPath: newPlatformPath
    }).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, oldPath, `Failed to rename ${oldPath} to ${newPath}`));
    });
}
/**
 *
 * @param contents {ArrayBuffer}
 * @param encoding {string}
 * @param callback {function}
 * @param path {string}
 * @private
 */ function $ca2f37f7bc08d808$var$_processContents(contents, encoding, callback, path) {
    try {
        let arrayBuffer = contents;
        if (contents.buffer instanceof ArrayBuffer) arrayBuffer = contents.buffer;
        if (encoding === $ca2f37f7bc08d808$require$Constants.BYTE_ARRAY_ENCODING) {
            callback(null, arrayBuffer, encoding);
            return;
        } else if (encoding === $ca2f37f7bc08d808$require$Constants.BINARY_ENCODING) {
            const contentBuffer = $ca2f37f7bc08d808$require$Buffer.from(arrayBuffer);
            callback(null, contentBuffer, encoding);
            return;
        }
        let decodedString = $ca2f37f7bc08d808$require$Utils.getDecodedString(arrayBuffer, encoding);
        callback(null, decodedString, encoding);
    } catch (e) {
        if ($ca2f37f7bc08d808$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $ca2f37f7bc08d808$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
/**
 * Reads the contents of a file.
 *
 * @param {string} path - The path of the file to read.
 * @param {Object|string} [options] - An object with encoding and flag options or a string representing the encoding.
 *   - If a string is provided, it specifies the encoding. Default is `'binary'` which returns a `'Buffer'`. To return a
 *     `UTF8` string use `utf8`. Get list of all supported encodings from `'fs.SUPPORTED_ENCODINGS'`.
 *      If reading binary files from within `/tauri/` or fsAccess(`/mnt/`) paths, then instead of `'binary'` encoding,
 *      prefer `'fs.BYTE_ARRAY_ENCODING'` for improved binary read performance. This will instead return an `ArrayBuffer`
 *      that is native to the browser environment instead of the 'Buffer' polyfill that we use.
 *   - If an object is provided, it can have the following properties:
 *     - `encoding` (string): The encoding type. Default is `'binary'`. Get list of supported encodings from `'fs.SUPPORTED_ENCODINGS'`.
 *     - `flag` (string): The file system flag. Default is `'r'`.
 * @param {function} callback - The callback function to execute when the file read operation is complete.
 *   - The callback is passed two arguments:
 *     1. An error object or null if no error occurred.
 *     2. The data read from the file (type depends on the encoding option).
 *
 * @example
 * fs.readFile("/path/to/file", { encoding: 'utf8' }, function(err, data) {
 *   if (err) throw err;
 *   console.log(data);
 * });
 * // OR
 * fs.readFile("/path/to/file", 'utf8', function(err, data) {
 *   if (err) throw err;
 *   console.log(data);
 * });
 *
 * @returns {void}
 */ function $ca2f37f7bc08d808$var$readFile(path, options, callback) {
    try {
        path = globalObject.path.normalize(path);
        callback = arguments[arguments.length - 1];
        options = $ca2f37f7bc08d808$require$Utils.validateFileOptions(options, $ca2f37f7bc08d808$require$Constants.BINARY_ENCODING, "r");
        if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) {
            $ca2f37f7bc08d808$require$NodeTauriFS.readBinaryFile(path).then((contents)=>{
                // contents is Array buffer, can be undefined if empty file
                contents = contents || new ArrayBuffer(0);
                $ca2f37f7bc08d808$var$_processContents(contents, options.encoding, callback, path);
            }).catch(callback);
            return;
        }
        const platformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(path);
        __TAURI__.fs.readBinaryFile(platformPath).then((contents)=>{
            // contents is Array buffer, can be undefined if empty file
            contents = contents || new ArrayBuffer(0);
            $ca2f37f7bc08d808$var$_processContents(contents, options.encoding, callback, path);
        }).catch((err)=>{
            callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, `Failed to read File at path ${path}`));
        });
    } catch (e) {
        if ($ca2f37f7bc08d808$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $ca2f37f7bc08d808$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
/**
 * Writes data to a file, replacing the file if it already exists.
 *
 * @param {string} path - The path of the file where data should be written.
 * @param {ArrayBuffer|Buffer|string|number} data - The data to write. This can be an ArrayBuffer, Buffer, string, or number.
 * @param {Object|string} [options] - An object with encoding and flag options or a string representing the encoding.
 *   - If a string is provided, it specifies the encoding. Default is `'binary'` which writes the buffer as is.
 *      Get list of all supported encodings from `'fs.SUPPORTED_ENCODINGS'`.
 *      If writing binary files from within `/tauri/` or fsAccess(`/mnt/`) paths, then instead of `'binary'` encoding,
 *      prefer `'fs.BYTE_ARRAY_ENCODING'` and `ArrayBuffer` data.
 *   - If provided as an `object`, it can have the following keys:
 *     - `encoding` (string): The type of encoding. Default is `'binary'`.
 *     - `flag` (string): The file system flag. Default is `'w'`.
 *     - `mode`- The permissions. Defaults to `0o666` if not provided.
 * @param {function} callback - The callback function to execute once the file write operation concludes.
 *   - The callback receives one argument:
 *     1. An error object (or null if there were no errors).
 *
 * @example
 * fs.writeFile("/path/to/file", "Hello World", { encoding: 'utf8' }, function(err) {
 *   if (err) throw err;
 *   console.log("File written successfully!");
 * });
 * // or
 * fs.writeFile("/path/to/file", "Hello World", 'utf8', function(err) {
 *   if (err) throw err;
 *   console.log("File written successfully!");
 * });
 * @returns {void}
 */ function $ca2f37f7bc08d808$var$writeFile(path, data, options, callback) {
    try {
        path = globalObject.path.normalize(path);
        callback = arguments[arguments.length - 1];
        options = $ca2f37f7bc08d808$require$Utils.validateFileOptions(options, $ca2f37f7bc08d808$require$Constants.BINARY_ENCODING, "w");
        let arrayBuffer;
        if (data instanceof ArrayBuffer) arrayBuffer = data;
        else if ($ca2f37f7bc08d808$require$Buffer.isBuffer(data)) arrayBuffer = $ca2f37f7bc08d808$require$Utils.toArrayBuffer(data);
        else {
            if (typeof data === "number") data = "" + data;
            data = data || ""; // this should be after number check as if data = 0, things break
            if (typeof data !== "string") data = data.toString();
            arrayBuffer = $ca2f37f7bc08d808$require$Utils.getEncodedArrayBuffer(data, options.encoding);
        }
        if (!globalObject.__TAURI__ || $ca2f37f7bc08d808$var$forceNodeWs || $ca2f37f7bc08d808$var$preferNodeWs && $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady()) {
            $ca2f37f7bc08d808$require$NodeTauriFS.writeBinaryFile(path, options.mode || 438, options.flag, arrayBuffer).then(()=>{
                callback(null);
            }).catch(callback);
            return;
        }
        const platformPath = $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath(path);
        __TAURI__.fs.writeBinaryFile(platformPath, arrayBuffer).then(()=>{
            callback(null);
        }).catch((err)=>{
            callback($ca2f37f7bc08d808$var$mapOSTauriErrorMessage(err, path, `Failed to write File at path ${path}`));
        });
    } catch (e) {
        if ($ca2f37f7bc08d808$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $ca2f37f7bc08d808$require$Errors.EIO(`IO error while processing data write from file on path: ${path}`, path));
    }
}
/**
 * Forces the usage of the Node WebSocket endpoint.
 * Throws an error if the Node WebSocket endpoint is not set.
 *
 * @param {boolean} use - If `true`, forces the use of the Node WebSocket endpoint.
 * @throws {Error} Throws an error if the Node WebSocket endpoint has not been set.
 */ function $ca2f37f7bc08d808$var$forceUseNodeWSEndpoint(use) {
    if (!$ca2f37f7bc08d808$require$NodeTauriFS.getNodeWSEndpoint()) throw new Error("Please call fs.setNodeWSEndpoint('ws://your server') before calling this function.");
    $ca2f37f7bc08d808$var$forceNodeWs = use;
}
/**
 * Sets the preference to use the Node WebSocket endpoint if available.
 * Throws an error if the Node WebSocket endpoint is not set.
 * If a Node connection is not available, it falls back to Tauri.
 * To always force the library to use the Node WebSocket endpoint for all FS APIs, use `forceUseNodeWSEndpoint`.
 *
 * @param {boolean} use - If `true`, prefers the use of the Node WebSocket endpoint.
 * @throws {Error} Throws an error if the Node WebSocket endpoint has not been set.
 */ function $ca2f37f7bc08d808$var$preferNodeWSEndpoint(use) {
    if (!$ca2f37f7bc08d808$require$NodeTauriFS.getNodeWSEndpoint()) throw new Error("Please call fs.setNodeWSEndpoint('ws://your server') before calling this function.");
    $ca2f37f7bc08d808$var$preferNodeWs = use;
}
function $ca2f37f7bc08d808$var$canCopy() {
    // we can only copy if node tari fs is ready as tauri doesn't have folder copy apis.
    return $ca2f37f7bc08d808$require$NodeTauriFS.isNodeWSReady();
}
async function $ca2f37f7bc08d808$var$copy(src, dst, callback) {
    if (!$ca2f37f7bc08d808$var$canCopy()) {
        callback(new $ca2f37f7bc08d808$require$Errors.EIO(`IO error while copying: ${src} to ${dst}, node not ready.`, src));
        return;
    }
    src = globalObject.path.normalize(src);
    dst = globalObject.path.normalize(dst);
    return $ca2f37f7bc08d808$require$NodeTauriFS.copy(src, dst, callback);
}
const $ca2f37f7bc08d808$var$TauriFS = {
    isTauriPath: $ca2f37f7bc08d808$require$Utils.isTauriPath,
    isTauriSubPath: $ca2f37f7bc08d808$require$Utils.isTauriSubPath,
    getTauriPlatformPath: $ca2f37f7bc08d808$require$Utils.getTauriPlatformPath,
    getTauriVirtualPath: $ca2f37f7bc08d808$require$Utils.getTauriVirtualPath,
    openTauriFilePickerAsync: $ca2f37f7bc08d808$var$openTauriFilePickerAsync,
    openTauriFileSaveDialogueAsync: $ca2f37f7bc08d808$var$openTauriFileSaveDialogueAsync,
    forceUseNodeWSEndpoint: $ca2f37f7bc08d808$var$forceUseNodeWSEndpoint,
    preferNodeWSEndpoint: $ca2f37f7bc08d808$var$preferNodeWSEndpoint,
    stat: $ca2f37f7bc08d808$var$stat,
    readdir: $ca2f37f7bc08d808$var$readdir,
    mkdirs: $ca2f37f7bc08d808$var$mkdirs,
    rename: $ca2f37f7bc08d808$var$rename,
    unlink: $ca2f37f7bc08d808$var$unlink,
    readFile: $ca2f37f7bc08d808$var$readFile,
    writeFile: $ca2f37f7bc08d808$var$writeFile,
    copy: $ca2f37f7bc08d808$var$copy,
    canCopy: $ca2f37f7bc08d808$var$canCopy
};
$ca2f37f7bc08d808$exports = {
    TauriFS: $ca2f37f7bc08d808$var$TauriFS
};


var $fe07aa8563a4b855$require$TauriFS = $ca2f37f7bc08d808$exports.TauriFS;
var $6c77e82584bcf935$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ // Ensure globalObject is available in both browser and web worker contexts

var $N0o3H = parcelRequire("N0o3H");
var $6c77e82584bcf935$require$Buffer = $N0o3H.Buffer;
if (typeof globalObject === "undefined") {
    if (typeof window !== "undefined") window.globalObject = window;
    else if (typeof self !== "undefined") self.globalObject = self;
}

var $6c77e82584bcf935$require$Constants = $53cc2e000314a49f$exports.Constants;

var $6c77e82584bcf935$require$Errors = $505970e6c1eacf0c$exports.Errors;
var $6c77e82584bcf935$require$ERR_CODES = $505970e6c1eacf0c$exports.ERR_CODES;

var $6c77e82584bcf935$require$Utils = $e1f0b8fa1ae2171c$exports.Utils;

var $6c77e82584bcf935$require$NodeTauriFS = $f66b1ce3442ad51c$exports.NodeTauriFS;
const $6c77e82584bcf935$var$IS_WINDOWS = navigator.userAgent.includes("Windows");
let $6c77e82584bcf935$var$preferNodeWs = false, $6c77e82584bcf935$var$forceNodeWs = false;
/**
 * Electron IPC strips Error.code during serialization (both main→preload and preload→renderer
 * via contextBridge). FS handlers in main.js return {__fsError, code, message} plain objects
 * on failure instead of throwing. This helper unwraps those into rejected promises.
 */ function $6c77e82584bcf935$var$unwrapFsResult(promise) {
    return promise.then((result)=>{
        if (result && result.__fsError) {
            const err = new Error(result.message);
            err.code = result.code;
            throw err;
        }
        return result;
    });
}
/**
 * Maps Node.js error codes to Phoenix FS errors.
 * @param {Error} err - The Node.js error
 * @param {string} path - The path that caused the error
 * @param {string} userMessage - Additional context message
 * @returns {Error} Phoenix FS error
 */ function $6c77e82584bcf935$var$mapNodeErrorMessage(err, path, userMessage = "") {
    const code = err.code || "";
    const message = err.message || "";
    switch(code){
        case "ENOENT":
            return new $6c77e82584bcf935$require$Errors.ENOENT(userMessage + ` No such File or Directory: ${path} ` + message, path);
        case "EEXIST":
            return new $6c77e82584bcf935$require$Errors.EEXIST(userMessage + ` File exists: ${path} ` + message, path);
        case "ENOTEMPTY":
            return new $6c77e82584bcf935$require$Errors.ENOTEMPTY(userMessage + ` Directory not empty: ${path} ` + message, path);
        case "ENOTDIR":
            return new $6c77e82584bcf935$require$Errors.ENOTDIR(userMessage + ` Not a Directory: ${path} ` + message, path);
        case "EACCES":
            return new $6c77e82584bcf935$require$Errors.EACCES(userMessage + ` Permission denied: ${path} ` + message, path);
        case "EPERM":
            return new $6c77e82584bcf935$require$Errors.EPERM(userMessage + ` Operation not permitted: ${path} ` + message, path);
        case "EISDIR":
            return new $6c77e82584bcf935$require$Errors.EISDIR(userMessage + ` Is a directory: ${path} ` + message, path);
        case "EBADF":
            return new $6c77e82584bcf935$require$Errors.EBADF(userMessage + ` Bad file number: ${path} ` + message, path);
        case "EROFS":
            return new $6c77e82584bcf935$require$Errors.EROFS(userMessage + ` Read-only file system: ${path} ` + message, path);
        case "ENOSPC":
            return new $6c77e82584bcf935$require$Errors.ENOSPC(userMessage + ` No space left on device: ${path} ` + message, path);
        case "EBUSY":
            return new $6c77e82584bcf935$require$Errors.EBUSY(userMessage + ` Device or resource busy: ${path} ` + message, path);
        case "EINVAL":
            return new $6c77e82584bcf935$require$Errors.EINVAL(userMessage + ` Invalid argument: ${path} ` + message, path);
        default:
            return new $6c77e82584bcf935$require$Errors.EIO(userMessage + ` IO error on path: ${path} ` + message, path);
    }
}
/**
 * Opens the Electron file picker asynchronously with given options.
 *
 * @param {Object} [options] - Configuration options for the file picker.
 * @param {boolean} [options.directory=false] - Whether it is directory or file to be picked.
 * @param {boolean} [options.multiple=false] - Whether to allow picking multiple files.
 * @param {string} [options.defaultPath] - Default directory to open in the file picker.
 * @param {string} [options.title] - The title of the dialog window.
 * @param {Array<{name: string, extensions: string[]}>} [options.filters] - Extension filters.
 *
 * @returns {Promise<null|string|Array<string>>} A promise that resolves to null if user dismissed,
 *          a string (selected filepath), or an array of strings (multiple selected filepaths).
 */ async function $6c77e82584bcf935$var$openElectronFilePickerAsync(options) {
    options = options || {
        multiple: false
    };
    if (!options.defaultPath) options.defaultPath = await globalObject.electronFSAPI.documentDir();
    const dialogOptions = {
        defaultPath: options.defaultPath,
        title: options.title,
        properties: []
    };
    if (options.directory) dialogOptions.properties.push("openDirectory");
    else dialogOptions.properties.push("openFile");
    if (options.multiple) dialogOptions.properties.push("multiSelections");
    if (options.filters) dialogOptions.filters = options.filters;
    try {
        const filePaths = await globalObject.electronFSAPI.showOpenDialog(dialogOptions);
        if (!filePaths || filePaths.length === 0) return null;
        if (options.multiple) return filePaths.map((p)=>$6c77e82584bcf935$require$Utils.getTauriVirtualPath(p));
        return $6c77e82584bcf935$require$Utils.getTauriVirtualPath(filePaths[0]);
    } catch (err) {
        throw $6c77e82584bcf935$var$mapNodeErrorMessage(err, options.defaultPath, "Failed to open file picker");
    }
}
/**
 * Opens the Electron file save dialogue asynchronously using the provided options.
 *
 * @param {Object} [options] - Configuration options for the file save dialogue.
 * @param {string} [options.defaultPath] - Initial directory or file path.
 * @param {string} [options.title] - The title of the dialog window.
 * @param {Array<{name: string, extensions: string[]}>} [options.filters] - Extension filters.
 *
 * @returns {Promise<string|null>} A promise that resolves to the selected file path or null.
 */ async function $6c77e82584bcf935$var$openElectronFileSaveDialogueAsync(options) {
    options = options || {};
    if (!options.defaultPath) options.defaultPath = await globalObject.electronFSAPI.documentDir();
    const dialogOptions = {
        defaultPath: options.defaultPath,
        title: options.title
    };
    if (options.filters) dialogOptions.filters = options.filters;
    try {
        const filePath = await globalObject.electronFSAPI.showSaveDialog(dialogOptions);
        if (typeof filePath === "string" && filePath) return $6c77e82584bcf935$require$Utils.getTauriVirtualPath(filePath);
        return null;
    } catch (err) {
        throw $6c77e82584bcf935$var$mapNodeErrorMessage(err, options.defaultPath, "Failed to open save dialog");
    }
}
async function $6c77e82584bcf935$var$_getElectronStat(vfsPath) {
    const platformPath = globalObject.fs.getTauriPlatformPath(vfsPath);
    const stats = await $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsStat(platformPath));
    return $6c77e82584bcf935$require$Utils.createFromNodeStat(vfsPath, stats, $6c77e82584bcf935$require$Constants.ELECTRON_DEVICE_NAME);
}
function $6c77e82584bcf935$var$_readDirHelper(entries, path, options, callback, useDummyStats) {
    let children = [];
    for (const entry of entries){
        if (!options.withFileTypes) children.push(entry.name);
        else if (useDummyStats) children.push($6c77e82584bcf935$require$Utils.createDummyStatObject(`${path}/${entry.name}`, true, $6c77e82584bcf935$require$Constants.TAURI_DEVICE_NAME));
        else children.push($6c77e82584bcf935$var$_getElectronStat(`${path}/${entry.name}`));
    }
    if (!options.withFileTypes || useDummyStats) callback(null, children);
    else Promise.all(children).then((results)=>{
        callback(null, results);
    }).catch((err)=>{
        callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, "Failed to read directory: "));
    });
}
/**
 * Reads the contents of a directory.
 */ function $6c77e82584bcf935$var$readdir(path, options, callback) {
    path = globalObject.path.normalize(path);
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) return $6c77e82584bcf935$require$NodeTauriFS.readdir(path, options, callback);
    if ($6c77e82584bcf935$var$IS_WINDOWS && path === $6c77e82584bcf935$require$Constants.TAURI_ROOT) {
        // Windows drive listing not supported via Electron IPC fallback
        // NodeTauriFS should handle this
        callback(new $6c77e82584bcf935$require$Errors.ENOSYS("Windows drive listing requires NodeTauriFS"));
        return;
    }
    const platformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(path);
    $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsReaddir(platformPath)).then((entries)=>{
        $6c77e82584bcf935$var$_readDirHelper(entries, path, options, callback);
    }).catch((err)=>{
        callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, "Failed to read directory: "));
    });
}
/**
 * Creates a directory with optional mode and recursion.
 */ function $6c77e82584bcf935$var$mkdirs(path, mode, recursive, callback) {
    if (typeof mode !== "number") {
        callback = recursive;
        recursive = mode;
        mode = 511;
    }
    if (typeof recursive !== "boolean") {
        callback = recursive;
        recursive = false;
    }
    if (typeof callback !== "function") callback = function() {};
    if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) {
        $6c77e82584bcf935$require$NodeTauriFS.mkdirs(path, mode, recursive, callback);
        return;
    }
    const platformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(path);
    $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsMkdir(platformPath, {
        recursive: recursive,
        mode: mode
    })).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, "Failed to create directory: "));
    });
}
/**
 * Retrieves the status of a file or directory.
 */ function $6c77e82584bcf935$var$stat(path, callback, options = {}) {
    path = globalObject.path.normalize(path);
    if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) return $6c77e82584bcf935$require$NodeTauriFS.stat(path, callback, options);
    $6c77e82584bcf935$var$_getElectronStat(path).then((stat)=>{
        callback(null, stat);
    }).catch((err)=>{
        callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, "Failed to get stat"));
    });
}
function $6c77e82584bcf935$var$unlink(path, callback) {
    path = globalObject.path.normalize(path);
    if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) return $6c77e82584bcf935$require$NodeTauriFS.unlink(path, callback);
    function errCallback(err) {
        callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, "Failed to unlink"));
    }
    $6c77e82584bcf935$var$_getElectronStat(path).then((stat)=>{
        const platformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(path);
        if (stat.isDirectory()) $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsRmdir(platformPath, {
            recursive: true
        })).then(()=>{
            callback(null);
        }).catch(errCallback);
        else $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsUnlink(platformPath)).then(()=>{
            callback(null);
        }).catch(errCallback);
    }).catch(errCallback);
}
function $6c77e82584bcf935$var$rename(oldPath, newPath, callback) {
    oldPath = globalObject.path.normalize(oldPath);
    newPath = globalObject.path.normalize(newPath);
    if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) {
        $6c77e82584bcf935$require$NodeTauriFS.rename(oldPath, newPath, callback);
        return;
    }
    const oldPlatformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(oldPath);
    const newPlatformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(newPath);
    $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsRename(oldPlatformPath, newPlatformPath)).then(()=>{
        callback(null);
    }).catch((err)=>{
        callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, oldPath, `Failed to rename ${oldPath} to ${newPath}`));
    });
}
/**
 * Processes file contents for different encodings.
 */ function $6c77e82584bcf935$var$_processContents(contents, encoding, callback, path) {
    try {
        let arrayBuffer = contents;
        if (contents.buffer instanceof ArrayBuffer) arrayBuffer = contents.buffer;
        if (encoding === $6c77e82584bcf935$require$Constants.BYTE_ARRAY_ENCODING) {
            callback(null, arrayBuffer, encoding);
            return;
        } else if (encoding === $6c77e82584bcf935$require$Constants.BINARY_ENCODING) {
            const contentBuffer = $6c77e82584bcf935$require$Buffer.from(arrayBuffer);
            callback(null, contentBuffer, encoding);
            return;
        }
        let decodedString = $6c77e82584bcf935$require$Utils.getDecodedString(arrayBuffer, encoding);
        callback(null, decodedString, encoding);
    } catch (e) {
        if ($6c77e82584bcf935$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $6c77e82584bcf935$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
/**
 * Reads the contents of a file.
 */ function $6c77e82584bcf935$var$readFile(path, options, callback) {
    try {
        path = globalObject.path.normalize(path);
        callback = arguments[arguments.length - 1];
        options = $6c77e82584bcf935$require$Utils.validateFileOptions(options, $6c77e82584bcf935$require$Constants.BINARY_ENCODING, "r");
        if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) {
            $6c77e82584bcf935$require$NodeTauriFS.readBinaryFile(path).then((contents)=>{
                contents = contents || new ArrayBuffer(0);
                $6c77e82584bcf935$var$_processContents(contents, options.encoding, callback, path);
            }).catch(callback);
            return;
        }
        const platformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(path);
        $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsReadFile(platformPath)).then((contents)=>{
            // Electron returns a Buffer, convert to ArrayBuffer
            let arrayBuffer;
            if (contents instanceof ArrayBuffer) arrayBuffer = contents;
            else if (contents && contents.buffer) arrayBuffer = contents.buffer.slice(contents.byteOffset, contents.byteOffset + contents.byteLength);
            else if (contents) // Handle Uint8Array or similar
            arrayBuffer = new Uint8Array(contents).buffer;
            else arrayBuffer = new ArrayBuffer(0);
            $6c77e82584bcf935$var$_processContents(arrayBuffer, options.encoding, callback, path);
        }).catch((err)=>{
            callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, `Failed to read File at path ${path}`));
        });
    } catch (e) {
        if ($6c77e82584bcf935$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $6c77e82584bcf935$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
/**
 * Writes data to a file, replacing the file if it already exists.
 */ function $6c77e82584bcf935$var$writeFile(path, data, options, callback) {
    try {
        path = globalObject.path.normalize(path);
        callback = arguments[arguments.length - 1];
        options = $6c77e82584bcf935$require$Utils.validateFileOptions(options, $6c77e82584bcf935$require$Constants.BINARY_ENCODING, "w");
        let arrayBuffer;
        if (data instanceof ArrayBuffer) arrayBuffer = data;
        else if ($6c77e82584bcf935$require$Buffer.isBuffer(data)) arrayBuffer = $6c77e82584bcf935$require$Utils.toArrayBuffer(data);
        else {
            if (typeof data === "number") data = "" + data;
            data = data || "";
            if (typeof data !== "string") data = data.toString();
            arrayBuffer = $6c77e82584bcf935$require$Utils.getEncodedArrayBuffer(data, options.encoding);
        }
        if (!globalObject.__ELECTRON__ || $6c77e82584bcf935$var$forceNodeWs || $6c77e82584bcf935$var$preferNodeWs && $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady()) {
            $6c77e82584bcf935$require$NodeTauriFS.writeBinaryFile(path, options.mode || 438, options.flag, arrayBuffer).then(()=>{
                callback(null);
            }).catch(callback);
            return;
        }
        const platformPath = $6c77e82584bcf935$require$Utils.getTauriPlatformPath(path);
        // Convert ArrayBuffer to Uint8Array for IPC transfer
        const uint8Array = new Uint8Array(arrayBuffer);
        $6c77e82584bcf935$var$unwrapFsResult(globalObject.electronFSAPI.fsWriteFile(platformPath, Array.from(uint8Array))).then(()=>{
            callback(null);
        }).catch((err)=>{
            callback($6c77e82584bcf935$var$mapNodeErrorMessage(err, path, `Failed to write File at path ${path}`));
        });
    } catch (e) {
        if ($6c77e82584bcf935$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $6c77e82584bcf935$require$Errors.EIO(`IO error while processing data write from file on path: ${path}`, path));
    }
}
/**
 * Forces the usage of the Node WebSocket endpoint.
 */ function $6c77e82584bcf935$var$forceUseNodeWSEndpoint(use) {
    if (!$6c77e82584bcf935$require$NodeTauriFS.getNodeWSEndpoint()) throw new Error("Please call fs.setNodeWSEndpoint('ws://your server') before calling this function.");
    $6c77e82584bcf935$var$forceNodeWs = use;
}
/**
 * Sets the preference to use the Node WebSocket endpoint if available.
 */ function $6c77e82584bcf935$var$preferNodeWSEndpoint(use) {
    if (!$6c77e82584bcf935$require$NodeTauriFS.getNodeWSEndpoint()) throw new Error("Please call fs.setNodeWSEndpoint('ws://your server') before calling this function.");
    $6c77e82584bcf935$var$preferNodeWs = use;
}
function $6c77e82584bcf935$var$canCopy() {
    // we can only copy if node tari fs is ready as Electron IPC doesn't have folder copy APIs
    return $6c77e82584bcf935$require$NodeTauriFS.isNodeWSReady();
}
async function $6c77e82584bcf935$var$copy(src, dst, callback) {
    if (!$6c77e82584bcf935$var$canCopy()) {
        callback(new $6c77e82584bcf935$require$Errors.EIO(`IO error while copying: ${src} to ${dst}, node not ready.`, src));
        return;
    }
    src = globalObject.path.normalize(src);
    dst = globalObject.path.normalize(dst);
    return $6c77e82584bcf935$require$NodeTauriFS.copy(src, dst, callback);
}
const $6c77e82584bcf935$var$ElectronFS = {
    isTauriPath: $6c77e82584bcf935$require$Utils.isTauriPath,
    isTauriSubPath: $6c77e82584bcf935$require$Utils.isTauriSubPath,
    getTauriPlatformPath: $6c77e82584bcf935$require$Utils.getTauriPlatformPath,
    getTauriVirtualPath: $6c77e82584bcf935$require$Utils.getTauriVirtualPath,
    openElectronFilePickerAsync: $6c77e82584bcf935$var$openElectronFilePickerAsync,
    openElectronFileSaveDialogueAsync: $6c77e82584bcf935$var$openElectronFileSaveDialogueAsync,
    forceUseNodeWSEndpoint: $6c77e82584bcf935$var$forceUseNodeWSEndpoint,
    preferNodeWSEndpoint: $6c77e82584bcf935$var$preferNodeWSEndpoint,
    stat: $6c77e82584bcf935$var$stat,
    readdir: $6c77e82584bcf935$var$readdir,
    mkdirs: $6c77e82584bcf935$var$mkdirs,
    rename: $6c77e82584bcf935$var$rename,
    unlink: $6c77e82584bcf935$var$unlink,
    readFile: $6c77e82584bcf935$var$readFile,
    writeFile: $6c77e82584bcf935$var$writeFile,
    copy: $6c77e82584bcf935$var$copy,
    canCopy: $6c77e82584bcf935$var$canCopy
};
$6c77e82584bcf935$exports = {
    ElectronFS: $6c77e82584bcf935$var$ElectronFS
};


var $fe07aa8563a4b855$require$ElectronFS = $6c77e82584bcf935$exports.ElectronFS;

var $fe07aa8563a4b855$require$NodeTauriFS = $f66b1ce3442ad51c$exports.NodeTauriFS;
var $32fe822862cdb1d5$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ 
var $N0o3H = parcelRequire("N0o3H");
var $32fe822862cdb1d5$require$Buffer = $N0o3H.Buffer;

var $32fe822862cdb1d5$require$Constants = $53cc2e000314a49f$exports.Constants;

var $32fe822862cdb1d5$require$Errors = $505970e6c1eacf0c$exports.Errors;
var $32fe822862cdb1d5$require$ERR_CODES = $505970e6c1eacf0c$exports.ERR_CODES;

var $32fe822862cdb1d5$require$Utils = $e1f0b8fa1ae2171c$exports.Utils;
let $32fe822862cdb1d5$var$filerLib = null;
/**
 *
 * @param contentsBuffer {Buffer}
 * @param encoding {string}
 * @param callback {function}
 * @param path {string}
 * @private
 */ function $32fe822862cdb1d5$var$_processContents(contentsBuffer, encoding, callback, path) {
    try {
        if (encoding === $32fe822862cdb1d5$require$Constants.BYTE_ARRAY_ENCODING) {
            let arrayBuffer = contentsBuffer.buffer.slice(contentsBuffer.byteOffset, contentsBuffer.byteOffset + contentsBuffer.byteLength);
            callback(null, arrayBuffer, encoding);
            return;
        } else if (encoding === $32fe822862cdb1d5$require$Constants.BINARY_ENCODING) {
            callback(null, contentsBuffer, encoding);
            return;
        }
        let decodedString = $32fe822862cdb1d5$require$Utils.getDecodedStringFromBuffer(contentsBuffer, encoding);
        callback(null, decodedString, encoding);
    } catch (e) {
        if ($32fe822862cdb1d5$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $32fe822862cdb1d5$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
function $32fe822862cdb1d5$var$readFile(path, options, callback) {
    try {
        if (typeof path !== "string") return callback(new $32fe822862cdb1d5$require$Errors.EINVAL(`Error Invalid path for readFile: ${path}`));
        path = globalObject.path.normalize(path);
        callback = arguments[arguments.length - 1];
        options = $32fe822862cdb1d5$require$Utils.validateFileOptions(options, $32fe822862cdb1d5$require$Constants.BINARY_ENCODING, "r");
        const originalEncoding = options.encoding;
        // always read as binary
        options.encoding = $32fe822862cdb1d5$require$Constants.BINARY_ENCODING;
        $32fe822862cdb1d5$var$filerLib.fs.readFile(path, options, (err, contents)=>{
            if (err) {
                callback(err);
                return;
            }
            $32fe822862cdb1d5$var$_processContents(contents, originalEncoding, callback, path);
        });
    } catch (e) {
        if ($32fe822862cdb1d5$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $32fe822862cdb1d5$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
function $32fe822862cdb1d5$var$writeFile(path, data, options, callback) {
    try {
        callback = arguments[arguments.length - 1];
        options = $32fe822862cdb1d5$require$Utils.validateFileOptions(options, $32fe822862cdb1d5$require$Constants.BINARY_ENCODING, "w");
        if (typeof path !== "string") return callback(new $32fe822862cdb1d5$require$Errors.EINVAL(`Error Invalid path for writeFile: ${path}`));
        let bufferData;
        if (data instanceof ArrayBuffer) bufferData = $32fe822862cdb1d5$require$Buffer.from(data);
        else if ($32fe822862cdb1d5$require$Buffer.isBuffer(data)) bufferData = data;
        else {
            if (typeof data === "number") data = "" + data;
            data = data || ""; // this should be after number check as if data = 0, things break
            if (typeof data !== "string") data = data.toString();
            bufferData = $32fe822862cdb1d5$require$Utils.getEncodedBuffer(data, options.encoding);
        }
        path = globalObject.path.normalize(path);
        // always write as binary
        options.encoding = $32fe822862cdb1d5$require$Constants.BINARY_ENCODING;
        $32fe822862cdb1d5$var$filerLib.fs.writeFile(path, bufferData, options, (err)=>{
            if (err) callback(err);
            else callback(null);
        });
    } catch (e) {
        if ($32fe822862cdb1d5$require$ERR_CODES.ERROR_CODES[e.code]) callback(e);
        else callback(new $32fe822862cdb1d5$require$Errors.EIO(`IO error while processing data read from file on path: ${path}`, path));
    }
}
function $32fe822862cdb1d5$var$initFilerLib(FilerLib) {
    $32fe822862cdb1d5$var$filerLib = FilerLib;
}
const $32fe822862cdb1d5$var$FilerFSModified = {
    initFilerLib: $32fe822862cdb1d5$var$initFilerLib,
    readFile: $32fe822862cdb1d5$var$readFile,
    writeFile: $32fe822862cdb1d5$var$writeFile
};
$32fe822862cdb1d5$exports = {
    FilerFSModified: $32fe822862cdb1d5$var$FilerFSModified
};


var $fe07aa8563a4b855$require$FilerFSModified = $32fe822862cdb1d5$exports.FilerFSModified;

var $fe07aa8563a4b855$require$Constants = $53cc2e000314a49f$exports.Constants;

var $fe07aa8563a4b855$require$Mounts = $aa3c82cc608bd675$exports.Mounts;
var $37b095e0e8046d7a$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global globalObject, virtualfs*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ let $37b095e0e8046d7a$var$_channel = null;
const $37b095e0e8046d7a$var$_eventEmitters = [];

var $37b095e0e8046d7a$require$Errors = $505970e6c1eacf0c$exports.Errors;

var $f1acc5f0d0334d57$exports = {};
// A simple implementation of make-array

var $ibaza = parcelRequire("ibaza");
function $f1acc5f0d0334d57$var$makeArray(subject) {
    return Array.isArray(subject) ? subject : [
        subject
    ];
}
const $f1acc5f0d0334d57$var$EMPTY = "";
const $f1acc5f0d0334d57$var$SPACE = " ";
const $f1acc5f0d0334d57$var$ESCAPE = "\\";
const $f1acc5f0d0334d57$var$REGEX_TEST_BLANK_LINE = /^\s+$/;
const $f1acc5f0d0334d57$var$REGEX_INVALID_TRAILING_BACKSLASH = /(?:[^\\]|^)\\$/;
const $f1acc5f0d0334d57$var$REGEX_REPLACE_LEADING_EXCAPED_EXCLAMATION = /^\\!/;
const $f1acc5f0d0334d57$var$REGEX_REPLACE_LEADING_EXCAPED_HASH = /^\\#/;
const $f1acc5f0d0334d57$var$REGEX_SPLITALL_CRLF = /\r?\n/g;
// /foo,
// ./foo,
// ../foo,
// .
// ..
const $f1acc5f0d0334d57$var$REGEX_TEST_INVALID_PATH = /^\.*\/|^\.+$/;
const $f1acc5f0d0334d57$var$SLASH = "/";
// Do not use ternary expression here, since "istanbul ignore next" is buggy
let $f1acc5f0d0334d57$var$TMP_KEY_IGNORE = "node-ignore";
/* istanbul ignore else */ if (typeof Symbol !== "undefined") $f1acc5f0d0334d57$var$TMP_KEY_IGNORE = Symbol.for("node-ignore");
const $f1acc5f0d0334d57$var$KEY_IGNORE = $f1acc5f0d0334d57$var$TMP_KEY_IGNORE;
const $f1acc5f0d0334d57$var$define = (object, key, value)=>Object.defineProperty(object, key, {
        value: value
    });
const $f1acc5f0d0334d57$var$REGEX_REGEXP_RANGE = /([0-z])-([0-z])/g;
const $f1acc5f0d0334d57$var$RETURN_FALSE = ()=>false;
// Sanitize the range of a regular expression
// The cases are complicated, see test cases for details
const $f1acc5f0d0334d57$var$sanitizeRange = (range)=>range.replace($f1acc5f0d0334d57$var$REGEX_REGEXP_RANGE, (match, from, to)=>from.charCodeAt(0) <= to.charCodeAt(0) ? match : $f1acc5f0d0334d57$var$EMPTY);
// See fixtures #59
const $f1acc5f0d0334d57$var$cleanRangeBackSlash = (slashes)=>{
    const { length: length } = slashes;
    return slashes.slice(0, length - length % 2);
};
// > If the pattern ends with a slash,
// > it is removed for the purpose of the following description,
// > but it would only find a match with a directory.
// > In other words, foo/ will match a directory foo and paths underneath it,
// > but will not match a regular file or a symbolic link foo
// >  (this is consistent with the way how pathspec works in general in Git).
// '`foo/`' will not match regular file '`foo`' or symbolic link '`foo`'
// -> ignore-rules will not deal with it, because it costs extra `fs.stat` call
//      you could use option `mark: true` with `glob`
// '`foo/`' should not continue with the '`..`'
const $f1acc5f0d0334d57$var$REPLACERS = [
    // > Trailing spaces are ignored unless they are quoted with backslash ("\")
    [
        // (a\ ) -> (a )
        // (a  ) -> (a)
        // (a \ ) -> (a  )
        /\\?\s+$/,
        (match)=>match.indexOf("\\") === 0 ? $f1acc5f0d0334d57$var$SPACE : $f1acc5f0d0334d57$var$EMPTY
    ],
    // replace (\ ) with ' '
    [
        /\\\s/g,
        ()=>$f1acc5f0d0334d57$var$SPACE
    ],
    // Escape metacharacters
    // which is written down by users but means special for regular expressions.
    // > There are 12 characters with special meanings:
    // > - the backslash \,
    // > - the caret ^,
    // > - the dollar sign $,
    // > - the period or dot .,
    // > - the vertical bar or pipe symbol |,
    // > - the question mark ?,
    // > - the asterisk or star *,
    // > - the plus sign +,
    // > - the opening parenthesis (,
    // > - the closing parenthesis ),
    // > - and the opening square bracket [,
    // > - the opening curly brace {,
    // > These special characters are often called "metacharacters".
    [
        /[\\$.|*+(){^]/g,
        (match)=>`\\${match}`
    ],
    [
        // > a question mark (?) matches a single character
        /(?!\\)\?/g,
        ()=>"[^/]"
    ],
    // leading slash
    [
        // > A leading slash matches the beginning of the pathname.
        // > For example, "/*.c" matches "cat-file.c" but not "mozilla-sha1/sha1.c".
        // A leading slash matches the beginning of the pathname
        /^\//,
        ()=>"^"
    ],
    // replace special metacharacter slash after the leading slash
    [
        /\//g,
        ()=>"\\/"
    ],
    [
        // > A leading "**" followed by a slash means match in all directories.
        // > For example, "**/foo" matches file or directory "foo" anywhere,
        // > the same as pattern "foo".
        // > "**/foo/bar" matches file or directory "bar" anywhere that is directly
        // >   under directory "foo".
        // Notice that the '*'s have been replaced as '\\*'
        /^\^*\\\*\\\*\\\//,
        // '**/foo' <-> 'foo'
        ()=>"^(?:.*\\/)?"
    ],
    // starting
    [
        // there will be no leading '/'
        //   (which has been replaced by section "leading slash")
        // If starts with '**', adding a '^' to the regular expression also works
        /^(?=[^^])/,
        function startingReplacer() {
            // If has a slash `/` at the beginning or middle
            return !/\/(?!$)/.test(this) ? "(?:^|\\/)" : "^";
        }
    ],
    // two globstars
    [
        // Use lookahead assertions so that we could match more than one `'/**'`
        /\\\/\\\*\\\*(?=\\\/|$)/g,
        // Zero, one or several directories
        // should not use '*', or it will be replaced by the next replacer
        // Check if it is not the last `'/**'`
        (_, index, str)=>index + 6 < str.length ? "(?:\\/[^\\/]+)*" : "\\/.+"
    ],
    // normal intermediate wildcards
    [
        // Never replace escaped '*'
        // ignore rule '\*' will match the path '*'
        // 'abc.*/' -> go
        // 'abc.*'  -> skip this rule,
        //    coz trailing single wildcard will be handed by [trailing wildcard]
        /(^|[^\\]+)(\\\*)+(?=.+)/g,
        // '*.js' matches '.js'
        // '*.js' doesn't match 'abc'
        (_, p1, p2)=>{
            // 1.
            // > An asterisk "*" matches anything except a slash.
            // 2.
            // > Other consecutive asterisks are considered regular asterisks
            // > and will match according to the previous rules.
            const unescaped = p2.replace(/\\\*/g, "[^\\/]*");
            return p1 + unescaped;
        }
    ],
    [
        // unescape, revert step 3 except for back slash
        // For example, if a user escape a '\\*',
        // after step 3, the result will be '\\\\\\*'
        /\\\\\\(?=[$.|*+(){^])/g,
        ()=>$f1acc5f0d0334d57$var$ESCAPE
    ],
    [
        // '\\\\' -> '\\'
        /\\\\/g,
        ()=>$f1acc5f0d0334d57$var$ESCAPE
    ],
    [
        // > The range notation, e.g. [a-zA-Z],
        // > can be used to match one of the characters in a range.
        // `\` is escaped by step 3
        /(\\)?\[([^\]/]*?)(\\*)($|\])/g,
        (match, leadEscape, range, endEscape, close)=>leadEscape === $f1acc5f0d0334d57$var$ESCAPE ? `\\[${range}${$f1acc5f0d0334d57$var$cleanRangeBackSlash(endEscape)}${close}` : close === "]" ? endEscape.length % 2 === 0 ? `[${$f1acc5f0d0334d57$var$sanitizeRange(range)}${endEscape}]` : "[]" : "[]"
    ],
    // ending
    [
        // 'js' will not match 'js.'
        // 'ab' will not match 'abc'
        /(?:[^*])$/,
        // WTF!
        // https://git-scm.com/docs/gitignore
        // changes in [2.22.1](https://git-scm.com/docs/gitignore/2.22.1)
        // which re-fixes #24, #38
        // > If there is a separator at the end of the pattern then the pattern
        // > will only match directories, otherwise the pattern can match both
        // > files and directories.
        // 'js*' will not match 'a.js'
        // 'js/' will not match 'a.js'
        // 'js' will match 'a.js' and 'a.js/'
        (match)=>/\/$/.test(match) ? `${match}$` : `${match}(?=$|\\/$)`
    ],
    // trailing wildcard
    [
        /(\^|\\\/)?\\\*$/,
        (_, p1)=>{
            const prefix = p1 ? `${p1}[^/]+` : "[^/]*";
            return `${prefix}(?=$|\\/$)`;
        }
    ]
];
// A simple cache, because an ignore rule only has only one certain meaning
const $f1acc5f0d0334d57$var$regexCache = Object.create(null);
// @param {pattern}
const $f1acc5f0d0334d57$var$makeRegex = (pattern, ignoreCase)=>{
    let source = $f1acc5f0d0334d57$var$regexCache[pattern];
    if (!source) {
        source = $f1acc5f0d0334d57$var$REPLACERS.reduce((prev, current)=>prev.replace(current[0], current[1].bind(pattern)), pattern);
        $f1acc5f0d0334d57$var$regexCache[pattern] = source;
    }
    return ignoreCase ? new RegExp(source, "i") : new RegExp(source);
};
const $f1acc5f0d0334d57$var$isString = (subject)=>typeof subject === "string";
// > A blank line matches no files, so it can serve as a separator for readability.
const $f1acc5f0d0334d57$var$checkPattern = (pattern)=>pattern && $f1acc5f0d0334d57$var$isString(pattern) && !$f1acc5f0d0334d57$var$REGEX_TEST_BLANK_LINE.test(pattern) && !$f1acc5f0d0334d57$var$REGEX_INVALID_TRAILING_BACKSLASH.test(pattern) && pattern.indexOf("#") !== 0;
const $f1acc5f0d0334d57$var$splitPattern = (pattern)=>pattern.split($f1acc5f0d0334d57$var$REGEX_SPLITALL_CRLF);
class $f1acc5f0d0334d57$var$IgnoreRule {
    constructor(origin, pattern, negative, regex){
        this.origin = origin;
        this.pattern = pattern;
        this.negative = negative;
        this.regex = regex;
    }
}
const $f1acc5f0d0334d57$var$createRule = (pattern, ignoreCase)=>{
    const origin = pattern;
    let negative = false;
    // > An optional prefix "!" which negates the pattern;
    if (pattern.indexOf("!") === 0) {
        negative = true;
        pattern = pattern.substr(1);
    }
    pattern = pattern// > Put a backslash ("\") in front of the first "!" for patterns that
    // >   begin with a literal "!", for example, `"\!important!.txt"`.
    .replace($f1acc5f0d0334d57$var$REGEX_REPLACE_LEADING_EXCAPED_EXCLAMATION, "!")// > Put a backslash ("\") in front of the first hash for patterns that
    // >   begin with a hash.
    .replace($f1acc5f0d0334d57$var$REGEX_REPLACE_LEADING_EXCAPED_HASH, "#");
    const regex = $f1acc5f0d0334d57$var$makeRegex(pattern, ignoreCase);
    return new $f1acc5f0d0334d57$var$IgnoreRule(origin, pattern, negative, regex);
};
const $f1acc5f0d0334d57$var$throwError = (message, Ctor)=>{
    throw new Ctor(message);
};
const $f1acc5f0d0334d57$var$checkPath = (path, originalPath, doThrow)=>{
    if (!$f1acc5f0d0334d57$var$isString(path)) return doThrow(`path must be a string, but got \`${originalPath}\``, TypeError);
    // We don't know if we should ignore EMPTY, so throw
    if (!path) return doThrow(`path must not be empty`, TypeError);
    // Check if it is a relative path
    if ($f1acc5f0d0334d57$var$checkPath.isNotRelative(path)) {
        const r = "`path.relative()`d";
        return doThrow(`path should be a ${r} string, but got "${originalPath}"`, RangeError);
    }
    return true;
};
const $f1acc5f0d0334d57$var$isNotRelative = (path)=>$f1acc5f0d0334d57$var$REGEX_TEST_INVALID_PATH.test(path);
$f1acc5f0d0334d57$var$checkPath.isNotRelative = $f1acc5f0d0334d57$var$isNotRelative;
$f1acc5f0d0334d57$var$checkPath.convert = (p)=>p;
class $f1acc5f0d0334d57$var$Ignore {
    constructor({ ignorecase: ignorecase = true, ignoreCase: ignoreCase = ignorecase, allowRelativePaths: allowRelativePaths = false } = {}){
        $f1acc5f0d0334d57$var$define(this, $f1acc5f0d0334d57$var$KEY_IGNORE, true);
        this._rules = [];
        this._ignoreCase = ignoreCase;
        this._allowRelativePaths = allowRelativePaths;
        this._initCache();
    }
    _initCache() {
        this._ignoreCache = Object.create(null);
        this._testCache = Object.create(null);
    }
    _addPattern(pattern) {
        // #32
        if (pattern && pattern[$f1acc5f0d0334d57$var$KEY_IGNORE]) {
            this._rules = this._rules.concat(pattern._rules);
            this._added = true;
            return;
        }
        if ($f1acc5f0d0334d57$var$checkPattern(pattern)) {
            const rule = $f1acc5f0d0334d57$var$createRule(pattern, this._ignoreCase);
            this._added = true;
            this._rules.push(rule);
        }
    }
    // @param {Array<string> | string | Ignore} pattern
    add(pattern) {
        this._added = false;
        $f1acc5f0d0334d57$var$makeArray($f1acc5f0d0334d57$var$isString(pattern) ? $f1acc5f0d0334d57$var$splitPattern(pattern) : pattern).forEach(this._addPattern, this);
        // Some rules have just added to the ignore,
        // making the behavior changed.
        if (this._added) this._initCache();
        return this;
    }
    // legacy
    addPattern(pattern) {
        return this.add(pattern);
    }
    //          |           ignored : unignored
    // negative |   0:0   |   0:1   |   1:0   |   1:1
    // -------- | ------- | ------- | ------- | --------
    //     0    |  TEST   |  TEST   |  SKIP   |    X
    //     1    |  TESTIF |  SKIP   |  TEST   |    X
    // - SKIP: always skip
    // - TEST: always test
    // - TESTIF: only test if checkUnignored
    // - X: that never happen
    // @param {boolean} whether should check if the path is unignored,
    //   setting `checkUnignored` to `false` could reduce additional
    //   path matching.
    // @returns {TestResult} true if a file is ignored
    _testOne(path, checkUnignored) {
        let ignored = false;
        let unignored = false;
        this._rules.forEach((rule)=>{
            const { negative: negative } = rule;
            if (unignored === negative && ignored !== unignored || negative && !ignored && !unignored && !checkUnignored) return;
            const matched = rule.regex.test(path);
            if (matched) {
                ignored = !negative;
                unignored = negative;
            }
        });
        return {
            ignored: ignored,
            unignored: unignored
        };
    }
    // @returns {TestResult}
    _test(originalPath, cache, checkUnignored, slices) {
        const path = originalPath && $f1acc5f0d0334d57$var$checkPath.convert(originalPath);
        $f1acc5f0d0334d57$var$checkPath(path, originalPath, this._allowRelativePaths ? $f1acc5f0d0334d57$var$RETURN_FALSE : $f1acc5f0d0334d57$var$throwError);
        return this._t(path, cache, checkUnignored, slices);
    }
    _t(path, cache, checkUnignored, slices) {
        if (path in cache) return cache[path];
        if (!slices) // path/to/a.js
        // ['path', 'to', 'a.js']
        slices = path.split($f1acc5f0d0334d57$var$SLASH);
        slices.pop();
        // If the path has no parent directory, just test it
        if (!slices.length) return cache[path] = this._testOne(path, checkUnignored);
        const parent = this._t(slices.join($f1acc5f0d0334d57$var$SLASH) + $f1acc5f0d0334d57$var$SLASH, cache, checkUnignored, slices);
        // If the path contains a parent directory, check the parent first
        return cache[path] = parent.ignored ? parent : this._testOne(path, checkUnignored);
    }
    ignores(path) {
        return this._test(path, this._ignoreCache, false).ignored;
    }
    createFilter() {
        return (path)=>!this.ignores(path);
    }
    filter(paths) {
        return $f1acc5f0d0334d57$var$makeArray(paths).filter(this.createFilter());
    }
    // @returns {TestResult}
    test(path) {
        return this._test(path, this._testCache, true);
    }
}
const $f1acc5f0d0334d57$var$factory = (options)=>new $f1acc5f0d0334d57$var$Ignore(options);
const $f1acc5f0d0334d57$var$isPathValid = (path)=>$f1acc5f0d0334d57$var$checkPath(path && $f1acc5f0d0334d57$var$checkPath.convert(path), path, $f1acc5f0d0334d57$var$RETURN_FALSE);
$f1acc5f0d0334d57$var$factory.isPathValid = $f1acc5f0d0334d57$var$isPathValid;
// Fixes typescript
$f1acc5f0d0334d57$var$factory.default = $f1acc5f0d0334d57$var$factory;
$f1acc5f0d0334d57$exports = $f1acc5f0d0334d57$var$factory;
// Windows
// --------------------------------------------------------------
/* istanbul ignore if */ if (// Detect `process` so that it can run in browsers.
typeof $ibaza !== "undefined" && ($ibaza.env && undefined, $ibaza.platform === "win32")) {
    /* eslint no-control-regex: "off" */ const makePosix = (str)=>/^\\\\\?\\/.test(str) || /["<>|\u0000-\u001F]+/u.test(str) ? str : str.replace(/\\/g, "/");
    $f1acc5f0d0334d57$var$checkPath.convert = makePosix;
    // 'C:\\foo'     <- 'C:\\foo' has been converted to 'C:/'
    // 'd:\\foo'
    const REGIX_IS_WINDOWS_PATH_ABSOLUTE = /^[a-z]:\//i;
    $f1acc5f0d0334d57$var$checkPath.isNotRelative = (path)=>REGIX_IS_WINDOWS_PATH_ABSOLUTE.test(path) || $f1acc5f0d0334d57$var$isNotRelative(path);
}



var $37b095e0e8046d7a$require$Utils = $e1f0b8fa1ae2171c$exports.Utils;

var $37b095e0e8046d7a$require$Constants = $53cc2e000314a49f$exports.Constants;
const $37b095e0e8046d7a$var$WATCH_EVENT_NOTIFICATION = "PHOENIX_WATCH_EVENT_NOTIFICATION";
function $37b095e0e8046d7a$var$_setupBroadcastChannel() {
    if ($37b095e0e8046d7a$var$_channel) return;
    if (typeof BroadcastChannel === "undefined") {
        /* eslint no-console: 0 */ console.warn("BroadcastChannel not supported. File system watch events across tabs wont be synced.");
        return;
    }
    $37b095e0e8046d7a$var$_channel = new BroadcastChannel($37b095e0e8046d7a$var$WATCH_EVENT_NOTIFICATION);
}
function $37b095e0e8046d7a$var$_broadcastWatchEvent(event) {
    $37b095e0e8046d7a$var$_setupBroadcastChannel();
    $37b095e0e8046d7a$var$_channel.postMessage(event);
}
function $37b095e0e8046d7a$var$_isAnIgnoredPath(watchedPath, changedPath, gitignore) {
    const relativePath = globalObject.path.relative(watchedPath, changedPath);
    return relativePath && gitignore.ignores(relativePath);
}
function $37b095e0e8046d7a$var$_isSameOrSubDirectory(parent, child) {
    return !globalObject.path.relative(parent, child).startsWith("..");
}
// event{ path, eventName}
function $37b095e0e8046d7a$var$_processFsWatchEvent(event, broadcast = true) {
    if (broadcast) $37b095e0e8046d7a$var$_broadcastWatchEvent(event);
    for (const eventEmitter of $37b095e0e8046d7a$var$_eventEmitters)if ($37b095e0e8046d7a$var$_isSameOrSubDirectory(eventEmitter.watchedPath, event.path) && !$37b095e0e8046d7a$var$_isAnIgnoredPath(eventEmitter.watchedPath, event.path, eventEmitter.gitignore)) eventEmitter.emit(event.event, {
        path: event.path
    });
}
function $37b095e0e8046d7a$var$_listenToExternalFsWatchEvents() {
    $37b095e0e8046d7a$var$_setupBroadcastChannel();
    $37b095e0e8046d7a$var$_channel.onmessage = async function(event) {
        if (virtualfs.debugMode) console.log("PhoenixFS: External fs watch event: ", event.data);
        $37b095e0e8046d7a$var$_processFsWatchEvent(event.data, false);
    };
}
function $37b095e0e8046d7a$var$_triggerEvent(path, eventType) {
    let pathLib = globalObject.path;
    path = pathLib.normalize(path);
    let event = {
        event: eventType,
        path: path
    };
    $37b095e0e8046d7a$var$_processFsWatchEvent(event);
}
function $37b095e0e8046d7a$var$reportUnlinkEvent(path, isDir) {
    if ($37b095e0e8046d7a$require$Utils.isTauriSubPath(path)) // tauri watches native paths with node, so no virtual events needs to be handled
    return;
    if (isDir) $37b095e0e8046d7a$var$_triggerEvent(path, $37b095e0e8046d7a$require$Constants.WATCH_EVENTS.UNLINK_DIR);
    else $37b095e0e8046d7a$var$_triggerEvent(path, $37b095e0e8046d7a$require$Constants.WATCH_EVENTS.UNLINK_FILE);
}
function $37b095e0e8046d7a$var$reportChangeEvent(path) {
    if ($37b095e0e8046d7a$require$Utils.isTauriSubPath(path)) // tauri watches native paths with node, so no virtual events needs to be handled
    return;
    $37b095e0e8046d7a$var$_triggerEvent(path, $37b095e0e8046d7a$require$Constants.WATCH_EVENTS.CHANGE);
}
function $37b095e0e8046d7a$var$reportCreateEvent(path, isDir) {
    if ($37b095e0e8046d7a$require$Utils.isTauriSubPath(path)) // tauri watches native paths with node, so no virtual events needs to be handled
    return;
    if (isDir) $37b095e0e8046d7a$var$_triggerEvent(path, $37b095e0e8046d7a$require$Constants.WATCH_EVENTS.ADD_DIR);
    else $37b095e0e8046d7a$var$_triggerEvent(path, $37b095e0e8046d7a$require$Constants.WATCH_EVENTS.ADD_FILE);
}
/**
 * Watch a specific path asynchronously for filesystem changes.
 *
 * This function returns a promise that resolves an `EventEmitter` that will emit the following events:
 * - `fs.WATCH_EVENTS.ADD_FILE`: When a file is created.
 * - `fs.WATCH_EVENTS.ADD_DIR`: When a directory is created.
 * - `fs.WATCH_EVENTS.UNLINK_FILE`: When a file is deleted.
 * - `fs.WATCH_EVENTS.UNLINK_DIR`: When a directory is deleted.
 * - `fs.WATCH_EVENTS.CHANGE`: When a file is changed.
 *
 * The watcher will ignore all files matching patterns in the provided gitignore.
 *
 * @function
 * @async
 * @param {string} path - The path to watch for filesystem changes.
 * @param {string|Array<string>} [gitIgnorePaths=""] - The patterns to ignore, either provided as a string
 *      (representing the content of a `.gitignore` file) or an array of individual patterns. The watcher will
 *      adhere to the standard `.gitignore` specification as detailed at https://git-scm.com/docs/gitignore.
 *      It's important to note that if a parent directory is excluded from watching, its child directories
 *      will also be excluded, regardless of any `un-ignore` patterns in git ignore file(e.g., `!node_modules/dont_ignore_dir`).
 *
 * @returns {EventEmitter} - The event emitter that will notify of filesystem changes.
 *
 * @example
 * // In the below watcher, we provide a gitignore formatted text to ignores 'node_modules' folder
 * // See https://git-scm.com/docs/gitignore for details.
 * const watcher = await fs.watchAsync('/path/to/watch', 'node_modules');
 *
 * watcher.on(Constants.WATCH_EVENTS.ADD_FILE, (event) => {
 *   console.log(`File created: ${event.path}`);
 * });
 *
 * watcher.on(Constants.WATCH_EVENTS.UNLINK_DIR, (event) => {
 *   console.log(`Directory deleted: ${event.path}`);
 * });
 */ async function $37b095e0e8046d7a$var$watchAsync(path, gitIgnorePaths = "") {
    const eventEmitter = new $6e2b186194ca9ee7$exports();
    eventEmitter.gitignore = $f1acc5f0d0334d57$exports().add(gitIgnorePaths);
    eventEmitter.watchedPath = path;
    $37b095e0e8046d7a$var$_eventEmitters.push(eventEmitter);
    return eventEmitter;
}
/**
 * Stops watching for filesystem changes on a previously set path.
 *
 * Once you've stopped watching using `unwatchAsync`, any further operations on the event emitter
 * will throw an error. If you wish to start watching again, you will need to call `fs.watchAsync`.
 *
 * @function
 * @param {EventEmitter} eventEmitter - The event emitter returned by `fs.watchAsync` that you wish to stop watching.
 * @throws {Errors.EINVAL} Throws an error if the watcher is already closed or if operations are attempted after closing.
 *
 * @example
 * const watcher = await fs.watchAsync('/path/to/watch', 'node_modules');
 *
 * // Listen to an event.
 * watcher.on(fs.WATCH_EVENTS.ADD_FILE, (event) => {
 *   console.log(`File created: ${event.path}`);
 * });
 *
 * // ... After some time, stop watching.
 * await unwatchAsync(watcher);
 *
 * // Throws error since the watcher is closed.
 * watcher.on(fs.WATCH_EVENTS.ADD_FILE, (event) => {
 *   console.log(`File created: ${event.path}`);
 * });
 */ async function $37b095e0e8046d7a$var$unwatchAsync(eventEmitter) {
    if (eventEmitter.allreadyClosed) return;
    eventEmitter.removeAllListeners();
    eventEmitter.on = function() {
        throw new $37b095e0e8046d7a$require$Errors.EINVAL("The File watcher is closed. Please use `fs.watchAsync` if you want to watch again.");
    };
    eventEmitter.allreadyClosed = true;
    let index = $37b095e0e8046d7a$var$_eventEmitters.findIndex((e)=>e === eventEmitter);
    if (index !== -1) $37b095e0e8046d7a$var$_eventEmitters.splice(index, 1);
}
$37b095e0e8046d7a$var$_listenToExternalFsWatchEvents();
const $37b095e0e8046d7a$var$FsWatch = {
    watchAsync: $37b095e0e8046d7a$var$watchAsync,
    unwatchAsync: $37b095e0e8046d7a$var$unwatchAsync,
    reportUnlinkEvent: $37b095e0e8046d7a$var$reportUnlinkEvent,
    reportChangeEvent: $37b095e0e8046d7a$var$reportChangeEvent,
    reportCreateEvent: $37b095e0e8046d7a$var$reportCreateEvent
};
$37b095e0e8046d7a$exports = {
    FsWatch: $37b095e0e8046d7a$var$FsWatch
};


var $fe07aa8563a4b855$require$FsWatch = $37b095e0e8046d7a$exports.FsWatch;
var $e319fa88088e7e31$exports = {};
/*
 * GNU AGPL-3.0 License
 *
 * Copyright (c) 2021 - present core.ai . All rights reserved.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see https://opensource.org/licenses/AGPL-3.0.
 *
 */ // jshint ignore: start
/*global fs, globalObject*/ /*eslint no-console: 0*/ /*eslint strict: ["error", "global"]*/ 
var $e319fa88088e7e31$require$TauriFS = $ca2f37f7bc08d808$exports.TauriFS;

var $e319fa88088e7e31$require$Mounts = $aa3c82cc608bd675$exports.Mounts;

var $e319fa88088e7e31$require$Constants = $53cc2e000314a49f$exports.Constants;

var $e319fa88088e7e31$require$ERR_CODES = $505970e6c1eacf0c$exports.ERR_CODES;
var $e319fa88088e7e31$require$Errors = $505970e6c1eacf0c$exports.Errors;
const $e319fa88088e7e31$var$ERROR_CODES = $e319fa88088e7e31$require$ERR_CODES.ERROR_CODES;
function $e319fa88088e7e31$var$_stat(path) {
    return new Promise((resolve, reject)=>{
        fs.stat(path, async (err, stat)=>{
            if (err && err.code === $e319fa88088e7e31$var$ERROR_CODES.ENOENT) resolve(null);
            else if (err) reject(err);
            else resolve(stat);
        });
    });
}
function $e319fa88088e7e31$var$_mkdirIfNotPresent(path) {
    return new Promise((resolve, reject)=>{
        fs.mkdir(path, async (err)=>{
            err && err.code !== $e319fa88088e7e31$var$ERROR_CODES.EEXIST ? reject(err) : resolve();
        });
    });
}
function $e319fa88088e7e31$var$_readDir(path) {
    return new Promise((resolve, reject)=>{
        fs.readdir(path, (err, listing)=>{
            if (err) reject(err);
            else resolve(listing);
        });
    });
}
function $e319fa88088e7e31$var$_copyFileContents(src, dst) {
    let encoding = $e319fa88088e7e31$require$Constants.BINARY_ENCODING; // this is the Filer default binary return object
    if ($e319fa88088e7e31$require$TauriFS.isTauriSubPath(src) && $e319fa88088e7e31$require$TauriFS.isTauriSubPath(dst) || $e319fa88088e7e31$require$Mounts.isMountSubPath(src) && $e319fa88088e7e31$require$Mounts.isMountSubPath(dst)) encoding = $e319fa88088e7e31$require$Constants.BYTE_ARRAY_ENCODING; // this is the browser native encoding to make copying faster
    return new Promise((resolve, reject)=>{
        fs.readFile(src, encoding, (err, data)=>{
            if (err) reject(err);
            else fs.writeFile(dst, data, encoding, function(writeErr) {
                writeErr ? reject(writeErr) : resolve();
            });
        });
    });
}
async function $e319fa88088e7e31$var$_copyFile(srcFile, dst) {
    let dstStat = await $e319fa88088e7e31$var$_stat(dst);
    if (!dstStat) {
        let parentDir = globalObject.path.dirname(dst);
        let dstFileName = globalObject.path.basename(dst);
        dstStat = await $e319fa88088e7e31$var$_stat(parentDir);
        if (dstStat && dstStat.isDirectory()) {
            let dstFilePath = `${parentDir}/${dstFileName}`;
            await $e319fa88088e7e31$var$_copyFileContents(srcFile, dstFilePath);
            return dstFilePath;
        } else throw new $e319fa88088e7e31$require$Errors.EIO(`_copyFile Cannot create destination file: ${dst}`);
    }
    let srcFileName = globalObject.path.basename(srcFile);
    if (dstStat && dstStat.isDirectory()) {
        let dstFilePath = `${dst}/${srcFileName}`;
        await $e319fa88088e7e31$var$_copyFileContents(srcFile, dstFilePath);
        return dstFilePath;
    } else if (dstStat && dstStat.isFile()) throw new $e319fa88088e7e31$require$Errors.EEXIST(`_copyFile Destination file already exists: ${dst}`);
    else throw new $e319fa88088e7e31$require$Errors.EIO(`_copyFile Cannot copy file, unknown destination: ${srcFile} to ${dst}`);
}
async function $e319fa88088e7e31$var$_copyTree(src, dst) {
    let srcEntries = await $e319fa88088e7e31$var$_readDir(src);
    for (let entry of srcEntries){
        let entryPath = `${src}/${entry}`;
        let dstPath = `${dst}/${entry}`;
        let srcStat = await $e319fa88088e7e31$var$_stat(entryPath);
        if (srcStat.isFile()) await $e319fa88088e7e31$var$_copyFileContents(entryPath, dstPath);
        else {
            await $e319fa88088e7e31$var$_mkdirIfNotPresent(dstPath);
            await $e319fa88088e7e31$var$_copyTree(entryPath, dstPath);
        }
    }
}
async function $e319fa88088e7e31$var$_copyFolder(srcFolder, dst) {
    let dstStat = await $e319fa88088e7e31$var$_stat(dst);
    if (dstStat && dstStat.isFile()) throw new $e319fa88088e7e31$require$Errors.EEXIST(`Destination file already exists: ${dst}`);
    else if (dstStat && dstStat.isDirectory()) {
        let destSubFolderPath = `${dst}/${globalObject.path.basename(srcFolder)}`;
        dstStat = await $e319fa88088e7e31$var$_stat(destSubFolderPath);
        if (dstStat) throw new $e319fa88088e7e31$require$Errors.EEXIST(`Destination folder already exists: ${destSubFolderPath}`);
        await $e319fa88088e7e31$var$_mkdirIfNotPresent(destSubFolderPath);
        await $e319fa88088e7e31$var$_copyTree(srcFolder, destSubFolderPath);
        return destSubFolderPath;
    } else {
        await $e319fa88088e7e31$var$_mkdirIfNotPresent(dst);
        await $e319fa88088e7e31$var$_copyTree(srcFolder, dst);
        return dst;
    }
}
/**
 * Asynchronously copies a source file or directory to a destination.
 * If the source is a file, it will be copied to the specified destination (the destination file doesn't exist).
 * If the source is a directory, the directory will be copied recursively to the destination.
 *
 * @param {string} src - The path to the source file or directory.
 * @param {string} dst - The path to the destination. If the source is a file, this should be the full path to the destination file.
 * If the source is a directory, this should be the destination directory where the source directory's contents should be copied.
 * If the destination directory exists, the source folder will be copied as a child of the destination folder.
 * @param {function(Error|null, string?)} callback - Callback function called once the copy operation completes.
 *        - The first argument is an error if any occurred during the copy operation or `null` if the copy was successful.
 *        - The second argument is the path to the copied file or directory if the copy was successful.
 *
 * @throws {Errors.ENOENT} When the source doesn't exist.
 * @throws {Errors.EIO} For I/O related errors.
 * @throws {Errors.EEXIST} When the destination file or directory already exists.
 *
 * @example
 * copy('/path/to/src', '/path/to/dest', (err, copiedPath) => {
 *   if (err) {
 *     console.error('Copy failed:', err);
 *   } else {
 *     console.log('Copy succeeded:', copiedPath);
 *   }
 * });
 *
 * @returns {void}
 */ async function $e319fa88088e7e31$var$copy(src, dst, callback) {
    try {
        let srcStat = await $e319fa88088e7e31$var$_stat(src);
        if (!srcStat) {
            callback(new $e319fa88088e7e31$require$Errors.ENOENT(`Cannot copy src that doesnt exist: ${src}`));
            return;
        }
        if (srcStat.isFile()) {
            let copiedPath = await $e319fa88088e7e31$var$_copyFile(src, dst);
            callback(null, copiedPath);
        } else if (srcStat.isDirectory()) {
            let copiedPath = await $e319fa88088e7e31$var$_copyFolder(src, dst);
            callback(null, copiedPath);
        }
    } catch (e) {
        callback(new $e319fa88088e7e31$require$Errors.EIO(`${e}: Cannot copy src: ${src} to ${dst}`));
    }
}
function $e319fa88088e7e31$var$globalCopy(src, dst, cb) {
    $e319fa88088e7e31$var$copy(globalObject.path.normalize(src), globalObject.path.normalize(dst), cb);
}
$e319fa88088e7e31$exports = {
    globalCopy: $e319fa88088e7e31$var$globalCopy
};


var $fe07aa8563a4b855$require$globalCopy = $e319fa88088e7e31$exports.globalCopy;
var $1d25b01ef0c2a15f$exports = {};
"use strict";

$1d25b01ef0c2a15f$exports = (parcelRequire("8RBlD"));



let $fe07aa8563a4b855$var$filerLib = null;
let $fe07aa8563a4b855$var$filerShell = null;
/**
 * Offers functionality similar to mkdir -p
 *
 * Asynchronous operation. No arguments other than a possible exception
 * are given to the completion callback.
 */ function $fe07aa8563a4b855$var$_mkdir_p(fsLib, path, mode, callback, _position) {
    const osSep = "/";
    const parts = $fe07aa8563a4b855$var$filerLib.path.normalize(path).split(osSep);
    mode = mode || $ibaza.umask();
    _position = _position || 0;
    if (_position >= parts.length) return callback(null);
    var directory = parts.slice(0, _position + 1).join(osSep) || osSep;
    fsLib.stat(directory, function(err) {
        if (err === null) $fe07aa8563a4b855$var$_mkdir_p(fsLib, path, mode, callback, _position + 1);
        else fsLib.mkdir(directory, mode, function(error) {
            if (error && error.code !== "EEXIST") return callback(error);
            else $fe07aa8563a4b855$var$_mkdir_p(fsLib, path, mode, callback, _position + 1);
        });
    });
}
function $fe07aa8563a4b855$var$_ensure_mount_directory() {
    $fe07aa8563a4b855$var$fileSystemLib.mkdirs($fe07aa8563a4b855$require$Constants.MOUNT_POINT_ROOT);
    $fe07aa8563a4b855$var$fileSystemLib.mkdirs($fe07aa8563a4b855$require$Constants.TAURI_ROOT);
    $fe07aa8563a4b855$require$NativeFS.refreshMountPoints();
}
function $fe07aa8563a4b855$var$_getFirstFunctionIndex(argsArray) {
    for(let i = 0; i < argsArray.length; i++){
        if (typeof argsArray[i] === "function") return i;
    }
    return -1;
}
function $fe07aa8563a4b855$var$_isSubPathOf(dir, subDir) {
    const relative = $fe07aa8563a4b855$var$filerLib.path.relative(dir, subDir);
    return relative && !relative.startsWith("..") && !$fe07aa8563a4b855$var$filerLib.path.isAbsolute(relative);
}
const $fe07aa8563a4b855$var$fileSystemLib = {
    mountNativeFolder: async function(...args) {
        // Opens a file picker(or use provided handle) to open the folder in the system with fs access api.
        // to be used in browsers like chrome/edge that supports fs access apis
        return $fe07aa8563a4b855$require$NativeFS.mountNativeFolder(...args);
    },
    openTauriFilePickerAsync: function(options) {
        if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.openElectronFilePickerAsync(options);
        return $fe07aa8563a4b855$require$TauriFS.openTauriFilePickerAsync(options);
    },
    openTauriFileSaveDialogueAsync: function(options) {
        if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.openElectronFileSaveDialogueAsync(options);
        return $fe07aa8563a4b855$require$TauriFS.openTauriFileSaveDialogueAsync(options);
    },
    getTauriPlatformPath: function(virtualPath) {
        if ($fe07aa8563a4b855$require$TauriFS.isTauriPath(virtualPath) || $fe07aa8563a4b855$require$TauriFS.isTauriSubPath(virtualPath)) return $fe07aa8563a4b855$require$TauriFS.getTauriPlatformPath(virtualPath);
        return null;
    },
    getTauriVirtualPath: function(platformPath) {
        return $fe07aa8563a4b855$require$TauriFS.getTauriVirtualPath(platformPath);
    },
    readdir: function(...args) {
        let path = args[0];
        if ($fe07aa8563a4b855$require$TauriFS.isTauriPath(path) || $fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.readdir(...args);
            return $fe07aa8563a4b855$require$TauriFS.readdir(...args);
        }
        if ($fe07aa8563a4b855$require$Mounts.isMountPath(path) || $fe07aa8563a4b855$require$Mounts.isMountSubPath(path)) return $fe07aa8563a4b855$require$NativeFS.readdir(...args);
        return $fe07aa8563a4b855$var$filerLib.fs.readdir(...args);
    },
    stat: function(...args) {
        let path = args[0];
        if (typeof path !== "string") {
            let callback = args[$fe07aa8563a4b855$var$_getFirstFunctionIndex(args)];
            return callback(new $fe07aa8563a4b855$require$Errors.EINVAL(`Error Invalid path for stat: ${path}`));
        }
        if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.stat(...args);
            return $fe07aa8563a4b855$require$TauriFS.stat(...args);
        }
        if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(path)) return $fe07aa8563a4b855$require$NativeFS.stat(...args);
        return $fe07aa8563a4b855$var$filerLib.fs.stat(...args);
    },
    readFile: function(...args) {
        let path = args[0];
        if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.readFile(...args);
            return $fe07aa8563a4b855$require$TauriFS.readFile(...args);
        } else if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(path)) return $fe07aa8563a4b855$require$NativeFS.readFile(...args);
        return $fe07aa8563a4b855$require$FilerFSModified.readFile(...args);
    },
    writeFile: function(...args) {
        let path = args[0];
        let newFileCreated = false;
        function callbackInterceptor(...interceptedArgs) {
            let err = interceptedArgs.length >= 1 ? interceptedArgs[0] : null;
            if (!err) {
                if (newFileCreated) $fe07aa8563a4b855$require$FsWatch.reportCreateEvent(path, false);
                else $fe07aa8563a4b855$require$FsWatch.reportChangeEvent(path);
            }
            if (args.originalCallback) args.originalCallback(...interceptedArgs);
        }
        let callbackIndex = $fe07aa8563a4b855$var$_getFirstFunctionIndex(args);
        if (callbackIndex !== -1) {
            args.originalCallback = args[callbackIndex];
            args[callbackIndex] = callbackInterceptor;
        }
        if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.writeFile(...args);
            return $fe07aa8563a4b855$require$TauriFS.writeFile(...args);
        }
        $fe07aa8563a4b855$var$fileSystemLib.stat(path, (err)=>{
            if (err && err.code === $fe07aa8563a4b855$require$ERR_CODES.ERROR_CODES.ENOENT) newFileCreated = true;
            if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(path)) return $fe07aa8563a4b855$require$NativeFS.writeFile(...args);
            return $fe07aa8563a4b855$require$FilerFSModified.writeFile(...args);
        });
    },
    mkdir: function(...args) {
        let path = args[0];
        function callbackInterceptor(...interceptedArgs) {
            let err = interceptedArgs.length >= 1 ? interceptedArgs[0] : null;
            if (!err) $fe07aa8563a4b855$require$FsWatch.reportCreateEvent(path, true);
            if (args.originalCallback) args.originalCallback(...interceptedArgs);
        }
        let callbackIndex = $fe07aa8563a4b855$var$_getFirstFunctionIndex(args);
        if (callbackIndex !== -1) {
            args.originalCallback = args[callbackIndex];
            args[callbackIndex] = callbackInterceptor;
        }
        if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.mkdirs(...args);
            return $fe07aa8563a4b855$require$TauriFS.mkdirs(...args);
        }
        if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(path)) return $fe07aa8563a4b855$require$NativeFS.mkdir(...args);
        return $fe07aa8563a4b855$var$filerLib.fs.mkdir(...args);
    },
    rename: function(oldPath, newPath, cb) {
        function callbackInterceptor(...args) {
            let err = args.length >= 1 ? args[0] : null;
            if (!err) {
                if (!$fe07aa8563a4b855$require$TauriFS.isTauriSubPath(oldPath) || !$fe07aa8563a4b855$require$TauriFS.isTauriSubPath(newPath)) // we only need to manually handle watch events for non tauri paths as tauri watch is done at node
                $fe07aa8563a4b855$var$fileSystemLib.stat(newPath, (err, stat)=>{
                    const isDir = !err && stat.isDirectory();
                    if (!$fe07aa8563a4b855$require$TauriFS.isTauriSubPath(oldPath)) $fe07aa8563a4b855$require$FsWatch.reportUnlinkEvent(oldPath, isDir);
                    if (!$fe07aa8563a4b855$require$TauriFS.isTauriSubPath(newPath)) $fe07aa8563a4b855$require$FsWatch.reportCreateEvent(newPath, isDir);
                });
            }
            if (cb) cb(...args);
        }
        if ($fe07aa8563a4b855$var$_isSubPathOf(oldPath, newPath) || $fe07aa8563a4b855$var$_isSubPathOf(newPath, oldPath)) {
            callbackInterceptor(new $fe07aa8563a4b855$require$Errors.EINVAL(`Error renaming as one is a sub-path of other: ${newPath}, ${oldPath}`));
            return;
        }
        if ($fe07aa8563a4b855$require$Mounts.isMountPath(oldPath) || $fe07aa8563a4b855$require$Mounts.isMountPath(newPath)) {
            cb(new $fe07aa8563a4b855$require$Errors.EPERM("Mount root directory cannot be renamed."));
            return;
        } else if ($fe07aa8563a4b855$require$TauriFS.isTauriPath(oldPath) || $fe07aa8563a4b855$require$TauriFS.isTauriPath(newPath)) {
            cb(new $fe07aa8563a4b855$require$Errors.EPERM("Tauri root directory cannot be renamed."));
            return;
        }
        if (oldPath !== newPath && oldPath.toLowerCase() === newPath.toLowerCase()) {
            // in windows, we should be able to rename "a.txt" to "A.txt". Since windows is case-insensitive,
            // the below stat(A.txt) will return a stat for "a.txt" which is not what we want.
            if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(oldPath) && $fe07aa8563a4b855$require$TauriFS.isTauriSubPath(newPath)) {
                if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.rename(oldPath, newPath, callbackInterceptor);
                return $fe07aa8563a4b855$require$TauriFS.rename(oldPath, newPath, callbackInterceptor);
            } else if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(oldPath) && $fe07aa8563a4b855$require$Mounts.isMountSubPath(newPath)) return $fe07aa8563a4b855$require$NativeFS.renameSameNameDiffCase(oldPath, newPath, callbackInterceptor);
        }
        $fe07aa8563a4b855$var$fileSystemLib.stat(newPath, (err)=>{
            if (!err) {
                // the destination folder/file exists and we should not rename
                cb(new $fe07aa8563a4b855$require$Errors.EEXIST("Cannot rename, The destination path exists: " + newPath));
                return;
            }
            if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(oldPath) && $fe07aa8563a4b855$require$TauriFS.isTauriSubPath(newPath)) {
                if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.rename(oldPath, newPath, callbackInterceptor);
                return $fe07aa8563a4b855$require$TauriFS.rename(oldPath, newPath, callbackInterceptor);
            } else if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(oldPath) && $fe07aa8563a4b855$require$Mounts.isMountSubPath(newPath)) return $fe07aa8563a4b855$require$NativeFS.rename(oldPath, newPath, callbackInterceptor);
            return $fe07aa8563a4b855$var$filerLib.fs.rename(oldPath, newPath, callbackInterceptor);
        });
    },
    unlink: function(path, cb) {
        let isDir;
        function callbackInterceptor(...args) {
            let err = args.length >= 1 ? args[0] : null;
            if (!err) $fe07aa8563a4b855$require$FsWatch.reportUnlinkEvent(path, isDir);
            if (cb) cb(...args);
        }
        if ($fe07aa8563a4b855$require$Mounts.isMountPath(path) || $fe07aa8563a4b855$require$TauriFS.isTauriPath(path)) {
            callbackInterceptor(new $fe07aa8563a4b855$require$Errors.EPERM("Mount root directory cannot be deleted."));
            return;
        } else if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.unlink(path, callbackInterceptor);
            return $fe07aa8563a4b855$require$TauriFS.unlink(path, callbackInterceptor);
        }
        $fe07aa8563a4b855$var$fileSystemLib.stat(path, (err, stat)=>{
            isDir = !err && stat.isDirectory();
            // we do this to emit fs watch events for non-tauri path unlinks.
            // We only need to manually handle watch events for non tauri paths as tauri watch is done at node
            if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(path)) return $fe07aa8563a4b855$require$NativeFS.unlink(path, callbackInterceptor);
            if (typeof path !== "string") {
                callbackInterceptor(new $fe07aa8563a4b855$require$Errors.EINVAL("Invalid arguments."));
                return;
            }
            return $fe07aa8563a4b855$var$filerShell.rm(path, {
                recursive: true
            }, callbackInterceptor);
        });
    },
    copy: function(src, dst, cb) {
        function callbackInterceptor(...args) {
            let err = args.length >= 1 ? args[0] : null;
            if (!err) $fe07aa8563a4b855$var$fileSystemLib.stat(dst, (err, stat)=>{
                const isDir = !err && stat.isDirectory();
                $fe07aa8563a4b855$require$FsWatch.reportCreateEvent(dst, isDir);
            });
            if (cb) cb(...args);
        }
        if ($fe07aa8563a4b855$var$_isSubPathOf(src, dst)) {
            callbackInterceptor(new $fe07aa8563a4b855$require$Errors.EINVAL(`Error copying: ${dst} cannot be a subpath of ${src}`));
            return;
        }
        // we have two implementation here even though the globalCopy fn is capable of copying anywhere. Native has its
        // own impl to prevent large number of file node io in fs access impl.
        // Ideally we should have a tauri copy impl too, but to unblock main thread while copy, we need to
        // spawn different threads in rust and write tauri handlers which is pretty complex atm. so instead we will
        // fall back to global copy here and will use node Tauri web socket fs adapter as and when it becomes available.
        if ($fe07aa8563a4b855$require$Mounts.isMountSubPath(src) && $fe07aa8563a4b855$require$Mounts.isMountSubPath(dst)) return $fe07aa8563a4b855$require$NativeFS.copy(src, dst, callbackInterceptor);
        else if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(src) && $fe07aa8563a4b855$require$TauriFS.isTauriSubPath(dst)) {
            if (globalObject.__ELECTRON__ && $fe07aa8563a4b855$require$ElectronFS.canCopy()) return $fe07aa8563a4b855$require$ElectronFS.copy(src, dst, callbackInterceptor);
            if ($fe07aa8563a4b855$require$TauriFS.canCopy()) return $fe07aa8563a4b855$require$TauriFS.copy(src, dst, callbackInterceptor);
            return $fe07aa8563a4b855$require$globalCopy(src, dst, callbackInterceptor);
        } else return $fe07aa8563a4b855$require$globalCopy(src, dst, callbackInterceptor);
    },
    showSaveDialog: function(options) {
        if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$var$fileSystemLib.openElectronFileSaveDialogueAsync(options);
        // Default to Tauri for native environments (including workers via WebSocket)
        return $fe07aa8563a4b855$var$fileSystemLib.openTauriFileSaveDialogueAsync(options);
    },
    watchAsync: function(path, gitIgnorePaths = "") {
        if ($fe07aa8563a4b855$require$TauriFS.isTauriPath(path)) throw new $fe07aa8563a4b855$require$Errors.EPERM("Cannot watch root directory!", path);
        else if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) return $fe07aa8563a4b855$require$NodeTauriFS.watchAsync(path, gitIgnorePaths);
        return $fe07aa8563a4b855$require$FsWatch.watchAsync(path, gitIgnorePaths);
    },
    unwatchAsync: function(eventEmitter) {
        if (eventEmitter.eventEmitterID) return $fe07aa8563a4b855$require$NodeTauriFS.unwatchAsync(eventEmitter);
        return $fe07aa8563a4b855$require$FsWatch.unwatchAsync(eventEmitter);
    },
    moveToTrash: function() {
        throw new $fe07aa8563a4b855$require$Errors.ENOSYS("Phoenix fs moveToTrash function not yet supported.");
    },
    mkdirs: function(path, mode, recursive, callback) {
        // Determine if 'mode' is provided
        if (typeof mode !== "number") {
            callback = recursive;
            recursive = mode;
            mode = 511; // Default mode (or any other default you'd like to set)
        }
        // Determine if 'recursive' is provided
        if (typeof recursive !== "boolean") {
            callback = recursive;
            recursive = false;
        }
        // Determine if 'callback' is provided
        if (typeof callback !== "function") callback = function() {
        // Do Nothing
        };
        if (!recursive) $fe07aa8563a4b855$var$fileSystemLib.mkdir(path, mode, callback);
        else if ($fe07aa8563a4b855$require$TauriFS.isTauriSubPath(path)) {
            if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.mkdirs(path, mode, true, callback);
            return $fe07aa8563a4b855$require$TauriFS.mkdirs(path, mode, true, callback);
        } else $fe07aa8563a4b855$var$_mkdir_p($fe07aa8563a4b855$var$fileSystemLib, path, mode, callback);
    },
    testNodeWsEndpoint: function(wsEndPoint, echoData, echoBuffer) {
        return $fe07aa8563a4b855$require$NodeTauriFS.testNodeWsEndpoint(wsEndPoint, echoData, echoBuffer);
    },
    setNodeWSEndpoint: function(wsEndPoint) {
        return $fe07aa8563a4b855$require$NodeTauriFS.setNodeWSEndpoint(wsEndPoint);
    },
    stopNodeWSEndpoint: function(wsEndPoint) {
        return $fe07aa8563a4b855$require$NodeTauriFS.stopNodeWSEndpoint(wsEndPoint);
    },
    getNodeWSEndpoint: function() {
        return $fe07aa8563a4b855$require$NodeTauriFS.getNodeWSEndpoint();
    },
    forceUseNodeWSEndpoint: function(use) {
        if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.forceUseNodeWSEndpoint(use);
        return $fe07aa8563a4b855$require$TauriFS.forceUseNodeWSEndpoint(use);
    },
    preferNodeWSEndpoint: function(use) {
        if (globalObject.__ELECTRON__) return $fe07aa8563a4b855$require$ElectronFS.preferNodeWSEndpoint(use);
        return $fe07aa8563a4b855$require$TauriFS.preferNodeWSEndpoint(use);
    },
    BYTE_ARRAY_ENCODING: $fe07aa8563a4b855$require$Constants.BYTE_ARRAY_ENCODING,
    MOUNT_POINT_ROOT: $fe07aa8563a4b855$require$Constants.MOUNT_POINT_ROOT,
    TAURI_ROOT: $fe07aa8563a4b855$require$Constants.TAURI_ROOT,
    ERR_CODES: {},
    WATCH_EVENTS: $fe07aa8563a4b855$require$Constants.WATCH_EVENTS,
    isEncodingSupported: function(encoding) {
        if (encoding.toLowerCase() === $fe07aa8563a4b855$require$Constants.BYTE_ARRAY_ENCODING) return true;
        return $3c12ae0d63e57f9f$exports.encodingExists(encoding);
    },
    utils: {
        iconv: $3c12ae0d63e57f9f$exports,
        picomatch: $1d25b01ef0c2a15f$exports,
        ignore: $f1acc5f0d0334d57$exports
    }
};
for (let errCode of Object.values($fe07aa8563a4b855$require$ERR_CODES.FS_ERROR_CODES))$fe07aa8563a4b855$var$fileSystemLib.ERR_CODES[errCode] = errCode;
$fe07aa8563a4b855$var$fileSystemLib.copyFile = $fe07aa8563a4b855$var$fileSystemLib.copy;
$fe07aa8563a4b855$var$fileSystemLib.name = "phoenixFS";
function $fe07aa8563a4b855$var$_populateSupportedEncodings() {
    if ($3c12ae0d63e57f9f$exports.encodingExists("utf8")) {
        // we do this as iconv bootstraps this
        const SUPPORTED_ENCODINGS = [];
        for (let encoding of Object.keys($3c12ae0d63e57f9f$exports.encodings))// the Object.keys list contains encoding functions and privates. so filter
        if ($3c12ae0d63e57f9f$exports.encodingExists(encoding)) SUPPORTED_ENCODINGS.push(encoding);
        SUPPORTED_ENCODINGS.push($fe07aa8563a4b855$var$fileSystemLib.BYTE_ARRAY_ENCODING);
        $fe07aa8563a4b855$var$fileSystemLib.SUPPORTED_ENCODINGS = SUPPORTED_ENCODINGS;
    }
}
function $fe07aa8563a4b855$var$initFsLib(FilerLib) {
    $fe07aa8563a4b855$var$filerLib = FilerLib;
    $fe07aa8563a4b855$require$FilerFSModified.initFilerLib($fe07aa8563a4b855$var$filerLib);
    $fe07aa8563a4b855$var$filerShell = new $fe07aa8563a4b855$var$filerLib.fs.Shell();
    globalObject.path = FilerLib.path;
    globalObject.Buffer = FilerLib.Buffer;
    globalObject.iconv = $3c12ae0d63e57f9f$exports;
    globalObject.fs = $fe07aa8563a4b855$var$fileSystemLib;
    globalObject.fs.path = FilerLib.path;
    globalObject.fs.Buffer = FilerLib.Buffer;
    $fe07aa8563a4b855$var$_populateSupportedEncodings();
    $fe07aa8563a4b855$var$_ensure_mount_directory();
}
$fe07aa8563a4b855$exports = {
    initFsLib: $fe07aa8563a4b855$var$initFsLib
};


var $d2d6477b44a50ea0$require$initFsLib = $fe07aa8563a4b855$exports.initFsLib;
$d2d6477b44a50ea0$require$initFsLib($8f57302d7f35c9a9$exports);

})();
//# sourceMappingURL=virtualfs.js.map
